(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'snabbdom', 'kvision-kvision-common-types-js-legacy', 'kotlinx-serialization-kotlinx-serialization-core-js-legacy', 'kotlinx-serialization-kotlinx-serialization-json-js-legacy', 'snabbdom'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('snabbdom'), require('kvision-kvision-common-types-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-core-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-json-js-legacy'), require('snabbdom'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-js-legacy'.");
    }if (typeof snabbdom === 'undefined') {
      throw new Error("Error loading module 'kvision-js-legacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-js-legacy'.");
    }if (typeof this['kvision-kvision-common-types-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-js-legacy'. Its dependency 'kvision-kvision-common-types-js-legacy' was not found. Please, check whether 'kvision-kvision-common-types-js-legacy' is loaded prior to 'kvision-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' is loaded prior to 'kvision-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' is loaded prior to 'kvision-js-legacy'.");
    }if (typeof modulesExt === 'undefined') {
      throw new Error("Error loading module 'kvision-js-legacy'. Its dependency 'snabbdom' was not found. Please, check whether 'snabbdom' is loaded prior to 'kvision-js-legacy'.");
    }root['kvision-js-legacy'] = factory(typeof this['kvision-js-legacy'] === 'undefined' ? {} : this['kvision-js-legacy'], kotlin, snabbdom, this['kvision-kvision-common-types-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'], modulesExt);
  }
}(this, function (_, Kotlin, $module$snabbdom, $module$kvision_kvision_common_types_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy, $module$snabbdom_0) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var Unit = Kotlin.kotlin.Unit;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var emptyMap = Kotlin.kotlin.collections.emptyMap_q3lmfv$;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var clear = Kotlin.kotlinx.dom.clear_asww5s$;
  var init = $module$snabbdom.init;
  var asList = Kotlin.kotlin.collections.asList_us0mfu$;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var listOf = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var toString = Kotlin.kotlin.text.toString_dqglrj$;
  var padStart = Kotlin.kotlin.text.padStart_vrc1nu$;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var toString_0 = Kotlin.toString;
  var iterator = Kotlin.kotlin.js.iterator_s8jyvk$;
  var to = Kotlin.kotlin.to_ujzrz7$;
  var listOf_0 = Kotlin.kotlin.collections.listOf_mh5how$;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var defineInlineFunction = Kotlin.defineInlineFunction;
  var wrapFunction = Kotlin.wrapFunction;
  var split = Kotlin.kotlin.text.split_o64adg$;
  var last = Kotlin.kotlin.collections.last_2p1efm$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var ensureNotNull = Kotlin.ensureNotNull;
  var h = $module$snabbdom.h;
  var equals = Kotlin.equals;
  var toMap = Kotlin.kotlin.collections.toMap_6hr0sd$;
  var toMutableMap = Kotlin.kotlin.collections.toMutableMap_abgq59$;
  var first = Kotlin.kotlin.collections.first_7wnvza$;
  var throwCCE = Kotlin.throwCCE;
  var getCallableRef = Kotlin.getCallableRef;
  var mutableMapOf = Kotlin.kotlin.collections.mutableMapOf_qfcya0$;
  var startsWith = Kotlin.kotlin.text.startsWith_7epoxm$;
  var setOf = Kotlin.kotlin.collections.setOf_mh5how$;
  var toSet = Kotlin.kotlin.collections.toSet_us0mfu$;
  var intersect = Kotlin.kotlin.collections.intersect_q4559j$;
  var split_0 = Kotlin.kotlin.text.split_ip8yn$;
  var toSet_0 = Kotlin.kotlin.collections.toSet_7wnvza$;
  var mapOf = Kotlin.kotlin.collections.mapOf_qfcya0$;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init_0 = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var Object_init = Object;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  var copyToArray = Kotlin.kotlin.collections.copyToArray;
  var toMutableSet = Kotlin.kotlin.collections.toMutableSet_7wnvza$;
  var LinkedHashSet_init = Kotlin.kotlin.collections.LinkedHashSet_init_287e2$;
  var emptySet = Kotlin.kotlin.collections.emptySet_287e2$;
  var KFile = $module$kvision_kvision_common_types_js_legacy.io.kvision.types.KFile;
  var ListSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.builtins.ListSerializer_swdriu$;
  var contains = Kotlin.kotlin.collections.contains_mjy6jw$;
  var withDefault = Kotlin.kotlin.collections.withDefault_jgsead$;
  var Json = $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy.kotlinx.serialization.json.Json;
  var getKClass = Kotlin.getKClass;
  var overwriteWith = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.overwriteWith_nz2fmb$;
  var Json_0 = $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy.kotlinx.serialization.json.Json_x26noe$;
  var List = Kotlin.kotlin.collections.List;
  var Map = Kotlin.kotlin.collections.Map;
  var mapCapacity = Kotlin.kotlin.collections.mapCapacity_za3lpa$;
  var coerceAtLeast = Kotlin.kotlin.ranges.coerceAtLeast_dqglrj$;
  var LinkedHashMap_init_0 = Kotlin.kotlin.collections.LinkedHashMap_init_bwtc7$;
  var SerializersModuleBuilder_init = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.SerializersModuleBuilder;
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init;
  var firstOrNull = Kotlin.kotlin.collections.firstOrNull_2p1efm$;
  var toDoubleOrNull = Kotlin.kotlin.text.toDoubleOrNull_pdl1vz$;
  var getPropertyCallableRef = Kotlin.getPropertyCallableRef;
  var getOrNull = Kotlin.kotlin.collections.getOrNull_yzln2o$;
  var mapOf_0 = Kotlin.kotlin.collections.mapOf_x2b85n$;
  var replace = Kotlin.kotlin.text.replace_680rmw$;
  var contains_0 = Kotlin.kotlin.collections.contains_2ws7j4$;
  var asList_0 = Kotlin.org.w3c.dom.asList_kt9thq$;
  var numberToDouble = Kotlin.numberToDouble;
  var IllegalStateException_init_0 = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  var throwUPAE = Kotlin.throwUPAE;
  var checkIndexOverflow = Kotlin.kotlin.collections.checkIndexOverflow_za3lpa$;
  var Annotation = Kotlin.kotlin.Annotation;
  var dropLast = Kotlin.kotlin.text.dropLast_6ic1pp$;
  var last_0 = Kotlin.kotlin.text.last_gw00vp$;
  var Exception = Kotlin.kotlin.Exception;
  var toIntOrNull = Kotlin.kotlin.text.toIntOrNull_pdl1vz$;
  var plus_0 = Kotlin.kotlin.collections.plus_mydzjv$;
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  var JsMath = Math;
  var indexOf = Kotlin.kotlin.collections.indexOf_bv23uc$;
  var get_indices = Kotlin.kotlin.collections.get_indices_gzk92b$;
  var firstOrNull_0 = Kotlin.kotlin.collections.firstOrNull_7wnvza$;
  var ObservableProperty = Kotlin.kotlin.properties.ObservableProperty;
  var types = $module$kvision_kvision_common_types_js_legacy.io.kvision.types;
  var buildClassSerialDescriptor = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.descriptors.buildClassSerialDescriptor_dowfwv$;
  var KSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.KSerializer;
  var HashMap_init = Kotlin.kotlin.collections.HashMap_init_q3lmfv$;
  var MutableMap = Kotlin.kotlin.collections.MutableMap;
  var plus_1 = Kotlin.kotlin.collections.plus_drqvgf$;
  var lazy = Kotlin.kotlin.lazy_klfg04$;
  var toList = Kotlin.kotlin.collections.toList_7wnvza$;
  var get_js = Kotlin.kotlin.js.get_js_1yb8b7$;
  var serializersModuleOf = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.modules.serializersModuleOf_cfhkba$;
  var Pair = Kotlin.kotlin.Pair;
  var Regex_init = Kotlin.kotlin.text.Regex_init_61zpoe$;
  var drop = Kotlin.kotlin.text.drop_6ic1pp$;
  UNIT.prototype = Object.create(Enum.prototype);
  UNIT.prototype.constructor = UNIT;
  Col.prototype = Object.create(Enum.prototype);
  Col.prototype.constructor = Col;
  BgSize.prototype = Object.create(Enum.prototype);
  BgSize.prototype.constructor = BgSize;
  BgRepeat.prototype = Object.create(Enum.prototype);
  BgRepeat.prototype.constructor = BgRepeat;
  Display.prototype = Object.create(Enum.prototype);
  Display.prototype.constructor = Display;
  Overflow.prototype = Object.create(Enum.prototype);
  Overflow.prototype.constructor = Overflow;
  Resize.prototype = Object.create(Enum.prototype);
  Resize.prototype.constructor = Resize;
  TextAlign.prototype = Object.create(Enum.prototype);
  TextAlign.prototype.constructor = TextAlign;
  VerticalAlign.prototype = Object.create(Enum.prototype);
  VerticalAlign.prototype.constructor = VerticalAlign;
  PosFloat.prototype = Object.create(Enum.prototype);
  PosFloat.prototype.constructor = PosFloat;
  Clear.prototype = Object.create(Enum.prototype);
  Clear.prototype.constructor = Clear;
  Cursor.prototype = Object.create(Enum.prototype);
  Cursor.prototype.constructor = Cursor;
  FlexDirection.prototype = Object.create(Enum.prototype);
  FlexDirection.prototype.constructor = FlexDirection;
  JustifyContent.prototype = Object.create(Enum.prototype);
  JustifyContent.prototype.constructor = JustifyContent;
  Style.prototype = Object.create(StyledComponent.prototype);
  Style.prototype.constructor = Style;
  Widget.prototype = Object.create(StyledComponent.prototype);
  Widget.prototype.constructor = Widget;
  SimplePanel.prototype = Object.create(Widget.prototype);
  SimplePanel.prototype.constructor = SimplePanel;
  WidgetWrapper.prototype = Object.create(SimplePanel.prototype);
  WidgetWrapper.prototype.constructor = WidgetWrapper;
  Tag.prototype = Object.create(SimplePanel.prototype);
  Tag.prototype.constructor = Tag;
  FieldLabel.prototype = Object.create(Tag.prototype);
  FieldLabel.prototype.constructor = FieldLabel;
  FieldLabelCheck.prototype = Object.create(FieldLabel.prototype);
  FieldLabelCheck.prototype.constructor = FieldLabelCheck;
  InputSize.prototype = Object.create(Enum.prototype);
  InputSize.prototype.constructor = InputSize;
  ValidationStatus.prototype = Object.create(Enum.prototype);
  ValidationStatus.prototype.constructor = ValidationStatus;
  InvalidFeedback.prototype = Object.create(Tag.prototype);
  InvalidFeedback.prototype.constructor = InvalidFeedback;
  CheckBox.prototype = Object.create(SimplePanel.prototype);
  CheckBox.prototype.constructor = CheckBox;
  CheckInput.prototype = Object.create(Widget.prototype);
  CheckInput.prototype.constructor = CheckInput;
  CheckBoxInput.prototype = Object.create(CheckInput.prototype);
  CheckBoxInput.prototype.constructor = CheckBoxInput;
  CheckInputType.prototype = Object.create(Enum.prototype);
  CheckInputType.prototype.constructor = CheckInputType;
  GenericRadioGroup.prototype = Object.create(SimplePanel.prototype);
  GenericRadioGroup.prototype.constructor = GenericRadioGroup;
  Radio.prototype = Object.create(SimplePanel.prototype);
  Radio.prototype.constructor = Radio;
  RadioGroup.prototype = Object.create(GenericRadioGroup.prototype);
  RadioGroup.prototype.constructor = RadioGroup;
  RadioInput.prototype = Object.create(CheckInput.prototype);
  RadioInput.prototype.constructor = RadioInput;
  TriStateCheckBox.prototype = Object.create(SimplePanel.prototype);
  Range.prototype = Object.create(SimplePanel.prototype);
  Range.prototype.constructor = Range;
  RangeInput.prototype = Object.create(Widget.prototype);
  RangeInput.prototype.constructor = RangeInput;
  SimpleSelect.prototype = Object.create(SimplePanel.prototype);
  SimpleSpinner.prototype = Object.create(SimplePanel.prototype);
  SimpleSpinner.prototype.constructor = SimpleSpinner;
  SimpleSpinnerInput.prototype = Object.create(Widget.prototype);
  SimpleSpinnerInput.prototype.constructor = SimpleSpinnerInput;
  AbstractText.prototype = Object.create(SimplePanel.prototype);
  AbstractText.prototype.constructor = AbstractText;
  AbstractTextInput.prototype = Object.create(Widget.prototype);
  AbstractTextInput.prototype.constructor = AbstractTextInput;
  Text.prototype = Object.create(AbstractText.prototype);
  Text.prototype.constructor = Text;
  Password.prototype = Object.create(Text.prototype);
  Password.prototype.constructor = Password;
  TextArea.prototype = Object.create(AbstractText.prototype);
  TextArea.prototype.constructor = TextArea;
  TextAreaInput.prototype = Object.create(AbstractTextInput.prototype);
  TextAreaInput.prototype.constructor = TextAreaInput;
  TextInput.prototype = Object.create(AbstractTextInput.prototype);
  TextInput.prototype.constructor = TextInput;
  B.prototype = Object.create(Tag.prototype);
  B.prototype.constructor = B;
  ButtonStyle.prototype = Object.create(Enum.prototype);
  ButtonStyle.prototype.constructor = ButtonStyle;
  ButtonType.prototype = Object.create(Enum.prototype);
  ButtonType.prototype.constructor = ButtonType;
  Button.prototype = Object.create(SimplePanel.prototype);
  Button.prototype.constructor = Button;
  Canvas.prototype = Object.create(Widget.prototype);
  Canvas.prototype.constructor = Canvas;
  Div.prototype = Object.create(Tag.prototype);
  Div.prototype.constructor = Div;
  H2.prototype = Object.create(Tag.prototype);
  H2.prototype.constructor = H2;
  H3.prototype = Object.create(Tag.prototype);
  H3.prototype.constructor = H3;
  Icon.prototype = Object.create(Tag.prototype);
  Icon.prototype.constructor = Icon;
  Iframe.prototype = Object.create(Widget.prototype);
  Iframe.prototype.constructor = Iframe;
  Image.prototype = Object.create(Widget.prototype);
  Image.prototype.constructor = Image;
  InputType.prototype = Object.create(Enum.prototype);
  InputType.prototype.constructor = InputType;
  Li.prototype = Object.create(Tag.prototype);
  Li.prototype.constructor = Li;
  Link.prototype = Object.create(SimplePanel.prototype);
  Link.prototype.constructor = Link;
  ListType.prototype = Object.create(Enum.prototype);
  ListType.prototype.constructor = ListType;
  ListTag.prototype = Object.create(SimplePanel.prototype);
  ListTag.prototype.constructor = ListTag;
  P.prototype = Object.create(Tag.prototype);
  P.prototype.constructor = P;
  Span.prototype = Object.create(Tag.prototype);
  Span.prototype.constructor = Span;
  TAG.prototype = Object.create(Enum.prototype);
  TAG.prototype.constructor = TAG;
  TextNode.prototype = Object.create(Widget.prototype);
  TextNode.prototype.constructor = TextNode;
  Ul.prototype = Object.create(ListTag.prototype);
  Ul.prototype.constructor = Ul;
  FieldsetPanel.prototype = Object.create(SimplePanel.prototype);
  FieldsetPanel.prototype.constructor = FieldsetPanel;
  FlexPanel.prototype = Object.create(SimplePanel.prototype);
  FlexPanel.prototype.constructor = FlexPanel;
  HPanel.prototype = Object.create(FlexPanel.prototype);
  HPanel.prototype.constructor = HPanel;
  ContainerType.prototype = Object.create(Enum.prototype);
  ContainerType.prototype.constructor = ContainerType;
  Root.prototype = Object.create(SimplePanel.prototype);
  Root.prototype.constructor = Root;
  Direction_0.prototype = Object.create(Enum.prototype);
  Direction_0.prototype.constructor = Direction_0;
  SplitPanel.prototype = Object.create(SimplePanel.prototype);
  SplitPanel.prototype.constructor = SplitPanel;
  Splitter.prototype = Object.create(SimplePanel.prototype);
  Splitter.prototype.constructor = Splitter;
  StackPanel.prototype = Object.create(SimplePanel.prototype);
  StackPanel.prototype.constructor = StackPanel;
  VPanel.prototype = Object.create(FlexPanel.prototype);
  VPanel.prototype.constructor = VPanel;
  function Application() {
  }
  Application.prototype.start = function () {
  };
  Application.prototype.start_x7u0o8$ = function (state) {
    this.start();
  };
  Application.prototype.dispose = function () {
    return emptyMap();
  };
  Application.$metadata$ = {kind: Kind_CLASS, simpleName: 'Application', interfaces: []};
  function startApplication$start(closure$builder) {
    return function (state) {
      var tmp$;
      if ((state != null ? state.appState : null) != undefined) {
        RoutingManager_getInstance().initRouter();
      }var application = closure$builder();
      application.start_x7u0o8$((tmp$ = state != null ? state.appState : null) != null ? tmp$ : emptyMap());
      return application;
    };
  }
  function startApplication$lambda$lambda(closure$application) {
    return function (data) {
      var tmp$;
      Root$Companion_getInstance().disposeAllRoots();
      RoutingManager_getInstance().shutdownRouter();
      data.appState = (tmp$ = closure$application.v) != null ? tmp$.dispose() : null;
      closure$application.v = null;
      return Unit;
    };
  }
  function startApplication$lambda(closure$state, closure$start, closure$application) {
    return function (it) {
      closure$application.v = closure$start(closure$state);
      return Unit;
    };
  }
  function startApplication(builder, hot, moduleInitializer, panelsCompatibilityMode) {
    if (hot === void 0)
      hot = null;
    if (panelsCompatibilityMode === void 0)
      panelsCompatibilityMode = false;
    if (window.__karma__)
      return;
    KVManager_getInstance().panelsCompatibilityMode_8be2vx$ = panelsCompatibilityMode;
    var tmp$;
    for (tmp$ = 0; tmp$ !== moduleInitializer.length; ++tmp$) {
      var element = moduleInitializer[tmp$];
      element.initialize();
    }
    var start = startApplication$start(builder);
    var application = {v: null};
    var tmp$_0;
    if (hot != null) {
      hot.accept();
      hot.dispose(startApplication$lambda$lambda(application));
      tmp$_0 = hot.data;
    } else
      tmp$_0 = null;
    var state = tmp$_0;
    if (document.body != null) {
      application.v = start(state);
    } else {
      application.v = null;
      document.addEventListener('DOMContentLoaded', startApplication$lambda(state, start, application));
    }
  }
  function ModuleInitializer() {
  }
  ModuleInitializer.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ModuleInitializer', interfaces: []};
  function CoreModule() {
    CoreModule_instance = this;
  }
  CoreModule.prototype.initialize = function () {
    require('kvision-assets/css/style.css');
  };
  CoreModule.$metadata$ = {kind: Kind_OBJECT, simpleName: 'CoreModule', interfaces: [ModuleInitializer]};
  var CoreModule_instance = null;
  function CoreModule_getInstance() {
    if (CoreModule_instance === null) {
      new CoreModule();
    }return CoreModule_instance;
  }
  function KVManager() {
    KVManager_instance = this;
    this.splitjs_8be2vx$ = require('split.js').default;
    this.fecha_8be2vx$ = require('fecha').default;
    this.sdPatch_0 = init([classModule, attributesModule, propsModule, styleModule, eventListenersModule]);
    this.sdVirtualize_0 = require('@rjaros/snabbdom-virtualize/strings').default;
    this.virtualizeCache_0 = {};
    this.panelsCompatibilityMode_8be2vx$ = false;
  }
  KVManager.prototype.patch_w7nmm6$ = function (id, vnode) {
    var container = document.getElementById(id);
    container != null ? (clear(container), Unit) : null;
    return this.sdPatch_0(container, vnode);
  };
  KVManager.prototype.patch_bcdad0$ = function (element, vnode) {
    return this.sdPatch_0(element, vnode);
  };
  KVManager.prototype.patch_6ju63b$ = function (oldVNode, newVNode) {
    return this.sdPatch_0(oldVNode, newVNode);
  };
  KVManager.prototype.virtualize_61zpoe$ = function (html) {
    var tmp$;
    var node = this.virtualizeCache_0[html];
    if (node != null) {
      tmp$ = JSON.parse(JSON.stringify(node));
    } else {
      var newNode = this.sdVirtualize_0(html);
      this.virtualizeCache_0[html] = newNode;
      tmp$ = newNode;
    }
    return tmp$;
  };
  KVManager.$metadata$ = {kind: Kind_OBJECT, simpleName: 'KVManager', interfaces: []};
  var KVManager_instance = null;
  function KVManager_getInstance() {
    if (KVManager_instance === null) {
      new KVManager();
    }return KVManager_instance;
  }
  function AttributeSetBuilder() {
  }
  AttributeSetBuilder.prototype.add_puj7f4$ = function (name, value, callback$default) {
    if (value === void 0)
      value = name;
    callback$default ? callback$default(name, value) : this.add_puj7f4$$default(name, value);
  };
  AttributeSetBuilder.prototype.addAll_y0zsll$ = function (attributes) {
    var tmp$;
    tmp$ = attributes.entries.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.key;
      var value = element.value;
      this.add_puj7f4$(key, value);
    }
  };
  AttributeSetBuilder.prototype.add_lcqont$ = function (attribute) {
    if (attribute != null) {
      this.add_puj7f4$(attribute.attributeName, attribute.attributeValue);
    }};
  AttributeSetBuilder.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'AttributeSetBuilder', interfaces: []};
  function AttributeSetBuilderImpl() {
    this._attributes_0 = {};
  }
  Object.defineProperty(AttributeSetBuilderImpl.prototype, 'attributes', {configurable: true, get: function () {
    return Object.assign({}, this._attributes_0);
  }});
  AttributeSetBuilderImpl.prototype.add_puj7f4$$default = function (name, value) {
    this._attributes_0[name] = value;
  };
  AttributeSetBuilderImpl.$metadata$ = {kind: Kind_CLASS, simpleName: 'AttributeSetBuilderImpl', interfaces: [AttributeSetBuilder]};
  function buildAttributeSet(delegate) {
    var $receiver = new AttributeSetBuilderImpl();
    delegate($receiver);
    return $receiver.attributes;
  }
  function ClassSetBuilder() {
  }
  ClassSetBuilder.prototype.add_vqcfem$ = function (value) {
    if (value != null) {
      this.add_61zpoe$(value.className);
    }};
  ClassSetBuilder.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ClassSetBuilder', interfaces: []};
  function ClassSetBuilderImpl() {
    this._classes_0 = {};
  }
  Object.defineProperty(ClassSetBuilderImpl.prototype, 'classes', {configurable: true, get: function () {
    return Object.assign({}, this._classes_0);
  }});
  ClassSetBuilderImpl.prototype.add_61zpoe$ = function (value) {
    if (value.length > 0) {
      this._classes_0[value] = true;
    }};
  ClassSetBuilderImpl.prototype.addAll_jfy1ql$ = function (values) {
    var tmp$;
    tmp$ = values.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      this.add_61zpoe$(element);
    }
  };
  ClassSetBuilderImpl.$metadata$ = {kind: Kind_CLASS, simpleName: 'ClassSetBuilderImpl', interfaces: [ClassSetBuilder]};
  function buildClassSet(delegate) {
    var $receiver = new ClassSetBuilderImpl();
    delegate($receiver);
    return $receiver.classes;
  }
  function Component() {
  }
  Component.prototype.focus = function () {
    var tmp$;
    (tmp$ = this.getElementD()) != null ? tmp$.focus() : null;
  };
  Component.prototype.blur = function () {
    var tmp$;
    (tmp$ = this.getElementD()) != null ? tmp$.blur() : null;
  };
  Component.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Component', interfaces: []};
  function Container() {
  }
  Container.prototype.invoke_4h7hma$ = function (children) {
    return this.addAll_xquxs0$(asList(children));
  };
  Container.prototype.unaryPlus_pdl1vz$ = function ($receiver) {
    this.add_87eobz$(new TextNode($receiver));
  };
  Container.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Container', interfaces: [Component]};
  function UNIT(name, ordinal, unit) {
    Enum.call(this);
    this.unit_8be2vx$ = unit;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function UNIT_initFields() {
    UNIT_initFields = function () {
    };
    UNIT$px_instance = new UNIT('px', 0, 'px');
    UNIT$pt_instance = new UNIT('pt', 1, 'pt');
    UNIT$em_instance = new UNIT('em', 2, 'em');
    UNIT$cm_instance = new UNIT('cm', 3, 'cm');
    UNIT$mm_instance = new UNIT('mm', 4, 'mm');
    UNIT$in_instance = new UNIT('in', 5, 'in');
    UNIT$pc_instance = new UNIT('pc', 6, 'pc');
    UNIT$ch_instance = new UNIT('ch', 7, 'ch');
    UNIT$rem_instance = new UNIT('rem', 8, 'rem');
    UNIT$vw_instance = new UNIT('vw', 9, 'vw');
    UNIT$vh_instance = new UNIT('vh', 10, 'vh');
    UNIT$vmin_instance = new UNIT('vmin', 11, 'vmin');
    UNIT$vmax_instance = new UNIT('vmax', 12, 'vmax');
    UNIT$perc_instance = new UNIT('perc', 13, '%');
    UNIT$auto_instance = new UNIT('auto', 14, 'auto');
    UNIT$normal_instance = new UNIT('normal', 15, 'normal');
  }
  var UNIT$px_instance;
  function UNIT$px_getInstance() {
    UNIT_initFields();
    return UNIT$px_instance;
  }
  var UNIT$pt_instance;
  function UNIT$pt_getInstance() {
    UNIT_initFields();
    return UNIT$pt_instance;
  }
  var UNIT$em_instance;
  function UNIT$em_getInstance() {
    UNIT_initFields();
    return UNIT$em_instance;
  }
  var UNIT$cm_instance;
  function UNIT$cm_getInstance() {
    UNIT_initFields();
    return UNIT$cm_instance;
  }
  var UNIT$mm_instance;
  function UNIT$mm_getInstance() {
    UNIT_initFields();
    return UNIT$mm_instance;
  }
  var UNIT$in_instance;
  function UNIT$in_getInstance() {
    UNIT_initFields();
    return UNIT$in_instance;
  }
  var UNIT$pc_instance;
  function UNIT$pc_getInstance() {
    UNIT_initFields();
    return UNIT$pc_instance;
  }
  var UNIT$ch_instance;
  function UNIT$ch_getInstance() {
    UNIT_initFields();
    return UNIT$ch_instance;
  }
  var UNIT$rem_instance;
  function UNIT$rem_getInstance() {
    UNIT_initFields();
    return UNIT$rem_instance;
  }
  var UNIT$vw_instance;
  function UNIT$vw_getInstance() {
    UNIT_initFields();
    return UNIT$vw_instance;
  }
  var UNIT$vh_instance;
  function UNIT$vh_getInstance() {
    UNIT_initFields();
    return UNIT$vh_instance;
  }
  var UNIT$vmin_instance;
  function UNIT$vmin_getInstance() {
    UNIT_initFields();
    return UNIT$vmin_instance;
  }
  var UNIT$vmax_instance;
  function UNIT$vmax_getInstance() {
    UNIT_initFields();
    return UNIT$vmax_instance;
  }
  var UNIT$perc_instance;
  function UNIT$perc_getInstance() {
    UNIT_initFields();
    return UNIT$perc_instance;
  }
  var UNIT$auto_instance;
  function UNIT$auto_getInstance() {
    UNIT_initFields();
    return UNIT$auto_instance;
  }
  var UNIT$normal_instance;
  function UNIT$normal_getInstance() {
    UNIT_initFields();
    return UNIT$normal_instance;
  }
  UNIT.$metadata$ = {kind: Kind_CLASS, simpleName: 'UNIT', interfaces: [Enum]};
  function UNIT$values() {
    return [UNIT$px_getInstance(), UNIT$pt_getInstance(), UNIT$em_getInstance(), UNIT$cm_getInstance(), UNIT$mm_getInstance(), UNIT$in_getInstance(), UNIT$pc_getInstance(), UNIT$ch_getInstance(), UNIT$rem_getInstance(), UNIT$vw_getInstance(), UNIT$vh_getInstance(), UNIT$vmin_getInstance(), UNIT$vmax_getInstance(), UNIT$perc_getInstance(), UNIT$auto_getInstance(), UNIT$normal_getInstance()];
  }
  UNIT.values = UNIT$values;
  function UNIT$valueOf(name) {
    switch (name) {
      case 'px':
        return UNIT$px_getInstance();
      case 'pt':
        return UNIT$pt_getInstance();
      case 'em':
        return UNIT$em_getInstance();
      case 'cm':
        return UNIT$cm_getInstance();
      case 'mm':
        return UNIT$mm_getInstance();
      case 'in':
        return UNIT$in_getInstance();
      case 'pc':
        return UNIT$pc_getInstance();
      case 'ch':
        return UNIT$ch_getInstance();
      case 'rem':
        return UNIT$rem_getInstance();
      case 'vw':
        return UNIT$vw_getInstance();
      case 'vh':
        return UNIT$vh_getInstance();
      case 'vmin':
        return UNIT$vmin_getInstance();
      case 'vmax':
        return UNIT$vmax_getInstance();
      case 'perc':
        return UNIT$perc_getInstance();
      case 'auto':
        return UNIT$auto_getInstance();
      case 'normal':
        return UNIT$normal_getInstance();
      default:throwISE('No enum constant io.kvision.core.UNIT.' + name);
    }
  }
  UNIT.valueOf_61zpoe$ = UNIT$valueOf;
  var BorderStyle$NONE_instance;
  var BorderStyle$HIDDEN_instance;
  var BorderStyle$DOTTED_instance;
  var BorderStyle$DASHED_instance;
  var BorderStyle$SOLID_instance;
  var BorderStyle$DOUBLE_instance;
  var BorderStyle$GROOVE_instance;
  var BorderStyle$RIDGE_instance;
  var BorderStyle$INSET_instance;
  var BorderStyle$OUTSET_instance;
  var BorderStyle$INITIAL_instance;
  var BorderStyle$INHERIT_instance;
  var BorderStyle$UNSET_instance;
  var OutlineStyle$AUTO_instance;
  var OutlineStyle$NONE_instance;
  var OutlineStyle$HIDDEN_instance;
  var OutlineStyle$DOTTED_instance;
  var OutlineStyle$DASHED_instance;
  var OutlineStyle$SOLID_instance;
  var OutlineStyle$DOUBLE_instance;
  var OutlineStyle$GROOVE_instance;
  var OutlineStyle$RIDGE_instance;
  var OutlineStyle$INSET_instance;
  var OutlineStyle$OUTSET_instance;
  var OutlineStyle$INITIAL_instance;
  var OutlineStyle$INHERIT_instance;
  var OutlineStyle$UNSET_instance;
  function Col(name, ordinal, color) {
    Enum.call(this);
    this.color_8be2vx$ = color;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Col_initFields() {
    Col_initFields = function () {
    };
    Col$ALICEBLUE_instance = new Col('ALICEBLUE', 0, 'aliceblue');
    Col$ANTIQUEWHITE_instance = new Col('ANTIQUEWHITE', 1, 'antiquewhite');
    Col$AQUA_instance = new Col('AQUA', 2, 'aqua');
    Col$AQUAMARINE_instance = new Col('AQUAMARINE', 3, 'aquamarine');
    Col$AZURE_instance = new Col('AZURE', 4, 'azure');
    Col$BEIGE_instance = new Col('BEIGE', 5, 'beige');
    Col$BISQUE_instance = new Col('BISQUE', 6, 'bisque');
    Col$BLACK_instance = new Col('BLACK', 7, 'black');
    Col$BLANCHEDALMOND_instance = new Col('BLANCHEDALMOND', 8, 'blanchedalmond');
    Col$BLUE_instance = new Col('BLUE', 9, 'blue');
    Col$BLUEVIOLET_instance = new Col('BLUEVIOLET', 10, 'blueviolet');
    Col$BROWN_instance = new Col('BROWN', 11, 'brown');
    Col$BURLYWOOD_instance = new Col('BURLYWOOD', 12, 'burlywood');
    Col$CADETBLUE_instance = new Col('CADETBLUE', 13, 'cadetblue');
    Col$CHARTREUSE_instance = new Col('CHARTREUSE', 14, 'chartreuse');
    Col$CHOCOLATE_instance = new Col('CHOCOLATE', 15, 'chocolate');
    Col$CORAL_instance = new Col('CORAL', 16, 'coral');
    Col$CORNFLOWERBLUE_instance = new Col('CORNFLOWERBLUE', 17, 'cornflowerblue');
    Col$CORNSILK_instance = new Col('CORNSILK', 18, 'cornsilk');
    Col$CRIMSON_instance = new Col('CRIMSON', 19, 'crimson');
    Col$CYAN_instance = new Col('CYAN', 20, 'cyan');
    Col$DARKBLUE_instance = new Col('DARKBLUE', 21, 'darkblue');
    Col$DARKCYAN_instance = new Col('DARKCYAN', 22, 'darkcyan');
    Col$DARKGOLDENROD_instance = new Col('DARKGOLDENROD', 23, 'darkgoldenrod');
    Col$DARKGRAY_instance = new Col('DARKGRAY', 24, 'darkgray');
    Col$DARKGREEN_instance = new Col('DARKGREEN', 25, 'darkgreen');
    Col$DARKKHAKI_instance = new Col('DARKKHAKI', 26, 'darkkhaki');
    Col$DARKMAGENTA_instance = new Col('DARKMAGENTA', 27, 'darkmagenta');
    Col$DARKOLIVEGREEN_instance = new Col('DARKOLIVEGREEN', 28, 'darkolivegreen');
    Col$DARKORANGE_instance = new Col('DARKORANGE', 29, 'darkorange');
    Col$DARKORCHID_instance = new Col('DARKORCHID', 30, 'darkorchid');
    Col$DARKRED_instance = new Col('DARKRED', 31, 'darkred');
    Col$DARKSALMON_instance = new Col('DARKSALMON', 32, 'darksalmon');
    Col$DARKSEAGREEN_instance = new Col('DARKSEAGREEN', 33, 'darkseagreen');
    Col$DARKSLATEBLUE_instance = new Col('DARKSLATEBLUE', 34, 'darkslateblue');
    Col$DARKSLATEGRAY_instance = new Col('DARKSLATEGRAY', 35, 'darkslategray');
    Col$DARKTURQUOISE_instance = new Col('DARKTURQUOISE', 36, 'darkturquoise');
    Col$DARKVIOLET_instance = new Col('DARKVIOLET', 37, 'darkviolet');
    Col$DEEPPINK_instance = new Col('DEEPPINK', 38, 'deeppink');
    Col$DEEPSKYBLUE_instance = new Col('DEEPSKYBLUE', 39, 'deepskyblue');
    Col$DIMGRAY_instance = new Col('DIMGRAY', 40, 'dimgray');
    Col$DODGERBLUE_instance = new Col('DODGERBLUE', 41, 'dodgerblue');
    Col$FIREBRICK_instance = new Col('FIREBRICK', 42, 'firebrick');
    Col$FLORALWHITE_instance = new Col('FLORALWHITE', 43, 'floralwhite');
    Col$FORESTGREEN_instance = new Col('FORESTGREEN', 44, 'forestgreen');
    Col$FUCHSIA_instance = new Col('FUCHSIA', 45, 'fuchsia');
    Col$GAINSBORO_instance = new Col('GAINSBORO', 46, 'gainsboro');
    Col$GHOSTWHITE_instance = new Col('GHOSTWHITE', 47, 'ghostwhite');
    Col$GOLD_instance = new Col('GOLD', 48, 'gold');
    Col$GOLDENROD_instance = new Col('GOLDENROD', 49, 'goldenrod');
    Col$GRAY_instance = new Col('GRAY', 50, 'gray');
    Col$GREEN_instance = new Col('GREEN', 51, 'green');
    Col$GREENYELLOW_instance = new Col('GREENYELLOW', 52, 'greenyellow');
    Col$HONEYDEW_instance = new Col('HONEYDEW', 53, 'honeydew');
    Col$HOTPINK_instance = new Col('HOTPINK', 54, 'hotpink');
    Col$INDIANRED_instance = new Col('INDIANRED', 55, 'indianred');
    Col$INDIGO_instance = new Col('INDIGO', 56, 'indigo');
    Col$IVORY_instance = new Col('IVORY', 57, 'ivory');
    Col$KHAKI_instance = new Col('KHAKI', 58, 'khaki');
    Col$LAVENDER_instance = new Col('LAVENDER', 59, 'lavender');
    Col$LAVENDERBLUSH_instance = new Col('LAVENDERBLUSH', 60, 'lavenderblush');
    Col$LAWNGREEN_instance = new Col('LAWNGREEN', 61, 'lawngreen');
    Col$LEMONCHIFFON_instance = new Col('LEMONCHIFFON', 62, 'lemonchiffon');
    Col$LIGHTBLUE_instance = new Col('LIGHTBLUE', 63, 'lightblue');
    Col$LIGHTCORAL_instance = new Col('LIGHTCORAL', 64, 'lightcoral');
    Col$LIGHTCYAN_instance = new Col('LIGHTCYAN', 65, 'lightcyan');
    Col$LIGHTGOLDENRODYELLOW_instance = new Col('LIGHTGOLDENRODYELLOW', 66, 'lightgoldenrodyellow');
    Col$LIGHTGRAY_instance = new Col('LIGHTGRAY', 67, 'lightgray');
    Col$LIGHTGREEN_instance = new Col('LIGHTGREEN', 68, 'lightgreen');
    Col$LIGHTPINK_instance = new Col('LIGHTPINK', 69, 'lightpink');
    Col$LIGHTSALMON_instance = new Col('LIGHTSALMON', 70, 'lightsalmon');
    Col$LIGHTSEAGREEN_instance = new Col('LIGHTSEAGREEN', 71, 'lightseagreen');
    Col$LIGHTSKYBLUE_instance = new Col('LIGHTSKYBLUE', 72, 'lightskyblue');
    Col$LIGHTSLATEGRAY_instance = new Col('LIGHTSLATEGRAY', 73, 'lightslategray');
    Col$LIGHTSTEELBLUE_instance = new Col('LIGHTSTEELBLUE', 74, 'lightsteelblue');
    Col$LIGHTYELLOW_instance = new Col('LIGHTYELLOW', 75, 'lightyellow');
    Col$LIME_instance = new Col('LIME', 76, 'lime');
    Col$LIMEGREEN_instance = new Col('LIMEGREEN', 77, 'limegreen');
    Col$LINEN_instance = new Col('LINEN', 78, 'linen');
    Col$MAGENTA_instance = new Col('MAGENTA', 79, 'magenta');
    Col$MAROON_instance = new Col('MAROON', 80, 'maroon');
    Col$MEDIUMAQUAMARINE_instance = new Col('MEDIUMAQUAMARINE', 81, 'mediumaquamarine');
    Col$MEDIUMBLUE_instance = new Col('MEDIUMBLUE', 82, 'mediumblue');
    Col$MEDIUMORCHID_instance = new Col('MEDIUMORCHID', 83, 'mediumorchid');
    Col$MEDIUMPURPLE_instance = new Col('MEDIUMPURPLE', 84, 'mediumpurple');
    Col$MEDIUMSEAGREEN_instance = new Col('MEDIUMSEAGREEN', 85, 'mediumseagreen');
    Col$MEDIUMSLATEBLUE_instance = new Col('MEDIUMSLATEBLUE', 86, 'mediumslateblue');
    Col$MEDIUMSPRINGGREEN_instance = new Col('MEDIUMSPRINGGREEN', 87, 'mediumspringgreen');
    Col$MEDIUMTURQUOISE_instance = new Col('MEDIUMTURQUOISE', 88, 'mediumturquoise');
    Col$MEDIUMVIOLETRED_instance = new Col('MEDIUMVIOLETRED', 89, 'mediumvioletred');
    Col$MIDNIGHTBLUE_instance = new Col('MIDNIGHTBLUE', 90, 'midnightblue');
    Col$MINTCREAM_instance = new Col('MINTCREAM', 91, 'mintcream');
    Col$MISTYROSE_instance = new Col('MISTYROSE', 92, 'mistyrose');
    Col$MOCCASIN_instance = new Col('MOCCASIN', 93, 'moccasin');
    Col$NAVAJOWHITE_instance = new Col('NAVAJOWHITE', 94, 'navajowhite');
    Col$NAVY_instance = new Col('NAVY', 95, 'navy');
    Col$OLDLACE_instance = new Col('OLDLACE', 96, 'oldlace');
    Col$OLIVE_instance = new Col('OLIVE', 97, 'olive');
    Col$OLIVEDRAB_instance = new Col('OLIVEDRAB', 98, 'olivedrab');
    Col$ORANGE_instance = new Col('ORANGE', 99, 'orange');
    Col$ORANGERED_instance = new Col('ORANGERED', 100, 'orangered');
    Col$ORCHID_instance = new Col('ORCHID', 101, 'orchid');
    Col$PALEGOLDENROD_instance = new Col('PALEGOLDENROD', 102, 'palegoldenrod');
    Col$PALEGREEN_instance = new Col('PALEGREEN', 103, 'palegreen');
    Col$PALETURQUOISE_instance = new Col('PALETURQUOISE', 104, 'paleturquoise');
    Col$PALEVIOLETRED_instance = new Col('PALEVIOLETRED', 105, 'palevioletred');
    Col$PAPAYAWHIP_instance = new Col('PAPAYAWHIP', 106, 'papayawhip');
    Col$PEACHPUFF_instance = new Col('PEACHPUFF', 107, 'peachpuff');
    Col$PERU_instance = new Col('PERU', 108, 'peru');
    Col$PINK_instance = new Col('PINK', 109, 'pink');
    Col$PLUM_instance = new Col('PLUM', 110, 'plum');
    Col$POWDERBLUE_instance = new Col('POWDERBLUE', 111, 'powderblue');
    Col$PURPLE_instance = new Col('PURPLE', 112, 'purple');
    Col$REBECCAPURPLE_instance = new Col('REBECCAPURPLE', 113, 'rebeccapurple');
    Col$RED_instance = new Col('RED', 114, 'red');
    Col$ROSYBROWN_instance = new Col('ROSYBROWN', 115, 'rosybrown');
    Col$ROYALBLUE_instance = new Col('ROYALBLUE', 116, 'royalblue');
    Col$SADDLEBROWN_instance = new Col('SADDLEBROWN', 117, 'saddlebrown');
    Col$SALMON_instance = new Col('SALMON', 118, 'salmon');
    Col$SANDYBROWN_instance = new Col('SANDYBROWN', 119, 'sandybrown');
    Col$SEAGREEN_instance = new Col('SEAGREEN', 120, 'seagreen');
    Col$SEASHELL_instance = new Col('SEASHELL', 121, 'seashell');
    Col$SIENNA_instance = new Col('SIENNA', 122, 'sienna');
    Col$SILVER_instance = new Col('SILVER', 123, 'silver');
    Col$SKYBLUE_instance = new Col('SKYBLUE', 124, 'skyblue');
    Col$SLATEBLUE_instance = new Col('SLATEBLUE', 125, 'slateblue');
    Col$SLATEGRAY_instance = new Col('SLATEGRAY', 126, 'slategray');
    Col$SNOW_instance = new Col('SNOW', 127, 'snow');
    Col$SPRINGGREEN_instance = new Col('SPRINGGREEN', 128, 'springgreen');
    Col$STEELBLUE_instance = new Col('STEELBLUE', 129, 'steelblue');
    Col$TAN_instance = new Col('TAN', 130, 'tan');
    Col$TEAL_instance = new Col('TEAL', 131, 'teal');
    Col$THISTLE_instance = new Col('THISTLE', 132, 'thistle');
    Col$TOMATO_instance = new Col('TOMATO', 133, 'tomato');
    Col$TURQUOISE_instance = new Col('TURQUOISE', 134, 'turquoise');
    Col$VIOLET_instance = new Col('VIOLET', 135, 'violet');
    Col$WHEAT_instance = new Col('WHEAT', 136, 'wheat');
    Col$WHITE_instance = new Col('WHITE', 137, 'white');
    Col$WHITESMOKE_instance = new Col('WHITESMOKE', 138, 'whitesmoke');
    Col$YELLOW_instance = new Col('YELLOW', 139, 'yellow');
    Col$YELLOWGREEN_instance = new Col('YELLOWGREEN', 140, 'yellowgreen');
  }
  var Col$ALICEBLUE_instance;
  function Col$ALICEBLUE_getInstance() {
    Col_initFields();
    return Col$ALICEBLUE_instance;
  }
  var Col$ANTIQUEWHITE_instance;
  function Col$ANTIQUEWHITE_getInstance() {
    Col_initFields();
    return Col$ANTIQUEWHITE_instance;
  }
  var Col$AQUA_instance;
  function Col$AQUA_getInstance() {
    Col_initFields();
    return Col$AQUA_instance;
  }
  var Col$AQUAMARINE_instance;
  function Col$AQUAMARINE_getInstance() {
    Col_initFields();
    return Col$AQUAMARINE_instance;
  }
  var Col$AZURE_instance;
  function Col$AZURE_getInstance() {
    Col_initFields();
    return Col$AZURE_instance;
  }
  var Col$BEIGE_instance;
  function Col$BEIGE_getInstance() {
    Col_initFields();
    return Col$BEIGE_instance;
  }
  var Col$BISQUE_instance;
  function Col$BISQUE_getInstance() {
    Col_initFields();
    return Col$BISQUE_instance;
  }
  var Col$BLACK_instance;
  function Col$BLACK_getInstance() {
    Col_initFields();
    return Col$BLACK_instance;
  }
  var Col$BLANCHEDALMOND_instance;
  function Col$BLANCHEDALMOND_getInstance() {
    Col_initFields();
    return Col$BLANCHEDALMOND_instance;
  }
  var Col$BLUE_instance;
  function Col$BLUE_getInstance() {
    Col_initFields();
    return Col$BLUE_instance;
  }
  var Col$BLUEVIOLET_instance;
  function Col$BLUEVIOLET_getInstance() {
    Col_initFields();
    return Col$BLUEVIOLET_instance;
  }
  var Col$BROWN_instance;
  function Col$BROWN_getInstance() {
    Col_initFields();
    return Col$BROWN_instance;
  }
  var Col$BURLYWOOD_instance;
  function Col$BURLYWOOD_getInstance() {
    Col_initFields();
    return Col$BURLYWOOD_instance;
  }
  var Col$CADETBLUE_instance;
  function Col$CADETBLUE_getInstance() {
    Col_initFields();
    return Col$CADETBLUE_instance;
  }
  var Col$CHARTREUSE_instance;
  function Col$CHARTREUSE_getInstance() {
    Col_initFields();
    return Col$CHARTREUSE_instance;
  }
  var Col$CHOCOLATE_instance;
  function Col$CHOCOLATE_getInstance() {
    Col_initFields();
    return Col$CHOCOLATE_instance;
  }
  var Col$CORAL_instance;
  function Col$CORAL_getInstance() {
    Col_initFields();
    return Col$CORAL_instance;
  }
  var Col$CORNFLOWERBLUE_instance;
  function Col$CORNFLOWERBLUE_getInstance() {
    Col_initFields();
    return Col$CORNFLOWERBLUE_instance;
  }
  var Col$CORNSILK_instance;
  function Col$CORNSILK_getInstance() {
    Col_initFields();
    return Col$CORNSILK_instance;
  }
  var Col$CRIMSON_instance;
  function Col$CRIMSON_getInstance() {
    Col_initFields();
    return Col$CRIMSON_instance;
  }
  var Col$CYAN_instance;
  function Col$CYAN_getInstance() {
    Col_initFields();
    return Col$CYAN_instance;
  }
  var Col$DARKBLUE_instance;
  function Col$DARKBLUE_getInstance() {
    Col_initFields();
    return Col$DARKBLUE_instance;
  }
  var Col$DARKCYAN_instance;
  function Col$DARKCYAN_getInstance() {
    Col_initFields();
    return Col$DARKCYAN_instance;
  }
  var Col$DARKGOLDENROD_instance;
  function Col$DARKGOLDENROD_getInstance() {
    Col_initFields();
    return Col$DARKGOLDENROD_instance;
  }
  var Col$DARKGRAY_instance;
  function Col$DARKGRAY_getInstance() {
    Col_initFields();
    return Col$DARKGRAY_instance;
  }
  var Col$DARKGREEN_instance;
  function Col$DARKGREEN_getInstance() {
    Col_initFields();
    return Col$DARKGREEN_instance;
  }
  var Col$DARKKHAKI_instance;
  function Col$DARKKHAKI_getInstance() {
    Col_initFields();
    return Col$DARKKHAKI_instance;
  }
  var Col$DARKMAGENTA_instance;
  function Col$DARKMAGENTA_getInstance() {
    Col_initFields();
    return Col$DARKMAGENTA_instance;
  }
  var Col$DARKOLIVEGREEN_instance;
  function Col$DARKOLIVEGREEN_getInstance() {
    Col_initFields();
    return Col$DARKOLIVEGREEN_instance;
  }
  var Col$DARKORANGE_instance;
  function Col$DARKORANGE_getInstance() {
    Col_initFields();
    return Col$DARKORANGE_instance;
  }
  var Col$DARKORCHID_instance;
  function Col$DARKORCHID_getInstance() {
    Col_initFields();
    return Col$DARKORCHID_instance;
  }
  var Col$DARKRED_instance;
  function Col$DARKRED_getInstance() {
    Col_initFields();
    return Col$DARKRED_instance;
  }
  var Col$DARKSALMON_instance;
  function Col$DARKSALMON_getInstance() {
    Col_initFields();
    return Col$DARKSALMON_instance;
  }
  var Col$DARKSEAGREEN_instance;
  function Col$DARKSEAGREEN_getInstance() {
    Col_initFields();
    return Col$DARKSEAGREEN_instance;
  }
  var Col$DARKSLATEBLUE_instance;
  function Col$DARKSLATEBLUE_getInstance() {
    Col_initFields();
    return Col$DARKSLATEBLUE_instance;
  }
  var Col$DARKSLATEGRAY_instance;
  function Col$DARKSLATEGRAY_getInstance() {
    Col_initFields();
    return Col$DARKSLATEGRAY_instance;
  }
  var Col$DARKTURQUOISE_instance;
  function Col$DARKTURQUOISE_getInstance() {
    Col_initFields();
    return Col$DARKTURQUOISE_instance;
  }
  var Col$DARKVIOLET_instance;
  function Col$DARKVIOLET_getInstance() {
    Col_initFields();
    return Col$DARKVIOLET_instance;
  }
  var Col$DEEPPINK_instance;
  function Col$DEEPPINK_getInstance() {
    Col_initFields();
    return Col$DEEPPINK_instance;
  }
  var Col$DEEPSKYBLUE_instance;
  function Col$DEEPSKYBLUE_getInstance() {
    Col_initFields();
    return Col$DEEPSKYBLUE_instance;
  }
  var Col$DIMGRAY_instance;
  function Col$DIMGRAY_getInstance() {
    Col_initFields();
    return Col$DIMGRAY_instance;
  }
  var Col$DODGERBLUE_instance;
  function Col$DODGERBLUE_getInstance() {
    Col_initFields();
    return Col$DODGERBLUE_instance;
  }
  var Col$FIREBRICK_instance;
  function Col$FIREBRICK_getInstance() {
    Col_initFields();
    return Col$FIREBRICK_instance;
  }
  var Col$FLORALWHITE_instance;
  function Col$FLORALWHITE_getInstance() {
    Col_initFields();
    return Col$FLORALWHITE_instance;
  }
  var Col$FORESTGREEN_instance;
  function Col$FORESTGREEN_getInstance() {
    Col_initFields();
    return Col$FORESTGREEN_instance;
  }
  var Col$FUCHSIA_instance;
  function Col$FUCHSIA_getInstance() {
    Col_initFields();
    return Col$FUCHSIA_instance;
  }
  var Col$GAINSBORO_instance;
  function Col$GAINSBORO_getInstance() {
    Col_initFields();
    return Col$GAINSBORO_instance;
  }
  var Col$GHOSTWHITE_instance;
  function Col$GHOSTWHITE_getInstance() {
    Col_initFields();
    return Col$GHOSTWHITE_instance;
  }
  var Col$GOLD_instance;
  function Col$GOLD_getInstance() {
    Col_initFields();
    return Col$GOLD_instance;
  }
  var Col$GOLDENROD_instance;
  function Col$GOLDENROD_getInstance() {
    Col_initFields();
    return Col$GOLDENROD_instance;
  }
  var Col$GRAY_instance;
  function Col$GRAY_getInstance() {
    Col_initFields();
    return Col$GRAY_instance;
  }
  var Col$GREEN_instance;
  function Col$GREEN_getInstance() {
    Col_initFields();
    return Col$GREEN_instance;
  }
  var Col$GREENYELLOW_instance;
  function Col$GREENYELLOW_getInstance() {
    Col_initFields();
    return Col$GREENYELLOW_instance;
  }
  var Col$HONEYDEW_instance;
  function Col$HONEYDEW_getInstance() {
    Col_initFields();
    return Col$HONEYDEW_instance;
  }
  var Col$HOTPINK_instance;
  function Col$HOTPINK_getInstance() {
    Col_initFields();
    return Col$HOTPINK_instance;
  }
  var Col$INDIANRED_instance;
  function Col$INDIANRED_getInstance() {
    Col_initFields();
    return Col$INDIANRED_instance;
  }
  var Col$INDIGO_instance;
  function Col$INDIGO_getInstance() {
    Col_initFields();
    return Col$INDIGO_instance;
  }
  var Col$IVORY_instance;
  function Col$IVORY_getInstance() {
    Col_initFields();
    return Col$IVORY_instance;
  }
  var Col$KHAKI_instance;
  function Col$KHAKI_getInstance() {
    Col_initFields();
    return Col$KHAKI_instance;
  }
  var Col$LAVENDER_instance;
  function Col$LAVENDER_getInstance() {
    Col_initFields();
    return Col$LAVENDER_instance;
  }
  var Col$LAVENDERBLUSH_instance;
  function Col$LAVENDERBLUSH_getInstance() {
    Col_initFields();
    return Col$LAVENDERBLUSH_instance;
  }
  var Col$LAWNGREEN_instance;
  function Col$LAWNGREEN_getInstance() {
    Col_initFields();
    return Col$LAWNGREEN_instance;
  }
  var Col$LEMONCHIFFON_instance;
  function Col$LEMONCHIFFON_getInstance() {
    Col_initFields();
    return Col$LEMONCHIFFON_instance;
  }
  var Col$LIGHTBLUE_instance;
  function Col$LIGHTBLUE_getInstance() {
    Col_initFields();
    return Col$LIGHTBLUE_instance;
  }
  var Col$LIGHTCORAL_instance;
  function Col$LIGHTCORAL_getInstance() {
    Col_initFields();
    return Col$LIGHTCORAL_instance;
  }
  var Col$LIGHTCYAN_instance;
  function Col$LIGHTCYAN_getInstance() {
    Col_initFields();
    return Col$LIGHTCYAN_instance;
  }
  var Col$LIGHTGOLDENRODYELLOW_instance;
  function Col$LIGHTGOLDENRODYELLOW_getInstance() {
    Col_initFields();
    return Col$LIGHTGOLDENRODYELLOW_instance;
  }
  var Col$LIGHTGRAY_instance;
  function Col$LIGHTGRAY_getInstance() {
    Col_initFields();
    return Col$LIGHTGRAY_instance;
  }
  var Col$LIGHTGREEN_instance;
  function Col$LIGHTGREEN_getInstance() {
    Col_initFields();
    return Col$LIGHTGREEN_instance;
  }
  var Col$LIGHTPINK_instance;
  function Col$LIGHTPINK_getInstance() {
    Col_initFields();
    return Col$LIGHTPINK_instance;
  }
  var Col$LIGHTSALMON_instance;
  function Col$LIGHTSALMON_getInstance() {
    Col_initFields();
    return Col$LIGHTSALMON_instance;
  }
  var Col$LIGHTSEAGREEN_instance;
  function Col$LIGHTSEAGREEN_getInstance() {
    Col_initFields();
    return Col$LIGHTSEAGREEN_instance;
  }
  var Col$LIGHTSKYBLUE_instance;
  function Col$LIGHTSKYBLUE_getInstance() {
    Col_initFields();
    return Col$LIGHTSKYBLUE_instance;
  }
  var Col$LIGHTSLATEGRAY_instance;
  function Col$LIGHTSLATEGRAY_getInstance() {
    Col_initFields();
    return Col$LIGHTSLATEGRAY_instance;
  }
  var Col$LIGHTSTEELBLUE_instance;
  function Col$LIGHTSTEELBLUE_getInstance() {
    Col_initFields();
    return Col$LIGHTSTEELBLUE_instance;
  }
  var Col$LIGHTYELLOW_instance;
  function Col$LIGHTYELLOW_getInstance() {
    Col_initFields();
    return Col$LIGHTYELLOW_instance;
  }
  var Col$LIME_instance;
  function Col$LIME_getInstance() {
    Col_initFields();
    return Col$LIME_instance;
  }
  var Col$LIMEGREEN_instance;
  function Col$LIMEGREEN_getInstance() {
    Col_initFields();
    return Col$LIMEGREEN_instance;
  }
  var Col$LINEN_instance;
  function Col$LINEN_getInstance() {
    Col_initFields();
    return Col$LINEN_instance;
  }
  var Col$MAGENTA_instance;
  function Col$MAGENTA_getInstance() {
    Col_initFields();
    return Col$MAGENTA_instance;
  }
  var Col$MAROON_instance;
  function Col$MAROON_getInstance() {
    Col_initFields();
    return Col$MAROON_instance;
  }
  var Col$MEDIUMAQUAMARINE_instance;
  function Col$MEDIUMAQUAMARINE_getInstance() {
    Col_initFields();
    return Col$MEDIUMAQUAMARINE_instance;
  }
  var Col$MEDIUMBLUE_instance;
  function Col$MEDIUMBLUE_getInstance() {
    Col_initFields();
    return Col$MEDIUMBLUE_instance;
  }
  var Col$MEDIUMORCHID_instance;
  function Col$MEDIUMORCHID_getInstance() {
    Col_initFields();
    return Col$MEDIUMORCHID_instance;
  }
  var Col$MEDIUMPURPLE_instance;
  function Col$MEDIUMPURPLE_getInstance() {
    Col_initFields();
    return Col$MEDIUMPURPLE_instance;
  }
  var Col$MEDIUMSEAGREEN_instance;
  function Col$MEDIUMSEAGREEN_getInstance() {
    Col_initFields();
    return Col$MEDIUMSEAGREEN_instance;
  }
  var Col$MEDIUMSLATEBLUE_instance;
  function Col$MEDIUMSLATEBLUE_getInstance() {
    Col_initFields();
    return Col$MEDIUMSLATEBLUE_instance;
  }
  var Col$MEDIUMSPRINGGREEN_instance;
  function Col$MEDIUMSPRINGGREEN_getInstance() {
    Col_initFields();
    return Col$MEDIUMSPRINGGREEN_instance;
  }
  var Col$MEDIUMTURQUOISE_instance;
  function Col$MEDIUMTURQUOISE_getInstance() {
    Col_initFields();
    return Col$MEDIUMTURQUOISE_instance;
  }
  var Col$MEDIUMVIOLETRED_instance;
  function Col$MEDIUMVIOLETRED_getInstance() {
    Col_initFields();
    return Col$MEDIUMVIOLETRED_instance;
  }
  var Col$MIDNIGHTBLUE_instance;
  function Col$MIDNIGHTBLUE_getInstance() {
    Col_initFields();
    return Col$MIDNIGHTBLUE_instance;
  }
  var Col$MINTCREAM_instance;
  function Col$MINTCREAM_getInstance() {
    Col_initFields();
    return Col$MINTCREAM_instance;
  }
  var Col$MISTYROSE_instance;
  function Col$MISTYROSE_getInstance() {
    Col_initFields();
    return Col$MISTYROSE_instance;
  }
  var Col$MOCCASIN_instance;
  function Col$MOCCASIN_getInstance() {
    Col_initFields();
    return Col$MOCCASIN_instance;
  }
  var Col$NAVAJOWHITE_instance;
  function Col$NAVAJOWHITE_getInstance() {
    Col_initFields();
    return Col$NAVAJOWHITE_instance;
  }
  var Col$NAVY_instance;
  function Col$NAVY_getInstance() {
    Col_initFields();
    return Col$NAVY_instance;
  }
  var Col$OLDLACE_instance;
  function Col$OLDLACE_getInstance() {
    Col_initFields();
    return Col$OLDLACE_instance;
  }
  var Col$OLIVE_instance;
  function Col$OLIVE_getInstance() {
    Col_initFields();
    return Col$OLIVE_instance;
  }
  var Col$OLIVEDRAB_instance;
  function Col$OLIVEDRAB_getInstance() {
    Col_initFields();
    return Col$OLIVEDRAB_instance;
  }
  var Col$ORANGE_instance;
  function Col$ORANGE_getInstance() {
    Col_initFields();
    return Col$ORANGE_instance;
  }
  var Col$ORANGERED_instance;
  function Col$ORANGERED_getInstance() {
    Col_initFields();
    return Col$ORANGERED_instance;
  }
  var Col$ORCHID_instance;
  function Col$ORCHID_getInstance() {
    Col_initFields();
    return Col$ORCHID_instance;
  }
  var Col$PALEGOLDENROD_instance;
  function Col$PALEGOLDENROD_getInstance() {
    Col_initFields();
    return Col$PALEGOLDENROD_instance;
  }
  var Col$PALEGREEN_instance;
  function Col$PALEGREEN_getInstance() {
    Col_initFields();
    return Col$PALEGREEN_instance;
  }
  var Col$PALETURQUOISE_instance;
  function Col$PALETURQUOISE_getInstance() {
    Col_initFields();
    return Col$PALETURQUOISE_instance;
  }
  var Col$PALEVIOLETRED_instance;
  function Col$PALEVIOLETRED_getInstance() {
    Col_initFields();
    return Col$PALEVIOLETRED_instance;
  }
  var Col$PAPAYAWHIP_instance;
  function Col$PAPAYAWHIP_getInstance() {
    Col_initFields();
    return Col$PAPAYAWHIP_instance;
  }
  var Col$PEACHPUFF_instance;
  function Col$PEACHPUFF_getInstance() {
    Col_initFields();
    return Col$PEACHPUFF_instance;
  }
  var Col$PERU_instance;
  function Col$PERU_getInstance() {
    Col_initFields();
    return Col$PERU_instance;
  }
  var Col$PINK_instance;
  function Col$PINK_getInstance() {
    Col_initFields();
    return Col$PINK_instance;
  }
  var Col$PLUM_instance;
  function Col$PLUM_getInstance() {
    Col_initFields();
    return Col$PLUM_instance;
  }
  var Col$POWDERBLUE_instance;
  function Col$POWDERBLUE_getInstance() {
    Col_initFields();
    return Col$POWDERBLUE_instance;
  }
  var Col$PURPLE_instance;
  function Col$PURPLE_getInstance() {
    Col_initFields();
    return Col$PURPLE_instance;
  }
  var Col$REBECCAPURPLE_instance;
  function Col$REBECCAPURPLE_getInstance() {
    Col_initFields();
    return Col$REBECCAPURPLE_instance;
  }
  var Col$RED_instance;
  function Col$RED_getInstance() {
    Col_initFields();
    return Col$RED_instance;
  }
  var Col$ROSYBROWN_instance;
  function Col$ROSYBROWN_getInstance() {
    Col_initFields();
    return Col$ROSYBROWN_instance;
  }
  var Col$ROYALBLUE_instance;
  function Col$ROYALBLUE_getInstance() {
    Col_initFields();
    return Col$ROYALBLUE_instance;
  }
  var Col$SADDLEBROWN_instance;
  function Col$SADDLEBROWN_getInstance() {
    Col_initFields();
    return Col$SADDLEBROWN_instance;
  }
  var Col$SALMON_instance;
  function Col$SALMON_getInstance() {
    Col_initFields();
    return Col$SALMON_instance;
  }
  var Col$SANDYBROWN_instance;
  function Col$SANDYBROWN_getInstance() {
    Col_initFields();
    return Col$SANDYBROWN_instance;
  }
  var Col$SEAGREEN_instance;
  function Col$SEAGREEN_getInstance() {
    Col_initFields();
    return Col$SEAGREEN_instance;
  }
  var Col$SEASHELL_instance;
  function Col$SEASHELL_getInstance() {
    Col_initFields();
    return Col$SEASHELL_instance;
  }
  var Col$SIENNA_instance;
  function Col$SIENNA_getInstance() {
    Col_initFields();
    return Col$SIENNA_instance;
  }
  var Col$SILVER_instance;
  function Col$SILVER_getInstance() {
    Col_initFields();
    return Col$SILVER_instance;
  }
  var Col$SKYBLUE_instance;
  function Col$SKYBLUE_getInstance() {
    Col_initFields();
    return Col$SKYBLUE_instance;
  }
  var Col$SLATEBLUE_instance;
  function Col$SLATEBLUE_getInstance() {
    Col_initFields();
    return Col$SLATEBLUE_instance;
  }
  var Col$SLATEGRAY_instance;
  function Col$SLATEGRAY_getInstance() {
    Col_initFields();
    return Col$SLATEGRAY_instance;
  }
  var Col$SNOW_instance;
  function Col$SNOW_getInstance() {
    Col_initFields();
    return Col$SNOW_instance;
  }
  var Col$SPRINGGREEN_instance;
  function Col$SPRINGGREEN_getInstance() {
    Col_initFields();
    return Col$SPRINGGREEN_instance;
  }
  var Col$STEELBLUE_instance;
  function Col$STEELBLUE_getInstance() {
    Col_initFields();
    return Col$STEELBLUE_instance;
  }
  var Col$TAN_instance;
  function Col$TAN_getInstance() {
    Col_initFields();
    return Col$TAN_instance;
  }
  var Col$TEAL_instance;
  function Col$TEAL_getInstance() {
    Col_initFields();
    return Col$TEAL_instance;
  }
  var Col$THISTLE_instance;
  function Col$THISTLE_getInstance() {
    Col_initFields();
    return Col$THISTLE_instance;
  }
  var Col$TOMATO_instance;
  function Col$TOMATO_getInstance() {
    Col_initFields();
    return Col$TOMATO_instance;
  }
  var Col$TURQUOISE_instance;
  function Col$TURQUOISE_getInstance() {
    Col_initFields();
    return Col$TURQUOISE_instance;
  }
  var Col$VIOLET_instance;
  function Col$VIOLET_getInstance() {
    Col_initFields();
    return Col$VIOLET_instance;
  }
  var Col$WHEAT_instance;
  function Col$WHEAT_getInstance() {
    Col_initFields();
    return Col$WHEAT_instance;
  }
  var Col$WHITE_instance;
  function Col$WHITE_getInstance() {
    Col_initFields();
    return Col$WHITE_instance;
  }
  var Col$WHITESMOKE_instance;
  function Col$WHITESMOKE_getInstance() {
    Col_initFields();
    return Col$WHITESMOKE_instance;
  }
  var Col$YELLOW_instance;
  function Col$YELLOW_getInstance() {
    Col_initFields();
    return Col$YELLOW_instance;
  }
  var Col$YELLOWGREEN_instance;
  function Col$YELLOWGREEN_getInstance() {
    Col_initFields();
    return Col$YELLOWGREEN_instance;
  }
  Col.$metadata$ = {kind: Kind_CLASS, simpleName: 'Col', interfaces: [Enum]};
  function Col$values() {
    return [Col$ALICEBLUE_getInstance(), Col$ANTIQUEWHITE_getInstance(), Col$AQUA_getInstance(), Col$AQUAMARINE_getInstance(), Col$AZURE_getInstance(), Col$BEIGE_getInstance(), Col$BISQUE_getInstance(), Col$BLACK_getInstance(), Col$BLANCHEDALMOND_getInstance(), Col$BLUE_getInstance(), Col$BLUEVIOLET_getInstance(), Col$BROWN_getInstance(), Col$BURLYWOOD_getInstance(), Col$CADETBLUE_getInstance(), Col$CHARTREUSE_getInstance(), Col$CHOCOLATE_getInstance(), Col$CORAL_getInstance(), Col$CORNFLOWERBLUE_getInstance(), Col$CORNSILK_getInstance(), Col$CRIMSON_getInstance(), Col$CYAN_getInstance(), Col$DARKBLUE_getInstance(), Col$DARKCYAN_getInstance(), Col$DARKGOLDENROD_getInstance(), Col$DARKGRAY_getInstance(), Col$DARKGREEN_getInstance(), Col$DARKKHAKI_getInstance(), Col$DARKMAGENTA_getInstance(), Col$DARKOLIVEGREEN_getInstance(), Col$DARKORANGE_getInstance(), Col$DARKORCHID_getInstance(), Col$DARKRED_getInstance(), Col$DARKSALMON_getInstance(), Col$DARKSEAGREEN_getInstance(), Col$DARKSLATEBLUE_getInstance(), Col$DARKSLATEGRAY_getInstance(), Col$DARKTURQUOISE_getInstance(), Col$DARKVIOLET_getInstance(), Col$DEEPPINK_getInstance(), Col$DEEPSKYBLUE_getInstance(), Col$DIMGRAY_getInstance(), Col$DODGERBLUE_getInstance(), Col$FIREBRICK_getInstance(), Col$FLORALWHITE_getInstance(), Col$FORESTGREEN_getInstance(), Col$FUCHSIA_getInstance(), Col$GAINSBORO_getInstance(), Col$GHOSTWHITE_getInstance(), Col$GOLD_getInstance(), Col$GOLDENROD_getInstance(), Col$GRAY_getInstance(), Col$GREEN_getInstance(), Col$GREENYELLOW_getInstance(), Col$HONEYDEW_getInstance(), Col$HOTPINK_getInstance(), Col$INDIANRED_getInstance(), Col$INDIGO_getInstance(), Col$IVORY_getInstance(), Col$KHAKI_getInstance(), Col$LAVENDER_getInstance(), Col$LAVENDERBLUSH_getInstance(), Col$LAWNGREEN_getInstance(), Col$LEMONCHIFFON_getInstance(), Col$LIGHTBLUE_getInstance(), Col$LIGHTCORAL_getInstance(), Col$LIGHTCYAN_getInstance(), Col$LIGHTGOLDENRODYELLOW_getInstance(), Col$LIGHTGRAY_getInstance(), Col$LIGHTGREEN_getInstance(), Col$LIGHTPINK_getInstance(), Col$LIGHTSALMON_getInstance(), Col$LIGHTSEAGREEN_getInstance(), Col$LIGHTSKYBLUE_getInstance(), Col$LIGHTSLATEGRAY_getInstance(), Col$LIGHTSTEELBLUE_getInstance(), Col$LIGHTYELLOW_getInstance(), Col$LIME_getInstance(), Col$LIMEGREEN_getInstance(), Col$LINEN_getInstance(), Col$MAGENTA_getInstance(), Col$MAROON_getInstance(), Col$MEDIUMAQUAMARINE_getInstance(), Col$MEDIUMBLUE_getInstance(), Col$MEDIUMORCHID_getInstance(), Col$MEDIUMPURPLE_getInstance(), Col$MEDIUMSEAGREEN_getInstance(), Col$MEDIUMSLATEBLUE_getInstance(), Col$MEDIUMSPRINGGREEN_getInstance(), Col$MEDIUMTURQUOISE_getInstance(), Col$MEDIUMVIOLETRED_getInstance(), Col$MIDNIGHTBLUE_getInstance(), Col$MINTCREAM_getInstance(), Col$MISTYROSE_getInstance(), Col$MOCCASIN_getInstance(), Col$NAVAJOWHITE_getInstance(), Col$NAVY_getInstance(), Col$OLDLACE_getInstance(), Col$OLIVE_getInstance(), Col$OLIVEDRAB_getInstance(), Col$ORANGE_getInstance(), Col$ORANGERED_getInstance(), Col$ORCHID_getInstance(), Col$PALEGOLDENROD_getInstance(), Col$PALEGREEN_getInstance(), Col$PALETURQUOISE_getInstance(), Col$PALEVIOLETRED_getInstance(), Col$PAPAYAWHIP_getInstance(), Col$PEACHPUFF_getInstance(), Col$PERU_getInstance(), Col$PINK_getInstance(), Col$PLUM_getInstance(), Col$POWDERBLUE_getInstance(), Col$PURPLE_getInstance(), Col$REBECCAPURPLE_getInstance(), Col$RED_getInstance(), Col$ROSYBROWN_getInstance(), Col$ROYALBLUE_getInstance(), Col$SADDLEBROWN_getInstance(), Col$SALMON_getInstance(), Col$SANDYBROWN_getInstance(), Col$SEAGREEN_getInstance(), Col$SEASHELL_getInstance(), Col$SIENNA_getInstance(), Col$SILVER_getInstance(), Col$SKYBLUE_getInstance(), Col$SLATEBLUE_getInstance(), Col$SLATEGRAY_getInstance(), Col$SNOW_getInstance(), Col$SPRINGGREEN_getInstance(), Col$STEELBLUE_getInstance(), Col$TAN_getInstance(), Col$TEAL_getInstance(), Col$THISTLE_getInstance(), Col$TOMATO_getInstance(), Col$TURQUOISE_getInstance(), Col$VIOLET_getInstance(), Col$WHEAT_getInstance(), Col$WHITE_getInstance(), Col$WHITESMOKE_getInstance(), Col$YELLOW_getInstance(), Col$YELLOWGREEN_getInstance()];
  }
  Col.values = Col$values;
  function Col$valueOf(name) {
    switch (name) {
      case 'ALICEBLUE':
        return Col$ALICEBLUE_getInstance();
      case 'ANTIQUEWHITE':
        return Col$ANTIQUEWHITE_getInstance();
      case 'AQUA':
        return Col$AQUA_getInstance();
      case 'AQUAMARINE':
        return Col$AQUAMARINE_getInstance();
      case 'AZURE':
        return Col$AZURE_getInstance();
      case 'BEIGE':
        return Col$BEIGE_getInstance();
      case 'BISQUE':
        return Col$BISQUE_getInstance();
      case 'BLACK':
        return Col$BLACK_getInstance();
      case 'BLANCHEDALMOND':
        return Col$BLANCHEDALMOND_getInstance();
      case 'BLUE':
        return Col$BLUE_getInstance();
      case 'BLUEVIOLET':
        return Col$BLUEVIOLET_getInstance();
      case 'BROWN':
        return Col$BROWN_getInstance();
      case 'BURLYWOOD':
        return Col$BURLYWOOD_getInstance();
      case 'CADETBLUE':
        return Col$CADETBLUE_getInstance();
      case 'CHARTREUSE':
        return Col$CHARTREUSE_getInstance();
      case 'CHOCOLATE':
        return Col$CHOCOLATE_getInstance();
      case 'CORAL':
        return Col$CORAL_getInstance();
      case 'CORNFLOWERBLUE':
        return Col$CORNFLOWERBLUE_getInstance();
      case 'CORNSILK':
        return Col$CORNSILK_getInstance();
      case 'CRIMSON':
        return Col$CRIMSON_getInstance();
      case 'CYAN':
        return Col$CYAN_getInstance();
      case 'DARKBLUE':
        return Col$DARKBLUE_getInstance();
      case 'DARKCYAN':
        return Col$DARKCYAN_getInstance();
      case 'DARKGOLDENROD':
        return Col$DARKGOLDENROD_getInstance();
      case 'DARKGRAY':
        return Col$DARKGRAY_getInstance();
      case 'DARKGREEN':
        return Col$DARKGREEN_getInstance();
      case 'DARKKHAKI':
        return Col$DARKKHAKI_getInstance();
      case 'DARKMAGENTA':
        return Col$DARKMAGENTA_getInstance();
      case 'DARKOLIVEGREEN':
        return Col$DARKOLIVEGREEN_getInstance();
      case 'DARKORANGE':
        return Col$DARKORANGE_getInstance();
      case 'DARKORCHID':
        return Col$DARKORCHID_getInstance();
      case 'DARKRED':
        return Col$DARKRED_getInstance();
      case 'DARKSALMON':
        return Col$DARKSALMON_getInstance();
      case 'DARKSEAGREEN':
        return Col$DARKSEAGREEN_getInstance();
      case 'DARKSLATEBLUE':
        return Col$DARKSLATEBLUE_getInstance();
      case 'DARKSLATEGRAY':
        return Col$DARKSLATEGRAY_getInstance();
      case 'DARKTURQUOISE':
        return Col$DARKTURQUOISE_getInstance();
      case 'DARKVIOLET':
        return Col$DARKVIOLET_getInstance();
      case 'DEEPPINK':
        return Col$DEEPPINK_getInstance();
      case 'DEEPSKYBLUE':
        return Col$DEEPSKYBLUE_getInstance();
      case 'DIMGRAY':
        return Col$DIMGRAY_getInstance();
      case 'DODGERBLUE':
        return Col$DODGERBLUE_getInstance();
      case 'FIREBRICK':
        return Col$FIREBRICK_getInstance();
      case 'FLORALWHITE':
        return Col$FLORALWHITE_getInstance();
      case 'FORESTGREEN':
        return Col$FORESTGREEN_getInstance();
      case 'FUCHSIA':
        return Col$FUCHSIA_getInstance();
      case 'GAINSBORO':
        return Col$GAINSBORO_getInstance();
      case 'GHOSTWHITE':
        return Col$GHOSTWHITE_getInstance();
      case 'GOLD':
        return Col$GOLD_getInstance();
      case 'GOLDENROD':
        return Col$GOLDENROD_getInstance();
      case 'GRAY':
        return Col$GRAY_getInstance();
      case 'GREEN':
        return Col$GREEN_getInstance();
      case 'GREENYELLOW':
        return Col$GREENYELLOW_getInstance();
      case 'HONEYDEW':
        return Col$HONEYDEW_getInstance();
      case 'HOTPINK':
        return Col$HOTPINK_getInstance();
      case 'INDIANRED':
        return Col$INDIANRED_getInstance();
      case 'INDIGO':
        return Col$INDIGO_getInstance();
      case 'IVORY':
        return Col$IVORY_getInstance();
      case 'KHAKI':
        return Col$KHAKI_getInstance();
      case 'LAVENDER':
        return Col$LAVENDER_getInstance();
      case 'LAVENDERBLUSH':
        return Col$LAVENDERBLUSH_getInstance();
      case 'LAWNGREEN':
        return Col$LAWNGREEN_getInstance();
      case 'LEMONCHIFFON':
        return Col$LEMONCHIFFON_getInstance();
      case 'LIGHTBLUE':
        return Col$LIGHTBLUE_getInstance();
      case 'LIGHTCORAL':
        return Col$LIGHTCORAL_getInstance();
      case 'LIGHTCYAN':
        return Col$LIGHTCYAN_getInstance();
      case 'LIGHTGOLDENRODYELLOW':
        return Col$LIGHTGOLDENRODYELLOW_getInstance();
      case 'LIGHTGRAY':
        return Col$LIGHTGRAY_getInstance();
      case 'LIGHTGREEN':
        return Col$LIGHTGREEN_getInstance();
      case 'LIGHTPINK':
        return Col$LIGHTPINK_getInstance();
      case 'LIGHTSALMON':
        return Col$LIGHTSALMON_getInstance();
      case 'LIGHTSEAGREEN':
        return Col$LIGHTSEAGREEN_getInstance();
      case 'LIGHTSKYBLUE':
        return Col$LIGHTSKYBLUE_getInstance();
      case 'LIGHTSLATEGRAY':
        return Col$LIGHTSLATEGRAY_getInstance();
      case 'LIGHTSTEELBLUE':
        return Col$LIGHTSTEELBLUE_getInstance();
      case 'LIGHTYELLOW':
        return Col$LIGHTYELLOW_getInstance();
      case 'LIME':
        return Col$LIME_getInstance();
      case 'LIMEGREEN':
        return Col$LIMEGREEN_getInstance();
      case 'LINEN':
        return Col$LINEN_getInstance();
      case 'MAGENTA':
        return Col$MAGENTA_getInstance();
      case 'MAROON':
        return Col$MAROON_getInstance();
      case 'MEDIUMAQUAMARINE':
        return Col$MEDIUMAQUAMARINE_getInstance();
      case 'MEDIUMBLUE':
        return Col$MEDIUMBLUE_getInstance();
      case 'MEDIUMORCHID':
        return Col$MEDIUMORCHID_getInstance();
      case 'MEDIUMPURPLE':
        return Col$MEDIUMPURPLE_getInstance();
      case 'MEDIUMSEAGREEN':
        return Col$MEDIUMSEAGREEN_getInstance();
      case 'MEDIUMSLATEBLUE':
        return Col$MEDIUMSLATEBLUE_getInstance();
      case 'MEDIUMSPRINGGREEN':
        return Col$MEDIUMSPRINGGREEN_getInstance();
      case 'MEDIUMTURQUOISE':
        return Col$MEDIUMTURQUOISE_getInstance();
      case 'MEDIUMVIOLETRED':
        return Col$MEDIUMVIOLETRED_getInstance();
      case 'MIDNIGHTBLUE':
        return Col$MIDNIGHTBLUE_getInstance();
      case 'MINTCREAM':
        return Col$MINTCREAM_getInstance();
      case 'MISTYROSE':
        return Col$MISTYROSE_getInstance();
      case 'MOCCASIN':
        return Col$MOCCASIN_getInstance();
      case 'NAVAJOWHITE':
        return Col$NAVAJOWHITE_getInstance();
      case 'NAVY':
        return Col$NAVY_getInstance();
      case 'OLDLACE':
        return Col$OLDLACE_getInstance();
      case 'OLIVE':
        return Col$OLIVE_getInstance();
      case 'OLIVEDRAB':
        return Col$OLIVEDRAB_getInstance();
      case 'ORANGE':
        return Col$ORANGE_getInstance();
      case 'ORANGERED':
        return Col$ORANGERED_getInstance();
      case 'ORCHID':
        return Col$ORCHID_getInstance();
      case 'PALEGOLDENROD':
        return Col$PALEGOLDENROD_getInstance();
      case 'PALEGREEN':
        return Col$PALEGREEN_getInstance();
      case 'PALETURQUOISE':
        return Col$PALETURQUOISE_getInstance();
      case 'PALEVIOLETRED':
        return Col$PALEVIOLETRED_getInstance();
      case 'PAPAYAWHIP':
        return Col$PAPAYAWHIP_getInstance();
      case 'PEACHPUFF':
        return Col$PEACHPUFF_getInstance();
      case 'PERU':
        return Col$PERU_getInstance();
      case 'PINK':
        return Col$PINK_getInstance();
      case 'PLUM':
        return Col$PLUM_getInstance();
      case 'POWDERBLUE':
        return Col$POWDERBLUE_getInstance();
      case 'PURPLE':
        return Col$PURPLE_getInstance();
      case 'REBECCAPURPLE':
        return Col$REBECCAPURPLE_getInstance();
      case 'RED':
        return Col$RED_getInstance();
      case 'ROSYBROWN':
        return Col$ROSYBROWN_getInstance();
      case 'ROYALBLUE':
        return Col$ROYALBLUE_getInstance();
      case 'SADDLEBROWN':
        return Col$SADDLEBROWN_getInstance();
      case 'SALMON':
        return Col$SALMON_getInstance();
      case 'SANDYBROWN':
        return Col$SANDYBROWN_getInstance();
      case 'SEAGREEN':
        return Col$SEAGREEN_getInstance();
      case 'SEASHELL':
        return Col$SEASHELL_getInstance();
      case 'SIENNA':
        return Col$SIENNA_getInstance();
      case 'SILVER':
        return Col$SILVER_getInstance();
      case 'SKYBLUE':
        return Col$SKYBLUE_getInstance();
      case 'SLATEBLUE':
        return Col$SLATEBLUE_getInstance();
      case 'SLATEGRAY':
        return Col$SLATEGRAY_getInstance();
      case 'SNOW':
        return Col$SNOW_getInstance();
      case 'SPRINGGREEN':
        return Col$SPRINGGREEN_getInstance();
      case 'STEELBLUE':
        return Col$STEELBLUE_getInstance();
      case 'TAN':
        return Col$TAN_getInstance();
      case 'TEAL':
        return Col$TEAL_getInstance();
      case 'THISTLE':
        return Col$THISTLE_getInstance();
      case 'TOMATO':
        return Col$TOMATO_getInstance();
      case 'TURQUOISE':
        return Col$TURQUOISE_getInstance();
      case 'VIOLET':
        return Col$VIOLET_getInstance();
      case 'WHEAT':
        return Col$WHEAT_getInstance();
      case 'WHITE':
        return Col$WHITE_getInstance();
      case 'WHITESMOKE':
        return Col$WHITESMOKE_getInstance();
      case 'YELLOW':
        return Col$YELLOW_getInstance();
      case 'YELLOWGREEN':
        return Col$YELLOWGREEN_getInstance();
      default:throwISE('No enum constant io.kvision.core.Col.' + name);
    }
  }
  Col.valueOf_61zpoe$ = Col$valueOf;
  function BgSize(name, ordinal, size) {
    Enum.call(this);
    this.size_8be2vx$ = size;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function BgSize_initFields() {
    BgSize_initFields = function () {
    };
    BgSize$COVER_instance = new BgSize('COVER', 0, 'cover');
    BgSize$CONTAIN_instance = new BgSize('CONTAIN', 1, 'contain');
  }
  var BgSize$COVER_instance;
  function BgSize$COVER_getInstance() {
    BgSize_initFields();
    return BgSize$COVER_instance;
  }
  var BgSize$CONTAIN_instance;
  function BgSize$CONTAIN_getInstance() {
    BgSize_initFields();
    return BgSize$CONTAIN_instance;
  }
  BgSize.$metadata$ = {kind: Kind_CLASS, simpleName: 'BgSize', interfaces: [Enum]};
  function BgSize$values() {
    return [BgSize$COVER_getInstance(), BgSize$CONTAIN_getInstance()];
  }
  BgSize.values = BgSize$values;
  function BgSize$valueOf(name) {
    switch (name) {
      case 'COVER':
        return BgSize$COVER_getInstance();
      case 'CONTAIN':
        return BgSize$CONTAIN_getInstance();
      default:throwISE('No enum constant io.kvision.core.BgSize.' + name);
    }
  }
  BgSize.valueOf_61zpoe$ = BgSize$valueOf;
  function BgRepeat(name, ordinal, repeat) {
    Enum.call(this);
    this.repeat_8be2vx$ = repeat;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function BgRepeat_initFields() {
    BgRepeat_initFields = function () {
    };
    BgRepeat$REPEAT_instance = new BgRepeat('REPEAT', 0, 'repeat');
    BgRepeat$REPEATX_instance = new BgRepeat('REPEATX', 1, 'repeat-x');
    BgRepeat$REPEATY_instance = new BgRepeat('REPEATY', 2, 'repeat-y');
    BgRepeat$NOREPEAT_instance = new BgRepeat('NOREPEAT', 3, 'no-repeat');
  }
  var BgRepeat$REPEAT_instance;
  function BgRepeat$REPEAT_getInstance() {
    BgRepeat_initFields();
    return BgRepeat$REPEAT_instance;
  }
  var BgRepeat$REPEATX_instance;
  function BgRepeat$REPEATX_getInstance() {
    BgRepeat_initFields();
    return BgRepeat$REPEATX_instance;
  }
  var BgRepeat$REPEATY_instance;
  function BgRepeat$REPEATY_getInstance() {
    BgRepeat_initFields();
    return BgRepeat$REPEATY_instance;
  }
  var BgRepeat$NOREPEAT_instance;
  function BgRepeat$NOREPEAT_getInstance() {
    BgRepeat_initFields();
    return BgRepeat$NOREPEAT_instance;
  }
  BgRepeat.$metadata$ = {kind: Kind_CLASS, simpleName: 'BgRepeat', interfaces: [Enum]};
  function BgRepeat$values() {
    return [BgRepeat$REPEAT_getInstance(), BgRepeat$REPEATX_getInstance(), BgRepeat$REPEATY_getInstance(), BgRepeat$NOREPEAT_getInstance()];
  }
  BgRepeat.values = BgRepeat$values;
  function BgRepeat$valueOf(name) {
    switch (name) {
      case 'REPEAT':
        return BgRepeat$REPEAT_getInstance();
      case 'REPEATX':
        return BgRepeat$REPEATX_getInstance();
      case 'REPEATY':
        return BgRepeat$REPEATY_getInstance();
      case 'NOREPEAT':
        return BgRepeat$NOREPEAT_getInstance();
      default:throwISE('No enum constant io.kvision.core.BgRepeat.' + name);
    }
  }
  BgRepeat.valueOf_61zpoe$ = BgRepeat$valueOf;
  var BgAttach$SCROLL_instance;
  var BgAttach$FIXED_instance;
  var BgAttach$LOCAL_instance;
  var BgOrigin$PADDING_instance;
  var BgOrigin$BORDER_instance;
  var BgOrigin$CONTENT_instance;
  var BgClip$PADDING_instance;
  var BgClip$BORDER_instance;
  var BgClip$CONTENT_instance;
  function Display(name, ordinal, display) {
    Enum.call(this);
    this.display_8be2vx$ = display;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Display_initFields() {
    Display_initFields = function () {
    };
    Display$INLINE_instance = new Display('INLINE', 0, 'inline');
    Display$BLOCK_instance = new Display('BLOCK', 1, 'block');
    Display$FLEX_instance = new Display('FLEX', 2, 'flex');
    Display$GRID_instance = new Display('GRID', 3, 'grid');
    Display$INLINEBLOCK_instance = new Display('INLINEBLOCK', 4, 'inline-block');
    Display$INLINEFLEX_instance = new Display('INLINEFLEX', 5, 'inline-flex');
    Display$INLINEGRID_instance = new Display('INLINEGRID', 6, 'inline-grid');
    Display$INLINETABLE_instance = new Display('INLINETABLE', 7, 'inline-table');
    Display$LISTITEM_instance = new Display('LISTITEM', 8, 'list-item');
    Display$RUNIN_instance = new Display('RUNIN', 9, 'run-in');
    Display$TABLE_instance = new Display('TABLE', 10, 'table');
    Display$TABLECAPTION_instance = new Display('TABLECAPTION', 11, 'table-caption');
    Display$TABLECOLUMNGROUP_instance = new Display('TABLECOLUMNGROUP', 12, 'table-column-group');
    Display$TABLEHEADERGROUP_instance = new Display('TABLEHEADERGROUP', 13, 'table-header-group');
    Display$TABLEFOOTERGROUP_instance = new Display('TABLEFOOTERGROUP', 14, 'table-footer-group');
    Display$TABLEROWGROUP_instance = new Display('TABLEROWGROUP', 15, 'table-row-group');
    Display$TABLECELL_instance = new Display('TABLECELL', 16, 'table-cell');
    Display$TABLECOLUMN_instance = new Display('TABLECOLUMN', 17, 'table-column');
    Display$TABLEROW_instance = new Display('TABLEROW', 18, 'table-row');
    Display$CONTENTS_instance = new Display('CONTENTS', 19, 'contents');
    Display$NONE_instance = new Display('NONE', 20, 'none');
    Display$INITIAL_instance = new Display('INITIAL', 21, 'initial');
    Display$INHERIT_instance = new Display('INHERIT', 22, 'inherit');
  }
  var Display$INLINE_instance;
  function Display$INLINE_getInstance() {
    Display_initFields();
    return Display$INLINE_instance;
  }
  var Display$BLOCK_instance;
  function Display$BLOCK_getInstance() {
    Display_initFields();
    return Display$BLOCK_instance;
  }
  var Display$FLEX_instance;
  function Display$FLEX_getInstance() {
    Display_initFields();
    return Display$FLEX_instance;
  }
  var Display$GRID_instance;
  function Display$GRID_getInstance() {
    Display_initFields();
    return Display$GRID_instance;
  }
  var Display$INLINEBLOCK_instance;
  function Display$INLINEBLOCK_getInstance() {
    Display_initFields();
    return Display$INLINEBLOCK_instance;
  }
  var Display$INLINEFLEX_instance;
  function Display$INLINEFLEX_getInstance() {
    Display_initFields();
    return Display$INLINEFLEX_instance;
  }
  var Display$INLINEGRID_instance;
  function Display$INLINEGRID_getInstance() {
    Display_initFields();
    return Display$INLINEGRID_instance;
  }
  var Display$INLINETABLE_instance;
  function Display$INLINETABLE_getInstance() {
    Display_initFields();
    return Display$INLINETABLE_instance;
  }
  var Display$LISTITEM_instance;
  function Display$LISTITEM_getInstance() {
    Display_initFields();
    return Display$LISTITEM_instance;
  }
  var Display$RUNIN_instance;
  function Display$RUNIN_getInstance() {
    Display_initFields();
    return Display$RUNIN_instance;
  }
  var Display$TABLE_instance;
  function Display$TABLE_getInstance() {
    Display_initFields();
    return Display$TABLE_instance;
  }
  var Display$TABLECAPTION_instance;
  function Display$TABLECAPTION_getInstance() {
    Display_initFields();
    return Display$TABLECAPTION_instance;
  }
  var Display$TABLECOLUMNGROUP_instance;
  function Display$TABLECOLUMNGROUP_getInstance() {
    Display_initFields();
    return Display$TABLECOLUMNGROUP_instance;
  }
  var Display$TABLEHEADERGROUP_instance;
  function Display$TABLEHEADERGROUP_getInstance() {
    Display_initFields();
    return Display$TABLEHEADERGROUP_instance;
  }
  var Display$TABLEFOOTERGROUP_instance;
  function Display$TABLEFOOTERGROUP_getInstance() {
    Display_initFields();
    return Display$TABLEFOOTERGROUP_instance;
  }
  var Display$TABLEROWGROUP_instance;
  function Display$TABLEROWGROUP_getInstance() {
    Display_initFields();
    return Display$TABLEROWGROUP_instance;
  }
  var Display$TABLECELL_instance;
  function Display$TABLECELL_getInstance() {
    Display_initFields();
    return Display$TABLECELL_instance;
  }
  var Display$TABLECOLUMN_instance;
  function Display$TABLECOLUMN_getInstance() {
    Display_initFields();
    return Display$TABLECOLUMN_instance;
  }
  var Display$TABLEROW_instance;
  function Display$TABLEROW_getInstance() {
    Display_initFields();
    return Display$TABLEROW_instance;
  }
  var Display$CONTENTS_instance;
  function Display$CONTENTS_getInstance() {
    Display_initFields();
    return Display$CONTENTS_instance;
  }
  var Display$NONE_instance;
  function Display$NONE_getInstance() {
    Display_initFields();
    return Display$NONE_instance;
  }
  var Display$INITIAL_instance;
  function Display$INITIAL_getInstance() {
    Display_initFields();
    return Display$INITIAL_instance;
  }
  var Display$INHERIT_instance;
  function Display$INHERIT_getInstance() {
    Display_initFields();
    return Display$INHERIT_instance;
  }
  Display.$metadata$ = {kind: Kind_CLASS, simpleName: 'Display', interfaces: [Enum]};
  function Display$values() {
    return [Display$INLINE_getInstance(), Display$BLOCK_getInstance(), Display$FLEX_getInstance(), Display$GRID_getInstance(), Display$INLINEBLOCK_getInstance(), Display$INLINEFLEX_getInstance(), Display$INLINEGRID_getInstance(), Display$INLINETABLE_getInstance(), Display$LISTITEM_getInstance(), Display$RUNIN_getInstance(), Display$TABLE_getInstance(), Display$TABLECAPTION_getInstance(), Display$TABLECOLUMNGROUP_getInstance(), Display$TABLEHEADERGROUP_getInstance(), Display$TABLEFOOTERGROUP_getInstance(), Display$TABLEROWGROUP_getInstance(), Display$TABLECELL_getInstance(), Display$TABLECOLUMN_getInstance(), Display$TABLEROW_getInstance(), Display$CONTENTS_getInstance(), Display$NONE_getInstance(), Display$INITIAL_getInstance(), Display$INHERIT_getInstance()];
  }
  Display.values = Display$values;
  function Display$valueOf(name) {
    switch (name) {
      case 'INLINE':
        return Display$INLINE_getInstance();
      case 'BLOCK':
        return Display$BLOCK_getInstance();
      case 'FLEX':
        return Display$FLEX_getInstance();
      case 'GRID':
        return Display$GRID_getInstance();
      case 'INLINEBLOCK':
        return Display$INLINEBLOCK_getInstance();
      case 'INLINEFLEX':
        return Display$INLINEFLEX_getInstance();
      case 'INLINEGRID':
        return Display$INLINEGRID_getInstance();
      case 'INLINETABLE':
        return Display$INLINETABLE_getInstance();
      case 'LISTITEM':
        return Display$LISTITEM_getInstance();
      case 'RUNIN':
        return Display$RUNIN_getInstance();
      case 'TABLE':
        return Display$TABLE_getInstance();
      case 'TABLECAPTION':
        return Display$TABLECAPTION_getInstance();
      case 'TABLECOLUMNGROUP':
        return Display$TABLECOLUMNGROUP_getInstance();
      case 'TABLEHEADERGROUP':
        return Display$TABLEHEADERGROUP_getInstance();
      case 'TABLEFOOTERGROUP':
        return Display$TABLEFOOTERGROUP_getInstance();
      case 'TABLEROWGROUP':
        return Display$TABLEROWGROUP_getInstance();
      case 'TABLECELL':
        return Display$TABLECELL_getInstance();
      case 'TABLECOLUMN':
        return Display$TABLECOLUMN_getInstance();
      case 'TABLEROW':
        return Display$TABLEROW_getInstance();
      case 'CONTENTS':
        return Display$CONTENTS_getInstance();
      case 'NONE':
        return Display$NONE_getInstance();
      case 'INITIAL':
        return Display$INITIAL_getInstance();
      case 'INHERIT':
        return Display$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Display.' + name);
    }
  }
  Display.valueOf_61zpoe$ = Display$valueOf;
  var Position$STATIC_instance;
  var Position$RELATIVE_instance;
  var Position$FIXED_instance;
  var Position$ABSOLUTE_instance;
  var Position$STICKY_instance;
  function Overflow(name, ordinal, overflow) {
    Enum.call(this);
    this.overflow_8be2vx$ = overflow;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Overflow_initFields() {
    Overflow_initFields = function () {
    };
    Overflow$VISIBLE_instance = new Overflow('VISIBLE', 0, 'visible');
    Overflow$HIDDEN_instance = new Overflow('HIDDEN', 1, 'hidden');
    Overflow$SCROLL_instance = new Overflow('SCROLL', 2, 'scroll');
    Overflow$AUTO_instance = new Overflow('AUTO', 3, 'auto');
    Overflow$INITIAL_instance = new Overflow('INITIAL', 4, 'initial');
    Overflow$INHERIT_instance = new Overflow('INHERIT', 5, 'inherit');
  }
  var Overflow$VISIBLE_instance;
  function Overflow$VISIBLE_getInstance() {
    Overflow_initFields();
    return Overflow$VISIBLE_instance;
  }
  var Overflow$HIDDEN_instance;
  function Overflow$HIDDEN_getInstance() {
    Overflow_initFields();
    return Overflow$HIDDEN_instance;
  }
  var Overflow$SCROLL_instance;
  function Overflow$SCROLL_getInstance() {
    Overflow_initFields();
    return Overflow$SCROLL_instance;
  }
  var Overflow$AUTO_instance;
  function Overflow$AUTO_getInstance() {
    Overflow_initFields();
    return Overflow$AUTO_instance;
  }
  var Overflow$INITIAL_instance;
  function Overflow$INITIAL_getInstance() {
    Overflow_initFields();
    return Overflow$INITIAL_instance;
  }
  var Overflow$INHERIT_instance;
  function Overflow$INHERIT_getInstance() {
    Overflow_initFields();
    return Overflow$INHERIT_instance;
  }
  Overflow.$metadata$ = {kind: Kind_CLASS, simpleName: 'Overflow', interfaces: [Enum]};
  function Overflow$values() {
    return [Overflow$VISIBLE_getInstance(), Overflow$HIDDEN_getInstance(), Overflow$SCROLL_getInstance(), Overflow$AUTO_getInstance(), Overflow$INITIAL_getInstance(), Overflow$INHERIT_getInstance()];
  }
  Overflow.values = Overflow$values;
  function Overflow$valueOf(name) {
    switch (name) {
      case 'VISIBLE':
        return Overflow$VISIBLE_getInstance();
      case 'HIDDEN':
        return Overflow$HIDDEN_getInstance();
      case 'SCROLL':
        return Overflow$SCROLL_getInstance();
      case 'AUTO':
        return Overflow$AUTO_getInstance();
      case 'INITIAL':
        return Overflow$INITIAL_getInstance();
      case 'INHERIT':
        return Overflow$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Overflow.' + name);
    }
  }
  Overflow.valueOf_61zpoe$ = Overflow$valueOf;
  var OverflowWrap$NORMAL_instance;
  var OverflowWrap$BREAKWORK_instance;
  var OverflowWrap$ANYWHERE_instance;
  function Resize(name, ordinal, resize) {
    Enum.call(this);
    this.resize_8be2vx$ = resize;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Resize_initFields() {
    Resize_initFields = function () {
    };
    Resize$NONE_instance = new Resize('NONE', 0, 'none');
    Resize$BOTH_instance = new Resize('BOTH', 1, 'both');
    Resize$HORIZONTAL_instance = new Resize('HORIZONTAL', 2, 'horizontal');
    Resize$VERTICAL_instance = new Resize('VERTICAL', 3, 'vertical');
    Resize$INITIAL_instance = new Resize('INITIAL', 4, 'initial');
    Resize$INHERIT_instance = new Resize('INHERIT', 5, 'inherit');
  }
  var Resize$NONE_instance;
  function Resize$NONE_getInstance() {
    Resize_initFields();
    return Resize$NONE_instance;
  }
  var Resize$BOTH_instance;
  function Resize$BOTH_getInstance() {
    Resize_initFields();
    return Resize$BOTH_instance;
  }
  var Resize$HORIZONTAL_instance;
  function Resize$HORIZONTAL_getInstance() {
    Resize_initFields();
    return Resize$HORIZONTAL_instance;
  }
  var Resize$VERTICAL_instance;
  function Resize$VERTICAL_getInstance() {
    Resize_initFields();
    return Resize$VERTICAL_instance;
  }
  var Resize$INITIAL_instance;
  function Resize$INITIAL_getInstance() {
    Resize_initFields();
    return Resize$INITIAL_instance;
  }
  var Resize$INHERIT_instance;
  function Resize$INHERIT_getInstance() {
    Resize_initFields();
    return Resize$INHERIT_instance;
  }
  Resize.$metadata$ = {kind: Kind_CLASS, simpleName: 'Resize', interfaces: [Enum]};
  function Resize$values() {
    return [Resize$NONE_getInstance(), Resize$BOTH_getInstance(), Resize$HORIZONTAL_getInstance(), Resize$VERTICAL_getInstance(), Resize$INITIAL_getInstance(), Resize$INHERIT_getInstance()];
  }
  Resize.values = Resize$values;
  function Resize$valueOf(name) {
    switch (name) {
      case 'NONE':
        return Resize$NONE_getInstance();
      case 'BOTH':
        return Resize$BOTH_getInstance();
      case 'HORIZONTAL':
        return Resize$HORIZONTAL_getInstance();
      case 'VERTICAL':
        return Resize$VERTICAL_getInstance();
      case 'INITIAL':
        return Resize$INITIAL_getInstance();
      case 'INHERIT':
        return Resize$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Resize.' + name);
    }
  }
  Resize.valueOf_61zpoe$ = Resize$valueOf;
  var Direction$LTR_instance;
  var Direction$RTL_instance;
  var Direction$INITIAL_instance;
  var Direction$INHERIT_instance;
  function TextAlign(name, ordinal, textAlign) {
    Enum.call(this);
    this.textAlign_8be2vx$ = textAlign;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function TextAlign_initFields() {
    TextAlign_initFields = function () {
    };
    TextAlign$LEFT_instance = new TextAlign('LEFT', 0, 'left');
    TextAlign$RIGHT_instance = new TextAlign('RIGHT', 1, 'right');
    TextAlign$CENTER_instance = new TextAlign('CENTER', 2, 'center');
    TextAlign$JUSTIFY_instance = new TextAlign('JUSTIFY', 3, 'justify');
    TextAlign$INITIAL_instance = new TextAlign('INITIAL', 4, 'initial');
    TextAlign$INHERIT_instance = new TextAlign('INHERIT', 5, 'inherit');
  }
  var TextAlign$LEFT_instance;
  function TextAlign$LEFT_getInstance() {
    TextAlign_initFields();
    return TextAlign$LEFT_instance;
  }
  var TextAlign$RIGHT_instance;
  function TextAlign$RIGHT_getInstance() {
    TextAlign_initFields();
    return TextAlign$RIGHT_instance;
  }
  var TextAlign$CENTER_instance;
  function TextAlign$CENTER_getInstance() {
    TextAlign_initFields();
    return TextAlign$CENTER_instance;
  }
  var TextAlign$JUSTIFY_instance;
  function TextAlign$JUSTIFY_getInstance() {
    TextAlign_initFields();
    return TextAlign$JUSTIFY_instance;
  }
  var TextAlign$INITIAL_instance;
  function TextAlign$INITIAL_getInstance() {
    TextAlign_initFields();
    return TextAlign$INITIAL_instance;
  }
  var TextAlign$INHERIT_instance;
  function TextAlign$INHERIT_getInstance() {
    TextAlign_initFields();
    return TextAlign$INHERIT_instance;
  }
  TextAlign.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextAlign', interfaces: [Enum]};
  function TextAlign$values() {
    return [TextAlign$LEFT_getInstance(), TextAlign$RIGHT_getInstance(), TextAlign$CENTER_getInstance(), TextAlign$JUSTIFY_getInstance(), TextAlign$INITIAL_getInstance(), TextAlign$INHERIT_getInstance()];
  }
  TextAlign.values = TextAlign$values;
  function TextAlign$valueOf(name) {
    switch (name) {
      case 'LEFT':
        return TextAlign$LEFT_getInstance();
      case 'RIGHT':
        return TextAlign$RIGHT_getInstance();
      case 'CENTER':
        return TextAlign$CENTER_getInstance();
      case 'JUSTIFY':
        return TextAlign$JUSTIFY_getInstance();
      case 'INITIAL':
        return TextAlign$INITIAL_getInstance();
      case 'INHERIT':
        return TextAlign$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.TextAlign.' + name);
    }
  }
  TextAlign.valueOf_61zpoe$ = TextAlign$valueOf;
  var TextDecorationLine$NONE_instance;
  var TextDecorationLine$UNDERLINE_instance;
  var TextDecorationLine$OVERLINE_instance;
  var TextDecorationLine$LINETHROUGH_instance;
  var TextDecorationLine$JUSTIFY_instance;
  var TextDecorationLine$INITIAL_instance;
  var TextDecorationLine$INHERIT_instance;
  var TextDecorationStyle$SOLID_instance;
  var TextDecorationStyle$DOUBLE_instance;
  var TextDecorationStyle$DOTTED_instance;
  var TextDecorationStyle$DASHED_instance;
  var TextDecorationStyle$WAVY_instance;
  var TextDecorationStyle$INITIAL_instance;
  var TextDecorationStyle$INHERIT_instance;
  var TextTransform$NONE_instance;
  var TextTransform$CAPITALIZE_instance;
  var TextTransform$UPPERCASE_instance;
  var TextTransform$LOWERCASE_instance;
  var TextTransform$INITIAL_instance;
  var TextTransform$INHERIT_instance;
  var TextOverflow$CLIP_instance;
  var TextOverflow$ELLIPSIS_instance;
  var TextOverflow$INITIAL_instance;
  var TextOverflow$INHERIT_instance;
  var UnicodeBidi$NORMAL_instance;
  var UnicodeBidi$EMBED_instance;
  var UnicodeBidi$BIDIOVERRIDE_instance;
  var UnicodeBidi$INITIAL_instance;
  var UnicodeBidi$INHERIT_instance;
  function VerticalAlign(name, ordinal, verticalAlign) {
    Enum.call(this);
    this.verticalAlign_8be2vx$ = verticalAlign;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function VerticalAlign_initFields() {
    VerticalAlign_initFields = function () {
    };
    VerticalAlign$BASELINE_instance = new VerticalAlign('BASELINE', 0, 'baseline');
    VerticalAlign$SUB_instance = new VerticalAlign('SUB', 1, 'sub');
    VerticalAlign$SUPER_instance = new VerticalAlign('SUPER', 2, 'super');
    VerticalAlign$TOP_instance = new VerticalAlign('TOP', 3, 'top');
    VerticalAlign$TEXTTOP_instance = new VerticalAlign('TEXTTOP', 4, 'text-top');
    VerticalAlign$MIDDLE_instance = new VerticalAlign('MIDDLE', 5, 'middle');
    VerticalAlign$BOTTOM_instance = new VerticalAlign('BOTTOM', 6, 'bottom');
    VerticalAlign$TEXTBOTTOM_instance = new VerticalAlign('TEXTBOTTOM', 7, 'text-bottom');
    VerticalAlign$INITIAL_instance = new VerticalAlign('INITIAL', 8, 'initial');
    VerticalAlign$INHERIT_instance = new VerticalAlign('INHERIT', 9, 'inherit');
  }
  var VerticalAlign$BASELINE_instance;
  function VerticalAlign$BASELINE_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$BASELINE_instance;
  }
  var VerticalAlign$SUB_instance;
  function VerticalAlign$SUB_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$SUB_instance;
  }
  var VerticalAlign$SUPER_instance;
  function VerticalAlign$SUPER_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$SUPER_instance;
  }
  var VerticalAlign$TOP_instance;
  function VerticalAlign$TOP_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$TOP_instance;
  }
  var VerticalAlign$TEXTTOP_instance;
  function VerticalAlign$TEXTTOP_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$TEXTTOP_instance;
  }
  var VerticalAlign$MIDDLE_instance;
  function VerticalAlign$MIDDLE_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$MIDDLE_instance;
  }
  var VerticalAlign$BOTTOM_instance;
  function VerticalAlign$BOTTOM_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$BOTTOM_instance;
  }
  var VerticalAlign$TEXTBOTTOM_instance;
  function VerticalAlign$TEXTBOTTOM_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$TEXTBOTTOM_instance;
  }
  var VerticalAlign$INITIAL_instance;
  function VerticalAlign$INITIAL_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$INITIAL_instance;
  }
  var VerticalAlign$INHERIT_instance;
  function VerticalAlign$INHERIT_getInstance() {
    VerticalAlign_initFields();
    return VerticalAlign$INHERIT_instance;
  }
  VerticalAlign.$metadata$ = {kind: Kind_CLASS, simpleName: 'VerticalAlign', interfaces: [Enum]};
  function VerticalAlign$values() {
    return [VerticalAlign$BASELINE_getInstance(), VerticalAlign$SUB_getInstance(), VerticalAlign$SUPER_getInstance(), VerticalAlign$TOP_getInstance(), VerticalAlign$TEXTTOP_getInstance(), VerticalAlign$MIDDLE_getInstance(), VerticalAlign$BOTTOM_getInstance(), VerticalAlign$TEXTBOTTOM_getInstance(), VerticalAlign$INITIAL_getInstance(), VerticalAlign$INHERIT_getInstance()];
  }
  VerticalAlign.values = VerticalAlign$values;
  function VerticalAlign$valueOf(name) {
    switch (name) {
      case 'BASELINE':
        return VerticalAlign$BASELINE_getInstance();
      case 'SUB':
        return VerticalAlign$SUB_getInstance();
      case 'SUPER':
        return VerticalAlign$SUPER_getInstance();
      case 'TOP':
        return VerticalAlign$TOP_getInstance();
      case 'TEXTTOP':
        return VerticalAlign$TEXTTOP_getInstance();
      case 'MIDDLE':
        return VerticalAlign$MIDDLE_getInstance();
      case 'BOTTOM':
        return VerticalAlign$BOTTOM_getInstance();
      case 'TEXTBOTTOM':
        return VerticalAlign$TEXTBOTTOM_getInstance();
      case 'INITIAL':
        return VerticalAlign$INITIAL_getInstance();
      case 'INHERIT':
        return VerticalAlign$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.VerticalAlign.' + name);
    }
  }
  VerticalAlign.valueOf_61zpoe$ = VerticalAlign$valueOf;
  var WhiteSpace$NORMAL_instance;
  var WhiteSpace$NOWRAP_instance;
  var WhiteSpace$PRE_instance;
  var WhiteSpace$PRELINE_instance;
  var WhiteSpace$PREWRAP_instance;
  var WhiteSpace$INITIAL_instance;
  var WhiteSpace$INHERIT_instance;
  var FontStyle$NORMAL_instance;
  var FontStyle$ITALIC_instance;
  var FontStyle$OBLIQUE_instance;
  var FontStyle$INITIAL_instance;
  var FontStyle$INHERIT_instance;
  var FontVariant$NORMAL_instance;
  var FontVariant$SMALLCAPS_instance;
  var FontVariant$INITIAL_instance;
  var FontVariant$INHERIT_instance;
  var FontWeight$NORMAL_instance;
  var FontWeight$BOLD_instance;
  var FontWeight$BOLDER_instance;
  var FontWeight$LIGHTER_instance;
  var FontWeight$INITIAL_instance;
  var FontWeight$INHERIT_instance;
  function PosFloat(name, ordinal, posFloat) {
    Enum.call(this);
    this.posFloat_8be2vx$ = posFloat;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function PosFloat_initFields() {
    PosFloat_initFields = function () {
    };
    PosFloat$NONE_instance = new PosFloat('NONE', 0, 'none');
    PosFloat$LEFT_instance = new PosFloat('LEFT', 1, 'left');
    PosFloat$RIGHT_instance = new PosFloat('RIGHT', 2, 'right');
    PosFloat$INITIAL_instance = new PosFloat('INITIAL', 3, 'initial');
    PosFloat$INHERIT_instance = new PosFloat('INHERIT', 4, 'inherit');
  }
  var PosFloat$NONE_instance;
  function PosFloat$NONE_getInstance() {
    PosFloat_initFields();
    return PosFloat$NONE_instance;
  }
  var PosFloat$LEFT_instance;
  function PosFloat$LEFT_getInstance() {
    PosFloat_initFields();
    return PosFloat$LEFT_instance;
  }
  var PosFloat$RIGHT_instance;
  function PosFloat$RIGHT_getInstance() {
    PosFloat_initFields();
    return PosFloat$RIGHT_instance;
  }
  var PosFloat$INITIAL_instance;
  function PosFloat$INITIAL_getInstance() {
    PosFloat_initFields();
    return PosFloat$INITIAL_instance;
  }
  var PosFloat$INHERIT_instance;
  function PosFloat$INHERIT_getInstance() {
    PosFloat_initFields();
    return PosFloat$INHERIT_instance;
  }
  PosFloat.$metadata$ = {kind: Kind_CLASS, simpleName: 'PosFloat', interfaces: [Enum]};
  function PosFloat$values() {
    return [PosFloat$NONE_getInstance(), PosFloat$LEFT_getInstance(), PosFloat$RIGHT_getInstance(), PosFloat$INITIAL_getInstance(), PosFloat$INHERIT_getInstance()];
  }
  PosFloat.values = PosFloat$values;
  function PosFloat$valueOf(name) {
    switch (name) {
      case 'NONE':
        return PosFloat$NONE_getInstance();
      case 'LEFT':
        return PosFloat$LEFT_getInstance();
      case 'RIGHT':
        return PosFloat$RIGHT_getInstance();
      case 'INITIAL':
        return PosFloat$INITIAL_getInstance();
      case 'INHERIT':
        return PosFloat$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.PosFloat.' + name);
    }
  }
  PosFloat.valueOf_61zpoe$ = PosFloat$valueOf;
  function Clear(name, ordinal, clear) {
    Enum.call(this);
    this.clear_8be2vx$ = clear;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Clear_initFields() {
    Clear_initFields = function () {
    };
    Clear$NONE_instance = new Clear('NONE', 0, 'none');
    Clear$LEFT_instance = new Clear('LEFT', 1, 'left');
    Clear$RIGHT_instance = new Clear('RIGHT', 2, 'right');
    Clear$BOTH_instance = new Clear('BOTH', 3, 'both');
    Clear$INITIAL_instance = new Clear('INITIAL', 4, 'initial');
    Clear$INHERIT_instance = new Clear('INHERIT', 5, 'inherit');
  }
  var Clear$NONE_instance;
  function Clear$NONE_getInstance() {
    Clear_initFields();
    return Clear$NONE_instance;
  }
  var Clear$LEFT_instance;
  function Clear$LEFT_getInstance() {
    Clear_initFields();
    return Clear$LEFT_instance;
  }
  var Clear$RIGHT_instance;
  function Clear$RIGHT_getInstance() {
    Clear_initFields();
    return Clear$RIGHT_instance;
  }
  var Clear$BOTH_instance;
  function Clear$BOTH_getInstance() {
    Clear_initFields();
    return Clear$BOTH_instance;
  }
  var Clear$INITIAL_instance;
  function Clear$INITIAL_getInstance() {
    Clear_initFields();
    return Clear$INITIAL_instance;
  }
  var Clear$INHERIT_instance;
  function Clear$INHERIT_getInstance() {
    Clear_initFields();
    return Clear$INHERIT_instance;
  }
  Clear.$metadata$ = {kind: Kind_CLASS, simpleName: 'Clear', interfaces: [Enum]};
  function Clear$values() {
    return [Clear$NONE_getInstance(), Clear$LEFT_getInstance(), Clear$RIGHT_getInstance(), Clear$BOTH_getInstance(), Clear$INITIAL_getInstance(), Clear$INHERIT_getInstance()];
  }
  Clear.values = Clear$values;
  function Clear$valueOf(name) {
    switch (name) {
      case 'NONE':
        return Clear$NONE_getInstance();
      case 'LEFT':
        return Clear$LEFT_getInstance();
      case 'RIGHT':
        return Clear$RIGHT_getInstance();
      case 'BOTH':
        return Clear$BOTH_getInstance();
      case 'INITIAL':
        return Clear$INITIAL_getInstance();
      case 'INHERIT':
        return Clear$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Clear.' + name);
    }
  }
  Clear.valueOf_61zpoe$ = Clear$valueOf;
  var WordBreak$NORMAL_instance;
  var WordBreak$KEEPALL_instance;
  var WordBreak$BREAKALL_instance;
  var LineBreak$AUTO_instance;
  var LineBreak$LOOSE_instance;
  var LineBreak$NORMAL_instance;
  var LineBreak$STRICT_instance;
  var LineBreak$ANYWHERE_instance;
  function Cursor(name, ordinal, cursor) {
    Enum.call(this);
    this.cursor_8be2vx$ = cursor;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Cursor_initFields() {
    Cursor_initFields = function () {
    };
    Cursor$DEFAULT_instance = new Cursor('DEFAULT', 0, 'default');
    Cursor$AUTO_instance = new Cursor('AUTO', 1, 'auto');
    Cursor$NONE_instance = new Cursor('NONE', 2, 'none');
    Cursor$ALIAS_instance = new Cursor('ALIAS', 3, 'alias');
    Cursor$ALLSCROLL_instance = new Cursor('ALLSCROLL', 4, 'all-scroll');
    Cursor$CELL_instance = new Cursor('CELL', 5, 'cell');
    Cursor$CONTEXTMENU_instance = new Cursor('CONTEXTMENU', 6, 'context-menu');
    Cursor$COLRESIZE_instance = new Cursor('COLRESIZE', 7, 'col-resize');
    Cursor$COPY_instance = new Cursor('COPY', 8, 'copy');
    Cursor$CROSSHAIR_instance = new Cursor('CROSSHAIR', 9, 'crosshair');
    Cursor$ERESIZE_instance = new Cursor('ERESIZE', 10, 'e-resize');
    Cursor$EWRESIZE_instance = new Cursor('EWRESIZE', 11, 'ew-resize');
    Cursor$GRAB_instance = new Cursor('GRAB', 12, 'grab');
    Cursor$GRABBING_instance = new Cursor('GRABBING', 13, 'grabbing');
    Cursor$HELP_instance = new Cursor('HELP', 14, 'help');
    Cursor$MOVE_instance = new Cursor('MOVE', 15, 'move');
    Cursor$NRESIZE_instance = new Cursor('NRESIZE', 16, 'n-resize');
    Cursor$NERESIZE_instance = new Cursor('NERESIZE', 17, 'ne-resize');
    Cursor$NESWRESIZE_instance = new Cursor('NESWRESIZE', 18, 'nesw-resize');
    Cursor$NSRESIZE_instance = new Cursor('NSRESIZE', 19, 'ns-resize');
    Cursor$NWRESIZE_instance = new Cursor('NWRESIZE', 20, 'nw-resize');
    Cursor$NWSERESIZE_instance = new Cursor('NWSERESIZE', 21, 'nwse-resize');
    Cursor$NODROP_instance = new Cursor('NODROP', 22, 'no-drop');
    Cursor$NOTALLOWED_instance = new Cursor('NOTALLOWED', 23, 'not-allowed');
    Cursor$POINTER_instance = new Cursor('POINTER', 24, 'pointer');
    Cursor$PROGRESS_instance = new Cursor('PROGRESS', 25, 'progress');
    Cursor$ROWRESIZE_instance = new Cursor('ROWRESIZE', 26, 'row-resize');
    Cursor$SRESIZE_instance = new Cursor('SRESIZE', 27, 's-resize');
    Cursor$SERESIZE_instance = new Cursor('SERESIZE', 28, 'se-resize');
    Cursor$SWRESIZE_instance = new Cursor('SWRESIZE', 29, 'sw-resize');
    Cursor$TEXT_instance = new Cursor('TEXT', 30, 'text');
    Cursor$VERTICALTEXT_instance = new Cursor('VERTICALTEXT', 31, 'vertical-text');
    Cursor$WRESIZE_instance = new Cursor('WRESIZE', 32, 'w-resize');
    Cursor$WAIT_instance = new Cursor('WAIT', 33, 'wait');
    Cursor$ZOOMIN_instance = new Cursor('ZOOMIN', 34, 'zoom-in');
    Cursor$ZOOMOUT_instance = new Cursor('ZOOMOUT', 35, 'zoom-out');
    Cursor$INITIAL_instance = new Cursor('INITIAL', 36, 'initial');
    Cursor$INHERIT_instance = new Cursor('INHERIT', 37, 'inherit');
  }
  var Cursor$DEFAULT_instance;
  function Cursor$DEFAULT_getInstance() {
    Cursor_initFields();
    return Cursor$DEFAULT_instance;
  }
  var Cursor$AUTO_instance;
  function Cursor$AUTO_getInstance() {
    Cursor_initFields();
    return Cursor$AUTO_instance;
  }
  var Cursor$NONE_instance;
  function Cursor$NONE_getInstance() {
    Cursor_initFields();
    return Cursor$NONE_instance;
  }
  var Cursor$ALIAS_instance;
  function Cursor$ALIAS_getInstance() {
    Cursor_initFields();
    return Cursor$ALIAS_instance;
  }
  var Cursor$ALLSCROLL_instance;
  function Cursor$ALLSCROLL_getInstance() {
    Cursor_initFields();
    return Cursor$ALLSCROLL_instance;
  }
  var Cursor$CELL_instance;
  function Cursor$CELL_getInstance() {
    Cursor_initFields();
    return Cursor$CELL_instance;
  }
  var Cursor$CONTEXTMENU_instance;
  function Cursor$CONTEXTMENU_getInstance() {
    Cursor_initFields();
    return Cursor$CONTEXTMENU_instance;
  }
  var Cursor$COLRESIZE_instance;
  function Cursor$COLRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$COLRESIZE_instance;
  }
  var Cursor$COPY_instance;
  function Cursor$COPY_getInstance() {
    Cursor_initFields();
    return Cursor$COPY_instance;
  }
  var Cursor$CROSSHAIR_instance;
  function Cursor$CROSSHAIR_getInstance() {
    Cursor_initFields();
    return Cursor$CROSSHAIR_instance;
  }
  var Cursor$ERESIZE_instance;
  function Cursor$ERESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$ERESIZE_instance;
  }
  var Cursor$EWRESIZE_instance;
  function Cursor$EWRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$EWRESIZE_instance;
  }
  var Cursor$GRAB_instance;
  function Cursor$GRAB_getInstance() {
    Cursor_initFields();
    return Cursor$GRAB_instance;
  }
  var Cursor$GRABBING_instance;
  function Cursor$GRABBING_getInstance() {
    Cursor_initFields();
    return Cursor$GRABBING_instance;
  }
  var Cursor$HELP_instance;
  function Cursor$HELP_getInstance() {
    Cursor_initFields();
    return Cursor$HELP_instance;
  }
  var Cursor$MOVE_instance;
  function Cursor$MOVE_getInstance() {
    Cursor_initFields();
    return Cursor$MOVE_instance;
  }
  var Cursor$NRESIZE_instance;
  function Cursor$NRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$NRESIZE_instance;
  }
  var Cursor$NERESIZE_instance;
  function Cursor$NERESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$NERESIZE_instance;
  }
  var Cursor$NESWRESIZE_instance;
  function Cursor$NESWRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$NESWRESIZE_instance;
  }
  var Cursor$NSRESIZE_instance;
  function Cursor$NSRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$NSRESIZE_instance;
  }
  var Cursor$NWRESIZE_instance;
  function Cursor$NWRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$NWRESIZE_instance;
  }
  var Cursor$NWSERESIZE_instance;
  function Cursor$NWSERESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$NWSERESIZE_instance;
  }
  var Cursor$NODROP_instance;
  function Cursor$NODROP_getInstance() {
    Cursor_initFields();
    return Cursor$NODROP_instance;
  }
  var Cursor$NOTALLOWED_instance;
  function Cursor$NOTALLOWED_getInstance() {
    Cursor_initFields();
    return Cursor$NOTALLOWED_instance;
  }
  var Cursor$POINTER_instance;
  function Cursor$POINTER_getInstance() {
    Cursor_initFields();
    return Cursor$POINTER_instance;
  }
  var Cursor$PROGRESS_instance;
  function Cursor$PROGRESS_getInstance() {
    Cursor_initFields();
    return Cursor$PROGRESS_instance;
  }
  var Cursor$ROWRESIZE_instance;
  function Cursor$ROWRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$ROWRESIZE_instance;
  }
  var Cursor$SRESIZE_instance;
  function Cursor$SRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$SRESIZE_instance;
  }
  var Cursor$SERESIZE_instance;
  function Cursor$SERESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$SERESIZE_instance;
  }
  var Cursor$SWRESIZE_instance;
  function Cursor$SWRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$SWRESIZE_instance;
  }
  var Cursor$TEXT_instance;
  function Cursor$TEXT_getInstance() {
    Cursor_initFields();
    return Cursor$TEXT_instance;
  }
  var Cursor$VERTICALTEXT_instance;
  function Cursor$VERTICALTEXT_getInstance() {
    Cursor_initFields();
    return Cursor$VERTICALTEXT_instance;
  }
  var Cursor$WRESIZE_instance;
  function Cursor$WRESIZE_getInstance() {
    Cursor_initFields();
    return Cursor$WRESIZE_instance;
  }
  var Cursor$WAIT_instance;
  function Cursor$WAIT_getInstance() {
    Cursor_initFields();
    return Cursor$WAIT_instance;
  }
  var Cursor$ZOOMIN_instance;
  function Cursor$ZOOMIN_getInstance() {
    Cursor_initFields();
    return Cursor$ZOOMIN_instance;
  }
  var Cursor$ZOOMOUT_instance;
  function Cursor$ZOOMOUT_getInstance() {
    Cursor_initFields();
    return Cursor$ZOOMOUT_instance;
  }
  var Cursor$INITIAL_instance;
  function Cursor$INITIAL_getInstance() {
    Cursor_initFields();
    return Cursor$INITIAL_instance;
  }
  var Cursor$INHERIT_instance;
  function Cursor$INHERIT_getInstance() {
    Cursor_initFields();
    return Cursor$INHERIT_instance;
  }
  Cursor.$metadata$ = {kind: Kind_CLASS, simpleName: 'Cursor', interfaces: [Enum]};
  function Cursor$values() {
    return [Cursor$DEFAULT_getInstance(), Cursor$AUTO_getInstance(), Cursor$NONE_getInstance(), Cursor$ALIAS_getInstance(), Cursor$ALLSCROLL_getInstance(), Cursor$CELL_getInstance(), Cursor$CONTEXTMENU_getInstance(), Cursor$COLRESIZE_getInstance(), Cursor$COPY_getInstance(), Cursor$CROSSHAIR_getInstance(), Cursor$ERESIZE_getInstance(), Cursor$EWRESIZE_getInstance(), Cursor$GRAB_getInstance(), Cursor$GRABBING_getInstance(), Cursor$HELP_getInstance(), Cursor$MOVE_getInstance(), Cursor$NRESIZE_getInstance(), Cursor$NERESIZE_getInstance(), Cursor$NESWRESIZE_getInstance(), Cursor$NSRESIZE_getInstance(), Cursor$NWRESIZE_getInstance(), Cursor$NWSERESIZE_getInstance(), Cursor$NODROP_getInstance(), Cursor$NOTALLOWED_getInstance(), Cursor$POINTER_getInstance(), Cursor$PROGRESS_getInstance(), Cursor$ROWRESIZE_getInstance(), Cursor$SRESIZE_getInstance(), Cursor$SERESIZE_getInstance(), Cursor$SWRESIZE_getInstance(), Cursor$TEXT_getInstance(), Cursor$VERTICALTEXT_getInstance(), Cursor$WRESIZE_getInstance(), Cursor$WAIT_getInstance(), Cursor$ZOOMIN_getInstance(), Cursor$ZOOMOUT_getInstance(), Cursor$INITIAL_getInstance(), Cursor$INHERIT_getInstance()];
  }
  Cursor.values = Cursor$values;
  function Cursor$valueOf(name) {
    switch (name) {
      case 'DEFAULT':
        return Cursor$DEFAULT_getInstance();
      case 'AUTO':
        return Cursor$AUTO_getInstance();
      case 'NONE':
        return Cursor$NONE_getInstance();
      case 'ALIAS':
        return Cursor$ALIAS_getInstance();
      case 'ALLSCROLL':
        return Cursor$ALLSCROLL_getInstance();
      case 'CELL':
        return Cursor$CELL_getInstance();
      case 'CONTEXTMENU':
        return Cursor$CONTEXTMENU_getInstance();
      case 'COLRESIZE':
        return Cursor$COLRESIZE_getInstance();
      case 'COPY':
        return Cursor$COPY_getInstance();
      case 'CROSSHAIR':
        return Cursor$CROSSHAIR_getInstance();
      case 'ERESIZE':
        return Cursor$ERESIZE_getInstance();
      case 'EWRESIZE':
        return Cursor$EWRESIZE_getInstance();
      case 'GRAB':
        return Cursor$GRAB_getInstance();
      case 'GRABBING':
        return Cursor$GRABBING_getInstance();
      case 'HELP':
        return Cursor$HELP_getInstance();
      case 'MOVE':
        return Cursor$MOVE_getInstance();
      case 'NRESIZE':
        return Cursor$NRESIZE_getInstance();
      case 'NERESIZE':
        return Cursor$NERESIZE_getInstance();
      case 'NESWRESIZE':
        return Cursor$NESWRESIZE_getInstance();
      case 'NSRESIZE':
        return Cursor$NSRESIZE_getInstance();
      case 'NWRESIZE':
        return Cursor$NWRESIZE_getInstance();
      case 'NWSERESIZE':
        return Cursor$NWSERESIZE_getInstance();
      case 'NODROP':
        return Cursor$NODROP_getInstance();
      case 'NOTALLOWED':
        return Cursor$NOTALLOWED_getInstance();
      case 'POINTER':
        return Cursor$POINTER_getInstance();
      case 'PROGRESS':
        return Cursor$PROGRESS_getInstance();
      case 'ROWRESIZE':
        return Cursor$ROWRESIZE_getInstance();
      case 'SRESIZE':
        return Cursor$SRESIZE_getInstance();
      case 'SERESIZE':
        return Cursor$SERESIZE_getInstance();
      case 'SWRESIZE':
        return Cursor$SWRESIZE_getInstance();
      case 'TEXT':
        return Cursor$TEXT_getInstance();
      case 'VERTICALTEXT':
        return Cursor$VERTICALTEXT_getInstance();
      case 'WRESIZE':
        return Cursor$WRESIZE_getInstance();
      case 'WAIT':
        return Cursor$WAIT_getInstance();
      case 'ZOOMIN':
        return Cursor$ZOOMIN_getInstance();
      case 'ZOOMOUT':
        return Cursor$ZOOMOUT_getInstance();
      case 'INITIAL':
        return Cursor$INITIAL_getInstance();
      case 'INHERIT':
        return Cursor$INHERIT_getInstance();
      default:throwISE('No enum constant io.kvision.core.Cursor.' + name);
    }
  }
  Cursor.valueOf_61zpoe$ = Cursor$valueOf;
  function FlexDirection(name, ordinal, dir) {
    Enum.call(this);
    this.dir_8be2vx$ = dir;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function FlexDirection_initFields() {
    FlexDirection_initFields = function () {
    };
    FlexDirection$ROW_instance = new FlexDirection('ROW', 0, 'row');
    FlexDirection$ROWREV_instance = new FlexDirection('ROWREV', 1, 'row-reverse');
    FlexDirection$COLUMN_instance = new FlexDirection('COLUMN', 2, 'column');
    FlexDirection$COLUMNREV_instance = new FlexDirection('COLUMNREV', 3, 'column-reverse');
  }
  var FlexDirection$ROW_instance;
  function FlexDirection$ROW_getInstance() {
    FlexDirection_initFields();
    return FlexDirection$ROW_instance;
  }
  var FlexDirection$ROWREV_instance;
  function FlexDirection$ROWREV_getInstance() {
    FlexDirection_initFields();
    return FlexDirection$ROWREV_instance;
  }
  var FlexDirection$COLUMN_instance;
  function FlexDirection$COLUMN_getInstance() {
    FlexDirection_initFields();
    return FlexDirection$COLUMN_instance;
  }
  var FlexDirection$COLUMNREV_instance;
  function FlexDirection$COLUMNREV_getInstance() {
    FlexDirection_initFields();
    return FlexDirection$COLUMNREV_instance;
  }
  FlexDirection.$metadata$ = {kind: Kind_CLASS, simpleName: 'FlexDirection', interfaces: [Enum]};
  function FlexDirection$values() {
    return [FlexDirection$ROW_getInstance(), FlexDirection$ROWREV_getInstance(), FlexDirection$COLUMN_getInstance(), FlexDirection$COLUMNREV_getInstance()];
  }
  FlexDirection.values = FlexDirection$values;
  function FlexDirection$valueOf(name) {
    switch (name) {
      case 'ROW':
        return FlexDirection$ROW_getInstance();
      case 'ROWREV':
        return FlexDirection$ROWREV_getInstance();
      case 'COLUMN':
        return FlexDirection$COLUMN_getInstance();
      case 'COLUMNREV':
        return FlexDirection$COLUMNREV_getInstance();
      default:throwISE('No enum constant io.kvision.core.FlexDirection.' + name);
    }
  }
  FlexDirection.valueOf_61zpoe$ = FlexDirection$valueOf;
  var FlexWrap$NOWRAP_instance;
  var FlexWrap$WRAP_instance;
  var FlexWrap$WRAPREV_instance;
  var JustifyItems$START_instance;
  var JustifyItems$END_instance;
  var JustifyItems$CENTER_instance;
  var JustifyItems$STRETCH_instance;
  function JustifyContent(name, ordinal, justifyContent) {
    Enum.call(this);
    this.justifyContent_8be2vx$ = justifyContent;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function JustifyContent_initFields() {
    JustifyContent_initFields = function () {
    };
    JustifyContent$FLEXSTART_instance = new JustifyContent('FLEXSTART', 0, 'flex-start');
    JustifyContent$FLEXEND_instance = new JustifyContent('FLEXEND', 1, 'flex-end');
    JustifyContent$CENTER_instance = new JustifyContent('CENTER', 2, 'center');
    JustifyContent$SPACEBETWEEN_instance = new JustifyContent('SPACEBETWEEN', 3, 'space-between');
    JustifyContent$SPACEAROUND_instance = new JustifyContent('SPACEAROUND', 4, 'space-around');
    JustifyContent$SPACEEVENLY_instance = new JustifyContent('SPACEEVENLY', 5, 'space-evenly');
    JustifyContent$START_instance = new JustifyContent('START', 6, 'start');
    JustifyContent$END_instance = new JustifyContent('END', 7, 'end');
    JustifyContent$STRETCH_instance = new JustifyContent('STRETCH', 8, 'stretch');
  }
  var JustifyContent$FLEXSTART_instance;
  function JustifyContent$FLEXSTART_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$FLEXSTART_instance;
  }
  var JustifyContent$FLEXEND_instance;
  function JustifyContent$FLEXEND_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$FLEXEND_instance;
  }
  var JustifyContent$CENTER_instance;
  function JustifyContent$CENTER_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$CENTER_instance;
  }
  var JustifyContent$SPACEBETWEEN_instance;
  function JustifyContent$SPACEBETWEEN_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$SPACEBETWEEN_instance;
  }
  var JustifyContent$SPACEAROUND_instance;
  function JustifyContent$SPACEAROUND_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$SPACEAROUND_instance;
  }
  var JustifyContent$SPACEEVENLY_instance;
  function JustifyContent$SPACEEVENLY_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$SPACEEVENLY_instance;
  }
  var JustifyContent$START_instance;
  function JustifyContent$START_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$START_instance;
  }
  var JustifyContent$END_instance;
  function JustifyContent$END_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$END_instance;
  }
  var JustifyContent$STRETCH_instance;
  function JustifyContent$STRETCH_getInstance() {
    JustifyContent_initFields();
    return JustifyContent$STRETCH_instance;
  }
  JustifyContent.$metadata$ = {kind: Kind_CLASS, simpleName: 'JustifyContent', interfaces: [Enum]};
  function JustifyContent$values() {
    return [JustifyContent$FLEXSTART_getInstance(), JustifyContent$FLEXEND_getInstance(), JustifyContent$CENTER_getInstance(), JustifyContent$SPACEBETWEEN_getInstance(), JustifyContent$SPACEAROUND_getInstance(), JustifyContent$SPACEEVENLY_getInstance(), JustifyContent$START_getInstance(), JustifyContent$END_getInstance(), JustifyContent$STRETCH_getInstance()];
  }
  JustifyContent.values = JustifyContent$values;
  function JustifyContent$valueOf(name) {
    switch (name) {
      case 'FLEXSTART':
        return JustifyContent$FLEXSTART_getInstance();
      case 'FLEXEND':
        return JustifyContent$FLEXEND_getInstance();
      case 'CENTER':
        return JustifyContent$CENTER_getInstance();
      case 'SPACEBETWEEN':
        return JustifyContent$SPACEBETWEEN_getInstance();
      case 'SPACEAROUND':
        return JustifyContent$SPACEAROUND_getInstance();
      case 'SPACEEVENLY':
        return JustifyContent$SPACEEVENLY_getInstance();
      case 'START':
        return JustifyContent$START_getInstance();
      case 'END':
        return JustifyContent$END_getInstance();
      case 'STRETCH':
        return JustifyContent$STRETCH_getInstance();
      default:throwISE('No enum constant io.kvision.core.JustifyContent.' + name);
    }
  }
  JustifyContent.valueOf_61zpoe$ = JustifyContent$valueOf;
  var AlignItems$FLEXSTART_instance;
  var AlignItems$FLEXEND_instance;
  var AlignItems$CENTER_instance;
  var AlignItems$BASELINE_instance;
  var AlignItems$STRETCH_instance;
  var AlignItems$START_instance;
  var AlignItems$END_instance;
  var AlignContent$FLEXSTART_instance;
  var AlignContent$FLEXEND_instance;
  var AlignContent$CENTER_instance;
  var AlignContent$SPACEBETWEEN_instance;
  var AlignContent$SPACEAROUND_instance;
  var AlignContent$STRETCH_instance;
  var AlignContent$START_instance;
  var AlignContent$END_instance;
  var AlignContent$SPACEEVENLY_instance;
  var GridAutoFlow$ROW_instance;
  var GridAutoFlow$COLUMN_instance;
  var GridAutoFlow$ROWDENSE_instance;
  var GridAutoFlow$COLUMNDENSE_instance;
  function Color(color) {
    Color$Companion_getInstance();
    if (color === void 0)
      color = null;
    this.color = color;
  }
  Color.prototype.asString = function () {
    var $receiver = this.color;
    return $receiver != null ? $receiver : '';
  };
  Color.prototype.toString = function () {
    return this.asString();
  };
  function Color$Companion() {
    Color$Companion_instance = this;
  }
  Color$Companion.prototype.hex_za3lpa$ = function (color) {
    return new Color('#' + toHexString(color));
  };
  Color$Companion.prototype.name_fntfe4$ = function (color) {
    return new Color(color.color_8be2vx$);
  };
  function Color$Companion$rgb$lambda(it) {
    return padStart(toString(it, 16), 2, 48);
  }
  Color$Companion.prototype.rgb_qt1dr2$ = function (red, green, blue) {
    return new Color('#' + joinToString(listOf([red, green, blue]), '', void 0, void 0, void 0, void 0, Color$Companion$rgb$lambda));
  };
  function Color$Companion$rgba$lambda(it) {
    return padStart(toString(it, 16), 2, 48);
  }
  Color$Companion.prototype.rgba_tjonv8$ = function (red, green, blue, alpha) {
    return new Color('#' + joinToString(listOf([red, green, blue, alpha]), '', void 0, void 0, void 0, void 0, Color$Companion$rgba$lambda));
  };
  Color$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Color$Companion_instance = null;
  function Color$Companion_getInstance() {
    if (Color$Companion_instance === null) {
      new Color$Companion();
    }return Color$Companion_instance;
  }
  Color.$metadata$ = {kind: Kind_CLASS, simpleName: 'Color', interfaces: []};
  function Background(color, image, positionX, positionY, sizeX, sizeY, size, repeat, origin, clip, attachment) {
    if (color === void 0)
      color = null;
    if (image === void 0)
      image = null;
    if (positionX === void 0)
      positionX = null;
    if (positionY === void 0)
      positionY = null;
    if (sizeX === void 0)
      sizeX = null;
    if (sizeY === void 0)
      sizeY = null;
    if (size === void 0)
      size = null;
    if (repeat === void 0)
      repeat = null;
    if (origin === void 0)
      origin = null;
    if (clip === void 0)
      clip = null;
    if (attachment === void 0)
      attachment = null;
    this.color_0 = color;
    this.image_0 = image;
    this.positionX_0 = positionX;
    this.positionY_0 = positionY;
    this.sizeX_0 = sizeX;
    this.sizeY_0 = sizeY;
    this.size_0 = size;
    this.repeat_0 = repeat;
    this.origin_0 = origin;
    this.clip_0 = clip;
    this.attachment_0 = attachment;
  }
  Background.prototype.asString_8be2vx$ = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11, tmp$_12, tmp$_13, tmp$_14;
    var img = this.image_0 != null ? 'url(' + toString_0(this.image_0) + ')' : null;
    var posX = (tmp$ = this.positionX_0) != null ? asString(tmp$) : null;
    var posY = (tmp$_0 = this.positionY_0) != null ? asString(tmp$_0) : null;
    var sX = (tmp$_1 = this.sizeX_0) != null ? asString(tmp$_1) : null;
    var sY = (tmp$_2 = this.sizeY_0) != null ? asString(tmp$_2) : null;
    var $receiver = (tmp$_3 = this.color_0) != null ? tmp$_3.asString() : null;
    tmp$_7 = ($receiver != null ? $receiver : '') + ' ' + (img != null ? img : '') + ' ' + (posX != null ? posX : '') + ' ' + (posY != null ? posY : '');
    if (sX != null || sY != null || this.size_0 != null) {
      tmp$_5 = (posX != null || posY != null ? ' / ' : ' 0px 0px / ') + (sX != null ? sX : '') + ' ' + (sY != null ? sY : '') + ' ';
      var $receiver_0 = (tmp$_4 = this.size_0) != null ? tmp$_4.size_8be2vx$ : null;
      tmp$_6 = tmp$_5 + ($receiver_0 != null ? $receiver_0 : '');
    } else {
      tmp$_6 = '';
    }
    var $receiver_1 = (tmp$_8 = this.repeat_0) != null ? tmp$_8.repeat_8be2vx$ : null;
    tmp$_9 = $receiver_1 != null ? $receiver_1 : '';
    var $receiver_2 = (tmp$_10 = this.origin_0) != null ? tmp$_10.origin_8be2vx$ : null;
    tmp$_11 = $receiver_2 != null ? $receiver_2 : '';
    var $receiver_3 = (tmp$_12 = this.clip_0) != null ? tmp$_12.clip_8be2vx$ : null;
    tmp$_13 = $receiver_3 != null ? $receiver_3 : '';
    var $receiver_4 = (tmp$_14 = this.attachment_0) != null ? tmp$_14.attachment_8be2vx$ : null;
    return tmp$_7 + tmp$_6 + ' ' + tmp$_9 + ' ' + tmp$_11 + ' ' + tmp$_13 + ' ' + ($receiver_4 != null ? $receiver_4 : '');
  };
  Background.prototype.toString = function () {
    return this.asString_8be2vx$();
  };
  Background.$metadata$ = {kind: Kind_CLASS, simpleName: 'Background', interfaces: []};
  function CssClass() {
  }
  CssClass.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'CssClass', interfaces: []};
  function DomAttribute() {
  }
  DomAttribute.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'DomAttribute', interfaces: []};
  function SingleObjectCache() {
  }
  SingleObjectCache.prototype.clearOn_u332lz$ = function (shouldClear) {
    return new AutoClearCache(this, shouldClear);
  };
  SingleObjectCache.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'SingleObjectCache', interfaces: []};
  function LazyCache(initializer) {
    this.initializer = initializer;
    this._value_0 = null;
  }
  Object.defineProperty(LazyCache.prototype, 'value', {configurable: true, get: function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this._value_0) != null)
      tmp$_0 = tmp$;
    else {
      var $receiver = this.initializer();
      this._value_0 = $receiver;
      tmp$_0 = $receiver;
    }
    return tmp$_0;
  }});
  LazyCache.prototype.clear = function () {
    this._value_0 = null;
  };
  LazyCache.$metadata$ = {kind: Kind_CLASS, simpleName: 'LazyCache', interfaces: [SingleObjectCache]};
  function AutoClearCache(delegate, shouldClear) {
    this.delegate = delegate;
    this.shouldClear = shouldClear;
  }
  Object.defineProperty(AutoClearCache.prototype, 'value', {configurable: true, get: function () {
    if (this.shouldClear()) {
      this.delegate.clear();
    }return this.delegate.value;
  }});
  AutoClearCache.prototype.clear = function () {
    return this.delegate.clear();
  };
  AutoClearCache.prototype.clearOn_u332lz$ = function (shouldClear) {
    return this.delegate.clearOn_u332lz$(shouldClear);
  };
  AutoClearCache.$metadata$ = {kind: Kind_CLASS, simpleName: 'AutoClearCache', interfaces: [SingleObjectCache]};
  function Style$refreshOnUpdate$lambda(this$Style) {
    return function (it) {
      this$Style.refresh();
      return Unit;
    };
  }
  function Style$refreshOnUpdate$lambda_0(this$Style) {
    return function (it) {
      this$Style.refresh();
      return Unit;
    };
  }
  var PClass$ACTIVE_instance;
  var PClass$CHECKED_instance;
  var PClass$DISABLED_instance;
  var PClass$EMPTY_instance;
  var PClass$ENABLED_instance;
  var PClass$FIRSTCHILD_instance;
  var PClass$FIRSTOFTYPE_instance;
  var PClass$FOCUS_instance;
  var PClass$HOVER_instance;
  var PClass$INRANGE_instance;
  var PClass$INVALID_instance;
  var PClass$LASTCHILD_instance;
  var PClass$LASTOFTYPE_instance;
  var PClass$LINK_instance;
  var PClass$ONLYOFTYPE_instance;
  var PClass$ONLYCHILD_instance;
  var PClass$OPTIONAL_instance;
  var PClass$OUTOFRANGE_instance;
  var PClass$READONLY_instance;
  var PClass$READWRITE_instance;
  var PClass$REQUIRED_instance;
  var PClass$ROOT_instance;
  var PClass$TARGET_instance;
  var PClass$VALID_instance;
  var PClass$VISITED_instance;
  var PElement$AFTER_instance;
  var PElement$BEFORE_instance;
  var PElement$FIRSTLETTER_instance;
  var PElement$FIRSTLINE_instance;
  var PElement$MARKER_instance;
  var PElement$SELECTION_instance;
  function Style(selector, pClass, pElement, mediaQuery, parentStyle, init) {
    Style$Companion_getInstance();
    if (selector === void 0)
      selector = null;
    if (pClass === void 0)
      pClass = null;
    if (pElement === void 0)
      pElement = null;
    if (mediaQuery === void 0)
      mediaQuery = null;
    if (parentStyle === void 0)
      parentStyle = null;
    if (init === void 0)
      init = null;
    StyledComponent.call(this);
    this.parentStyle = parentStyle;
    this.propertyValues_8shy5i$_0 = {};
    var tmp$;
    this.selector = selector != null ? selector : '.kv_styleclass_' + (tmp$ = Style$Companion_getInstance().counter_8be2vx$, Style$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    this.cssClassName_8be2vx$ = last(split(last(split(this.selector, Kotlin.charArrayOf(32))), Kotlin.charArrayOf(46)));
    this.pClass_mmj6hj$_0 = (new Style$RefreshDelegateProvider(this, pClass, Style$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Style$pClass_metadata);
    this.customPClass_635oqw$_0 = (new Style$RefreshDelegateProvider(this, null, Style$refreshOnUpdate$lambda_0(this))).provideDelegate_n5byny$(this, Style$customPClass_metadata);
    this.pElement_jmqjq3$_0 = (new Style$RefreshDelegateProvider(this, pElement, Style$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Style$pElement_metadata);
    this.mediaQuery_ur3vn7$_0 = (new Style$RefreshDelegateProvider(this, mediaQuery, Style$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Style$mediaQuery_metadata);
    Style$Companion_getInstance().styles_8be2vx$.add_11rb$(this);
    init != null ? init(this) : null;
  }
  var Style$pClass_metadata = new PropertyMetadata('pClass');
  Object.defineProperty(Style.prototype, 'pClass', {configurable: true, get: function () {
    return this.pClass_mmj6hj$_0.getValue_fmbzy8$(this, Style$pClass_metadata);
  }, set: function (pClass) {
    this.pClass_mmj6hj$_0.setValue_19qrsr$(this, Style$pClass_metadata, pClass);
  }});
  var Style$customPClass_metadata = new PropertyMetadata('customPClass');
  Object.defineProperty(Style.prototype, 'customPClass', {configurable: true, get: function () {
    return this.customPClass_635oqw$_0.getValue_fmbzy8$(this, Style$customPClass_metadata);
  }, set: function (customPClass) {
    this.customPClass_635oqw$_0.setValue_19qrsr$(this, Style$customPClass_metadata, customPClass);
  }});
  var Style$pElement_metadata = new PropertyMetadata('pElement');
  Object.defineProperty(Style.prototype, 'pElement', {configurable: true, get: function () {
    return this.pElement_jmqjq3$_0.getValue_fmbzy8$(this, Style$pElement_metadata);
  }, set: function (pElement) {
    this.pElement_jmqjq3$_0.setValue_19qrsr$(this, Style$pElement_metadata, pElement);
  }});
  var Style$mediaQuery_metadata = new PropertyMetadata('mediaQuery');
  Object.defineProperty(Style.prototype, 'mediaQuery', {configurable: true, get: function () {
    return this.mediaQuery_ur3vn7$_0.getValue_fmbzy8$(this, Style$mediaQuery_metadata);
  }, set: function (mediaQuery) {
    this.mediaQuery_ur3vn7$_0.setValue_19qrsr$(this, Style$mediaQuery_metadata, mediaQuery);
  }});
  Style.prototype.getStyleDeclaration = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6;
    var pseudoElementName = (tmp$_0 = (tmp$ = this.pElement) != null ? '::' + tmp$.pname_8be2vx$ : null) != null ? tmp$_0 : '';
    var pseudoClassName = (tmp$_4 = (tmp$_3 = (tmp$_1 = this.customPClass) != null ? ':' + tmp$_1 : null) != null ? tmp$_3 : (tmp$_2 = this.pClass) != null ? ':' + tmp$_2.pname_8be2vx$ : null) != null ? tmp$_4 : '';
    var fullSelector = this.selector + pseudoElementName + pseudoClassName;
    return ((tmp$_6 = (tmp$_5 = this.parentStyle) != null ? tmp$_5.getStyleDeclaration() + ' ' : null) != null ? tmp$_6 : '') + fullSelector;
  };
  function Style$generateStyle$lambda(it) {
    return it.first + ': ' + it.second + ';';
  }
  Style.prototype.generateStyle_8be2vx$ = function () {
    var tmp$;
    var styles = this.getSnStyle();
    var stylesList = ArrayList_init();
    tmp$ = iterator(Object.keys(styles));
    while (tmp$.hasNext()) {
      var key = tmp$.next();
      stylesList.add_11rb$(to(key, styles[key]));
    }
    return this.getStyleDeclaration() + ' {' + '\n' + joinToString(stylesList, '\n', void 0, void 0, void 0, void 0, Style$generateStyle$lambda) + '\n}';
  };
  Style.prototype.refresh = function () {
    var tmp$;
    StyledComponent.prototype.refresh.call(this);
    if ((tmp$ = Root$Companion_getInstance().getFirstRoot()) != null) {
      tmp$.clearStylesCache_8be2vx$();
      tmp$.reRender_8be2vx$();
    }return this;
  };
  Style.prototype.refreshOnUpdate_7qq44f$ = defineInlineFunction('kvision-js-legacy.io.kvision.core.Style.refreshOnUpdate_7qq44f$', wrapFunction(function () {
    var Unit = Kotlin.kotlin.Unit;
    var Style$Style$RefreshDelegateProvider_init = _.io.kvision.core.Style.RefreshDelegateProvider;
    function Style$refreshOnUpdate$lambda(this$Style) {
      return function (it) {
        this$Style.refresh();
        return Unit;
      };
    }
    return function (refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = Style$refreshOnUpdate$lambda(this);
      return new Style$Style$RefreshDelegateProvider_init(this, null, refreshFunction);
    };
  }));
  Style.prototype.refreshOnUpdate_7uhc0p$ = defineInlineFunction('kvision-js-legacy.io.kvision.core.Style.refreshOnUpdate_7uhc0p$', wrapFunction(function () {
    var Unit = Kotlin.kotlin.Unit;
    var Style$Style$RefreshDelegateProvider_init = _.io.kvision.core.Style.RefreshDelegateProvider;
    function Style$refreshOnUpdate$lambda(this$Style) {
      return function (it) {
        this$Style.refresh();
        return Unit;
      };
    }
    return function (initialValue, refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = Style$refreshOnUpdate$lambda(this);
      return new Style$Style$RefreshDelegateProvider_init(this, initialValue, refreshFunction);
    };
  }));
  function Style$RefreshDelegateProvider($outer, initialValue, refreshFunction) {
    this.$outer = $outer;
    this.initialValue_0 = initialValue;
    this.refreshFunction_0 = refreshFunction;
  }
  Style$RefreshDelegateProvider.prototype.provideDelegate_n5byny$ = function (thisRef, prop) {
    if (this.initialValue_0 != null)
      this.$outer.propertyValues_8shy5i$_0[prop.callableName] = this.initialValue_0;
    return new Style$RefreshDelegate(this.$outer, this.refreshFunction_0);
  };
  Style$RefreshDelegateProvider.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegateProvider', interfaces: []};
  function Style$RefreshDelegate($outer, refreshFunction) {
    this.$outer = $outer;
    this.refreshFunction_0 = refreshFunction;
  }
  Style$RefreshDelegate.prototype.getValue_fmbzy8$ = function (thisRef, property) {
    var tmp$;
    var value = this.$outer.propertyValues_8shy5i$_0[property.callableName];
    if (value != null) {
      tmp$ = value;
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  Style$RefreshDelegate.prototype.setValue_19qrsr$ = function (thisRef, property, value) {
    this.$outer.propertyValues_8shy5i$_0[property.callableName] = value;
    this.refreshFunction_0(value);
  };
  Style$RefreshDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegate', interfaces: []};
  function Style$Companion() {
    Style$Companion_instance = this;
    this.counter_8be2vx$ = 0;
    this.styles_8be2vx$ = ArrayList_init();
  }
  Style$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Style$Companion_instance = null;
  function Style$Companion_getInstance() {
    if (Style$Companion_instance === null) {
      new Style$Companion();
    }return Style$Companion_instance;
  }
  Style.$metadata$ = {kind: Kind_CLASS, simpleName: 'Style', interfaces: [StyledComponent]};
  function style_0($receiver, selector, pClass, pElement, mediaQuery, init) {
    if (selector === void 0)
      selector = null;
    if (pClass === void 0)
      pClass = null;
    if (pElement === void 0)
      pElement = null;
    if (mediaQuery === void 0)
      mediaQuery = null;
    if (init === void 0)
      init = null;
    var style = new Style(selector, pClass, pElement, mediaQuery, null, init);
    $receiver.addCssStyle_807zt1$(style);
    return style;
  }
  function StyledComponent() {
    this.propertyValues_mhxfgz$_0 = {};
    this.propertyStyles_ccf0vh$_0 = {};
    this.snStyleCache_4me8oy$_0 = null;
    this.width_kzal5o$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$width$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$width_metadata);
    this.minWidth_k32s5m$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$minWidth$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$minWidth_metadata);
    this.maxWidth_wuzofs$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$maxWidth$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$maxWidth_metadata);
    this.height_k0dlj1$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$height$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$height_metadata);
    this.minHeight_7qcdip$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$minHeight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$minHeight_metadata);
    this.maxHeight_x5f5cx$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$maxHeight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$maxHeight_metadata);
    this.display_wr589k$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$display$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$display_metadata);
    this.position_371c01$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$position$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$position_metadata);
    this.top_bh8wb$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$top$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$top_metadata);
    this.left_a0fkf1$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$left$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$left_metadata);
    this.right_nch0s2$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$right$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$right_metadata);
    this.bottom_w4wukh$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$bottom$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$bottom_metadata);
    this.zIndex_hwuxea$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$zIndex$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$zIndex_metadata);
    this.overflow_xeq3ig$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$overflow$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$overflow_metadata);
    this.overflowX_ts7rzg$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$overflowX$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$overflowX_metadata);
    this.overflowY_ts7ryl$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$overflowY$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$overflowY_metadata);
    this.overflowWrap_tjkgm6$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$overflowWrap$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$overflowWrap_metadata);
    this.resize_f53acq$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$resize$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$resize_metadata);
    this.border_w6auua$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$border$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$border_metadata);
    this.borderTop_zdbls1$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$borderTop$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderTop_metadata);
    this.borderRight_y7onae$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$borderRight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderRight_metadata);
    this.borderBottom_duwyh9$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$borderBottom$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderBottom_metadata);
    this.borderLeft_uvq0wn$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$borderLeft$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderLeft_metadata);
    this.margin_jeqk10$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$margin$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$margin_metadata);
    this.marginTop_x8pxtp$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$marginTop$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginTop_metadata);
    this.marginRight_h2q0ws$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$marginRight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginRight_metadata);
    this.marginBottom_df8o8h$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$marginBottom$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginBottom_metadata);
    this.marginLeft_ytrsgl$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$marginLeft$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$marginLeft_metadata);
    this.padding_oohi13$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$padding$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$padding_metadata);
    this.paddingTop_610hdm$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$paddingTop$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingTop_metadata);
    this.paddingRight_uftvbz$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$paddingRight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingRight_metadata);
    this.paddingBottom_1ivjgu$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$paddingBottom$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingBottom_metadata);
    this.paddingLeft_q3calu$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$paddingLeft$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$paddingLeft_metadata);
    this.color_ucr921$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$color$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$color_metadata);
    this.opacity_n5xnen$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$opacity$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$opacity_metadata);
    this.background_ox5nxg$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$background$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$background_metadata);
    this.textDirection_sm05k8$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textDirection$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textDirection_metadata);
    this.letterSpacing_ec5ik3$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$letterSpacing$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$letterSpacing_metadata);
    this.lineHeight_wk48nl$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$lineHeight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$lineHeight_metadata);
    this.textAlign_r5zeky$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textAlign$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textAlign_metadata);
    this.textDecoration_2yphpp$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textDecoration$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textDecoration_metadata);
    this.textIndent_xzlwjz$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textIndent$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textIndent_metadata);
    this.textShadow_w5swlf$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textShadow$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textShadow_metadata);
    this.textTransform_a57yiz$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textTransform$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textTransform_metadata);
    this.textOverflow_bkrw63$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$textOverflow$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$textOverflow_metadata);
    this.unicodeBidi_qqq9rz$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$unicodeBidi$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$unicodeBidi_metadata);
    this.verticalAlign_nohwyj$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$verticalAlign$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$verticalAlign_metadata);
    this.whiteSpace_3js5sd$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$whiteSpace$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$whiteSpace_metadata);
    this.wordSpacing_xblwen$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$wordSpacing$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$wordSpacing_metadata);
    this.fontFamily_u6vlcn$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$fontFamily$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontFamily_metadata);
    this.fontSize_kc6tju$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$fontSize$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontSize_metadata);
    this.fontStyle_8m3rw8$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$fontStyle$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontStyle_metadata);
    this.fontWeight_2kvum5$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$fontWeight$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontWeight_metadata);
    this.fontVariant_l61898$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$fontVariant$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$fontVariant_metadata);
    this.float_sz850y$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$float$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$float_metadata);
    this.clear_ueje4j$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$clear$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$clear_metadata);
    this.wordBreak_ll65md$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$wordBreak$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$wordBreak_metadata);
    this.lineBreak_5zhswx$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$lineBreak$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$lineBreak_metadata);
    this.cursor_end218$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$cursor$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$cursor_metadata);
    this.flexDirection_xxd36k$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$flexDirection$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexDirection_metadata);
    this.flexWrap_gtlwuf$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$flexWrap$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexWrap_metadata);
    this.justifyItems_aujwue$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$justifyItems$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$justifyItems_metadata);
    this.justifyContent_cxcf4v$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$justifyContent$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$justifyContent_metadata);
    this.alignItems_t3q0y9$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$alignItems$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$alignItems_metadata);
    this.alignContent_b2qiay$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$alignContent$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$alignContent_metadata);
    this.order_omppus$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$order$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$order_metadata);
    this.flexGrow_gkthwe$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$flexGrow$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexGrow_metadata);
    this.flexShrink_kteuxk$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$flexShrink$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexShrink_metadata);
    this.flexBasis_e33pz9$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$flexBasis$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$flexBasis_metadata);
    this.alignSelf_c8zyhz$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$alignSelf$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$alignSelf_metadata);
    this.justifySelf_9db8r6$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$justifySelf$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$justifySelf_metadata);
    this.gridAutoColumns_xba5ia$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridAutoColumns$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridAutoColumns_metadata);
    this.gridAutoRows_rirek$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridAutoRows$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridAutoRows_metadata);
    this.gridAutoFlow_kv5hj$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridAutoFlow$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridAutoFlow_metadata);
    this.gridTemplateColumns_vo4ai5$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridTemplateColumns$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridTemplateColumns_metadata);
    this.gridTemplateRows_ho38ep$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridTemplateRows$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridTemplateRows_metadata);
    this.gridTemplateAreas_sik7rw$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridTemplateAreas$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridTemplateAreas_metadata);
    this.gridColumnGap_493brk$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridColumnGap$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridColumnGap_metadata);
    this.gridRowGap_3z3jk8$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridRowGap$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridRowGap_metadata);
    this.gridColumnStart_vzmqfw$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridColumnStart$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridColumnStart_metadata);
    this.gridRowStart_9rqkas$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridRowStart$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridRowStart_metadata);
    this.gridColumnEnd_494cdx$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridColumnEnd$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridColumnEnd_metadata);
    this.gridRowEnd_3z2ixv$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridRowEnd$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridRowEnd_metadata);
    this.gridArea_4bi4y1$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$gridArea$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$gridArea_metadata);
    this.outline_ynlug8$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$outline$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$outline_metadata);
    this.boxShadow_uzi9dr$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$boxShadow$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$boxShadow_metadata);
    this.boxShadowList_4x0mm9$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$boxShadowList$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$boxShadowList_metadata);
    this.transition_cs5j8r$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$transition$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$transition_metadata);
    this.transitionList_5ctkx5$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$transitionList$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$transitionList_metadata);
    this.borderRadius_10h3vw$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$borderRadius$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderRadius_metadata);
    this.borderRadiusList_m77vu6$_0 = (new StyledComponent$RefreshDelegateProvider(this, StyledComponent$borderRadiusList$lambda(this))).provideDelegate_n5byny$(this, StyledComponent$borderRadiusList_metadata);
  }
  StyledComponent.prototype.setStyleProperty_f2ncb9$_0 = function (key, value) {
    if (value != null) {
      this.propertyStyles_ccf0vh$_0[key] = value;
    } else {
      delete_0(this.propertyStyles_ccf0vh$_0, key);
    }
  };
  var StyledComponent$width_metadata = new PropertyMetadata('width');
  Object.defineProperty(StyledComponent.prototype, 'width', {configurable: true, get: function () {
    return this.width_kzal5o$_0.getValue_fmbzy8$(this, StyledComponent$width_metadata);
  }, set: function (width) {
    this.width_kzal5o$_0.setValue_19qrsr$(this, StyledComponent$width_metadata, width);
  }});
  var StyledComponent$minWidth_metadata = new PropertyMetadata('minWidth');
  Object.defineProperty(StyledComponent.prototype, 'minWidth', {configurable: true, get: function () {
    return this.minWidth_k32s5m$_0.getValue_fmbzy8$(this, StyledComponent$minWidth_metadata);
  }, set: function (minWidth) {
    this.minWidth_k32s5m$_0.setValue_19qrsr$(this, StyledComponent$minWidth_metadata, minWidth);
  }});
  var StyledComponent$maxWidth_metadata = new PropertyMetadata('maxWidth');
  Object.defineProperty(StyledComponent.prototype, 'maxWidth', {configurable: true, get: function () {
    return this.maxWidth_wuzofs$_0.getValue_fmbzy8$(this, StyledComponent$maxWidth_metadata);
  }, set: function (maxWidth) {
    this.maxWidth_wuzofs$_0.setValue_19qrsr$(this, StyledComponent$maxWidth_metadata, maxWidth);
  }});
  var StyledComponent$height_metadata = new PropertyMetadata('height');
  Object.defineProperty(StyledComponent.prototype, 'height', {configurable: true, get: function () {
    return this.height_k0dlj1$_0.getValue_fmbzy8$(this, StyledComponent$height_metadata);
  }, set: function (height) {
    this.height_k0dlj1$_0.setValue_19qrsr$(this, StyledComponent$height_metadata, height);
  }});
  var StyledComponent$minHeight_metadata = new PropertyMetadata('minHeight');
  Object.defineProperty(StyledComponent.prototype, 'minHeight', {configurable: true, get: function () {
    return this.minHeight_7qcdip$_0.getValue_fmbzy8$(this, StyledComponent$minHeight_metadata);
  }, set: function (minHeight) {
    this.minHeight_7qcdip$_0.setValue_19qrsr$(this, StyledComponent$minHeight_metadata, minHeight);
  }});
  var StyledComponent$maxHeight_metadata = new PropertyMetadata('maxHeight');
  Object.defineProperty(StyledComponent.prototype, 'maxHeight', {configurable: true, get: function () {
    return this.maxHeight_x5f5cx$_0.getValue_fmbzy8$(this, StyledComponent$maxHeight_metadata);
  }, set: function (maxHeight) {
    this.maxHeight_x5f5cx$_0.setValue_19qrsr$(this, StyledComponent$maxHeight_metadata, maxHeight);
  }});
  var StyledComponent$display_metadata = new PropertyMetadata('display');
  Object.defineProperty(StyledComponent.prototype, 'display', {configurable: true, get: function () {
    return this.display_wr589k$_0.getValue_fmbzy8$(this, StyledComponent$display_metadata);
  }, set: function (display) {
    this.display_wr589k$_0.setValue_19qrsr$(this, StyledComponent$display_metadata, display);
  }});
  var StyledComponent$position_metadata = new PropertyMetadata('position');
  Object.defineProperty(StyledComponent.prototype, 'position', {configurable: true, get: function () {
    return this.position_371c01$_0.getValue_fmbzy8$(this, StyledComponent$position_metadata);
  }, set: function (position) {
    this.position_371c01$_0.setValue_19qrsr$(this, StyledComponent$position_metadata, position);
  }});
  var StyledComponent$top_metadata = new PropertyMetadata('top');
  Object.defineProperty(StyledComponent.prototype, 'top', {configurable: true, get: function () {
    return this.top_bh8wb$_0.getValue_fmbzy8$(this, StyledComponent$top_metadata);
  }, set: function (top) {
    this.top_bh8wb$_0.setValue_19qrsr$(this, StyledComponent$top_metadata, top);
  }});
  var StyledComponent$left_metadata = new PropertyMetadata('left');
  Object.defineProperty(StyledComponent.prototype, 'left', {configurable: true, get: function () {
    return this.left_a0fkf1$_0.getValue_fmbzy8$(this, StyledComponent$left_metadata);
  }, set: function (left) {
    this.left_a0fkf1$_0.setValue_19qrsr$(this, StyledComponent$left_metadata, left);
  }});
  var StyledComponent$right_metadata = new PropertyMetadata('right');
  Object.defineProperty(StyledComponent.prototype, 'right', {configurable: true, get: function () {
    return this.right_nch0s2$_0.getValue_fmbzy8$(this, StyledComponent$right_metadata);
  }, set: function (right) {
    this.right_nch0s2$_0.setValue_19qrsr$(this, StyledComponent$right_metadata, right);
  }});
  var StyledComponent$bottom_metadata = new PropertyMetadata('bottom');
  Object.defineProperty(StyledComponent.prototype, 'bottom', {configurable: true, get: function () {
    return this.bottom_w4wukh$_0.getValue_fmbzy8$(this, StyledComponent$bottom_metadata);
  }, set: function (bottom) {
    this.bottom_w4wukh$_0.setValue_19qrsr$(this, StyledComponent$bottom_metadata, bottom);
  }});
  var StyledComponent$zIndex_metadata = new PropertyMetadata('zIndex');
  Object.defineProperty(StyledComponent.prototype, 'zIndex', {configurable: true, get: function () {
    return this.zIndex_hwuxea$_0.getValue_fmbzy8$(this, StyledComponent$zIndex_metadata);
  }, set: function (zIndex) {
    this.zIndex_hwuxea$_0.setValue_19qrsr$(this, StyledComponent$zIndex_metadata, zIndex);
  }});
  var StyledComponent$overflow_metadata = new PropertyMetadata('overflow');
  Object.defineProperty(StyledComponent.prototype, 'overflow', {configurable: true, get: function () {
    return this.overflow_xeq3ig$_0.getValue_fmbzy8$(this, StyledComponent$overflow_metadata);
  }, set: function (overflow) {
    this.overflow_xeq3ig$_0.setValue_19qrsr$(this, StyledComponent$overflow_metadata, overflow);
  }});
  var StyledComponent$overflowX_metadata = new PropertyMetadata('overflowX');
  Object.defineProperty(StyledComponent.prototype, 'overflowX', {configurable: true, get: function () {
    return this.overflowX_ts7rzg$_0.getValue_fmbzy8$(this, StyledComponent$overflowX_metadata);
  }, set: function (overflowX) {
    this.overflowX_ts7rzg$_0.setValue_19qrsr$(this, StyledComponent$overflowX_metadata, overflowX);
  }});
  var StyledComponent$overflowY_metadata = new PropertyMetadata('overflowY');
  Object.defineProperty(StyledComponent.prototype, 'overflowY', {configurable: true, get: function () {
    return this.overflowY_ts7ryl$_0.getValue_fmbzy8$(this, StyledComponent$overflowY_metadata);
  }, set: function (overflowY) {
    this.overflowY_ts7ryl$_0.setValue_19qrsr$(this, StyledComponent$overflowY_metadata, overflowY);
  }});
  var StyledComponent$overflowWrap_metadata = new PropertyMetadata('overflowWrap');
  Object.defineProperty(StyledComponent.prototype, 'overflowWrap', {configurable: true, get: function () {
    return this.overflowWrap_tjkgm6$_0.getValue_fmbzy8$(this, StyledComponent$overflowWrap_metadata);
  }, set: function (overflowWrap) {
    this.overflowWrap_tjkgm6$_0.setValue_19qrsr$(this, StyledComponent$overflowWrap_metadata, overflowWrap);
  }});
  var StyledComponent$resize_metadata = new PropertyMetadata('resize');
  Object.defineProperty(StyledComponent.prototype, 'resize', {configurable: true, get: function () {
    return this.resize_f53acq$_0.getValue_fmbzy8$(this, StyledComponent$resize_metadata);
  }, set: function (resize) {
    this.resize_f53acq$_0.setValue_19qrsr$(this, StyledComponent$resize_metadata, resize);
  }});
  var StyledComponent$border_metadata = new PropertyMetadata('border');
  Object.defineProperty(StyledComponent.prototype, 'border', {configurable: true, get: function () {
    return this.border_w6auua$_0.getValue_fmbzy8$(this, StyledComponent$border_metadata);
  }, set: function (border) {
    this.border_w6auua$_0.setValue_19qrsr$(this, StyledComponent$border_metadata, border);
  }});
  var StyledComponent$borderTop_metadata = new PropertyMetadata('borderTop');
  Object.defineProperty(StyledComponent.prototype, 'borderTop', {configurable: true, get: function () {
    return this.borderTop_zdbls1$_0.getValue_fmbzy8$(this, StyledComponent$borderTop_metadata);
  }, set: function (borderTop) {
    this.borderTop_zdbls1$_0.setValue_19qrsr$(this, StyledComponent$borderTop_metadata, borderTop);
  }});
  var StyledComponent$borderRight_metadata = new PropertyMetadata('borderRight');
  Object.defineProperty(StyledComponent.prototype, 'borderRight', {configurable: true, get: function () {
    return this.borderRight_y7onae$_0.getValue_fmbzy8$(this, StyledComponent$borderRight_metadata);
  }, set: function (borderRight) {
    this.borderRight_y7onae$_0.setValue_19qrsr$(this, StyledComponent$borderRight_metadata, borderRight);
  }});
  var StyledComponent$borderBottom_metadata = new PropertyMetadata('borderBottom');
  Object.defineProperty(StyledComponent.prototype, 'borderBottom', {configurable: true, get: function () {
    return this.borderBottom_duwyh9$_0.getValue_fmbzy8$(this, StyledComponent$borderBottom_metadata);
  }, set: function (borderBottom) {
    this.borderBottom_duwyh9$_0.setValue_19qrsr$(this, StyledComponent$borderBottom_metadata, borderBottom);
  }});
  var StyledComponent$borderLeft_metadata = new PropertyMetadata('borderLeft');
  Object.defineProperty(StyledComponent.prototype, 'borderLeft', {configurable: true, get: function () {
    return this.borderLeft_uvq0wn$_0.getValue_fmbzy8$(this, StyledComponent$borderLeft_metadata);
  }, set: function (borderLeft) {
    this.borderLeft_uvq0wn$_0.setValue_19qrsr$(this, StyledComponent$borderLeft_metadata, borderLeft);
  }});
  var StyledComponent$margin_metadata = new PropertyMetadata('margin');
  Object.defineProperty(StyledComponent.prototype, 'margin', {configurable: true, get: function () {
    return this.margin_jeqk10$_0.getValue_fmbzy8$(this, StyledComponent$margin_metadata);
  }, set: function (margin) {
    this.margin_jeqk10$_0.setValue_19qrsr$(this, StyledComponent$margin_metadata, margin);
  }});
  var StyledComponent$marginTop_metadata = new PropertyMetadata('marginTop');
  Object.defineProperty(StyledComponent.prototype, 'marginTop', {configurable: true, get: function () {
    return this.marginTop_x8pxtp$_0.getValue_fmbzy8$(this, StyledComponent$marginTop_metadata);
  }, set: function (marginTop) {
    this.marginTop_x8pxtp$_0.setValue_19qrsr$(this, StyledComponent$marginTop_metadata, marginTop);
  }});
  var StyledComponent$marginRight_metadata = new PropertyMetadata('marginRight');
  Object.defineProperty(StyledComponent.prototype, 'marginRight', {configurable: true, get: function () {
    return this.marginRight_h2q0ws$_0.getValue_fmbzy8$(this, StyledComponent$marginRight_metadata);
  }, set: function (marginRight) {
    this.marginRight_h2q0ws$_0.setValue_19qrsr$(this, StyledComponent$marginRight_metadata, marginRight);
  }});
  var StyledComponent$marginBottom_metadata = new PropertyMetadata('marginBottom');
  Object.defineProperty(StyledComponent.prototype, 'marginBottom', {configurable: true, get: function () {
    return this.marginBottom_df8o8h$_0.getValue_fmbzy8$(this, StyledComponent$marginBottom_metadata);
  }, set: function (marginBottom) {
    this.marginBottom_df8o8h$_0.setValue_19qrsr$(this, StyledComponent$marginBottom_metadata, marginBottom);
  }});
  var StyledComponent$marginLeft_metadata = new PropertyMetadata('marginLeft');
  Object.defineProperty(StyledComponent.prototype, 'marginLeft', {configurable: true, get: function () {
    return this.marginLeft_ytrsgl$_0.getValue_fmbzy8$(this, StyledComponent$marginLeft_metadata);
  }, set: function (marginLeft) {
    this.marginLeft_ytrsgl$_0.setValue_19qrsr$(this, StyledComponent$marginLeft_metadata, marginLeft);
  }});
  var StyledComponent$padding_metadata = new PropertyMetadata('padding');
  Object.defineProperty(StyledComponent.prototype, 'padding', {configurable: true, get: function () {
    return this.padding_oohi13$_0.getValue_fmbzy8$(this, StyledComponent$padding_metadata);
  }, set: function (padding) {
    this.padding_oohi13$_0.setValue_19qrsr$(this, StyledComponent$padding_metadata, padding);
  }});
  var StyledComponent$paddingTop_metadata = new PropertyMetadata('paddingTop');
  Object.defineProperty(StyledComponent.prototype, 'paddingTop', {configurable: true, get: function () {
    return this.paddingTop_610hdm$_0.getValue_fmbzy8$(this, StyledComponent$paddingTop_metadata);
  }, set: function (paddingTop) {
    this.paddingTop_610hdm$_0.setValue_19qrsr$(this, StyledComponent$paddingTop_metadata, paddingTop);
  }});
  var StyledComponent$paddingRight_metadata = new PropertyMetadata('paddingRight');
  Object.defineProperty(StyledComponent.prototype, 'paddingRight', {configurable: true, get: function () {
    return this.paddingRight_uftvbz$_0.getValue_fmbzy8$(this, StyledComponent$paddingRight_metadata);
  }, set: function (paddingRight) {
    this.paddingRight_uftvbz$_0.setValue_19qrsr$(this, StyledComponent$paddingRight_metadata, paddingRight);
  }});
  var StyledComponent$paddingBottom_metadata = new PropertyMetadata('paddingBottom');
  Object.defineProperty(StyledComponent.prototype, 'paddingBottom', {configurable: true, get: function () {
    return this.paddingBottom_1ivjgu$_0.getValue_fmbzy8$(this, StyledComponent$paddingBottom_metadata);
  }, set: function (paddingBottom) {
    this.paddingBottom_1ivjgu$_0.setValue_19qrsr$(this, StyledComponent$paddingBottom_metadata, paddingBottom);
  }});
  var StyledComponent$paddingLeft_metadata = new PropertyMetadata('paddingLeft');
  Object.defineProperty(StyledComponent.prototype, 'paddingLeft', {configurable: true, get: function () {
    return this.paddingLeft_q3calu$_0.getValue_fmbzy8$(this, StyledComponent$paddingLeft_metadata);
  }, set: function (paddingLeft) {
    this.paddingLeft_q3calu$_0.setValue_19qrsr$(this, StyledComponent$paddingLeft_metadata, paddingLeft);
  }});
  var StyledComponent$color_metadata = new PropertyMetadata('color');
  Object.defineProperty(StyledComponent.prototype, 'color', {configurable: true, get: function () {
    return this.color_ucr921$_0.getValue_fmbzy8$(this, StyledComponent$color_metadata);
  }, set: function (color) {
    this.color_ucr921$_0.setValue_19qrsr$(this, StyledComponent$color_metadata, color);
  }});
  Object.defineProperty(StyledComponent.prototype, 'colorHex', {configurable: true, get: function () {
    return null;
  }, set: function (value) {
    this.color = value != null ? Color$Companion_getInstance().hex_za3lpa$(value) : null;
  }});
  Object.defineProperty(StyledComponent.prototype, 'colorName', {configurable: true, get: function () {
    return null;
  }, set: function (value) {
    this.color = value != null ? Color$Companion_getInstance().name_fntfe4$(value) : null;
  }});
  var StyledComponent$opacity_metadata = new PropertyMetadata('opacity');
  Object.defineProperty(StyledComponent.prototype, 'opacity', {configurable: true, get: function () {
    return this.opacity_n5xnen$_0.getValue_fmbzy8$(this, StyledComponent$opacity_metadata);
  }, set: function (opacity) {
    this.opacity_n5xnen$_0.setValue_19qrsr$(this, StyledComponent$opacity_metadata, opacity);
  }});
  var StyledComponent$background_metadata = new PropertyMetadata('background');
  Object.defineProperty(StyledComponent.prototype, 'background', {configurable: true, get: function () {
    return this.background_ox5nxg$_0.getValue_fmbzy8$(this, StyledComponent$background_metadata);
  }, set: function (background) {
    this.background_ox5nxg$_0.setValue_19qrsr$(this, StyledComponent$background_metadata, background);
  }});
  var StyledComponent$textDirection_metadata = new PropertyMetadata('textDirection');
  Object.defineProperty(StyledComponent.prototype, 'textDirection', {configurable: true, get: function () {
    return this.textDirection_sm05k8$_0.getValue_fmbzy8$(this, StyledComponent$textDirection_metadata);
  }, set: function (textDirection) {
    this.textDirection_sm05k8$_0.setValue_19qrsr$(this, StyledComponent$textDirection_metadata, textDirection);
  }});
  var StyledComponent$letterSpacing_metadata = new PropertyMetadata('letterSpacing');
  Object.defineProperty(StyledComponent.prototype, 'letterSpacing', {configurable: true, get: function () {
    return this.letterSpacing_ec5ik3$_0.getValue_fmbzy8$(this, StyledComponent$letterSpacing_metadata);
  }, set: function (letterSpacing) {
    this.letterSpacing_ec5ik3$_0.setValue_19qrsr$(this, StyledComponent$letterSpacing_metadata, letterSpacing);
  }});
  var StyledComponent$lineHeight_metadata = new PropertyMetadata('lineHeight');
  Object.defineProperty(StyledComponent.prototype, 'lineHeight', {configurable: true, get: function () {
    return this.lineHeight_wk48nl$_0.getValue_fmbzy8$(this, StyledComponent$lineHeight_metadata);
  }, set: function (lineHeight) {
    this.lineHeight_wk48nl$_0.setValue_19qrsr$(this, StyledComponent$lineHeight_metadata, lineHeight);
  }});
  var StyledComponent$textAlign_metadata = new PropertyMetadata('textAlign');
  Object.defineProperty(StyledComponent.prototype, 'textAlign', {configurable: true, get: function () {
    return this.textAlign_r5zeky$_0.getValue_fmbzy8$(this, StyledComponent$textAlign_metadata);
  }, set: function (textAlign) {
    this.textAlign_r5zeky$_0.setValue_19qrsr$(this, StyledComponent$textAlign_metadata, textAlign);
  }});
  var StyledComponent$textDecoration_metadata = new PropertyMetadata('textDecoration');
  Object.defineProperty(StyledComponent.prototype, 'textDecoration', {configurable: true, get: function () {
    return this.textDecoration_2yphpp$_0.getValue_fmbzy8$(this, StyledComponent$textDecoration_metadata);
  }, set: function (textDecoration) {
    this.textDecoration_2yphpp$_0.setValue_19qrsr$(this, StyledComponent$textDecoration_metadata, textDecoration);
  }});
  var StyledComponent$textIndent_metadata = new PropertyMetadata('textIndent');
  Object.defineProperty(StyledComponent.prototype, 'textIndent', {configurable: true, get: function () {
    return this.textIndent_xzlwjz$_0.getValue_fmbzy8$(this, StyledComponent$textIndent_metadata);
  }, set: function (textIndent) {
    this.textIndent_xzlwjz$_0.setValue_19qrsr$(this, StyledComponent$textIndent_metadata, textIndent);
  }});
  var StyledComponent$textShadow_metadata = new PropertyMetadata('textShadow');
  Object.defineProperty(StyledComponent.prototype, 'textShadow', {configurable: true, get: function () {
    return this.textShadow_w5swlf$_0.getValue_fmbzy8$(this, StyledComponent$textShadow_metadata);
  }, set: function (textShadow) {
    this.textShadow_w5swlf$_0.setValue_19qrsr$(this, StyledComponent$textShadow_metadata, textShadow);
  }});
  var StyledComponent$textTransform_metadata = new PropertyMetadata('textTransform');
  Object.defineProperty(StyledComponent.prototype, 'textTransform', {configurable: true, get: function () {
    return this.textTransform_a57yiz$_0.getValue_fmbzy8$(this, StyledComponent$textTransform_metadata);
  }, set: function (textTransform) {
    this.textTransform_a57yiz$_0.setValue_19qrsr$(this, StyledComponent$textTransform_metadata, textTransform);
  }});
  var StyledComponent$textOverflow_metadata = new PropertyMetadata('textOverflow');
  Object.defineProperty(StyledComponent.prototype, 'textOverflow', {configurable: true, get: function () {
    return this.textOverflow_bkrw63$_0.getValue_fmbzy8$(this, StyledComponent$textOverflow_metadata);
  }, set: function (textOverflow) {
    this.textOverflow_bkrw63$_0.setValue_19qrsr$(this, StyledComponent$textOverflow_metadata, textOverflow);
  }});
  var StyledComponent$unicodeBidi_metadata = new PropertyMetadata('unicodeBidi');
  Object.defineProperty(StyledComponent.prototype, 'unicodeBidi', {configurable: true, get: function () {
    return this.unicodeBidi_qqq9rz$_0.getValue_fmbzy8$(this, StyledComponent$unicodeBidi_metadata);
  }, set: function (unicodeBidi) {
    this.unicodeBidi_qqq9rz$_0.setValue_19qrsr$(this, StyledComponent$unicodeBidi_metadata, unicodeBidi);
  }});
  var StyledComponent$verticalAlign_metadata = new PropertyMetadata('verticalAlign');
  Object.defineProperty(StyledComponent.prototype, 'verticalAlign', {configurable: true, get: function () {
    return this.verticalAlign_nohwyj$_0.getValue_fmbzy8$(this, StyledComponent$verticalAlign_metadata);
  }, set: function (verticalAlign) {
    this.verticalAlign_nohwyj$_0.setValue_19qrsr$(this, StyledComponent$verticalAlign_metadata, verticalAlign);
  }});
  var StyledComponent$whiteSpace_metadata = new PropertyMetadata('whiteSpace');
  Object.defineProperty(StyledComponent.prototype, 'whiteSpace', {configurable: true, get: function () {
    return this.whiteSpace_3js5sd$_0.getValue_fmbzy8$(this, StyledComponent$whiteSpace_metadata);
  }, set: function (whiteSpace) {
    this.whiteSpace_3js5sd$_0.setValue_19qrsr$(this, StyledComponent$whiteSpace_metadata, whiteSpace);
  }});
  var StyledComponent$wordSpacing_metadata = new PropertyMetadata('wordSpacing');
  Object.defineProperty(StyledComponent.prototype, 'wordSpacing', {configurable: true, get: function () {
    return this.wordSpacing_xblwen$_0.getValue_fmbzy8$(this, StyledComponent$wordSpacing_metadata);
  }, set: function (wordSpacing) {
    this.wordSpacing_xblwen$_0.setValue_19qrsr$(this, StyledComponent$wordSpacing_metadata, wordSpacing);
  }});
  var StyledComponent$fontFamily_metadata = new PropertyMetadata('fontFamily');
  Object.defineProperty(StyledComponent.prototype, 'fontFamily', {configurable: true, get: function () {
    return this.fontFamily_u6vlcn$_0.getValue_fmbzy8$(this, StyledComponent$fontFamily_metadata);
  }, set: function (fontFamily) {
    this.fontFamily_u6vlcn$_0.setValue_19qrsr$(this, StyledComponent$fontFamily_metadata, fontFamily);
  }});
  var StyledComponent$fontSize_metadata = new PropertyMetadata('fontSize');
  Object.defineProperty(StyledComponent.prototype, 'fontSize', {configurable: true, get: function () {
    return this.fontSize_kc6tju$_0.getValue_fmbzy8$(this, StyledComponent$fontSize_metadata);
  }, set: function (fontSize) {
    this.fontSize_kc6tju$_0.setValue_19qrsr$(this, StyledComponent$fontSize_metadata, fontSize);
  }});
  var StyledComponent$fontStyle_metadata = new PropertyMetadata('fontStyle');
  Object.defineProperty(StyledComponent.prototype, 'fontStyle', {configurable: true, get: function () {
    return this.fontStyle_8m3rw8$_0.getValue_fmbzy8$(this, StyledComponent$fontStyle_metadata);
  }, set: function (fontStyle) {
    this.fontStyle_8m3rw8$_0.setValue_19qrsr$(this, StyledComponent$fontStyle_metadata, fontStyle);
  }});
  var StyledComponent$fontWeight_metadata = new PropertyMetadata('fontWeight');
  Object.defineProperty(StyledComponent.prototype, 'fontWeight', {configurable: true, get: function () {
    return this.fontWeight_2kvum5$_0.getValue_fmbzy8$(this, StyledComponent$fontWeight_metadata);
  }, set: function (fontWeight) {
    this.fontWeight_2kvum5$_0.setValue_19qrsr$(this, StyledComponent$fontWeight_metadata, fontWeight);
  }});
  var StyledComponent$fontVariant_metadata = new PropertyMetadata('fontVariant');
  Object.defineProperty(StyledComponent.prototype, 'fontVariant', {configurable: true, get: function () {
    return this.fontVariant_l61898$_0.getValue_fmbzy8$(this, StyledComponent$fontVariant_metadata);
  }, set: function (fontVariant) {
    this.fontVariant_l61898$_0.setValue_19qrsr$(this, StyledComponent$fontVariant_metadata, fontVariant);
  }});
  var StyledComponent$float_metadata = new PropertyMetadata('float');
  Object.defineProperty(StyledComponent.prototype, 'float', {configurable: true, get: function () {
    return this.float_sz850y$_0.getValue_fmbzy8$(this, StyledComponent$float_metadata);
  }, set: function (float) {
    this.float_sz850y$_0.setValue_19qrsr$(this, StyledComponent$float_metadata, float);
  }});
  var StyledComponent$clear_metadata = new PropertyMetadata('clear');
  Object.defineProperty(StyledComponent.prototype, 'clear', {configurable: true, get: function () {
    return this.clear_ueje4j$_0.getValue_fmbzy8$(this, StyledComponent$clear_metadata);
  }, set: function (clear) {
    this.clear_ueje4j$_0.setValue_19qrsr$(this, StyledComponent$clear_metadata, clear);
  }});
  var StyledComponent$wordBreak_metadata = new PropertyMetadata('wordBreak');
  Object.defineProperty(StyledComponent.prototype, 'wordBreak', {configurable: true, get: function () {
    return this.wordBreak_ll65md$_0.getValue_fmbzy8$(this, StyledComponent$wordBreak_metadata);
  }, set: function (wordBreak) {
    this.wordBreak_ll65md$_0.setValue_19qrsr$(this, StyledComponent$wordBreak_metadata, wordBreak);
  }});
  var StyledComponent$lineBreak_metadata = new PropertyMetadata('lineBreak');
  Object.defineProperty(StyledComponent.prototype, 'lineBreak', {configurable: true, get: function () {
    return this.lineBreak_5zhswx$_0.getValue_fmbzy8$(this, StyledComponent$lineBreak_metadata);
  }, set: function (lineBreak) {
    this.lineBreak_5zhswx$_0.setValue_19qrsr$(this, StyledComponent$lineBreak_metadata, lineBreak);
  }});
  var StyledComponent$cursor_metadata = new PropertyMetadata('cursor');
  Object.defineProperty(StyledComponent.prototype, 'cursor', {configurable: true, get: function () {
    return this.cursor_end218$_0.getValue_fmbzy8$(this, StyledComponent$cursor_metadata);
  }, set: function (cursor) {
    this.cursor_end218$_0.setValue_19qrsr$(this, StyledComponent$cursor_metadata, cursor);
  }});
  var StyledComponent$flexDirection_metadata = new PropertyMetadata('flexDirection');
  Object.defineProperty(StyledComponent.prototype, 'flexDirection', {configurable: true, get: function () {
    return this.flexDirection_xxd36k$_0.getValue_fmbzy8$(this, StyledComponent$flexDirection_metadata);
  }, set: function (flexDirection) {
    this.flexDirection_xxd36k$_0.setValue_19qrsr$(this, StyledComponent$flexDirection_metadata, flexDirection);
  }});
  var StyledComponent$flexWrap_metadata = new PropertyMetadata('flexWrap');
  Object.defineProperty(StyledComponent.prototype, 'flexWrap', {configurable: true, get: function () {
    return this.flexWrap_gtlwuf$_0.getValue_fmbzy8$(this, StyledComponent$flexWrap_metadata);
  }, set: function (flexWrap) {
    this.flexWrap_gtlwuf$_0.setValue_19qrsr$(this, StyledComponent$flexWrap_metadata, flexWrap);
  }});
  var StyledComponent$justifyItems_metadata = new PropertyMetadata('justifyItems');
  Object.defineProperty(StyledComponent.prototype, 'justifyItems', {configurable: true, get: function () {
    return this.justifyItems_aujwue$_0.getValue_fmbzy8$(this, StyledComponent$justifyItems_metadata);
  }, set: function (justifyItems) {
    this.justifyItems_aujwue$_0.setValue_19qrsr$(this, StyledComponent$justifyItems_metadata, justifyItems);
  }});
  var StyledComponent$justifyContent_metadata = new PropertyMetadata('justifyContent');
  Object.defineProperty(StyledComponent.prototype, 'justifyContent', {configurable: true, get: function () {
    return this.justifyContent_cxcf4v$_0.getValue_fmbzy8$(this, StyledComponent$justifyContent_metadata);
  }, set: function (justifyContent) {
    this.justifyContent_cxcf4v$_0.setValue_19qrsr$(this, StyledComponent$justifyContent_metadata, justifyContent);
  }});
  var StyledComponent$alignItems_metadata = new PropertyMetadata('alignItems');
  Object.defineProperty(StyledComponent.prototype, 'alignItems', {configurable: true, get: function () {
    return this.alignItems_t3q0y9$_0.getValue_fmbzy8$(this, StyledComponent$alignItems_metadata);
  }, set: function (alignItems) {
    this.alignItems_t3q0y9$_0.setValue_19qrsr$(this, StyledComponent$alignItems_metadata, alignItems);
  }});
  var StyledComponent$alignContent_metadata = new PropertyMetadata('alignContent');
  Object.defineProperty(StyledComponent.prototype, 'alignContent', {configurable: true, get: function () {
    return this.alignContent_b2qiay$_0.getValue_fmbzy8$(this, StyledComponent$alignContent_metadata);
  }, set: function (alignContent) {
    this.alignContent_b2qiay$_0.setValue_19qrsr$(this, StyledComponent$alignContent_metadata, alignContent);
  }});
  var StyledComponent$order_metadata = new PropertyMetadata('order');
  Object.defineProperty(StyledComponent.prototype, 'order', {configurable: true, get: function () {
    return this.order_omppus$_0.getValue_fmbzy8$(this, StyledComponent$order_metadata);
  }, set: function (order) {
    this.order_omppus$_0.setValue_19qrsr$(this, StyledComponent$order_metadata, order);
  }});
  var StyledComponent$flexGrow_metadata = new PropertyMetadata('flexGrow');
  Object.defineProperty(StyledComponent.prototype, 'flexGrow', {configurable: true, get: function () {
    return this.flexGrow_gkthwe$_0.getValue_fmbzy8$(this, StyledComponent$flexGrow_metadata);
  }, set: function (flexGrow) {
    this.flexGrow_gkthwe$_0.setValue_19qrsr$(this, StyledComponent$flexGrow_metadata, flexGrow);
  }});
  var StyledComponent$flexShrink_metadata = new PropertyMetadata('flexShrink');
  Object.defineProperty(StyledComponent.prototype, 'flexShrink', {configurable: true, get: function () {
    return this.flexShrink_kteuxk$_0.getValue_fmbzy8$(this, StyledComponent$flexShrink_metadata);
  }, set: function (flexShrink) {
    this.flexShrink_kteuxk$_0.setValue_19qrsr$(this, StyledComponent$flexShrink_metadata, flexShrink);
  }});
  var StyledComponent$flexBasis_metadata = new PropertyMetadata('flexBasis');
  Object.defineProperty(StyledComponent.prototype, 'flexBasis', {configurable: true, get: function () {
    return this.flexBasis_e33pz9$_0.getValue_fmbzy8$(this, StyledComponent$flexBasis_metadata);
  }, set: function (flexBasis) {
    this.flexBasis_e33pz9$_0.setValue_19qrsr$(this, StyledComponent$flexBasis_metadata, flexBasis);
  }});
  var StyledComponent$alignSelf_metadata = new PropertyMetadata('alignSelf');
  Object.defineProperty(StyledComponent.prototype, 'alignSelf', {configurable: true, get: function () {
    return this.alignSelf_c8zyhz$_0.getValue_fmbzy8$(this, StyledComponent$alignSelf_metadata);
  }, set: function (alignSelf) {
    this.alignSelf_c8zyhz$_0.setValue_19qrsr$(this, StyledComponent$alignSelf_metadata, alignSelf);
  }});
  var StyledComponent$justifySelf_metadata = new PropertyMetadata('justifySelf');
  Object.defineProperty(StyledComponent.prototype, 'justifySelf', {configurable: true, get: function () {
    return this.justifySelf_9db8r6$_0.getValue_fmbzy8$(this, StyledComponent$justifySelf_metadata);
  }, set: function (justifySelf) {
    this.justifySelf_9db8r6$_0.setValue_19qrsr$(this, StyledComponent$justifySelf_metadata, justifySelf);
  }});
  var StyledComponent$gridAutoColumns_metadata = new PropertyMetadata('gridAutoColumns');
  Object.defineProperty(StyledComponent.prototype, 'gridAutoColumns', {configurable: true, get: function () {
    return this.gridAutoColumns_xba5ia$_0.getValue_fmbzy8$(this, StyledComponent$gridAutoColumns_metadata);
  }, set: function (gridAutoColumns) {
    this.gridAutoColumns_xba5ia$_0.setValue_19qrsr$(this, StyledComponent$gridAutoColumns_metadata, gridAutoColumns);
  }});
  var StyledComponent$gridAutoRows_metadata = new PropertyMetadata('gridAutoRows');
  Object.defineProperty(StyledComponent.prototype, 'gridAutoRows', {configurable: true, get: function () {
    return this.gridAutoRows_rirek$_0.getValue_fmbzy8$(this, StyledComponent$gridAutoRows_metadata);
  }, set: function (gridAutoRows) {
    this.gridAutoRows_rirek$_0.setValue_19qrsr$(this, StyledComponent$gridAutoRows_metadata, gridAutoRows);
  }});
  var StyledComponent$gridAutoFlow_metadata = new PropertyMetadata('gridAutoFlow');
  Object.defineProperty(StyledComponent.prototype, 'gridAutoFlow', {configurable: true, get: function () {
    return this.gridAutoFlow_kv5hj$_0.getValue_fmbzy8$(this, StyledComponent$gridAutoFlow_metadata);
  }, set: function (gridAutoFlow) {
    this.gridAutoFlow_kv5hj$_0.setValue_19qrsr$(this, StyledComponent$gridAutoFlow_metadata, gridAutoFlow);
  }});
  var StyledComponent$gridTemplateColumns_metadata = new PropertyMetadata('gridTemplateColumns');
  Object.defineProperty(StyledComponent.prototype, 'gridTemplateColumns', {configurable: true, get: function () {
    return this.gridTemplateColumns_vo4ai5$_0.getValue_fmbzy8$(this, StyledComponent$gridTemplateColumns_metadata);
  }, set: function (gridTemplateColumns) {
    this.gridTemplateColumns_vo4ai5$_0.setValue_19qrsr$(this, StyledComponent$gridTemplateColumns_metadata, gridTemplateColumns);
  }});
  var StyledComponent$gridTemplateRows_metadata = new PropertyMetadata('gridTemplateRows');
  Object.defineProperty(StyledComponent.prototype, 'gridTemplateRows', {configurable: true, get: function () {
    return this.gridTemplateRows_ho38ep$_0.getValue_fmbzy8$(this, StyledComponent$gridTemplateRows_metadata);
  }, set: function (gridTemplateRows) {
    this.gridTemplateRows_ho38ep$_0.setValue_19qrsr$(this, StyledComponent$gridTemplateRows_metadata, gridTemplateRows);
  }});
  var StyledComponent$gridTemplateAreas_metadata = new PropertyMetadata('gridTemplateAreas');
  Object.defineProperty(StyledComponent.prototype, 'gridTemplateAreas', {configurable: true, get: function () {
    return this.gridTemplateAreas_sik7rw$_0.getValue_fmbzy8$(this, StyledComponent$gridTemplateAreas_metadata);
  }, set: function (gridTemplateAreas) {
    this.gridTemplateAreas_sik7rw$_0.setValue_19qrsr$(this, StyledComponent$gridTemplateAreas_metadata, gridTemplateAreas);
  }});
  var StyledComponent$gridColumnGap_metadata = new PropertyMetadata('gridColumnGap');
  Object.defineProperty(StyledComponent.prototype, 'gridColumnGap', {configurable: true, get: function () {
    return this.gridColumnGap_493brk$_0.getValue_fmbzy8$(this, StyledComponent$gridColumnGap_metadata);
  }, set: function (gridColumnGap) {
    this.gridColumnGap_493brk$_0.setValue_19qrsr$(this, StyledComponent$gridColumnGap_metadata, gridColumnGap);
  }});
  var StyledComponent$gridRowGap_metadata = new PropertyMetadata('gridRowGap');
  Object.defineProperty(StyledComponent.prototype, 'gridRowGap', {configurable: true, get: function () {
    return this.gridRowGap_3z3jk8$_0.getValue_fmbzy8$(this, StyledComponent$gridRowGap_metadata);
  }, set: function (gridRowGap) {
    this.gridRowGap_3z3jk8$_0.setValue_19qrsr$(this, StyledComponent$gridRowGap_metadata, gridRowGap);
  }});
  var StyledComponent$gridColumnStart_metadata = new PropertyMetadata('gridColumnStart');
  Object.defineProperty(StyledComponent.prototype, 'gridColumnStart', {configurable: true, get: function () {
    return this.gridColumnStart_vzmqfw$_0.getValue_fmbzy8$(this, StyledComponent$gridColumnStart_metadata);
  }, set: function (gridColumnStart) {
    this.gridColumnStart_vzmqfw$_0.setValue_19qrsr$(this, StyledComponent$gridColumnStart_metadata, gridColumnStart);
  }});
  var StyledComponent$gridRowStart_metadata = new PropertyMetadata('gridRowStart');
  Object.defineProperty(StyledComponent.prototype, 'gridRowStart', {configurable: true, get: function () {
    return this.gridRowStart_9rqkas$_0.getValue_fmbzy8$(this, StyledComponent$gridRowStart_metadata);
  }, set: function (gridRowStart) {
    this.gridRowStart_9rqkas$_0.setValue_19qrsr$(this, StyledComponent$gridRowStart_metadata, gridRowStart);
  }});
  var StyledComponent$gridColumnEnd_metadata = new PropertyMetadata('gridColumnEnd');
  Object.defineProperty(StyledComponent.prototype, 'gridColumnEnd', {configurable: true, get: function () {
    return this.gridColumnEnd_494cdx$_0.getValue_fmbzy8$(this, StyledComponent$gridColumnEnd_metadata);
  }, set: function (gridColumnEnd) {
    this.gridColumnEnd_494cdx$_0.setValue_19qrsr$(this, StyledComponent$gridColumnEnd_metadata, gridColumnEnd);
  }});
  var StyledComponent$gridRowEnd_metadata = new PropertyMetadata('gridRowEnd');
  Object.defineProperty(StyledComponent.prototype, 'gridRowEnd', {configurable: true, get: function () {
    return this.gridRowEnd_3z2ixv$_0.getValue_fmbzy8$(this, StyledComponent$gridRowEnd_metadata);
  }, set: function (gridRowEnd) {
    this.gridRowEnd_3z2ixv$_0.setValue_19qrsr$(this, StyledComponent$gridRowEnd_metadata, gridRowEnd);
  }});
  var StyledComponent$gridArea_metadata = new PropertyMetadata('gridArea');
  Object.defineProperty(StyledComponent.prototype, 'gridArea', {configurable: true, get: function () {
    return this.gridArea_4bi4y1$_0.getValue_fmbzy8$(this, StyledComponent$gridArea_metadata);
  }, set: function (gridArea) {
    this.gridArea_4bi4y1$_0.setValue_19qrsr$(this, StyledComponent$gridArea_metadata, gridArea);
  }});
  var StyledComponent$outline_metadata = new PropertyMetadata('outline');
  Object.defineProperty(StyledComponent.prototype, 'outline', {configurable: true, get: function () {
    return this.outline_ynlug8$_0.getValue_fmbzy8$(this, StyledComponent$outline_metadata);
  }, set: function (outline) {
    this.outline_ynlug8$_0.setValue_19qrsr$(this, StyledComponent$outline_metadata, outline);
  }});
  var StyledComponent$boxShadow_metadata = new PropertyMetadata('boxShadow');
  Object.defineProperty(StyledComponent.prototype, 'boxShadow', {configurable: true, get: function () {
    return this.boxShadow_uzi9dr$_0.getValue_fmbzy8$(this, StyledComponent$boxShadow_metadata);
  }, set: function (boxShadow) {
    this.boxShadow_uzi9dr$_0.setValue_19qrsr$(this, StyledComponent$boxShadow_metadata, boxShadow);
  }});
  var StyledComponent$boxShadowList_metadata = new PropertyMetadata('boxShadowList');
  Object.defineProperty(StyledComponent.prototype, 'boxShadowList', {configurable: true, get: function () {
    return this.boxShadowList_4x0mm9$_0.getValue_fmbzy8$(this, StyledComponent$boxShadowList_metadata);
  }, set: function (boxShadowList) {
    this.boxShadowList_4x0mm9$_0.setValue_19qrsr$(this, StyledComponent$boxShadowList_metadata, boxShadowList);
  }});
  var StyledComponent$transition_metadata = new PropertyMetadata('transition');
  Object.defineProperty(StyledComponent.prototype, 'transition', {configurable: true, get: function () {
    return this.transition_cs5j8r$_0.getValue_fmbzy8$(this, StyledComponent$transition_metadata);
  }, set: function (transition) {
    this.transition_cs5j8r$_0.setValue_19qrsr$(this, StyledComponent$transition_metadata, transition);
  }});
  var StyledComponent$transitionList_metadata = new PropertyMetadata('transitionList');
  Object.defineProperty(StyledComponent.prototype, 'transitionList', {configurable: true, get: function () {
    return this.transitionList_5ctkx5$_0.getValue_fmbzy8$(this, StyledComponent$transitionList_metadata);
  }, set: function (transitionList) {
    this.transitionList_5ctkx5$_0.setValue_19qrsr$(this, StyledComponent$transitionList_metadata, transitionList);
  }});
  var StyledComponent$borderRadius_metadata = new PropertyMetadata('borderRadius');
  Object.defineProperty(StyledComponent.prototype, 'borderRadius', {configurable: true, get: function () {
    return this.borderRadius_10h3vw$_0.getValue_fmbzy8$(this, StyledComponent$borderRadius_metadata);
  }, set: function (borderRadius) {
    this.borderRadius_10h3vw$_0.setValue_19qrsr$(this, StyledComponent$borderRadius_metadata, borderRadius);
  }});
  var StyledComponent$borderRadiusList_metadata = new PropertyMetadata('borderRadiusList');
  Object.defineProperty(StyledComponent.prototype, 'borderRadiusList', {configurable: true, get: function () {
    return this.borderRadiusList_m77vu6$_0.getValue_fmbzy8$(this, StyledComponent$borderRadiusList_metadata);
  }, set: function (borderRadiusList) {
    this.borderRadiusList_m77vu6$_0.setValue_19qrsr$(this, StyledComponent$borderRadiusList_metadata, borderRadiusList);
  }});
  StyledComponent.prototype.getSnStyle = function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.snStyleCache_4me8oy$_0) != null)
      tmp$_0 = tmp$;
    else {
      var s = Object.assign({}, this.propertyStyles_ccf0vh$_0);
      this.snStyleCache_4me8oy$_0 = s;
      tmp$_0 = s;
    }
    return tmp$_0;
  };
  StyledComponent.prototype.getStyle_61zpoe$ = function (name) {
    return this.propertyStyles_ccf0vh$_0[name];
  };
  StyledComponent.prototype.setStyle_puj7f4$ = function (name, value) {
    this.propertyStyles_ccf0vh$_0[name] = value;
    this.refresh();
    return this;
  };
  StyledComponent.prototype.removeStyle_61zpoe$ = function (name) {
    delete_0(this.propertyStyles_ccf0vh$_0, name);
    this.refresh();
    return this;
  };
  StyledComponent.prototype.refresh = function () {
    this.snStyleCache_4me8oy$_0 = null;
    return this;
  };
  StyledComponent.prototype.refreshOnUpdate_kckmjf$_0 = function (refreshFunction) {
    if (refreshFunction === void 0)
      refreshFunction = null;
    return new StyledComponent$RefreshDelegateProvider(this, refreshFunction);
  };
  function StyledComponent$RefreshDelegateProvider($outer, refreshFunction) {
    this.$outer = $outer;
    this.refreshFunction_0 = refreshFunction;
  }
  StyledComponent$RefreshDelegateProvider.prototype.provideDelegate_n5byny$ = function (thisRef, prop) {
    return new StyledComponent$RefreshDelegate(this.$outer, this.refreshFunction_0);
  };
  StyledComponent$RefreshDelegateProvider.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegateProvider', interfaces: []};
  function StyledComponent$RefreshDelegate($outer, refreshFunction) {
    this.$outer = $outer;
    this.refreshFunction_0 = refreshFunction;
  }
  StyledComponent$RefreshDelegate.prototype.getValue_fmbzy8$ = function (thisRef, property) {
    var tmp$;
    var value = this.$outer.propertyValues_mhxfgz$_0[property.callableName];
    if (value != null) {
      tmp$ = value;
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  StyledComponent$RefreshDelegate.prototype.setValue_19qrsr$ = function (thisRef, property, value) {
    var tmp$;
    var oldValue = this.$outer.propertyValues_mhxfgz$_0[property.callableName];
    if (value == null) {
      delete_0(this.$outer.propertyValues_mhxfgz$_0, property.callableName);
    } else {
      this.$outer.propertyValues_mhxfgz$_0[property.callableName] = value;
    }
    if (oldValue != value) {
      (tmp$ = this.refreshFunction_0) != null ? tmp$(value) : null;
      this.$outer.refresh();
    }};
  StyledComponent$RefreshDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegate', interfaces: []};
  function StyledComponent$width$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('width', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$minWidth$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('min-width', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$maxWidth$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('max-width', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$height$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('height', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$minHeight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('min-height', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$maxHeight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('max-height', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$display$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('display', it != null ? it.display_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$position$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('position', it != null ? it.position_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$top$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('top', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$left$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('left', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$right$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('right', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$bottom$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('bottom', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$zIndex$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('z-index', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$overflow$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('overflow', it != null ? it.overflow_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$overflowX$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('overflow-x', it != null ? it.overflow_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$overflowY$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('overflow-y', it != null ? it.overflow_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$overflowWrap$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('overflow-wrap', it != null ? it.overflowWrap_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$resize$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('resize', it != null ? it.resize_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$border$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$borderTop$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border-top', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$borderRight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border-right', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$borderBottom$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border-bottom', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$borderLeft$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border-left', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$margin$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('margin', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$marginTop$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('margin-top', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$marginRight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('margin-right', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$marginBottom$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('margin-bottom', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$marginLeft$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('margin-left', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$padding$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('padding', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$paddingTop$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('padding-top', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$paddingRight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('padding-right', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$paddingBottom$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('padding-bottom', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$paddingLeft$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('padding-left', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$color$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('color', it != null ? it.asString() : null);
      return Unit;
    };
  }
  function StyledComponent$opacity$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('opacity', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$background$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('background', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$textDirection$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-direction', it != null ? it.direction_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$letterSpacing$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('letter-spacing', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$lineHeight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('line-height', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$textAlign$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-align', it != null ? it.textAlign_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$textDecoration$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-decoration', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$textIndent$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-indent', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$textShadow$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-shadow', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$textTransform$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-transform', it != null ? it.textTransform_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$textOverflow$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('text-overflow', it != null ? it.textOverflow_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$unicodeBidi$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('unicode-bidi', it != null ? it.unicodeBidi_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$verticalAlign$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('vertical-align', it != null ? it.verticalAlign_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$whiteSpace$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('white-space', it != null ? it.whiteSpace_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$wordSpacing$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('word-spacing', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$fontFamily$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('font-family', it);
      return Unit;
    };
  }
  function StyledComponent$fontSize$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('font-size', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$fontStyle$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('font-style', it != null ? it.fontStyle_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$fontWeight$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('font-weight', it != null ? it.fontWeight_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$fontVariant$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('font-variant', it != null ? it.fontVariant_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$float$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('float', it != null ? it.posFloat_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$clear$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('clear', it != null ? it.clear_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$wordBreak$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('word-break', it != null ? it.wordBreak_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$lineBreak$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('line-break', it != null ? it.lineBreak_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$cursor$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('cursor', it != null ? it.cursor_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$flexDirection$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('flex-direction', it != null ? it.dir_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$flexWrap$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('flex-wrap', it != null ? it.wrap_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$justifyItems$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('justify-items', it != null ? it.justify_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$justifyContent$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('justify-content', it != null ? it.justifyContent_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$alignItems$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('align-items', it != null ? it.alignItems_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$alignContent$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('align-content', it != null ? it.alignContent_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$order$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('order', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$flexGrow$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('flex-grow', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$flexShrink$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('flex-shrink', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$flexBasis$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('flex-basis', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$alignSelf$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('align-self', it != null ? it.alignItems_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$justifySelf$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('justify-self', it != null ? it.justify_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$gridAutoColumns$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-auto-columns', it);
      return Unit;
    };
  }
  function StyledComponent$gridAutoRows$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-auto-rows', it);
      return Unit;
    };
  }
  function StyledComponent$gridAutoFlow$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-auto-flow', it != null ? it.flow_8be2vx$ : null);
      return Unit;
    };
  }
  function StyledComponent$gridTemplateColumns$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-template-columns', it);
      return Unit;
    };
  }
  function StyledComponent$gridTemplateRows$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-template-rows', it);
      return Unit;
    };
  }
  function StyledComponent$gridTemplateAreas$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-template-areas', it != null ? joinToString(it, '\n') : null);
      return Unit;
    };
  }
  function StyledComponent$gridColumnGap$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-column-gap', it != null ? it.toString() + 'px' : null);
      return Unit;
    };
  }
  function StyledComponent$gridRowGap$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-row-gap', it != null ? it.toString() + 'px' : null);
      return Unit;
    };
  }
  function StyledComponent$gridColumnStart$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-column-start', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$gridRowStart$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-row-start', it != null ? it.toString() : null);
      return Unit;
    };
  }
  function StyledComponent$gridColumnEnd$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-column-end', it);
      return Unit;
    };
  }
  function StyledComponent$gridRowEnd$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-row-end', it);
      return Unit;
    };
  }
  function StyledComponent$gridArea$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('grid-area', it);
      return Unit;
    };
  }
  function StyledComponent$outline$lambda(this$StyledComponent) {
    return function (it) {
      this$StyledComponent.setStyleProperty_f2ncb9$_0('outline', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$boxShadow$lambda(this$StyledComponent) {
    return function (it) {
      if (it != null && this$StyledComponent.boxShadowList != null)
        this$StyledComponent.boxShadowList = null;
      this$StyledComponent.setStyleProperty_f2ncb9$_0('box-shadow', it != null ? it.asString_8be2vx$() : null);
      this$StyledComponent.setStyleProperty_f2ncb9$_0('-webkit-box-shadow', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$boxShadowList$lambda$lambda(s) {
    return s.asString_8be2vx$();
  }
  function StyledComponent$boxShadowList$lambda(this$StyledComponent) {
    return function (it) {
      if (it != null && this$StyledComponent.boxShadow != null)
        this$StyledComponent.boxShadow = null;
      var value = it != null ? joinToString(it, void 0, void 0, void 0, void 0, void 0, StyledComponent$boxShadowList$lambda$lambda) : null;
      this$StyledComponent.setStyleProperty_f2ncb9$_0('box-shadow', value);
      this$StyledComponent.setStyleProperty_f2ncb9$_0('-webkit-box-shadow', value);
      return Unit;
    };
  }
  function StyledComponent$transition$lambda(this$StyledComponent) {
    return function (it) {
      if (it != null && this$StyledComponent.transitionList != null)
        this$StyledComponent.transitionList = null;
      this$StyledComponent.setStyleProperty_f2ncb9$_0('transition', it != null ? it.asString_8be2vx$() : null);
      return Unit;
    };
  }
  function StyledComponent$transitionList$lambda$lambda(t) {
    return t.asString_8be2vx$();
  }
  function StyledComponent$transitionList$lambda(this$StyledComponent) {
    return function (it) {
      if (it != null && this$StyledComponent.transition != null)
        this$StyledComponent.transition = null;
      this$StyledComponent.setStyleProperty_f2ncb9$_0('transition', it != null ? joinToString(it, void 0, void 0, void 0, void 0, void 0, StyledComponent$transitionList$lambda$lambda) : null);
      return Unit;
    };
  }
  function StyledComponent$borderRadius$lambda(this$StyledComponent) {
    return function (it) {
      if (it != null && this$StyledComponent.borderRadiusList != null)
        this$StyledComponent.borderRadiusList = null;
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border-radius', it != null ? asString(it) : null);
      this$StyledComponent.setStyleProperty_f2ncb9$_0('-webkit-border-radius', it != null ? asString(it) : null);
      return Unit;
    };
  }
  function StyledComponent$borderRadiusList$lambda$lambda(s) {
    return asString(s);
  }
  function StyledComponent$borderRadiusList$lambda(this$StyledComponent) {
    return function (it) {
      if (it != null && this$StyledComponent.borderRadius != null)
        this$StyledComponent.borderRadius = null;
      var value = it != null ? joinToString(it, ' ', void 0, void 0, void 0, void 0, StyledComponent$borderRadiusList$lambda$lambda) : null;
      this$StyledComponent.setStyleProperty_f2ncb9$_0('border-radius', value);
      this$StyledComponent.setStyleProperty_f2ncb9$_0('-webkit-border-radius', value);
      return Unit;
    };
  }
  StyledComponent.$metadata$ = {kind: Kind_CLASS, simpleName: 'StyledComponent', interfaces: []};
  function Widget$refreshOnUpdate$lambda(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget(className, init) {
    Widget$Companion_getInstance();
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    StyledComponent.call(this);
    this.className_8be2vx$ = className;
    this.propertyValues_v9485h$_0 = {};
    this.classes_8be2vx$ = null;
    this.surroundingClasses_8be2vx$ = null;
    this.attributes_8be2vx$ = null;
    this.internalListenersMap_8be2vx$ = null;
    this.listenersMap_8be2vx$ = null;
    this.listenerCounter_8be2vx$ = 0;
    this.jqueryListenersMap = null;
    this.parent_a7yca6$_0 = null;
    this.visible_pymgje$_0 = true;
    this.title_d56peo$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$title_metadata);
    this.id_w1ms5d$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$id_metadata);
    this.role_vok4fu$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$role_metadata);
    this.tabindex_hfhf29$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$tabindex_metadata);
    this.draggable_7fc13f$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda(this))).provideDelegate_n5byny$(this, Widget$draggable_metadata);
    this.tooltipOptions = null;
    this.tooltipHooksActive = false;
    this.popoverOptions = null;
    this.popoverHooksActive = false;
    this.kvscope = null;
    this.eventTarget = null;
    this.vnkey = undefined;
    this.vnode = null;
    this.snAttrsCache_cfphr3$_0 = (new LazyCache(Widget$snAttrsCache$lambda(this))).clearOn_u332lz$(Widget$snAttrsCache$lambda_0(this));
    this.snClassCache_hcl495$_0 = new LazyCache(Widget$snClassCache$lambda(this));
    this.snOnCache_aaik0$_0 = null;
    this.snHooksCache_rlx0tr$_0 = null;
    this.lastLanguage = null;
    this.afterInsertHooks_dk5ndt$_0 = null;
    this.afterDestroyHooks_9vsnae$_0 = null;
    this.beforeDisposeHooks_qk8awk$_0 = null;
    init != null ? init(this) : null;
  }
  Object.defineProperty(Widget.prototype, 'parent', {configurable: true, get: function () {
    return this.parent_a7yca6$_0;
  }, set: function (parent) {
    this.parent_a7yca6$_0 = parent;
  }});
  Object.defineProperty(Widget.prototype, 'visible', {configurable: true, get: function () {
    return this.visible_pymgje$_0;
  }, set: function (value) {
    var oldField = this.visible_pymgje$_0;
    this.visible_pymgje$_0 = value;
    if (oldField !== this.visible_pymgje$_0)
      this.refresh();
  }});
  var Widget$title_metadata = new PropertyMetadata('title');
  Object.defineProperty(Widget.prototype, 'title', {configurable: true, get: function () {
    return this.title_d56peo$_0.getValue_fmbzy8$(this, Widget$title_metadata);
  }, set: function (title) {
    this.title_d56peo$_0.setValue_19qrsr$(this, Widget$title_metadata, title);
  }});
  var Widget$id_metadata = new PropertyMetadata('id');
  Object.defineProperty(Widget.prototype, 'id', {configurable: true, get: function () {
    return this.id_w1ms5d$_0.getValue_fmbzy8$(this, Widget$id_metadata);
  }, set: function (id) {
    this.id_w1ms5d$_0.setValue_19qrsr$(this, Widget$id_metadata, id);
  }});
  var Widget$role_metadata = new PropertyMetadata('role');
  Object.defineProperty(Widget.prototype, 'role', {configurable: true, get: function () {
    return this.role_vok4fu$_0.getValue_fmbzy8$(this, Widget$role_metadata);
  }, set: function (role) {
    this.role_vok4fu$_0.setValue_19qrsr$(this, Widget$role_metadata, role);
  }});
  var Widget$tabindex_metadata = new PropertyMetadata('tabindex');
  Object.defineProperty(Widget.prototype, 'tabindex', {configurable: true, get: function () {
    return this.tabindex_hfhf29$_0.getValue_fmbzy8$(this, Widget$tabindex_metadata);
  }, set: function (tabindex) {
    this.tabindex_hfhf29$_0.setValue_19qrsr$(this, Widget$tabindex_metadata, tabindex);
  }});
  var Widget$draggable_metadata = new PropertyMetadata('draggable');
  Object.defineProperty(Widget.prototype, 'draggable', {configurable: true, get: function () {
    return this.draggable_7fc13f$_0.getValue_fmbzy8$(this, Widget$draggable_metadata);
  }, set: function (draggable) {
    this.draggable_7fc13f$_0.setValue_19qrsr$(this, Widget$draggable_metadata, draggable);
  }});
  Widget.prototype.useSnabbdomDistinctKey = function () {
    var tmp$;
    this.vnkey = 'kv_widget_' + (tmp$ = Widget$Companion_getInstance().counter_0, Widget$Companion_getInstance().counter_0 = tmp$ + 1 | 0, tmp$);
  };
  Widget.prototype.addBeforeDisposeHook_o14v8n$ = function (hook) {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.beforeDisposeHooks_qk8awk$_0) != null)
      tmp$_0 = tmp$;
    else {
      this.beforeDisposeHooks_qk8awk$_0 = ArrayList_init();
      tmp$_0 = ensureNotNull(this.beforeDisposeHooks_qk8awk$_0);
    }
    return tmp$_0.add_11rb$(hook);
  };
  Widget.prototype.addAfterDestroyHook_o14v8n$ = function (hook) {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.afterDestroyHooks_9vsnae$_0) != null)
      tmp$_0 = tmp$;
    else {
      this.useSnabbdomDistinctKey();
      this.afterDestroyHooks_9vsnae$_0 = ArrayList_init();
      tmp$_0 = ensureNotNull(this.afterDestroyHooks_9vsnae$_0);
    }
    return tmp$_0.add_11rb$(hook);
  };
  Widget.prototype.addAfterInsertHook_tcd33s$ = function (hook) {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.afterInsertHooks_dk5ndt$_0) != null)
      tmp$_0 = tmp$;
    else {
      this.useSnabbdomDistinctKey();
      this.afterInsertHooks_dk5ndt$_0 = ArrayList_init();
      tmp$_0 = ensureNotNull(this.afterInsertHooks_dk5ndt$_0);
    }
    return tmp$_0.add_11rb$(hook);
  };
  Widget.prototype.singleRender_klfg04$ = function (block) {
    var tmp$;
    var root = this.getRoot();
    if (root != null) {
      tmp$ = root.singleRender_klfg04$(block);
    } else {
      tmp$ = block();
    }
    return tmp$;
  };
  Widget.prototype.singleRenderAsync_o14v8n$ = function (block) {
    var root = this.getRoot();
    if (root != null) {
      root.singleRenderAsync_o14v8n$(block);
    } else {
      block();
    }
  };
  function Widget$renderVNode$lambda(this$Widget) {
    return function ($receiver) {
      $receiver.key = this$Widget.vnkey;
      var $receiver_0 = ensureNotNull(this$Widget.surroundingClasses_8be2vx$);
      var destination = ArrayList_init_0(collectionSizeOrDefault($receiver_0, 10));
      var tmp$;
      tmp$ = $receiver_0.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(to(item, true));
      }
      var $receiver_1 = new Object_init();
      var tmp$_0;
      tmp$_0 = destination.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        var key = element.component1(), value = element.component2();
        $receiver_1[key] = value;
      }
      $receiver.class = $receiver_1;
      return Unit;
    };
  }
  Widget.prototype.renderVNode = function () {
    var tmp$;
    if (this.surroundingClasses_8be2vx$ == null) {
      tmp$ = this.render();
    } else {
      var opt = getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(Widget$renderVNode$lambda(this));
      tmp$ = h('div', opt, [this.render()]);
    }
    return tmp$;
  };
  Widget.prototype.translate_61zpoe$ = function (text) {
    this.lastLanguage = I18n_getInstance().language;
    return I18n_getInstance().trans_61zpoe$(text);
  };
  Widget.prototype.translate_pdl1vj$ = function (text) {
    return text != null ? this.translate_61zpoe$(text) : null;
  };
  Widget.prototype.render = function () {
    return this.render_61zpoe$('div');
  };
  Widget.prototype.render_61zpoe$ = function (elementName) {
    return h(elementName, this.getSnOpt_tx4gd6$_0());
  };
  Widget.prototype.render_pjwf99$ = function (elementName, children) {
    return h(elementName, this.getSnOpt_tx4gd6$_0(), children);
  };
  function Widget$getSnOpt$lambda(this$Widget) {
    return function ($receiver) {
      $receiver.key = this$Widget.vnkey;
      $receiver.attrs = this$Widget.snAttrsCache_cfphr3$_0.value;
      $receiver.style = this$Widget.getSnStyle();
      $receiver.class = this$Widget.snClassCache_hcl495$_0.value;
      $receiver.on = this$Widget.getSnOn();
      $receiver.hook = this$Widget.getSnHooksInternal_766wlc$_0();
      return Unit;
    };
  }
  Widget.prototype.getSnOpt_tx4gd6$_0 = function () {
    return getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, {}))(Widget$getSnOpt$lambda(this));
  };
  function Widget$getSnOptSimple$lambda(this$Widget) {
    return function ($receiver) {
      var tmp$, tmp$_0;
      $receiver.key = (tmp$_0 = (tmp$ = this$Widget.vnkey) != null ? 'kv_s_' + tmp$ : null) != null ? tmp$_0 : undefined;
      return Unit;
    };
  }
  Widget.prototype.getSnOptSimple = function () {
    return getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, {}))(Widget$getSnOptSimple$lambda(this));
  };
  function Widget$getSnOptContents$lambda(this$Widget) {
    return function ($receiver) {
      var tmp$, tmp$_0;
      var $receiver_0 = new Object_init();
      $receiver_0.display = 'contents';
      $receiver.style = $receiver_0;
      $receiver.key = (tmp$_0 = (tmp$ = this$Widget.vnkey) != null ? 'kv_s_' + tmp$ : null) != null ? tmp$_0 : undefined;
      return Unit;
    };
  }
  Widget.prototype.getSnOptContents = function () {
    return getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, {}))(Widget$getSnOptContents$lambda(this));
  };
  Widget.prototype.getSnHooksInternal_766wlc$_0 = function () {
    var tmp$;
    var tmp$_0;
    if ((tmp$ = this.snHooksCache_rlx0tr$_0) != null)
      tmp$_0 = tmp$;
    else {
      var $receiver = this.getSnHooks();
      this.snHooksCache_rlx0tr$_0 = $receiver;
      tmp$_0 = $receiver;
    }
    return tmp$_0;
  };
  Widget.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    if (this.classes_8be2vx$ == null && this.className_8be2vx$ != null) {
      classSetBuilder.addAll_jfy1ql$(toSet_0(split_0(this.className_8be2vx$, [' '])));
    } else if (this.classes_8be2vx$ != null) {
      classSetBuilder.addAll_jfy1ql$(ensureNotNull(this.classes_8be2vx$));
    }if (!this.visible) {
      classSetBuilder.add_61zpoe$('hidden');
    }};
  Widget.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.attributes_8be2vx$ == null) {
      this.attributes_8be2vx$ = LinkedHashMap_init();
    }attributeSetBuilder.addAll_y0zsll$(ensureNotNull(this.attributes_8be2vx$));
    if ((tmp$ = this.id) != null) {
      attributeSetBuilder.add_puj7f4$('id', tmp$);
    }if ((tmp$_0 = this.title) != null) {
      attributeSetBuilder.add_puj7f4$('title', this.translate_61zpoe$(tmp$_0));
    }if ((tmp$_1 = this.role) != null) {
      attributeSetBuilder.add_puj7f4$('role', tmp$_1);
    }if ((tmp$_2 = this.tabindex) != null) {
      attributeSetBuilder.add_puj7f4$('tabindex', tmp$_2.toString());
    }if (this.draggable === true) {
      attributeSetBuilder.add_puj7f4$('draggable', 'true');
    }};
  Widget.prototype.getSnOn = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6;
    if (this.internalListenersMap_8be2vx$ == null && this.listenersMap_8be2vx$ == null)
      return null;
    var tmp$_7;
    if ((tmp$ = this.internalListenersMap_8be2vx$) != null) {
      var destination = LinkedHashMap_init();
      var tmp$_8;
      tmp$_8 = tmp$.entries.iterator();
      while (tmp$_8.hasNext()) {
        var element = tmp$_8.next();
        var tmp$_9 = !equals(element.key, 'self');
        if (tmp$_9) {
          tmp$_9 = !element.value.isEmpty();
        }if (tmp$_9) {
          destination.put_xwzc9p$(element.key, element.value);
        }}
      tmp$_7 = destination;
    } else
      tmp$_7 = null;
    var tmp$_10;
    if ((tmp$_0 = tmp$_7) != null) {
      var destination_0 = ArrayList_init_0(tmp$_0.size);
      var tmp$_11;
      tmp$_11 = tmp$_0.entries.iterator();
      while (tmp$_11.hasNext()) {
        var item = tmp$_11.next();
        var tmp$_12 = destination_0.add_11rb$;
        var internalListeners = LinkedHashMap_init();
        internalListeners.putAll_a2k3zr$(item.value);
        tmp$_12.call(destination_0, to(item.key, internalListeners));
      }
      tmp$_10 = destination_0;
    } else
      tmp$_10 = null;
    var map = (tmp$_3 = (tmp$_2 = (tmp$_1 = tmp$_10) != null ? toMap(tmp$_1) : null) != null ? toMutableMap(tmp$_2) : null) != null ? tmp$_3 : LinkedHashMap_init();
    var tmp$_13;
    if ((tmp$_4 = this.listenersMap_8be2vx$) != null) {
      var destination_1 = LinkedHashMap_init();
      var tmp$_14;
      tmp$_14 = tmp$_4.entries.iterator();
      while (tmp$_14.hasNext()) {
        var element_0 = tmp$_14.next();
        var tmp$_15 = !equals(element_0.key, 'self');
        if (tmp$_15) {
          tmp$_15 = !element_0.value.isEmpty();
        }if (tmp$_15) {
          destination_1.put_xwzc9p$(element_0.key, element_0.value);
        }}
      tmp$_13 = destination_1;
    } else
      tmp$_13 = null;
    if ((tmp$_5 = tmp$_13) != null) {
      var tmp$_16;
      tmp$_16 = tmp$_5.entries.iterator();
      while (tmp$_16.hasNext()) {
        var element_1 = tmp$_16.next();
        var event = element_1.key;
        var listeners = element_1.value;
        var internalListeners_0 = map.get_11rb$(event);
        if (internalListeners_0 != null) {
          internalListeners_0.putAll_a2k3zr$(listeners);
        } else {
          map.put_xwzc9p$(event, listeners);
        }
      }
    }if (!map.isEmpty()) {
      var handlers = emptyOn();
      var tmp$_17;
      tmp$_17 = map.entries.iterator();
      while (tmp$_17.hasNext()) {
        var element_2 = tmp$_17.next();
        var event_0 = element_2.key;
        var listeners_0 = element_2.value;
        var tmp$_18;
        if (listeners_0.size === 1) {
          tmp$_18 = first(listeners_0.values);
        } else {
          var destination_2 = ArrayList_init_0(listeners_0.size);
          var tmp$_19;
          tmp$_19 = listeners_0.entries.iterator();
          while (tmp$_19.hasNext()) {
            var item_0 = tmp$_19.next();
            destination_2.add_11rb$([item_0.value]);
          }
          tmp$_18 = copyToArray(destination_2);
        }
        handlers[event_0] = tmp$_18;
      }
      tmp$_6 = handlers;
    } else {
      tmp$_6 = null;
    }
    return tmp$_6;
  };
  function Widget$getSnHooks$lambda$lambda(this$Widget) {
    return function (f, v) {
      this$Widget.vnode = v;
      this$Widget.afterCreate_77isfd$(v);
      return Unit;
    };
  }
  function Widget$getSnHooks$lambda$lambda_0(this$Widget) {
    return function (v) {
      var tmp$;
      this$Widget.vnode = v;
      this$Widget.afterInsertInternal_77isfd$(v);
      this$Widget.afterInsert_77isfd$(v);
      this$Widget.bindAllJQueryListeners();
      var tmp$_0;
      if ((tmp$ = this$Widget.afterInsertHooks_dk5ndt$_0) != null) {
        var tmp$_1;
        tmp$_1 = tmp$.iterator();
        while (tmp$_1.hasNext()) {
          var element = tmp$_1.next();
          element(v);
        }
        tmp$_0 = Unit;
      } else
        tmp$_0 = null;
      return tmp$_0;
    };
  }
  function Widget$getSnHooks$lambda$lambda_1(this$Widget) {
    return function (f, v) {
      this$Widget.vnode = v;
      this$Widget.afterPatch_77isfd$(v);
      return Unit;
    };
  }
  function Widget$getSnHooks$lambda$lambda_2(this$Widget) {
    return function (it) {
      var tmp$;
      this$Widget.afterDestroyInternal();
      this$Widget.afterDestroy();
      if ((tmp$ = this$Widget.afterDestroyHooks_9vsnae$_0) != null) {
        var tmp$_0;
        tmp$_0 = tmp$.iterator();
        while (tmp$_0.hasNext()) {
          var element = tmp$_0.next();
          element();
        }
      }this$Widget.vnode = null;
      return this$Widget.vnode;
    };
  }
  Widget.prototype.getSnHooks = function () {
    var hooks = {};
    hooks.create = Widget$getSnHooks$lambda$lambda(this);
    hooks.insert = Widget$getSnHooks$lambda$lambda_0(this);
    hooks.postpatch = Widget$getSnHooks$lambda$lambda_1(this);
    hooks.destroy = Widget$getSnHooks$lambda$lambda_2(this);
    return hooks;
  };
  Widget.prototype.setInternalEventListener_a1up2z$ = function (block) {
    var tmp$, tmp$_0, tmp$_1;
    if (this.internalListenersMap_8be2vx$ == null) {
      this.internalListenersMap_8be2vx$ = LinkedHashMap_init();
    }var handlerCounter = (tmp$ = this.listenerCounter_8be2vx$, this.listenerCounter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    var blockAsWidget = typeof (tmp$_0 = block) === 'function' ? tmp$_0 : throwCCE();
    var handlers = on(this);
    getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, handlers))(blockAsWidget);
    tmp$_1 = iterator(Object.keys(handlers));
    while (tmp$_1.hasNext()) {
      var key = tmp$_1.next();
      if (!equals(key, 'self')) {
        var handler = handlers[key];
        var map = ensureNotNull(this.internalListenersMap_8be2vx$).get_11rb$(key);
        if (map != null) {
          map.put_xwzc9p$(handlerCounter, handler);
        } else {
          var $receiver = ensureNotNull(this.internalListenersMap_8be2vx$);
          var value = mutableMapOf([to(handlerCounter, handler)]);
          $receiver.put_xwzc9p$(key, value);
        }
      }}
    this.refresh();
    return handlerCounter;
  };
  Widget.prototype.setEventListener_a1up2z$ = function (block) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.listenersMap_8be2vx$ == null) {
      this.listenersMap_8be2vx$ = LinkedHashMap_init();
    }if (this.jqueryListenersMap == null) {
      this.jqueryListenersMap = LinkedHashMap_init();
    }this.removeAllJQueryListeners();
    var handlerCounter = (tmp$ = this.listenerCounter_8be2vx$, this.listenerCounter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    var blockAsWidget = typeof (tmp$_0 = block) === 'function' ? tmp$_0 : throwCCE();
    var handlers = on((tmp$_1 = this.eventTarget) != null ? tmp$_1 : this);
    getCallableRef('apply', function ($receiver, p1) {
      p1($receiver);
      return $receiver;
    }.bind(null, handlers))(blockAsWidget);
    tmp$_2 = iterator(Object.keys(handlers));
    while (tmp$_2.hasNext()) {
      var key = tmp$_2.next();
      if (!equals(key, 'self')) {
        var handler = handlers[key];
        if (!startsWith(key, Widget$Companion_getInstance().KV_JQUERY_EVENT_PREFIX)) {
          var map = ensureNotNull(this.listenersMap_8be2vx$).get_11rb$(key);
          if (map != null) {
            map.put_xwzc9p$(handlerCounter, handler);
          } else {
            var $receiver = ensureNotNull(this.listenersMap_8be2vx$);
            var value = mutableMapOf([to(handlerCounter, handler)]);
            $receiver.put_xwzc9p$(key, value);
          }
        } else {
          var jqueryKey = key.substring(15);
          var map_0 = ensureNotNull(this.jqueryListenersMap).get_11rb$(jqueryKey);
          if (map_0 != null) {
            map_0.put_xwzc9p$(handlerCounter, handler);
          } else {
            var $receiver_0 = ensureNotNull(this.jqueryListenersMap);
            var value_0 = mutableMapOf([to(handlerCounter, handler)]);
            $receiver_0.put_xwzc9p$(jqueryKey, value_0);
          }
        }
      }}
    this.refresh();
    this.bindAllJQueryListeners();
    return handlerCounter;
  };
  Widget.prototype.removeEventListener_za3lpa$ = function (id) {
    var tmp$, tmp$_0;
    if ((tmp$ = this.listenersMap_8be2vx$) != null) {
      var tmp$_1;
      tmp$_1 = tmp$.entries.iterator();
      while (tmp$_1.hasNext()) {
        var element = tmp$_1.next();
        element.value.remove_11rb$(id);
      }
    }this.removeAllJQueryListeners();
    if ((tmp$_0 = this.jqueryListenersMap) != null) {
      var tmp$_2;
      tmp$_2 = tmp$_0.entries.iterator();
      while (tmp$_2.hasNext()) {
        var element_0 = tmp$_2.next();
        element_0.value.remove_11rb$(id);
      }
    }this.bindAllJQueryListeners();
    this.refresh();
    return this;
  };
  Widget.prototype.removeEventListeners = function () {
    var tmp$, tmp$_0;
    (tmp$ = this.listenersMap_8be2vx$) != null ? (tmp$.clear(), Unit) : null;
    this.removeAllJQueryListeners();
    (tmp$_0 = this.jqueryListenersMap) != null ? (tmp$_0.clear(), Unit) : null;
    this.refresh();
    return this;
  };
  Widget.prototype.bindAllJQueryListeners = function () {
  };
  Widget.prototype.removeAllJQueryListeners = function () {
  };
  Widget.prototype.show = function () {
    this.visible = true;
    return this;
  };
  Widget.prototype.hide = function () {
    this.visible = false;
    return this;
  };
  Widget.prototype.toggleVisible = function () {
    return this.visible ? this.hide() : this.show();
  };
  Widget.prototype.addCssClass_61zpoe$ = function (css) {
    if (this.classes_8be2vx$ == null) {
      var $receiver = this.className_8be2vx$;
      var tmp$;
      this.classes_8be2vx$ = (tmp$ = $receiver != null ? toMutableSet(split_0($receiver, [' '])) : null) != null ? tmp$ : LinkedHashSet_init();
    }ensureNotNull(this.classes_8be2vx$).add_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.removeCssClass_61zpoe$ = function (css) {
    if (this.classes_8be2vx$ == null) {
      var $receiver = this.className_8be2vx$;
      var tmp$;
      this.classes_8be2vx$ = (tmp$ = $receiver != null ? toMutableSet(split_0($receiver, [' '])) : null) != null ? tmp$ : LinkedHashSet_init();
    }ensureNotNull(this.classes_8be2vx$).remove_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.hasCssClass_61zpoe$ = function (css) {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.classes_8be2vx$) != null ? tmp$.contains_11rb$(css) : null) != null ? tmp$_0 : false;
  };
  Widget.prototype.addSurroundingCssClass_61zpoe$ = function (css) {
    if (this.surroundingClasses_8be2vx$ == null) {
      this.surroundingClasses_8be2vx$ = LinkedHashSet_init();
    }ensureNotNull(this.surroundingClasses_8be2vx$).add_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.removeSurroundingCssClass_61zpoe$ = function (css) {
    if (this.surroundingClasses_8be2vx$ == null) {
      this.surroundingClasses_8be2vx$ = LinkedHashSet_init();
    }ensureNotNull(this.surroundingClasses_8be2vx$).remove_11rb$(css);
    this.refresh();
    return this;
  };
  Widget.prototype.addCssStyle_807zt1$ = function (css) {
    return this.addCssClass_61zpoe$(css.cssClassName_8be2vx$);
  };
  Widget.prototype.removeCssStyle_807zt1$ = function (css) {
    return this.removeCssClass_61zpoe$(css.cssClassName_8be2vx$);
  };
  Widget.prototype.addSurroundingCssStyle_807zt1$ = function (css) {
    return this.addSurroundingCssClass_61zpoe$(css.cssClassName_8be2vx$);
  };
  Widget.prototype.removeSurroundingCssStyle_807zt1$ = function (css) {
    return this.removeSurroundingCssClass_61zpoe$(css.cssClassName_8be2vx$);
  };
  Widget.prototype.getAttribute_61zpoe$ = function (name) {
    var tmp$;
    return (tmp$ = this.attributes_8be2vx$) != null ? tmp$.get_11rb$(name) : null;
  };
  Widget.prototype.setAttribute_puj7f4$ = function (name, value) {
    if (this.attributes_8be2vx$ == null) {
      this.attributes_8be2vx$ = LinkedHashMap_init();
    }ensureNotNull(this.attributes_8be2vx$).put_xwzc9p$(name, value);
    this.refresh();
    return this;
  };
  Widget.prototype.removeAttribute_61zpoe$ = function (name) {
    if (this.attributes_8be2vx$ == null) {
      this.attributes_8be2vx$ = LinkedHashMap_init();
    }ensureNotNull(this.attributes_8be2vx$).remove_11rb$(name);
    this.refresh();
    return this;
  };
  Widget.prototype.getElement = function () {
    var tmp$;
    return (tmp$ = this.vnode) != null ? tmp$.elm : null;
  };
  Widget.prototype.getElementD = function () {
    var tmp$;
    return (tmp$ = this.getElement()) != null ? tmp$ : null;
  };
  Widget.prototype.clearParent = function () {
    this.parent = null;
    return this;
  };
  Widget.prototype.refresh = function () {
    var tmp$;
    StyledComponent.prototype.refresh.call(this);
    this.snAttrsCache_cfphr3$_0.clear();
    this.snClassCache_hcl495$_0.clear();
    this.snOnCache_aaik0$_0 = null;
    this.snHooksCache_rlx0tr$_0 = null;
    (tmp$ = this.getRoot()) != null ? tmp$.reRender_8be2vx$() : null;
    return this;
  };
  Widget.prototype.afterCreate_77isfd$ = function (node) {
  };
  Widget.prototype.afterInsertInternal_77isfd$ = function (node) {
  };
  Widget.prototype.afterInsert_77isfd$ = function (node) {
  };
  Widget.prototype.afterPatch_77isfd$ = function (node) {
  };
  Widget.prototype.afterDestroyInternal = function () {
  };
  Widget.prototype.afterDestroy = function () {
  };
  Widget.prototype.getRoot = function () {
    var tmp$;
    return (tmp$ = this.parent) != null ? tmp$.getRoot() : null;
  };
  function Widget$setDragDropData$lambda$lambda(closure$format, closure$data) {
    return function (e) {
      var tmp$;
      (tmp$ = e.dataTransfer) != null ? (tmp$.setData(closure$format, closure$data), Unit) : null;
      return Unit;
    };
  }
  function Widget$setDragDropData$lambda(closure$format, closure$data) {
    return function ($receiver) {
      $receiver.dragstart = Widget$setDragDropData$lambda$lambda(closure$format, closure$data);
      return Unit;
    };
  }
  Widget.prototype.setDragDropData_puj7f4$ = function (format, data) {
    this.draggable = true;
    this.setEventListener_a1up2z$(Widget$setDragDropData$lambda(format, data));
  };
  function Widget$clearDragDropData$lambda$lambda(it) {
    return Unit;
  }
  function Widget$clearDragDropData$lambda($receiver) {
    $receiver.dragstart = Widget$clearDragDropData$lambda$lambda;
    return Unit;
  }
  Widget.prototype.clearDragDropData = function () {
    this.draggable = false;
    this.setEventListener_a1up2z$(Widget$clearDragDropData$lambda);
  };
  function Widget$setDropTargetData$lambda(closure$callback, closure$format) {
    return function (e) {
      var tmp$;
      closure$callback((tmp$ = e.dataTransfer) != null ? tmp$.getData(closure$format) : null);
      return Unit;
    };
  }
  Widget.prototype.setDropTargetData_2by8ig$ = function (format, callback) {
    this.setDropTarget_aem84q$(format, Widget$setDropTargetData$lambda(callback, format));
  };
  Widget.prototype.setDropTarget_aem84q$ = function (format, callback) {
    this.setDropTarget_jwrva8$(setOf(format), callback);
  };
  function Widget$setDropTarget$lambda$lambda(closure$formats) {
    return function (e) {
      var tmp$, tmp$_0, tmp$_1;
      var types = (tmp$_1 = (tmp$_0 = (tmp$ = e.dataTransfer) != null ? tmp$.types : null) != null ? toSet(tmp$_0) : null) != null ? tmp$_1 : emptySet();
      var tmp$_2 = closure$formats == null;
      if (!tmp$_2) {
        tmp$_2 = !intersect(closure$formats, types).isEmpty();
      }if (tmp$_2) {
        e.preventDefault();
      }return Unit;
    };
  }
  function Widget$setDropTarget$lambda$lambda_0(closure$callback) {
    return function (e) {
      e.preventDefault();
      e.stopPropagation();
      closure$callback(e);
      return Unit;
    };
  }
  function Widget$setDropTarget$lambda(closure$formats, closure$callback) {
    return function ($receiver) {
      $receiver.dragover = Widget$setDropTarget$lambda$lambda(closure$formats);
      $receiver.drop = Widget$setDropTarget$lambda$lambda_0(closure$callback);
      return Unit;
    };
  }
  Widget.prototype.setDropTarget_jwrva8$$default = function (formats, callback) {
    this.setEventListener_a1up2z$(Widget$setDropTarget$lambda(formats, callback));
  };
  Widget.prototype.setDropTarget_jwrva8$ = function (formats, callback, callback$default) {
    if (formats === void 0)
      formats = null;
    callback$default ? callback$default(formats, callback) : this.setDropTarget_jwrva8$$default(formats, callback);
  };
  function Widget$createLabelWithIcon$lambda(closure$iconClasses) {
    return function ($receiver) {
      var $receiver_0 = closure$iconClasses;
      var destination = ArrayList_init_0(collectionSizeOrDefault($receiver_0, 10));
      var tmp$;
      tmp$ = $receiver_0.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(to(item, true));
      }
      var $receiver_1 = new Object_init();
      var tmp$_0;
      tmp$_0 = destination.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        var key = element.component1(), value = element.component2();
        $receiver_1[key] = value;
      }
      $receiver.class = $receiver_1;
      return Unit;
    };
  }
  function Widget$createLabelWithIcon$lambda_0(closure$image) {
    return function ($receiver) {
      var pairs = mapOf([to('src', closure$image), to('alt', '')]);
      var $receiver_0 = new Object_init();
      var tmp$;
      tmp$ = pairs.entries.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        var key = element.key;
        var value = element.value;
        $receiver_0[key] = value;
      }
      $receiver.attrs = $receiver_0;
      return Unit;
    };
  }
  Widget.prototype.createLabelWithIcon_dawjdb$$default = function (label, icon, image, separator) {
    var tmp$;
    var translatedLabel = this.translate_61zpoe$(label);
    if (icon != null) {
      var iconClasses = toSet_0(split_0(icon, [' ']));
      var iconOpt = getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(Widget$createLabelWithIcon$lambda(iconClasses));
      if (separator == null) {
        tmp$ = [h('i', iconOpt), ' ' + translatedLabel];
      } else {
        tmp$ = [h('i', iconOpt), KVManager_getInstance().virtualize_61zpoe$(separator), translatedLabel];
      }
    } else if (image != null) {
      var imageOpt = getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(Widget$createLabelWithIcon$lambda_0(image));
      if (separator == null) {
        tmp$ = [h('img', imageOpt), ' ' + translatedLabel];
      } else {
        tmp$ = [h('img', imageOpt), KVManager_getInstance().virtualize_61zpoe$(separator), translatedLabel];
      }
    } else {
      tmp$ = [translatedLabel];
    }
    return tmp$;
  };
  Widget.prototype.createLabelWithIcon_dawjdb$ = function (label, icon, image, separator, callback$default) {
    if (icon === void 0)
      icon = null;
    if (image === void 0)
      image = null;
    if (separator === void 0)
      separator = null;
    return callback$default ? callback$default(label, icon, image, separator) : this.createLabelWithIcon_dawjdb$$default(label, icon, image, separator);
  };
  Widget.prototype.dispatchEvent_nxedta$ = function (type, eventInitDict) {
    var tmp$;
    var event = new CustomEvent(type, eventInitDict);
    return (tmp$ = this.getElement()) != null ? tmp$.dispatchEvent(event) : null;
  };
  Widget.prototype.dispose = function () {
    var tmp$, tmp$_0;
    this.afterDestroyInternal();
    this.afterDestroy();
    if ((tmp$ = this.afterDestroyHooks_9vsnae$_0) != null) {
      var tmp$_1;
      tmp$_1 = tmp$.iterator();
      while (tmp$_1.hasNext()) {
        var element = tmp$_1.next();
        element();
      }
    }if ((tmp$_0 = this.beforeDisposeHooks_qk8awk$_0) != null) {
      var tmp$_2;
      tmp$_2 = tmp$_0.iterator();
      while (tmp$_2.hasNext()) {
        var element_0 = tmp$_2.next();
        element_0();
      }
    }};
  Widget.prototype.refreshOnUpdate_7qq44f$ = defineInlineFunction('kvision-js-legacy.io.kvision.core.Widget.refreshOnUpdate_7qq44f$', wrapFunction(function () {
    var Unit = Kotlin.kotlin.Unit;
    var Widget$Widget$RefreshDelegateProvider_init = _.io.kvision.core.Widget.RefreshDelegateProvider;
    function Widget$refreshOnUpdate$lambda(this$Widget) {
      return function (it) {
        this$Widget.refresh();
        return Unit;
      };
    }
    return function (refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = Widget$refreshOnUpdate$lambda(this);
      return new Widget$Widget$RefreshDelegateProvider_init(this, null, refreshFunction);
    };
  }));
  Widget.prototype.refreshOnUpdate_7uhc0p$ = defineInlineFunction('kvision-js-legacy.io.kvision.core.Widget.refreshOnUpdate_7uhc0p$', wrapFunction(function () {
    var Unit = Kotlin.kotlin.Unit;
    var Widget$Widget$RefreshDelegateProvider_init = _.io.kvision.core.Widget.RefreshDelegateProvider;
    function Widget$refreshOnUpdate$lambda(this$Widget) {
      return function (it) {
        this$Widget.refresh();
        return Unit;
      };
    }
    return function (initialValue, refreshFunction) {
      if (refreshFunction === void 0)
        refreshFunction = Widget$refreshOnUpdate$lambda(this);
      return new Widget$Widget$RefreshDelegateProvider_init(this, initialValue, refreshFunction);
    };
  }));
  function Widget$RefreshDelegateProvider($outer, initialValue, refreshFunction) {
    this.$outer = $outer;
    this.initialValue_0 = initialValue;
    this.refreshFunction_0 = refreshFunction;
  }
  Widget$RefreshDelegateProvider.prototype.provideDelegate_n5byny$ = function (thisRef, prop) {
    if (this.initialValue_0 != null)
      this.$outer.propertyValues_v9485h$_0[prop.callableName] = this.initialValue_0;
    return new Widget$RefreshDelegate(this.$outer, this.refreshFunction_0);
  };
  Widget$RefreshDelegateProvider.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegateProvider', interfaces: []};
  function Widget$RefreshDelegate($outer, refreshFunction) {
    this.$outer = $outer;
    this.refreshFunction_0 = refreshFunction;
  }
  Widget$RefreshDelegate.prototype.getValue_fmbzy8$ = function (thisRef, property) {
    var tmp$;
    var value = this.$outer.propertyValues_v9485h$_0[property.callableName];
    if (value != null) {
      tmp$ = value;
    } else {
      tmp$ = null;
    }
    return tmp$;
  };
  Widget$RefreshDelegate.prototype.setValue_19qrsr$ = function (thisRef, property, value) {
    var oldValue = this.$outer.propertyValues_v9485h$_0[property.callableName];
    if (value == null) {
      delete_0(this.$outer.propertyValues_v9485h$_0, property.callableName);
    } else {
      this.$outer.propertyValues_v9485h$_0[property.callableName] = value;
    }
    if (oldValue != value) {
      this.refreshFunction_0(value);
    }};
  Widget$RefreshDelegate.$metadata$ = {kind: Kind_CLASS, simpleName: 'RefreshDelegate', interfaces: []};
  function Widget$Companion() {
    Widget$Companion_instance = this;
    this.KV_JQUERY_EVENT_PREFIX = 'KVJQUERYEVENT##';
    this.counter_0 = 0;
  }
  Widget$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Widget$Companion_instance = null;
  function Widget$Companion_getInstance() {
    if (Widget$Companion_instance === null) {
      new Widget$Companion();
    }return Widget$Companion_instance;
  }
  function Widget$snAttrsCache$lambda(this$Widget) {
    return function () {
      return buildAttributeSet(getCallableRef('buildAttributeSet', function ($receiver, p1) {
        return $receiver.buildAttributeSet_34lhpl$(p1), Unit;
      }.bind(null, this$Widget)));
    };
  }
  function Widget$snAttrsCache$lambda_0(this$Widget) {
    return function () {
      return this$Widget.lastLanguage != null && !equals(this$Widget.lastLanguage, I18n_getInstance().language);
    };
  }
  function Widget$snClassCache$lambda(this$Widget) {
    return function () {
      return buildClassSet(getCallableRef('buildClassSet', function ($receiver, p1) {
        return $receiver.buildClassSet_xutoed$(p1), Unit;
      }.bind(null, this$Widget)));
    };
  }
  Widget.$metadata$ = {kind: Kind_CLASS, simpleName: 'Widget', interfaces: [Component, StyledComponent]};
  function WidgetWrapper(wrapped, className) {
    if (className === void 0)
      className = null;
    SimplePanel.call(this, className);
    this.wrapped_8be2vx$ = wrapped;
    var tmp$;
    (tmp$ = this.wrapped_8be2vx$) != null ? (tmp$.parent = this) : null;
  }
  Object.defineProperty(WidgetWrapper.prototype, 'visible', {configurable: true, get: function () {
    var tmp$;
    return ((tmp$ = this.wrapped_8be2vx$) != null ? tmp$.visible : null) === true;
  }, set: function (value) {
    var tmp$;
    (tmp$ = this.wrapped_8be2vx$) != null ? (tmp$.visible = value) : null;
  }});
  WidgetWrapper.prototype.render = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.wrapped_8be2vx$) != null ? this.render_pjwf99$('div', [tmp$.renderVNode()]) : null) != null ? tmp$_0 : this.render_61zpoe$('div');
  };
  WidgetWrapper.prototype.dispose = function () {
    var tmp$;
    SimplePanel.prototype.dispose.call(this);
    (tmp$ = this.wrapped_8be2vx$) != null ? tmp$.clearParent() : null;
    this.wrapped_8be2vx$ = null;
  };
  WidgetWrapper.$metadata$ = {kind: Kind_CLASS, simpleName: 'WidgetWrapper', interfaces: [SimplePanel]};
  function FieldLabel(forId, content, rich, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$LABEL_getInstance(), content, rich, void 0, className);
    this.forId_8be2vx$ = forId;
    init != null ? init(this) : null;
  }
  FieldLabel.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    Tag.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('for', this.forId_8be2vx$);
  };
  FieldLabel.$metadata$ = {kind: Kind_CLASS, simpleName: 'FieldLabel', interfaces: [Tag]};
  function FieldLabelCheck(forId, content, rich, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    FieldLabel.call(this, forId, content, rich, className);
    init != null ? init(this) : null;
  }
  FieldLabelCheck.prototype.render = function () {
    var tmp$, tmp$_0;
    if (this.content != null) {
      var translatedContent = (tmp$ = this.content) != null ? this.translate_61zpoe$(tmp$) : null;
      if (this.rich) {
        var tmp$_1 = this.type.tagName_8be2vx$;
        var $receiver = [KVManager_getInstance().virtualize_61zpoe$('<span style=' + '"' + 'display: contents;' + '"' + '>' + toString_0(translatedContent) + '<\/span>')];
        var elements = this.childrenVNodes();
        tmp$_0 = this.render_pjwf99$(tmp$_1, $receiver.concat(elements));
      } else {
        var tmp$_2 = this.type.tagName_8be2vx$;
        var $receiver_0 = [translatedContent];
        var elements_0 = this.childrenVNodes();
        tmp$_0 = this.render_pjwf99$(tmp$_2, $receiver_0.concat(elements_0));
      }
    } else {
      tmp$_0 = this.render_pjwf99$(this.type.tagName_8be2vx$, this.childrenVNodes());
    }
    return tmp$_0;
  };
  FieldLabelCheck.$metadata$ = {kind: Kind_CLASS, simpleName: 'FieldLabelCheck', interfaces: [FieldLabel]};
  var Form$Companion_instance = null;
  function InputSize(name, ordinal, className) {
    Enum.call(this);
    this.className_blnk1$_0 = className;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function InputSize_initFields() {
    InputSize_initFields = function () {
    };
    InputSize$LARGE_instance = new InputSize('LARGE', 0, 'form-control-lg');
    InputSize$SMALL_instance = new InputSize('SMALL', 1, 'form-control-sm');
  }
  Object.defineProperty(InputSize.prototype, 'className', {get: function () {
    return this.className_blnk1$_0;
  }});
  var InputSize$LARGE_instance;
  function InputSize$LARGE_getInstance() {
    InputSize_initFields();
    return InputSize$LARGE_instance;
  }
  var InputSize$SMALL_instance;
  function InputSize$SMALL_getInstance() {
    InputSize_initFields();
    return InputSize$SMALL_instance;
  }
  InputSize.$metadata$ = {kind: Kind_CLASS, simpleName: 'InputSize', interfaces: [CssClass, Enum]};
  function InputSize$values() {
    return [InputSize$LARGE_getInstance(), InputSize$SMALL_getInstance()];
  }
  InputSize.values = InputSize$values;
  function InputSize$valueOf(name) {
    switch (name) {
      case 'LARGE':
        return InputSize$LARGE_getInstance();
      case 'SMALL':
        return InputSize$SMALL_getInstance();
      default:throwISE('No enum constant io.kvision.form.InputSize.' + name);
    }
  }
  InputSize.valueOf_61zpoe$ = InputSize$valueOf;
  function ValidationStatus(name, ordinal, className) {
    Enum.call(this);
    this.className_hq5h83$_0 = className;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ValidationStatus_initFields() {
    ValidationStatus_initFields = function () {
    };
    ValidationStatus$VALID_instance = new ValidationStatus('VALID', 0, 'is-valid');
    ValidationStatus$INVALID_instance = new ValidationStatus('INVALID', 1, 'is-invalid');
  }
  Object.defineProperty(ValidationStatus.prototype, 'className', {get: function () {
    return this.className_hq5h83$_0;
  }});
  var ValidationStatus$VALID_instance;
  function ValidationStatus$VALID_getInstance() {
    ValidationStatus_initFields();
    return ValidationStatus$VALID_instance;
  }
  var ValidationStatus$INVALID_instance;
  function ValidationStatus$INVALID_getInstance() {
    ValidationStatus_initFields();
    return ValidationStatus$INVALID_instance;
  }
  ValidationStatus.$metadata$ = {kind: Kind_CLASS, simpleName: 'ValidationStatus', interfaces: [CssClass, Enum]};
  function ValidationStatus$values() {
    return [ValidationStatus$VALID_getInstance(), ValidationStatus$INVALID_getInstance()];
  }
  ValidationStatus.values = ValidationStatus$values;
  function ValidationStatus$valueOf(name) {
    switch (name) {
      case 'VALID':
        return ValidationStatus$VALID_getInstance();
      case 'INVALID':
        return ValidationStatus$INVALID_getInstance();
      default:throwISE('No enum constant io.kvision.form.ValidationStatus.' + name);
    }
  }
  ValidationStatus.valueOf_61zpoe$ = ValidationStatus$valueOf;
  function FormInput() {
  }
  FormInput.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'FormInput', interfaces: [Component]};
  function GenericFormComponent() {
  }
  GenericFormComponent.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'GenericFormComponent', interfaces: [Component]};
  function FormControl() {
  }
  Object.defineProperty(FormControl.prototype, 'disabled', {configurable: true, get: function () {
    return this.input.disabled;
  }, set: function (value) {
    this.input.disabled = value;
  }});
  Object.defineProperty(FormControl.prototype, 'size', {configurable: true, get: function () {
    return this.input.size;
  }, set: function (value) {
    this.input.size = value;
    if (equals(value, InputSize$SMALL_getInstance())) {
      this.flabel.addCssClass_61zpoe$('col-form-label-sm');
    } else {
      this.flabel.removeCssClass_61zpoe$('col-form-label-sm');
    }
    if (equals(value, InputSize$LARGE_getInstance())) {
      this.flabel.addCssClass_61zpoe$('col-form-label-lg');
    } else {
      this.flabel.removeCssClass_61zpoe$('col-form-label-lg');
    }
  }});
  Object.defineProperty(FormControl.prototype, 'name', {configurable: true, get: function () {
    return this.input.name;
  }, set: function (value) {
    this.input.name = value;
  }});
  Object.defineProperty(FormControl.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.input.validationStatus;
  }, set: function (value) {
    this.input.validationStatus = value;
  }});
  Object.defineProperty(FormControl.prototype, 'validatorError', {configurable: true, get: function () {
    return this.invalidFeedback.content;
  }, set: function (value) {
    this.invalidFeedback.content = value;
    this.invalidFeedback.visible = value != null;
    this.input.validationStatus = value != null ? ValidationStatus$INVALID_getInstance() : null;
    if (this.hasCssClass_61zpoe$('kv-control-horiz')) {
      if (value != null) {
        this.input.addSurroundingCssClass_61zpoe$('is-invalid');
      } else {
        this.input.removeSurroundingCssClass_61zpoe$('is-invalid');
      }
    }this.refresh();
  }});
  FormControl.prototype.styleForVerticalFormPanel = function () {
  };
  FormControl.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    this.addCssClass_61zpoe$('row');
    this.addCssClass_61zpoe$('kv-control-horiz');
    this.flabel.addCssClass_61zpoe$('col-sm-' + horizontalRatio.labels);
    this.flabel.addCssClass_61zpoe$('col-form-label');
    this.input.addSurroundingCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    this.invalidFeedback.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
    this.invalidFeedback.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
  };
  FormControl.prototype.styleForInlineFormPanel = function () {
    this.removeCssClass_61zpoe$('kv-mb-3');
  };
  FormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'FormControl', interfaces: [Component]};
  function GenericFormControl() {
  }
  GenericFormControl.prototype.getValue = function () {
    return this.value;
  };
  GenericFormControl.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$;
    this.value = (tmp$ = v) == null || Kotlin.isType(tmp$, Object_init) ? tmp$ : null;
  };
  GenericFormControl.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? tmp$.toString() : null;
  };
  GenericFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'GenericFormControl', interfaces: [GenericFormComponent, FormControl]};
  function GenericNonNullableFormControl() {
  }
  GenericNonNullableFormControl.prototype.getValue = function () {
    return this.value;
  };
  GenericNonNullableFormControl.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$, tmp$_0;
    tmp$_0 = (tmp$ = v) == null || Kotlin.isType(tmp$, Object_init) ? tmp$ : null;
    if (tmp$_0 == null) {
      throw IllegalStateException_init();
    }this.value = tmp$_0;
  };
  GenericNonNullableFormControl.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? tmp$.toString() : null;
  };
  GenericNonNullableFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'GenericNonNullableFormControl', interfaces: [GenericFormComponent, FormControl]};
  function StringFormControl() {
  }
  StringFormControl.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$, tmp$_0;
    this.value = (tmp$_0 = typeof (tmp$ = v) === 'string' ? tmp$ : null) != null ? tmp$_0 : v != null ? v.toString() : null;
  };
  StringFormControl.prototype.getValueAsString = function () {
    return this.value;
  };
  StringFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'StringFormControl', interfaces: [GenericFormControl]};
  function NumberFormControl() {
  }
  NumberFormControl.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$;
    this.value = Kotlin.isNumber(tmp$ = v) ? tmp$ : null;
  };
  NumberFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'NumberFormControl', interfaces: [GenericFormControl]};
  function BoolFormControl() {
  }
  BoolFormControl.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$, tmp$_0;
    this.value = (tmp$_0 = typeof (tmp$ = v) === 'boolean' ? tmp$ : null) != null ? tmp$_0 : false;
  };
  BoolFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'BoolFormControl', interfaces: [GenericNonNullableFormControl]};
  function TriStateFormControl() {
  }
  function DateFormControl() {
  }
  DateFormControl.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$;
    this.value = Kotlin.isType(tmp$ = v, Date) ? tmp$ : null;
  };
  DateFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'DateFormControl', interfaces: [GenericFormControl]};
  function KFilesFormControl() {
  }
  KFilesFormControl.prototype.setValue_s8jyv4$ = function (v) {
    if (v == null)
      this.value = null;
  };
  function KFilesFormControl$getValueAsString$lambda(it) {
    return it.name;
  }
  KFilesFormControl.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? joinToString(tmp$, ',', void 0, void 0, void 0, void 0, KFilesFormControl$getValueAsString$lambda) : null;
  };
  KFilesFormControl.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'KFilesFormControl', interfaces: [GenericFormControl]};
  var FormType$INLINE_instance;
  var FormType$HORIZONTAL_instance;
  var FormHorizontalRatio$RATIO_2_instance;
  var FormHorizontalRatio$RATIO_3_instance;
  var FormHorizontalRatio$RATIO_4_instance;
  var FormHorizontalRatio$RATIO_5_instance;
  var FormHorizontalRatio$RATIO_6_instance;
  var FormHorizontalRatio$RATIO_7_instance;
  var FormHorizontalRatio$RATIO_8_instance;
  var FormHorizontalRatio$RATIO_9_instance;
  var FormHorizontalRatio$RATIO_10_instance;
  var FormMethod$GET_instance;
  var FormMethod$POST_instance;
  var FormEnctype$URLENCODED_instance;
  var FormEnctype$MULTIPART_instance;
  var FormEnctype$PLAIN_instance;
  var FormTarget$BLANK_instance;
  var FormTarget$SELF_instance;
  var FormTarget$PARENT_instance;
  var FormTarget$TOP_instance;
  var FormPanel$method_metadata = new PropertyMetadata('method');
  var FormPanel$action_metadata = new PropertyMetadata('action');
  var FormPanel$enctype_metadata = new PropertyMetadata('enctype');
  var FormPanel$name_metadata = new PropertyMetadata('name');
  var FormPanel$target_metadata = new PropertyMetadata('target');
  var FormPanel$novalidate_metadata = new PropertyMetadata('novalidate');
  var FormPanel$autocomplete_metadata = new PropertyMetadata('autocomplete');
  var FormPanel$condensed_metadata = new PropertyMetadata('condensed');
  var FormPanel$horizRatio_metadata = new PropertyMetadata('horizRatio');
  var FormPanel$Companion_instance = null;
  function InvalidFeedback(content, rich) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    Tag.call(this, TAG$DIV_getInstance(), content, rich, void 0, 'invalid-feedback');
  }
  InvalidFeedback.$metadata$ = {kind: Kind_CLASS, simpleName: 'InvalidFeedback', interfaces: [Tag]};
  function Widget$refreshOnUpdate$lambda_2(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function CheckBox(value, name, label, rich, init) {
    CheckBox$Companion_getInstance();
    if (value === void 0)
      value = false;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-check');
    this.inline_42we83$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, CheckBox$inline_metadata);
    this.switch_d0l51k$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, CheckBox$switch_metadata);
    this.reversed_dm82h2$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, CheckBox$reversed_metadata);
    this.labelFirst_nzrysg$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_2(this))).provideDelegate_n5byny$(this, CheckBox$labelFirst_metadata);
    this.idc_d81g9c$_0 = 'kv_form_checkbox_' + CheckBox$Companion_getInstance().counter_8be2vx$;
    var $receiver = new CheckBoxInput(value);
    var closure$name = name;
    $receiver.id = this.idc_d81g9c$_0;
    $receiver.name = closure$name;
    this.input_6qn93m$_0 = $receiver;
    this.flabel_tyjysu$_0 = new FieldLabelCheck(this.idc_d81g9c$_0, label, rich, 'form-check-label', CheckBox$flabel$lambda);
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_j5ykmc$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    tmp$ = CheckBox$Companion_getInstance().counter_8be2vx$;
    CheckBox$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(CheckBox.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(CheckBox.prototype, 'startValue', {configurable: true, get: function () {
    return this.input.startValue;
  }, set: function (value) {
    this.input.startValue = value;
  }});
  Object.defineProperty(CheckBox.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(CheckBox.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(CheckBox.prototype, 'style', {configurable: true, get: function () {
    return this.input.style;
  }, set: function (value) {
    this.input.style = value;
  }});
  Object.defineProperty(CheckBox.prototype, 'circled', {configurable: true, get: function () {
    return this.input.circled;
  }, set: function (value) {
    this.input.circled = value;
  }});
  var CheckBox$inline_metadata = new PropertyMetadata('inline');
  Object.defineProperty(CheckBox.prototype, 'inline', {configurable: true, get: function () {
    return this.inline_42we83$_0.getValue_fmbzy8$(this, CheckBox$inline_metadata);
  }, set: function (inline) {
    this.inline_42we83$_0.setValue_19qrsr$(this, CheckBox$inline_metadata, inline);
  }});
  var CheckBox$switch_metadata = new PropertyMetadata('switch');
  Object.defineProperty(CheckBox.prototype, 'switch', {configurable: true, get: function () {
    return this.switch_d0l51k$_0.getValue_fmbzy8$(this, CheckBox$switch_metadata);
  }, set: function (switch_0) {
    this.switch_d0l51k$_0.setValue_19qrsr$(this, CheckBox$switch_metadata, switch_0);
  }});
  var CheckBox$reversed_metadata = new PropertyMetadata('reversed');
  Object.defineProperty(CheckBox.prototype, 'reversed', {configurable: true, get: function () {
    return this.reversed_dm82h2$_0.getValue_fmbzy8$(this, CheckBox$reversed_metadata);
  }, set: function (reversed) {
    this.reversed_dm82h2$_0.setValue_19qrsr$(this, CheckBox$reversed_metadata, reversed);
  }});
  var CheckBox$labelFirst_metadata = new PropertyMetadata('labelFirst');
  Object.defineProperty(CheckBox.prototype, 'labelFirst', {configurable: true, get: function () {
    return this.labelFirst_nzrysg$_0.getValue_fmbzy8$(this, CheckBox$labelFirst_metadata);
  }, set: function (labelFirst) {
    this.labelFirst_nzrysg$_0.setValue_19qrsr$(this, CheckBox$labelFirst_metadata, labelFirst);
  }});
  Object.defineProperty(CheckBox.prototype, 'indeterminate', {configurable: true, get: function () {
    return this.input.indeterminate;
  }, set: function (value) {
    this.input.indeterminate = value;
  }});
  Object.defineProperty(CheckBox.prototype, 'input', {configurable: true, get: function () {
    return this.input_6qn93m$_0;
  }});
  Object.defineProperty(CheckBox.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_tyjysu$_0;
  }});
  Object.defineProperty(CheckBox.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_j5ykmc$_0;
  }});
  CheckBox.prototype.render = function () {
    var childrenList = this.labelFirst ? listOf([this.flabel, this.input, this.invalidFeedback]) : listOf([this.input, this.flabel, this.invalidFeedback]);
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = childrenList.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var tmp$_0;
      if ((tmp$_0 = element.visible ? element.renderVNode() : null) != null) {
        destination.add_11rb$(tmp$_0);
      }}
    var children = copyToArray(destination);
    return this.render_pjwf99$('div', children);
  };
  CheckBox.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  CheckBox.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  CheckBox.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  CheckBox.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.switch) {
      classSetBuilder.add_61zpoe$('form-switch');
    }if (this.inline) {
      classSetBuilder.add_61zpoe$('form-check-inline');
    }if (this.reversed) {
      classSetBuilder.add_61zpoe$('form-check-reverse');
    }if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  function CheckBox$onClick$lambda$lambda(this$, closure$handler) {
    return function (e) {
      closure$handler(this$.self, e);
      return Unit;
    };
  }
  function CheckBox$onClick$lambda(closure$handler) {
    return function ($receiver) {
      $receiver.click = CheckBox$onClick$lambda$lambda($receiver, closure$handler);
      return Unit;
    };
  }
  CheckBox.prototype.onClick_6di7d6$ = function (handler) {
    this.setEventListener_a1up2z$(CheckBox$onClick$lambda(handler));
    return this;
  };
  CheckBox.prototype.focus = function () {
    this.input.focus();
  };
  CheckBox.prototype.blur = function () {
    this.input.blur();
  };
  CheckBox.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    if (this.labelFirst) {
      BoolFormControl.prototype.styleForHorizontalFormPanel_fn6884$.call(this, horizontalRatio);
      this.addCssClass_61zpoe$('form-group');
      this.addCssClass_61zpoe$('kv-mb-3');
      this.removeCssClass_61zpoe$('form-check');
    } else {
      this.addCssClass_61zpoe$('form-group');
      this.addCssClass_61zpoe$('kv-mb-3');
      this.addSurroundingCssClass_61zpoe$('row');
      this.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
      this.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    }
  };
  CheckBox.prototype.styleForInlineFormPanel = function () {
    this.addCssClass_61zpoe$('form-group');
  };
  CheckBox.prototype.styleForVerticalFormPanel = function () {
    this.addCssClass_61zpoe$('form-group');
    this.addCssClass_61zpoe$('kv-mb-3');
  };
  CheckBox.prototype.dispose = function () {
    SimplePanel.prototype.dispose.call(this);
    this.input.dispose();
    this.flabel.dispose();
    this.invalidFeedback.dispose();
  };
  CheckBox.prototype.getState = function () {
    return this.input.getState();
  };
  CheckBox.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  CheckBox.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function CheckBox$Companion() {
    CheckBox$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  CheckBox$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var CheckBox$Companion_instance = null;
  function CheckBox$Companion_getInstance() {
    if (CheckBox$Companion_instance === null) {
      new CheckBox$Companion();
    }return CheckBox$Companion_instance;
  }
  function CheckBox$flabel$lambda($receiver) {
    span($receiver);
    return Unit;
  }
  CheckBox.$metadata$ = {kind: Kind_CLASS, simpleName: 'CheckBox', interfaces: [MutableState, BoolFormControl, SimplePanel]};
  function Widget$refreshOnUpdate$lambda_3(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function CheckBoxInput(value, className, init) {
    if (value === void 0)
      value = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    CheckInput.call(this, CheckInputType$CHECKBOX_getInstance(), value, className);
    this.indeterminate_v6t2r1$_0 = (new Widget$RefreshDelegateProvider(this, false, CheckBoxInput$indeterminate$lambda(this))).provideDelegate_n5byny$(this, CheckBoxInput$indeterminate_metadata);
    this.circled_1pnkdi$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_3(this))).provideDelegate_n5byny$(this, CheckBoxInput$circled_metadata);
    init != null ? init(this) : null;
  }
  var CheckBoxInput$indeterminate_metadata = new PropertyMetadata('indeterminate');
  Object.defineProperty(CheckBoxInput.prototype, 'indeterminate', {configurable: true, get: function () {
    return this.indeterminate_v6t2r1$_0.getValue_fmbzy8$(this, CheckBoxInput$indeterminate_metadata);
  }, set: function (indeterminate) {
    this.indeterminate_v6t2r1$_0.setValue_19qrsr$(this, CheckBoxInput$indeterminate_metadata, indeterminate);
  }});
  var CheckBoxInput$circled_metadata = new PropertyMetadata('circled');
  Object.defineProperty(CheckBoxInput.prototype, 'circled', {configurable: true, get: function () {
    return this.circled_1pnkdi$_0.getValue_fmbzy8$(this, CheckBoxInput$circled_metadata);
  }, set: function (circled) {
    this.circled_1pnkdi$_0.setValue_19qrsr$(this, CheckBoxInput$circled_metadata, circled);
  }});
  CheckBoxInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    CheckInput.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.circled) {
      classSetBuilder.add_61zpoe$('kv-checkbox-circle');
    }};
  CheckBoxInput.prototype.refreshState = function () {
    var tmp$;
    CheckInput.prototype.refreshState.call(this);
    (tmp$ = this.getElementD()) != null ? (tmp$.indeterminate = this.indeterminate) : null;
  };
  CheckBoxInput.prototype.changeValue_61zpoe$ = function (eventType) {
    this.indeterminate = false;
    CheckInput.prototype.changeValue_61zpoe$.call(this, eventType);
  };
  function CheckBoxInput$indeterminate$lambda(this$CheckBoxInput) {
    return function (it) {
      if (it)
        this$CheckBoxInput.value = false;
      this$CheckBoxInput.refreshState();
      var $receiver = this$CheckBoxInput.observers;
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(this$CheckBoxInput.value);
      }
      return Unit;
    };
  }
  CheckBoxInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'CheckBoxInput', interfaces: [CheckInput]};
  function Widget$refreshOnUpdate$lambda_4(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_5(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function CheckInputType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function CheckInputType_initFields() {
    CheckInputType_initFields = function () {
    };
    CheckInputType$CHECKBOX_instance = new CheckInputType('CHECKBOX', 0, 'checkbox');
    CheckInputType$RADIO_instance = new CheckInputType('RADIO', 1, 'radio');
  }
  var CheckInputType$CHECKBOX_instance;
  function CheckInputType$CHECKBOX_getInstance() {
    CheckInputType_initFields();
    return CheckInputType$CHECKBOX_instance;
  }
  var CheckInputType$RADIO_instance;
  function CheckInputType$RADIO_getInstance() {
    CheckInputType_initFields();
    return CheckInputType$RADIO_instance;
  }
  CheckInputType.$metadata$ = {kind: Kind_CLASS, simpleName: 'CheckInputType', interfaces: [Enum]};
  function CheckInputType$values() {
    return [CheckInputType$CHECKBOX_getInstance(), CheckInputType$RADIO_getInstance()];
  }
  CheckInputType.values = CheckInputType$values;
  function CheckInputType$valueOf(name) {
    switch (name) {
      case 'CHECKBOX':
        return CheckInputType$CHECKBOX_getInstance();
      case 'RADIO':
        return CheckInputType$RADIO_getInstance();
      default:throwISE('No enum constant io.kvision.form.check.CheckInputType.' + name);
    }
  }
  CheckInputType.valueOf_61zpoe$ = CheckInputType$valueOf;
  var CheckStyle$PRIMARY_instance;
  var CheckStyle$SECONDARY_instance;
  var CheckStyle$SUCCESS_instance;
  var CheckStyle$DANGER_instance;
  var CheckStyle$WARNING_instance;
  var CheckStyle$INFO_instance;
  var CheckStyle$LIGHT_instance;
  var CheckStyle$DARK_instance;
  function CheckInput(type, value, className) {
    if (type === void 0)
      type = CheckInputType$CHECKBOX_getInstance();
    if (value === void 0)
      value = false;
    if (className === void 0)
      className = null;
    Widget.call(this, className);
    this.observers = ArrayList_init();
    this.value_e8c4i0$_0 = (new Widget$RefreshDelegateProvider(this, value, CheckInput$value$lambda(this))).provideDelegate_n5byny$(this, CheckInput$value_metadata);
    this.startValue_x5gorw$_0 = (new Widget$RefreshDelegateProvider(this, value, CheckInput$startValue$lambda(this))).provideDelegate_n5byny$(this, CheckInput$startValue_metadata);
    this.type_e6s2v5$_0 = (new Widget$RefreshDelegateProvider(this, type, Widget$refreshOnUpdate$lambda_4(this))).provideDelegate_n5byny$(this, CheckInput$type_metadata);
    this.style_d3vgqw$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_5(this))).provideDelegate_n5byny$(this, CheckInput$style_metadata);
    this.name_e31xe8$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_5(this))).provideDelegate_n5byny$(this, CheckInput$name_metadata);
    this.disabled_10pvk1$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_4(this))).provideDelegate_n5byny$(this, CheckInput$disabled_metadata);
    this.extraValue_fkhztm$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_5(this))).provideDelegate_n5byny$(this, CheckInput$extraValue_metadata);
    this.size_e5y9wa$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_5(this))).provideDelegate_n5byny$(this, CheckInput$size_metadata);
    this.validationStatus_p1pg1c$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_5(this))).provideDelegate_n5byny$(this, CheckInput$validationStatus_metadata);
    this.useSnabbdomDistinctKey();
    this.setInternalEventListener_a1up2z$(CheckInput_init$lambda(this));
  }
  var CheckInput$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(CheckInput.prototype, 'value', {configurable: true, get: function () {
    return this.value_e8c4i0$_0.getValue_fmbzy8$(this, CheckInput$value_metadata);
  }, set: function (value) {
    this.value_e8c4i0$_0.setValue_19qrsr$(this, CheckInput$value_metadata, value);
  }});
  var CheckInput$startValue_metadata = new PropertyMetadata('startValue');
  Object.defineProperty(CheckInput.prototype, 'startValue', {configurable: true, get: function () {
    return this.startValue_x5gorw$_0.getValue_fmbzy8$(this, CheckInput$startValue_metadata);
  }, set: function (startValue) {
    this.startValue_x5gorw$_0.setValue_19qrsr$(this, CheckInput$startValue_metadata, startValue);
  }});
  var CheckInput$type_metadata = new PropertyMetadata('type');
  Object.defineProperty(CheckInput.prototype, 'type', {configurable: true, get: function () {
    return this.type_e6s2v5$_0.getValue_fmbzy8$(this, CheckInput$type_metadata);
  }, set: function (type) {
    this.type_e6s2v5$_0.setValue_19qrsr$(this, CheckInput$type_metadata, type);
  }});
  var CheckInput$style_metadata = new PropertyMetadata('style');
  Object.defineProperty(CheckInput.prototype, 'style', {configurable: true, get: function () {
    return this.style_d3vgqw$_0.getValue_fmbzy8$(this, CheckInput$style_metadata);
  }, set: function (style) {
    this.style_d3vgqw$_0.setValue_19qrsr$(this, CheckInput$style_metadata, style);
  }});
  var CheckInput$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(CheckInput.prototype, 'name', {configurable: true, get: function () {
    return this.name_e31xe8$_0.getValue_fmbzy8$(this, CheckInput$name_metadata);
  }, set: function (name) {
    this.name_e31xe8$_0.setValue_19qrsr$(this, CheckInput$name_metadata, name);
  }});
  var CheckInput$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(CheckInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_10pvk1$_0.getValue_fmbzy8$(this, CheckInput$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_10pvk1$_0.setValue_19qrsr$(this, CheckInput$disabled_metadata, disabled);
  }});
  var CheckInput$extraValue_metadata = new PropertyMetadata('extraValue');
  Object.defineProperty(CheckInput.prototype, 'extraValue', {configurable: true, get: function () {
    return this.extraValue_fkhztm$_0.getValue_fmbzy8$(this, CheckInput$extraValue_metadata);
  }, set: function (extraValue) {
    this.extraValue_fkhztm$_0.setValue_19qrsr$(this, CheckInput$extraValue_metadata, extraValue);
  }});
  var CheckInput$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(CheckInput.prototype, 'size', {configurable: true, get: function () {
    return this.size_e5y9wa$_0.getValue_fmbzy8$(this, CheckInput$size_metadata);
  }, set: function (size) {
    this.size_e5y9wa$_0.setValue_19qrsr$(this, CheckInput$size_metadata, size);
  }});
  var CheckInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  Object.defineProperty(CheckInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.validationStatus_p1pg1c$_0.getValue_fmbzy8$(this, CheckInput$validationStatus_metadata);
  }, set: function (validationStatus) {
    this.validationStatus_p1pg1c$_0.setValue_19qrsr$(this, CheckInput$validationStatus_metadata, validationStatus);
  }});
  CheckInput.prototype.render = function () {
    return this.render_61zpoe$('input');
  };
  CheckInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('form-check-input');
    classSetBuilder.add_vqcfem$(this.validationStatus);
    classSetBuilder.add_vqcfem$(this.size);
    classSetBuilder.add_vqcfem$(this.style);
  };
  CheckInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', this.type.type_8be2vx$);
    if (this.startValue) {
      attributeSetBuilder.add_puj7f4$('checked');
    }if ((tmp$ = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$);
    }if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }if ((tmp$_0 = this.extraValue) != null) {
      attributeSetBuilder.add_puj7f4$('value', tmp$_0);
    }};
  CheckInput.prototype.afterInsert_77isfd$ = function (node) {
    this.refreshState();
  };
  CheckInput.prototype.refreshState = function () {
    var tmp$, tmp$_0, tmp$_1;
    var v = (tmp$_0 = (tmp$ = this.getElementD()) != null ? tmp$.checked : null) != null ? tmp$_0 : null;
    if (this.value !== v) {
      (tmp$_1 = this.getElementD()) != null ? (tmp$_1.checked = this.value) : null;
    }};
  CheckInput.prototype.changeValue_61zpoe$ = function (eventType) {
    var tmp$, tmp$_0;
    var v = (tmp$_0 = (tmp$ = this.getElementD()) != null ? tmp$.checked : null) != null ? tmp$_0 : null;
    var newValue = v === true;
    if (this.value !== newValue)
      this.value = newValue;
  };
  function CheckInput$onClick$lambda$lambda(this$, closure$handler) {
    return function (e) {
      closure$handler(this$.self, e);
      return Unit;
    };
  }
  function CheckInput$onClick$lambda(closure$handler) {
    return function ($receiver) {
      $receiver.click = CheckInput$onClick$lambda$lambda($receiver, closure$handler);
      return Unit;
    };
  }
  CheckInput.prototype.onClick_h13fu3$ = function (handler) {
    this.setEventListener_a1up2z$(CheckInput$onClick$lambda(handler));
    return this;
  };
  CheckInput.prototype.getState = function () {
    return this.value;
  };
  function CheckInput$subscribe$lambda(this$CheckInput, closure$observer) {
    return function () {
      var $receiver = this$CheckInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  CheckInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return CheckInput$subscribe$lambda(this, observer);
  };
  CheckInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function CheckInput$value$lambda(this$CheckInput) {
    return function (it) {
      this$CheckInput.refreshState();
      var tmp$;
      tmp$ = this$CheckInput.observers.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(it);
      }
      return Unit;
    };
  }
  function CheckInput$startValue$lambda(this$CheckInput) {
    return function (it) {
      this$CheckInput.value = it;
      this$CheckInput.refresh();
      return Unit;
    };
  }
  function CheckInput_init$lambda$lambda(this$CheckInput) {
    return function (it) {
      this$CheckInput.changeValue_61zpoe$('click');
      return Unit;
    };
  }
  function CheckInput_init$lambda$lambda_0(this$CheckInput) {
    return function (it) {
      this$CheckInput.changeValue_61zpoe$('change');
      return Unit;
    };
  }
  function CheckInput_init$lambda(this$CheckInput) {
    return function ($receiver) {
      $receiver.click = CheckInput_init$lambda$lambda(this$CheckInput);
      $receiver.change = CheckInput_init$lambda$lambda_0(this$CheckInput);
      return Unit;
    };
  }
  CheckInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'CheckInput', interfaces: [MutableState, FormInput, GenericFormComponent, Widget]};
  function Widget$refreshOnUpdate$lambda_6(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function GenericRadioGroup(options, value, name, inline, label, rich, toStr, fromStr, init) {
    GenericRadioGroup$Companion_getInstance();
    if (options === void 0)
      options = null;
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (inline === void 0)
      inline = false;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (toStr === void 0)
      toStr = GenericRadioGroup_init$lambda;
    if (fromStr === void 0)
      fromStr = GenericRadioGroup_init$lambda_0;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-group kv-mb-3');
    this.toStr = toStr;
    this.fromStr = fromStr;
    this.observers = ArrayList_init();
    this.options_6dejzw$_0 = (new Widget$RefreshDelegateProvider(this, options, GenericRadioGroup$options$lambda(this))).provideDelegate_n5byny$(this, GenericRadioGroup$options_metadata);
    this.value_1sg3p3$_0 = (new Widget$RefreshDelegateProvider(this, value, GenericRadioGroup$value$lambda(this))).provideDelegate_n5byny$(this, GenericRadioGroup$value_metadata);
    this.inline_r2b2jj$_0 = (new Widget$RefreshDelegateProvider(this, inline, Widget$refreshOnUpdate$lambda_6(this))).provideDelegate_n5byny$(this, GenericRadioGroup$inline_metadata);
    this.idc_pcdz3m$_0 = 'kv_form_radiogroup_' + GenericRadioGroup$Companion_getInstance().counter_8be2vx$;
    this.input_7qtasw$_0 = new RadioInput();
    this.flabel_16nhys$_0 = new FieldLabel(this.idc_pcdz3m$_0, label, rich, 'form-label');
    var $receiver = new InvalidFeedback();
    $receiver.visible = false;
    this.invalidFeedback_z89ncy$_0 = $receiver;
    this.container_8be2vx$ = new SimplePanel('kv-radiogroup-container', GenericRadioGroup$container$lambda(this));
    var tmp$;
    this.addPrivate_87eobz$(this.flabel);
    this.addPrivate_87eobz$(this.container_8be2vx$);
    this.addPrivate_87eobz$(this.invalidFeedback);
    this.setChildrenFromOptions_vav3mh$_0();
    this.setValueToChildren_rkfpe2$_0(value);
    this.setNameToChildren_t1izuc$_0(name);
    tmp$ = GenericRadioGroup$Companion_getInstance().counter_8be2vx$;
    GenericRadioGroup$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  var GenericRadioGroup$options_metadata = new PropertyMetadata('options');
  Object.defineProperty(GenericRadioGroup.prototype, 'options', {configurable: true, get: function () {
    return this.options_6dejzw$_0.getValue_fmbzy8$(this, GenericRadioGroup$options_metadata);
  }, set: function (options) {
    this.options_6dejzw$_0.setValue_19qrsr$(this, GenericRadioGroup$options_metadata, options);
  }});
  var GenericRadioGroup$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(GenericRadioGroup.prototype, 'value', {configurable: true, get: function () {
    return this.value_1sg3p3$_0.getValue_fmbzy8$(this, GenericRadioGroup$value_metadata);
  }, set: function (value) {
    this.value_1sg3p3$_0.setValue_19qrsr$(this, GenericRadioGroup$value_metadata, value);
  }});
  var GenericRadioGroup$inline_metadata = new PropertyMetadata('inline');
  Object.defineProperty(GenericRadioGroup.prototype, 'inline', {configurable: true, get: function () {
    return this.inline_r2b2jj$_0.getValue_fmbzy8$(this, GenericRadioGroup$inline_metadata);
  }, set: function (inline) {
    this.inline_r2b2jj$_0.setValue_19qrsr$(this, GenericRadioGroup$inline_metadata, inline);
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'disabled', {configurable: true, get: function () {
    return this.getDisabledFromChildren_8sp1pd$_0();
  }, set: function (value) {
    this.setDisabledToChildren_s7ajnn$_0(value);
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'name', {configurable: true, get: function () {
    return this.getNameFromChildren_brjh4g$_0();
  }, set: function (value) {
    this.setNameToChildren_t1izuc$_0(value);
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'size', {configurable: true, get: function () {
    return this.getSizeFromChildren_p36jei$_0();
  }, set: function (value) {
    this.setSizeToChildren_4xlr6w$_0(value);
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.getValidationStatusFromChildren_xicrtc$_0();
  }, set: function (value) {
    this.setValidationStatusToChildren_wyk47a$_0(value);
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'validatorError', {configurable: true, get: function () {
    return Kotlin.callGetter(this, GenericFormControl.prototype, 'validatorError');
  }, set: function (value) {
    Kotlin.callSetter(this, GenericFormControl.prototype, 'validatorError', value);
    if (value != null) {
      this.container_8be2vx$.addCssClass_61zpoe$('is-invalid');
    } else {
      this.container_8be2vx$.removeCssClass_61zpoe$('is-invalid');
    }
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'input', {configurable: true, get: function () {
    return this.input_7qtasw$_0;
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_16nhys$_0;
  }});
  Object.defineProperty(GenericRadioGroup.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_z89ncy$_0;
  }});
  GenericRadioGroup.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }if (this.inline) {
      classSetBuilder.add_61zpoe$('kv-radiogroup-inline');
    } else {
      classSetBuilder.add_61zpoe$('kv-radiogroup');
    }
  };
  GenericRadioGroup.prototype.setValueToChildren_rkfpe2$_0 = function (value) {
    var tmp$;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    var radios = destination;
    var tmp$_1;
    tmp$_1 = radios.iterator();
    while (tmp$_1.hasNext()) {
      var element_0 = tmp$_1.next();
      element_0.value = false;
    }
    var firstOrNull$result;
    firstOrNull$break: do {
      var tmp$_2;
      tmp$_2 = radios.iterator();
      while (tmp$_2.hasNext()) {
        var element_1 = tmp$_2.next();
        if (equals(element_1.extraValue, value != null ? this.toStr(value) : null)) {
          firstOrNull$result = element_1;
          break firstOrNull$break;
        }}
      firstOrNull$result = null;
    }
     while (false);
    (tmp$ = firstOrNull$result) != null ? (tmp$.value = true) : null;
  };
  GenericRadioGroup.prototype.getDisabledFromChildren_8sp1pd$_0 = function () {
    var tmp$, tmp$_0;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_1;
    tmp$_1 = $receiver.iterator();
    while (tmp$_1.hasNext()) {
      var element = tmp$_1.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    return (tmp$_0 = (tmp$ = firstOrNull(destination)) != null ? tmp$.disabled : null) != null ? tmp$_0 : false;
  };
  GenericRadioGroup.prototype.setDisabledToChildren_s7ajnn$_0 = function (disabled) {
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      element_0.disabled = disabled;
    }
  };
  GenericRadioGroup.prototype.getNameFromChildren_brjh4g$_0 = function () {
    var tmp$, tmp$_0;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_1;
    tmp$_1 = $receiver.iterator();
    while (tmp$_1.hasNext()) {
      var element = tmp$_1.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    return (tmp$_0 = (tmp$ = firstOrNull(destination)) != null ? tmp$.name : null) != null ? tmp$_0 : this.idc_pcdz3m$_0;
  };
  GenericRadioGroup.prototype.setNameToChildren_t1izuc$_0 = function (name) {
    var tname = name != null ? name : this.idc_pcdz3m$_0;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      element_0.name = tname;
    }
  };
  GenericRadioGroup.prototype.getSizeFromChildren_p36jei$_0 = function () {
    var tmp$;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    return (tmp$ = firstOrNull(destination)) != null ? tmp$.size : null;
  };
  GenericRadioGroup.prototype.setSizeToChildren_4xlr6w$_0 = function (size) {
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      element_0.size = size;
    }
    Kotlin.callSetter(this, GenericFormControl.prototype, 'size', size);
  };
  GenericRadioGroup.prototype.getValidationStatusFromChildren_xicrtc$_0 = function () {
    var tmp$;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    return (tmp$ = firstOrNull(destination)) != null ? tmp$.validationStatus : null;
  };
  GenericRadioGroup.prototype.setValidationStatusToChildren_wyk47a$_0 = function (validationStatus) {
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      element_0.validationStatus = validationStatus;
    }
  };
  function GenericRadioGroup$setChildrenFromOptions$lambda$lambda$lambda$lambda$lambda(this$, this$GenericRadioGroup) {
    return function (ev) {
      var tmp$;
      var tmp$_0 = this$GenericRadioGroup;
      var tmp$_1;
      tmp$_1 = (tmp$ = this$.self.extraValue) != null ? this$GenericRadioGroup.fromStr(tmp$) : null;
      tmp$_0.value = tmp$_1;
      ev.stopPropagation();
      return Unit;
    };
  }
  function GenericRadioGroup$setChildrenFromOptions$lambda$lambda$lambda$lambda(this$GenericRadioGroup) {
    return function ($receiver) {
      $receiver.change = GenericRadioGroup$setChildrenFromOptions$lambda$lambda$lambda$lambda$lambda($receiver, this$GenericRadioGroup);
      return Unit;
    };
  }
  GenericRadioGroup.prototype.setChildrenFromOptions_vav3mh$_0 = function () {
    var tmp$;
    var currentName = this.name;
    this.container_8be2vx$.removeAll();
    if ((tmp$ = this.options) != null) {
      var tname = currentName != null ? currentName : this.idc_pcdz3m$_0;
      var tinline = this.inline;
      var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        var tmp$_1 = destination.add_11rb$;
        var $receiver = new Radio(false, this.toStr(item.first), void 0, item.second);
        $receiver.inline = tinline;
        $receiver.name = tname;
        $receiver.eventTarget = this;
        $receiver.setEventListener_a1up2z$(GenericRadioGroup$setChildrenFromOptions$lambda$lambda$lambda$lambda(this));
        tmp$_1.call(destination, $receiver);
      }
      var c = destination;
      this.container_8be2vx$.addAll_xquxs0$(c);
    }};
  function GenericRadioGroup$configureChild$lambda$lambda(this$, this$GenericRadioGroup) {
    return function (ev) {
      var tmp$;
      var tmp$_0 = this$GenericRadioGroup;
      var tmp$_1;
      tmp$_1 = (tmp$ = this$.self.extraValue) != null ? this$GenericRadioGroup.fromStr(tmp$) : null;
      tmp$_0.value = tmp$_1;
      ev.stopPropagation();
      return Unit;
    };
  }
  function GenericRadioGroup$configureChild$lambda(this$GenericRadioGroup) {
    return function ($receiver) {
      $receiver.change = GenericRadioGroup$configureChild$lambda$lambda($receiver, this$GenericRadioGroup);
      return Unit;
    };
  }
  GenericRadioGroup.prototype.configureChild_87eobz$ = function (child) {
    if (Kotlin.isType(child, Radio)) {
      child.eventTarget = this;
      child.name = this.name;
      child.setEventListener_a1up2z$(GenericRadioGroup$configureChild$lambda(this));
    }};
  GenericRadioGroup.prototype.add_87eobz$ = function (child) {
    this.configureChild_87eobz$(child);
    this.container_8be2vx$.add_87eobz$(child);
    return this;
  };
  GenericRadioGroup.prototype.add_pqktxj$ = function (position, child) {
    this.configureChild_87eobz$(child);
    this.container_8be2vx$.add_pqktxj$(position, child);
    return this;
  };
  GenericRadioGroup.prototype.addAll_xquxs0$ = function (children) {
    var tmp$;
    tmp$ = children.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      this.add_87eobz$(element);
    }
    return this;
  };
  GenericRadioGroup.prototype.remove_87eobz$ = function (child) {
    this.container_8be2vx$.remove_87eobz$(child);
    return this;
  };
  GenericRadioGroup.prototype.removeAt_za3lpa$ = function (position) {
    this.container_8be2vx$.removeAt_za3lpa$(position);
    return this;
  };
  GenericRadioGroup.prototype.removeAll = function () {
    this.container_8be2vx$.removeAll();
    return this;
  };
  GenericRadioGroup.prototype.disposeAll = function () {
    this.container_8be2vx$.disposeAll();
    return this;
  };
  GenericRadioGroup.prototype.getChildren = function () {
    return this.container_8be2vx$.getChildren();
  };
  GenericRadioGroup.prototype.focus = function () {
    var tmp$;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    (tmp$ = firstOrNull(destination)) != null ? (tmp$.focus(), Unit) : null;
  };
  GenericRadioGroup.prototype.blur = function () {
    var tmp$;
    var $receiver = this.container_8be2vx$.getChildren();
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (Kotlin.isType(element, Radio))
        destination.add_11rb$(element);
    }
    (tmp$ = firstOrNull(destination)) != null ? (tmp$.blur(), Unit) : null;
  };
  GenericRadioGroup.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    this.addCssClass_61zpoe$('row');
    this.addCssClass_61zpoe$('kv-control-horiz');
    this.flabel.addCssClass_61zpoe$('col-sm-' + horizontalRatio.labels);
    this.flabel.addCssClass_61zpoe$('col-form-label');
    this.container_8be2vx$.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    this.invalidFeedback.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
    this.invalidFeedback.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
  };
  GenericRadioGroup.prototype.getState = function () {
    return this.value;
  };
  function GenericRadioGroup$subscribe$lambda(this$GenericRadioGroup, closure$observer) {
    return function () {
      var $receiver = this$GenericRadioGroup.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  GenericRadioGroup.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return GenericRadioGroup$subscribe$lambda(this, observer);
  };
  GenericRadioGroup.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function GenericRadioGroup$Companion() {
    GenericRadioGroup$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  GenericRadioGroup$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var GenericRadioGroup$Companion_instance = null;
  function GenericRadioGroup$Companion_getInstance() {
    if (GenericRadioGroup$Companion_instance === null) {
      new GenericRadioGroup$Companion();
    }return GenericRadioGroup$Companion_instance;
  }
  function GenericRadioGroup_init$lambda(it) {
    return toString_0(it);
  }
  function GenericRadioGroup_init$lambda_0(it) {
    var tmp$;
    return (tmp$ = it) == null || Kotlin.isType(tmp$, Object_init) ? tmp$ : null;
  }
  function GenericRadioGroup$options$lambda(this$GenericRadioGroup) {
    return function (it) {
      this$GenericRadioGroup.setChildrenFromOptions_vav3mh$_0();
      return Unit;
    };
  }
  function GenericRadioGroup$value$lambda(this$GenericRadioGroup) {
    return function (it) {
      this$GenericRadioGroup.setValueToChildren_rkfpe2$_0(it);
      var tmp$;
      tmp$ = this$GenericRadioGroup.observers.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(it);
      }
      var tmp$_0 = this$GenericRadioGroup;
      var $receiver = new Object_init();
      var $receiver_0 = new Object_init();
      $receiver_0.data = it;
      $receiver.detail = $receiver_0;
      tmp$_0.dispatchEvent_nxedta$('change', $receiver);
      return Unit;
    };
  }
  function GenericRadioGroup$container$lambda(this$GenericRadioGroup) {
    return function ($receiver) {
      $receiver.id = this$GenericRadioGroup.idc_pcdz3m$_0;
      return Unit;
    };
  }
  GenericRadioGroup.$metadata$ = {kind: Kind_CLASS, simpleName: 'GenericRadioGroup', interfaces: [MutableState, GenericFormControl, SimplePanel]};
  var GenericRadioGroupInput$options_metadata = new PropertyMetadata('options');
  var GenericRadioGroupInput$value_metadata = new PropertyMetadata('value');
  var GenericRadioGroupInput$inline_metadata = new PropertyMetadata('inline');
  var GenericRadioGroupInput$Companion_instance = null;
  function Widget$refreshOnUpdate$lambda_8(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Radio(value, extraValue, name, label, rich, init) {
    Radio$Companion_getInstance();
    if (value === void 0)
      value = false;
    if (extraValue === void 0)
      extraValue = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-check');
    this.inline_7co69$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_8(this))).provideDelegate_n5byny$(this, Radio$inline_metadata);
    this.reversed_pv8fa0$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_8(this))).provideDelegate_n5byny$(this, Radio$reversed_metadata);
    this.labelFirst_wi7irm$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_8(this))).provideDelegate_n5byny$(this, Radio$labelFirst_metadata);
    this.idc_5148i6$_0 = 'kv_form_radio_' + Radio$Companion_getInstance().counter_8be2vx$;
    var $receiver = new RadioInput(value);
    var closure$extraValue = extraValue;
    var closure$name = name;
    $receiver.id = this.idc_5148i6$_0;
    $receiver.extraValue = closure$extraValue;
    $receiver.name = closure$name;
    this.input_4knrao$_0 = $receiver;
    this.flabel_q308r0$_0 = new FieldLabelCheck(this.idc_5148i6$_0, label, rich, 'form-check-label', Radio$flabel$lambda);
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_tlzv5q$_0 = $receiver_0;
    var tmp$, tmp$_0;
    this.input.eventTarget = (tmp$ = this.eventTarget) != null ? tmp$ : this;
    tmp$_0 = Radio$Companion_getInstance().counter_8be2vx$;
    Radio$Companion_getInstance().counter_8be2vx$ = tmp$_0 + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(Radio.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(Radio.prototype, 'startValue', {configurable: true, get: function () {
    return this.input.startValue;
  }, set: function (value) {
    this.input.startValue = value;
  }});
  Object.defineProperty(Radio.prototype, 'extraValue', {configurable: true, get: function () {
    return this.input.extraValue;
  }, set: function (value) {
    this.input.extraValue = value;
  }});
  Object.defineProperty(Radio.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(Radio.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(Radio.prototype, 'style', {configurable: true, get: function () {
    return this.input.style;
  }, set: function (value) {
    this.input.style = value;
  }});
  Object.defineProperty(Radio.prototype, 'squared', {configurable: true, get: function () {
    return this.input.squared;
  }, set: function (value) {
    this.input.squared = value;
  }});
  var Radio$inline_metadata = new PropertyMetadata('inline');
  Object.defineProperty(Radio.prototype, 'inline', {configurable: true, get: function () {
    return this.inline_7co69$_0.getValue_fmbzy8$(this, Radio$inline_metadata);
  }, set: function (inline) {
    this.inline_7co69$_0.setValue_19qrsr$(this, Radio$inline_metadata, inline);
  }});
  var Radio$reversed_metadata = new PropertyMetadata('reversed');
  Object.defineProperty(Radio.prototype, 'reversed', {configurable: true, get: function () {
    return this.reversed_pv8fa0$_0.getValue_fmbzy8$(this, Radio$reversed_metadata);
  }, set: function (reversed) {
    this.reversed_pv8fa0$_0.setValue_19qrsr$(this, Radio$reversed_metadata, reversed);
  }});
  var Radio$labelFirst_metadata = new PropertyMetadata('labelFirst');
  Object.defineProperty(Radio.prototype, 'labelFirst', {configurable: true, get: function () {
    return this.labelFirst_wi7irm$_0.getValue_fmbzy8$(this, Radio$labelFirst_metadata);
  }, set: function (labelFirst) {
    this.labelFirst_wi7irm$_0.setValue_19qrsr$(this, Radio$labelFirst_metadata, labelFirst);
  }});
  Object.defineProperty(Radio.prototype, 'input', {configurable: true, get: function () {
    return this.input_4knrao$_0;
  }});
  Object.defineProperty(Radio.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_q308r0$_0;
  }});
  Object.defineProperty(Radio.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_tlzv5q$_0;
  }});
  Radio.prototype.render = function () {
    var childrenList = this.labelFirst ? listOf([this.flabel, this.input, this.invalidFeedback]) : listOf([this.input, this.flabel, this.invalidFeedback]);
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = childrenList.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var tmp$_0;
      if ((tmp$_0 = element.visible ? element.renderVNode() : null) != null) {
        destination.add_11rb$(tmp$_0);
      }}
    var children = copyToArray(destination);
    return this.render_pjwf99$('div', children);
  };
  Radio.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  Radio.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  Radio.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  Radio.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.inline) {
      classSetBuilder.add_61zpoe$('form-check-inline');
    }if (this.reversed) {
      classSetBuilder.add_61zpoe$('form-check-reverse');
    }if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  function Radio$onClick$lambda$lambda(this$, closure$handler) {
    return function (e) {
      closure$handler(this$.self, e);
      return Unit;
    };
  }
  function Radio$onClick$lambda(closure$handler) {
    return function ($receiver) {
      $receiver.click = Radio$onClick$lambda$lambda($receiver, closure$handler);
      return Unit;
    };
  }
  Radio.prototype.onClick_k6wtwo$ = function (handler) {
    this.setEventListener_a1up2z$(Radio$onClick$lambda(handler));
    return this;
  };
  Radio.prototype.focus = function () {
    this.input.focus();
  };
  Radio.prototype.blur = function () {
    this.input.blur();
  };
  Radio.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    if (this.labelFirst) {
      BoolFormControl.prototype.styleForHorizontalFormPanel_fn6884$.call(this, horizontalRatio);
      this.addCssClass_61zpoe$('form-group');
      this.addCssClass_61zpoe$('kv-mb-3');
      this.removeCssClass_61zpoe$('form-check');
    } else {
      this.addCssClass_61zpoe$('form-group');
      this.addCssClass_61zpoe$('kv-mb-3');
      this.addSurroundingCssClass_61zpoe$('row');
      this.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
      this.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    }
  };
  Radio.prototype.styleForInlineFormPanel = function () {
    this.addCssClass_61zpoe$('form-group');
  };
  Radio.prototype.styleForVerticalFormPanel = function () {
    this.addCssClass_61zpoe$('form-group');
    this.addCssClass_61zpoe$('kv-mb-3');
  };
  Radio.prototype.dispose = function () {
    SimplePanel.prototype.dispose.call(this);
    this.input.dispose();
    this.flabel.dispose();
    this.invalidFeedback.dispose();
  };
  Radio.prototype.getState = function () {
    return this.input.getState();
  };
  Radio.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  Radio.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function Radio$Companion() {
    Radio$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Radio$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Radio$Companion_instance = null;
  function Radio$Companion_getInstance() {
    if (Radio$Companion_instance === null) {
      new Radio$Companion();
    }return Radio$Companion_instance;
  }
  function Radio$flabel$lambda($receiver) {
    span($receiver);
    return Unit;
  }
  Radio.$metadata$ = {kind: Kind_CLASS, simpleName: 'Radio', interfaces: [MutableState, BoolFormControl, SimplePanel]};
  function RadioGroup(options, value, name, inline, label, rich, init) {
    if (options === void 0)
      options = null;
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (inline === void 0)
      inline = false;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    GenericRadioGroup.call(this, options, value, name, inline, label, rich);
    init != null ? init(this) : null;
  }
  RadioGroup.prototype.getValue = function () {
    return this.value;
  };
  RadioGroup.prototype.setValue_s8jyv4$ = function (v) {
    var tmp$, tmp$_0;
    this.value = (tmp$_0 = typeof (tmp$ = v) === 'string' ? tmp$ : null) != null ? tmp$_0 : v != null ? v.toString() : null;
  };
  RadioGroup.prototype.getValueAsString = function () {
    return this.value;
  };
  RadioGroup.$metadata$ = {kind: Kind_CLASS, simpleName: 'RadioGroup', interfaces: [StringFormControl, GenericRadioGroup]};
  function radioGroup($receiver, options, value, name, inline, label, rich, init) {
    if (options === void 0)
      options = null;
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (inline === void 0)
      inline = false;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    var radioGroup = new RadioGroup(options, value, name, inline, label, rich, init);
    $receiver.add_87eobz$(radioGroup);
    return radioGroup;
  }
  function Widget$refreshOnUpdate$lambda_9(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function RadioInput(value, className, init) {
    if (value === void 0)
      value = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    CheckInput.call(this, CheckInputType$RADIO_getInstance(), value, className);
    this.squared_ihisqj$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_9(this))).provideDelegate_n5byny$(this, RadioInput$squared_metadata);
    this.setInternalEventListener_a1up2z$(RadioInput_init$lambda);
    init != null ? init(this) : null;
  }
  var RadioInput$squared_metadata = new PropertyMetadata('squared');
  Object.defineProperty(RadioInput.prototype, 'squared', {configurable: true, get: function () {
    return this.squared_ihisqj$_0.getValue_fmbzy8$(this, RadioInput$squared_metadata);
  }, set: function (squared) {
    this.squared_ihisqj$_0.setValue_19qrsr$(this, RadioInput$squared_metadata, squared);
  }});
  RadioInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    CheckInput.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.squared) {
      classSetBuilder.add_61zpoe$('kv-radio-square');
    }};
  RadioInput.prototype.changeValue_61zpoe$ = function (eventType) {
    var tmp$;
    CheckInput.prototype.changeValue_61zpoe$.call(this, eventType);
    if ((tmp$ = this.name) != null) {
      var tmp$_0;
      var elements = document.getElementsByName(tmp$);
      tmp$_0 = elements.length;
      for (var index = 0; index < tmp$_0; index++) {
        var element = ensureNotNull(elements.item(index));
        var tmp$_1 = equals(element.nodeName, 'INPUT') && !equals(element, this.getElement());
        if (tmp$_1) {
          tmp$_1 = equals(element.getAttribute('type'), 'radio');
        }if (tmp$_1) {
          element.dispatchEvent(new CustomEvent('deselect'));
        }}
    }};
  function RadioInput_init$lambda$lambda(this$) {
    return function (it) {
      if (this$.self.value)
        this$.self.value = false;
      return Unit;
    };
  }
  function RadioInput_init$lambda($receiver) {
    set($receiver, 'deselect', RadioInput_init$lambda$lambda($receiver));
    return Unit;
  }
  RadioInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'RadioInput', interfaces: [CheckInput]};
  function TriStateCheckBox(value, name, label, rich, init) {
    TriStateCheckBox$Companion_getInstance();
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-check');
    this.observers = ArrayList_init();
    this.inline_21wy0n$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, TriStateCheckBox$inline_metadata);
    this.switch_6vrssu$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, TriStateCheckBox$switch_metadata);
    this.reversed_cl3bcw$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, TriStateCheckBox$reversed_metadata);
    this.labelFirst_ks31d2$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_10(this))).provideDelegate_n5byny$(this, TriStateCheckBox$labelFirst_metadata);
    this.idc_a3rdsa$_0 = 'kv_form_tristatecheckbox_' + TriStateCheckBox$Companion_getInstance().counter_8be2vx$;
    var $receiver = new TriStateCheckBoxInput(value != null ? value : false);
    var closure$name = name;
    var closure$value = value;
    $receiver.id = this.idc_a3rdsa$_0;
    $receiver.name = closure$name;
    $receiver.indeterminate = closure$value == null;
    this.input_koozfc$_0 = $receiver;
    this.flabel_ntqmk4$_0 = new FieldLabelCheck(this.idc_a3rdsa$_0, label, rich, 'form-check-label', TriStateCheckBox$flabel$lambda);
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_k7e0a2$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    tmp$ = TriStateCheckBox$Companion_getInstance().counter_8be2vx$;
    TriStateCheckBox$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  var TriStateCheckBox$inline_metadata = new PropertyMetadata('inline');
  var TriStateCheckBox$switch_metadata = new PropertyMetadata('switch');
  var TriStateCheckBox$reversed_metadata = new PropertyMetadata('reversed');
  var TriStateCheckBox$labelFirst_metadata = new PropertyMetadata('labelFirst');
  var TriStateCheckBox$Companion_instance = null;
  function Range(value, name, min, max, step, label, rich, init) {
    Range$Companion_getInstance();
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (min === void 0)
      min = 0;
    if (max === void 0)
      max = 100;
    if (step === void 0)
      step = 1;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-group kv-mb-3');
    this.idc = 'kv_form_range_' + Range$Companion_getInstance().counter_8be2vx$;
    var $receiver = new RangeInput(value, min, max, step);
    var closure$name = name;
    $receiver.id = this.idc;
    $receiver.name = closure$name;
    this.input_rdqi6f$_0 = $receiver;
    this.flabel_tcrn5v$_0 = new FieldLabel(this.idc, label, rich, 'form-label');
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_3rtumx$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    this.addPrivate_87eobz$(this.flabel);
    this.addPrivate_87eobz$(this.input);
    this.addPrivate_87eobz$(this.invalidFeedback);
    tmp$ = Range$Companion_getInstance().counter_8be2vx$;
    Range$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(Range.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(Range.prototype, 'startValue', {configurable: true, get: function () {
    return this.input.startValue;
  }, set: function (value) {
    this.input.startValue = value;
  }});
  Object.defineProperty(Range.prototype, 'min', {configurable: true, get: function () {
    return this.input.min;
  }, set: function (value) {
    this.input.min = value;
  }});
  Object.defineProperty(Range.prototype, 'max', {configurable: true, get: function () {
    return this.input.max;
  }, set: function (value) {
    this.input.max = value;
  }});
  Object.defineProperty(Range.prototype, 'step', {configurable: true, get: function () {
    return this.input.step;
  }, set: function (value) {
    this.input.step = value;
  }});
  Object.defineProperty(Range.prototype, 'autofocus', {configurable: true, get: function () {
    return this.input.autofocus;
  }, set: function (value) {
    this.input.autofocus = value;
  }});
  Object.defineProperty(Range.prototype, 'readonly', {configurable: true, get: function () {
    return this.input.readonly;
  }, set: function (value) {
    this.input.readonly = value;
  }});
  Object.defineProperty(Range.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(Range.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(Range.prototype, 'validatorError', {configurable: true, get: function () {
    return Kotlin.callGetter(this, NumberFormControl.prototype, 'validatorError');
  }, set: function (value) {
    Kotlin.callSetter(this, NumberFormControl.prototype, 'validatorError', value);
    if (value != null) {
      this.input.addSurroundingCssClass_61zpoe$('is-invalid');
    } else {
      this.input.removeSurroundingCssClass_61zpoe$('is-invalid');
    }
  }});
  Object.defineProperty(Range.prototype, 'input', {configurable: true, get: function () {
    return this.input_rdqi6f$_0;
  }});
  Object.defineProperty(Range.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_tcrn5v$_0;
  }});
  Object.defineProperty(Range.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_3rtumx$_0;
  }});
  Range.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  Range.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  Range.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  Range.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  Range.prototype.getValueAsString = function () {
    return this.input.getValueAsString();
  };
  Range.prototype.stepUp = function () {
    this.input.stepUp();
    return this;
  };
  Range.prototype.stepDown = function () {
    this.input.stepDown();
    return this;
  };
  Range.prototype.focus = function () {
    this.input.focus();
  };
  Range.prototype.blur = function () {
    this.input.blur();
  };
  Range.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    this.addCssClass_61zpoe$('row');
    this.addCssClass_61zpoe$('kv-control-horiz');
    this.flabel.addCssClass_61zpoe$('col-sm-' + horizontalRatio.labels);
    this.flabel.addCssClass_61zpoe$('col-form-label');
    this.input.addSurroundingCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    this.invalidFeedback.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
    this.invalidFeedback.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
  };
  Range.prototype.getState = function () {
    return this.input.getState();
  };
  Range.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  Range.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function Range$Companion() {
    Range$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Range$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Range$Companion_instance = null;
  function Range$Companion_getInstance() {
    if (Range$Companion_instance === null) {
      new Range$Companion();
    }return Range$Companion_instance;
  }
  Range.$metadata$ = {kind: Kind_CLASS, simpleName: 'Range', interfaces: [MutableState, NumberFormControl, SimplePanel]};
  function Widget$refreshOnUpdate$lambda_11(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_12(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var DEFAULT_STEP;
  function RangeInput(value, min, max, step, className, init) {
    if (value === void 0)
      value = null;
    if (min === void 0)
      min = 0;
    if (max === void 0)
      max = 100;
    if (step === void 0)
      step = 1;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    Widget.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'form-range');
    this.observers = ArrayList_init();
    var tmp$_0;
    this.value_gi26q6$_0 = (new Widget$RefreshDelegateProvider(this, value != null ? value : (tmp$_0 = min) == null || Kotlin.isNumber(tmp$_0) ? tmp$_0 : throwCCE(), RangeInput$value$lambda(this))).provideDelegate_n5byny$(this, RangeInput$value_metadata);
    this.startValue_y01uke$_0 = (new Widget$RefreshDelegateProvider(this, value, RangeInput$startValue$lambda(this))).provideDelegate_n5byny$(this, RangeInput$startValue_metadata);
    this.min_t69zap$_0 = (new Widget$RefreshDelegateProvider(this, min, Widget$refreshOnUpdate$lambda_11(this))).provideDelegate_n5byny$(this, RangeInput$min_metadata);
    this.max_t69tlr$_0 = (new Widget$RefreshDelegateProvider(this, max, Widget$refreshOnUpdate$lambda_11(this))).provideDelegate_n5byny$(this, RangeInput$max_metadata);
    this.step_iwdoe3$_0 = (new Widget$RefreshDelegateProvider(this, step, Widget$refreshOnUpdate$lambda_11(this))).provideDelegate_n5byny$(this, RangeInput$step_metadata);
    this.name_izgmfu$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, RangeInput$name_metadata);
    this.disabled_cnov11$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_11(this))).provideDelegate_n5byny$(this, RangeInput$disabled_metadata);
    this.autofocus_4fefja$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, RangeInput$autofocus_metadata);
    this.readonly_2cy7zl$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, RangeInput$readonly_metadata);
    this.size_iwk9xs$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, RangeInput$size_metadata);
    this.validationStatus_olc95m$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_12(this))).provideDelegate_n5byny$(this, RangeInput$validationStatus_metadata);
    this.useSnabbdomDistinctKey();
    this.setInternalEventListener_a1up2z$(RangeInput_init$lambda);
    init != null ? init(this) : null;
  }
  var RangeInput$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(RangeInput.prototype, 'value', {configurable: true, get: function () {
    return this.value_gi26q6$_0.getValue_fmbzy8$(this, RangeInput$value_metadata);
  }, set: function (value) {
    this.value_gi26q6$_0.setValue_19qrsr$(this, RangeInput$value_metadata, value);
  }});
  var RangeInput$startValue_metadata = new PropertyMetadata('startValue');
  Object.defineProperty(RangeInput.prototype, 'startValue', {configurable: true, get: function () {
    return this.startValue_y01uke$_0.getValue_fmbzy8$(this, RangeInput$startValue_metadata);
  }, set: function (startValue) {
    this.startValue_y01uke$_0.setValue_19qrsr$(this, RangeInput$startValue_metadata, startValue);
  }});
  var RangeInput$min_metadata = new PropertyMetadata('min');
  Object.defineProperty(RangeInput.prototype, 'min', {configurable: true, get: function () {
    return this.min_t69zap$_0.getValue_fmbzy8$(this, RangeInput$min_metadata);
  }, set: function (min) {
    this.min_t69zap$_0.setValue_19qrsr$(this, RangeInput$min_metadata, min);
  }});
  var RangeInput$max_metadata = new PropertyMetadata('max');
  Object.defineProperty(RangeInput.prototype, 'max', {configurable: true, get: function () {
    return this.max_t69tlr$_0.getValue_fmbzy8$(this, RangeInput$max_metadata);
  }, set: function (max) {
    this.max_t69tlr$_0.setValue_19qrsr$(this, RangeInput$max_metadata, max);
  }});
  var RangeInput$step_metadata = new PropertyMetadata('step');
  Object.defineProperty(RangeInput.prototype, 'step', {configurable: true, get: function () {
    return this.step_iwdoe3$_0.getValue_fmbzy8$(this, RangeInput$step_metadata);
  }, set: function (step) {
    this.step_iwdoe3$_0.setValue_19qrsr$(this, RangeInput$step_metadata, step);
  }});
  var RangeInput$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(RangeInput.prototype, 'name', {configurable: true, get: function () {
    return this.name_izgmfu$_0.getValue_fmbzy8$(this, RangeInput$name_metadata);
  }, set: function (name) {
    this.name_izgmfu$_0.setValue_19qrsr$(this, RangeInput$name_metadata, name);
  }});
  var RangeInput$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(RangeInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_cnov11$_0.getValue_fmbzy8$(this, RangeInput$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_cnov11$_0.setValue_19qrsr$(this, RangeInput$disabled_metadata, disabled);
  }});
  var RangeInput$autofocus_metadata = new PropertyMetadata('autofocus');
  Object.defineProperty(RangeInput.prototype, 'autofocus', {configurable: true, get: function () {
    return this.autofocus_4fefja$_0.getValue_fmbzy8$(this, RangeInput$autofocus_metadata);
  }, set: function (autofocus) {
    this.autofocus_4fefja$_0.setValue_19qrsr$(this, RangeInput$autofocus_metadata, autofocus);
  }});
  var RangeInput$readonly_metadata = new PropertyMetadata('readonly');
  Object.defineProperty(RangeInput.prototype, 'readonly', {configurable: true, get: function () {
    return this.readonly_2cy7zl$_0.getValue_fmbzy8$(this, RangeInput$readonly_metadata);
  }, set: function (readonly) {
    this.readonly_2cy7zl$_0.setValue_19qrsr$(this, RangeInput$readonly_metadata, readonly);
  }});
  var RangeInput$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(RangeInput.prototype, 'size', {configurable: true, get: function () {
    return this.size_iwk9xs$_0.getValue_fmbzy8$(this, RangeInput$size_metadata);
  }, set: function (size) {
    this.size_iwk9xs$_0.setValue_19qrsr$(this, RangeInput$size_metadata, size);
  }});
  var RangeInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  Object.defineProperty(RangeInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.validationStatus_olc95m$_0.getValue_fmbzy8$(this, RangeInput$validationStatus_metadata);
  }, set: function (validationStatus) {
    this.validationStatus_olc95m$_0.setValue_19qrsr$(this, RangeInput$validationStatus_metadata, validationStatus);
  }});
  RangeInput.prototype.render = function () {
    return this.render_61zpoe$('input');
  };
  RangeInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.validationStatus);
    classSetBuilder.add_vqcfem$(this.size);
  };
  RangeInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', 'range');
    if ((tmp$ = this.startValue) != null) {
      attributeSetBuilder.add_puj7f4$('value', tmp$.toString());
    }if ((tmp$_0 = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$_0);
    }attributeSetBuilder.add_puj7f4$('min', this.min.toString());
    attributeSetBuilder.add_puj7f4$('max', this.max.toString());
    attributeSetBuilder.add_puj7f4$('step', this.step.toString());
    if ((tmp$_1 = this.autofocus) != null) {
      if (tmp$_1) {
        attributeSetBuilder.add_puj7f4$('autofocus');
      }}if ((tmp$_2 = this.readonly) != null) {
      if (tmp$_2) {
        attributeSetBuilder.add_puj7f4$('readonly');
      }}if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }};
  RangeInput.prototype.afterInsert_77isfd$ = function (node) {
    this.refreshState();
  };
  RangeInput.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? tmp$.toString() : null;
  };
  RangeInput.prototype.stepUp = function () {
    var tmp$, tmp$_0;
    (tmp$_0 = Kotlin.isType(tmp$ = this.getElement(), HTMLInputElement) ? tmp$ : null) != null ? (tmp$_0.stepUp(), Unit) : null;
    return this;
  };
  RangeInput.prototype.stepDown = function () {
    var tmp$, tmp$_0;
    (tmp$_0 = Kotlin.isType(tmp$ = this.getElement(), HTMLInputElement) ? tmp$ : null) != null ? (tmp$_0.stepDown(), Unit) : null;
    return this;
  };
  RangeInput.prototype.refreshState = function () {
    var tmp$;
    if ((tmp$ = this.value) != null) {
      var tmp$_0;
      (tmp$_0 = this.getElementD()) != null ? (tmp$_0.value = tmp$) : null;
    }if (this.value == null)
      this.value = this.min;
  };
  RangeInput.prototype.changeValue = function () {
    var tmp$, tmp$_0;
    var v = (tmp$_0 = (tmp$ = this.getElementD()) != null ? tmp$.value : null) != null ? tmp$_0 : null;
    if (v != null && !equals(v, '')) {
      var newValue = toDoubleOrNull(v);
      if (!equals(this.value, newValue))
        this.value = newValue;
    } else {
      this.value = null;
    }
  };
  RangeInput.prototype.getState = function () {
    return this.value;
  };
  function RangeInput$subscribe$lambda(this$RangeInput, closure$observer) {
    return function () {
      var $receiver = this$RangeInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  RangeInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return RangeInput$subscribe$lambda(this, observer);
  };
  RangeInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function RangeInput$value$lambda(this$RangeInput) {
    return function (it) {
      this$RangeInput.refreshState();
      var tmp$;
      tmp$ = this$RangeInput.observers.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(it);
      }
      return Unit;
    };
  }
  function RangeInput$startValue$lambda(this$RangeInput) {
    return function (it) {
      this$RangeInput.value = it;
      this$RangeInput.refresh();
      return Unit;
    };
  }
  function RangeInput_init$lambda$lambda(this$) {
    return function (it) {
      this$.self.changeValue();
      return Unit;
    };
  }
  function RangeInput_init$lambda($receiver) {
    $receiver.input = RangeInput_init$lambda$lambda($receiver);
    return Unit;
  }
  RangeInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'RangeInput', interfaces: [MutableState, FormInput, GenericFormComponent, Widget]};
  function SimpleSelect(options, value, emptyOption, multiple, selectSize, name, label, rich, floating, init) {
    SimpleSelect$Companion_getInstance();
    if (options === void 0)
      options = null;
    if (value === void 0)
      value = null;
    if (emptyOption === void 0)
      emptyOption = false;
    if (multiple === void 0)
      multiple = false;
    if (selectSize === void 0)
      selectSize = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (floating === void 0)
      floating = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, floating ? 'form-floating kv-mb-3' : 'form-group kv-mb-3');
    this.floating = floating;
    this.idc_p3pdcp$_0 = 'kv_form_simpleselect_' + SimpleSelect$Companion_getInstance().counter_8be2vx$;
    var $receiver = new SimpleSelectInput(options, value, emptyOption, multiple, selectSize);
    var closure$name = name;
    $receiver.id = this.idc_p3pdcp$_0;
    $receiver.name = closure$name;
    this.input_qrsr2d$_0 = $receiver;
    this.flabel_3dnabb$_0 = new FieldLabel(this.idc_p3pdcp$_0, label, rich, 'form-label');
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_3jev2l$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    if (!this.floating) {
      this.addPrivate_87eobz$(this.flabel);
      this.addPrivate_87eobz$(this.input);
    } else {
      this.addPrivate_87eobz$(this.input);
      this.addPrivate_87eobz$(this.flabel);
    }
    this.addPrivate_87eobz$(this.invalidFeedback);
    tmp$ = SimpleSelect$Companion_getInstance().counter_8be2vx$;
    SimpleSelect$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  var SimpleSelect$Companion_instance = null;
  var KVNULL;
  var SimpleSelectInput$options_metadata = new PropertyMetadata('options');
  var SimpleSelectInput$value_metadata = new PropertyMetadata('value');
  var SimpleSelectInput$startValue_metadata = new PropertyMetadata('startValue');
  var SimpleSelectInput$name_metadata = new PropertyMetadata('name');
  var SimpleSelectInput$disabled_metadata = new PropertyMetadata('disabled');
  var SimpleSelectInput$autofocus_metadata = new PropertyMetadata('autofocus');
  var SimpleSelectInput$emptyOption_metadata = new PropertyMetadata('emptyOption');
  var SimpleSelectInput$multiple_metadata = new PropertyMetadata('multiple');
  var SimpleSelectInput$selectSize_metadata = new PropertyMetadata('selectSize');
  var SimpleSelectInput$placeholder_metadata = new PropertyMetadata('placeholder');
  var SimpleSelectInput$size_metadata = new PropertyMetadata('size');
  var SimpleSelectInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  function SimpleSpinner(value, name, min, max, step, label, rich, init) {
    SimpleSpinner$Companion_getInstance();
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (min === void 0)
      min = null;
    if (max === void 0)
      max = null;
    if (step === void 0)
      step = 1;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, 'form-group kv-mb-3');
    this.idc = 'kv_form_simple_spinner_' + SimpleSpinner$Companion_getInstance().counter_8be2vx$;
    var $receiver = new SimpleSpinnerInput(value, min, max, step);
    var closure$name = name;
    $receiver.id = this.idc;
    $receiver.name = closure$name;
    this.input_84ph2l$_0 = $receiver;
    this.flabel_d5cwbb$_0 = new FieldLabel(this.idc, label, rich, 'form-label');
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_9dx9tt$_0 = $receiver_0;
    var tmp$;
    this.input.eventTarget = this;
    this.addPrivate_87eobz$(this.flabel);
    this.addPrivate_87eobz$(this.input);
    this.addPrivate_87eobz$(this.invalidFeedback);
    tmp$ = SimpleSpinner$Companion_getInstance().counter_8be2vx$;
    SimpleSpinner$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0;
    init != null ? init(this) : null;
  }
  Object.defineProperty(SimpleSpinner.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'startValue', {configurable: true, get: function () {
    return this.input.startValue;
  }, set: function (value) {
    this.input.startValue = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'min', {configurable: true, get: function () {
    return this.input.min;
  }, set: function (value) {
    this.input.min = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'max', {configurable: true, get: function () {
    return this.input.max;
  }, set: function (value) {
    this.input.max = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'step', {configurable: true, get: function () {
    return this.input.step;
  }, set: function (value) {
    this.input.step = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'placeholder', {configurable: true, get: function () {
    return this.input.placeholder;
  }, set: function (value) {
    this.input.placeholder = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'autofocus', {configurable: true, get: function () {
    return this.input.autofocus;
  }, set: function (value) {
    this.input.autofocus = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'readonly', {configurable: true, get: function () {
    return this.input.readonly;
  }, set: function (value) {
    this.input.readonly = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'validatorError', {configurable: true, get: function () {
    return Kotlin.callGetter(this, NumberFormControl.prototype, 'validatorError');
  }, set: function (value) {
    Kotlin.callSetter(this, NumberFormControl.prototype, 'validatorError', value);
    if (value != null) {
      this.input.addSurroundingCssClass_61zpoe$('is-invalid');
    } else {
      this.input.removeSurroundingCssClass_61zpoe$('is-invalid');
    }
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'input', {configurable: true, get: function () {
    return this.input_84ph2l$_0;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_d5cwbb$_0;
  }});
  Object.defineProperty(SimpleSpinner.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_9dx9tt$_0;
  }});
  SimpleSpinner.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  SimpleSpinner.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  SimpleSpinner.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  SimpleSpinner.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  SimpleSpinner.prototype.getValueAsString = function () {
    return this.input.getValueAsString();
  };
  SimpleSpinner.prototype.spinUp = function () {
    this.input.spinUp();
    return this;
  };
  SimpleSpinner.prototype.spinDown = function () {
    this.input.spinDown();
    return this;
  };
  SimpleSpinner.prototype.focus = function () {
    this.input.focus();
  };
  SimpleSpinner.prototype.blur = function () {
    this.input.blur();
  };
  SimpleSpinner.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    this.addCssClass_61zpoe$('row');
    this.addCssClass_61zpoe$('kv-control-horiz');
    this.flabel.addCssClass_61zpoe$('col-sm-' + horizontalRatio.labels);
    this.flabel.addCssClass_61zpoe$('col-form-label');
    this.input.addSurroundingCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    this.invalidFeedback.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
    this.invalidFeedback.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
  };
  SimpleSpinner.prototype.getState = function () {
    return this.input.getState();
  };
  SimpleSpinner.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  SimpleSpinner.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  function SimpleSpinner$Companion() {
    SimpleSpinner$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  SimpleSpinner$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var SimpleSpinner$Companion_instance = null;
  function SimpleSpinner$Companion_getInstance() {
    if (SimpleSpinner$Companion_instance === null) {
      new SimpleSpinner$Companion();
    }return SimpleSpinner$Companion_instance;
  }
  SimpleSpinner.$metadata$ = {kind: Kind_CLASS, simpleName: 'SimpleSpinner', interfaces: [MutableState, NumberFormControl, SimplePanel]};
  function Widget$refreshOnUpdate$lambda_15(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_16(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var SIMPLE_DEFAULT_STEP;
  function SimpleSpinnerInput(value, min, max, step, className, init) {
    if (value === void 0)
      value = null;
    if (min === void 0)
      min = null;
    if (max === void 0)
      max = null;
    if (step === void 0)
      step = 1;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    Widget.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'form-control');
    this.observers = ArrayList_init();
    this.value_8fezag$_0 = (new Widget$RefreshDelegateProvider(this, value != null ? value : min, SimpleSpinnerInput$value$lambda(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$value_metadata);
    this.startValue_kuaq3o$_0 = (new Widget$RefreshDelegateProvider(this, value, SimpleSpinnerInput$startValue$lambda(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$startValue_metadata);
    this.min_q2tluf$_0 = (new Widget$RefreshDelegateProvider(this, min, Widget$refreshOnUpdate$lambda_15(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$min_metadata);
    this.max_q2tg5h$_0 = (new Widget$RefreshDelegateProvider(this, max, Widget$refreshOnUpdate$lambda_15(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$max_metadata);
    this.step_r6qujj$_0 = (new Widget$RefreshDelegateProvider(this, step, Widget$refreshOnUpdate$lambda_15(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$step_metadata);
    this.placeholder_e630ly$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_16(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$placeholder_metadata);
    this.name_r3nwhs$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_16(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$name_metadata);
    this.disabled_iie67j$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_15(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$disabled_metadata);
    this.autofocus_yy6340$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_16(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$autofocus_metadata);
    this.readonly_3hr36x$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_16(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$readonly_metadata);
    this.size_r6k8zu$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_16(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$size_metadata);
    this.validationStatus_k1xitc$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_16(this))).provideDelegate_n5byny$(this, SimpleSpinnerInput$validationStatus_metadata);
    this.useSnabbdomDistinctKey();
    this.setInternalEventListener_a1up2z$(SimpleSpinnerInput_init$lambda);
    init != null ? init(this) : null;
  }
  var SimpleSpinnerInput$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'value', {configurable: true, get: function () {
    return this.value_8fezag$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$value_metadata);
  }, set: function (value) {
    this.value_8fezag$_0.setValue_19qrsr$(this, SimpleSpinnerInput$value_metadata, value);
  }});
  var SimpleSpinnerInput$startValue_metadata = new PropertyMetadata('startValue');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'startValue', {configurable: true, get: function () {
    return this.startValue_kuaq3o$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$startValue_metadata);
  }, set: function (startValue) {
    this.startValue_kuaq3o$_0.setValue_19qrsr$(this, SimpleSpinnerInput$startValue_metadata, startValue);
  }});
  var SimpleSpinnerInput$min_metadata = new PropertyMetadata('min');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'min', {configurable: true, get: function () {
    return this.min_q2tluf$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$min_metadata);
  }, set: function (min) {
    this.min_q2tluf$_0.setValue_19qrsr$(this, SimpleSpinnerInput$min_metadata, min);
  }});
  var SimpleSpinnerInput$max_metadata = new PropertyMetadata('max');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'max', {configurable: true, get: function () {
    return this.max_q2tg5h$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$max_metadata);
  }, set: function (max) {
    this.max_q2tg5h$_0.setValue_19qrsr$(this, SimpleSpinnerInput$max_metadata, max);
  }});
  var SimpleSpinnerInput$step_metadata = new PropertyMetadata('step');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'step', {configurable: true, get: function () {
    return this.step_r6qujj$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$step_metadata);
  }, set: function (step) {
    this.step_r6qujj$_0.setValue_19qrsr$(this, SimpleSpinnerInput$step_metadata, step);
  }});
  var SimpleSpinnerInput$placeholder_metadata = new PropertyMetadata('placeholder');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'placeholder', {configurable: true, get: function () {
    return this.placeholder_e630ly$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$placeholder_metadata);
  }, set: function (placeholder) {
    this.placeholder_e630ly$_0.setValue_19qrsr$(this, SimpleSpinnerInput$placeholder_metadata, placeholder);
  }});
  var SimpleSpinnerInput$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'name', {configurable: true, get: function () {
    return this.name_r3nwhs$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$name_metadata);
  }, set: function (name) {
    this.name_r3nwhs$_0.setValue_19qrsr$(this, SimpleSpinnerInput$name_metadata, name);
  }});
  var SimpleSpinnerInput$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_iie67j$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_iie67j$_0.setValue_19qrsr$(this, SimpleSpinnerInput$disabled_metadata, disabled);
  }});
  var SimpleSpinnerInput$autofocus_metadata = new PropertyMetadata('autofocus');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'autofocus', {configurable: true, get: function () {
    return this.autofocus_yy6340$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$autofocus_metadata);
  }, set: function (autofocus) {
    this.autofocus_yy6340$_0.setValue_19qrsr$(this, SimpleSpinnerInput$autofocus_metadata, autofocus);
  }});
  var SimpleSpinnerInput$readonly_metadata = new PropertyMetadata('readonly');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'readonly', {configurable: true, get: function () {
    return this.readonly_3hr36x$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$readonly_metadata);
  }, set: function (readonly) {
    this.readonly_3hr36x$_0.setValue_19qrsr$(this, SimpleSpinnerInput$readonly_metadata, readonly);
  }});
  var SimpleSpinnerInput$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'size', {configurable: true, get: function () {
    return this.size_r6k8zu$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$size_metadata);
  }, set: function (size) {
    this.size_r6k8zu$_0.setValue_19qrsr$(this, SimpleSpinnerInput$size_metadata, size);
  }});
  var SimpleSpinnerInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  Object.defineProperty(SimpleSpinnerInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.validationStatus_k1xitc$_0.getValue_fmbzy8$(this, SimpleSpinnerInput$validationStatus_metadata);
  }, set: function (validationStatus) {
    this.validationStatus_k1xitc$_0.setValue_19qrsr$(this, SimpleSpinnerInput$validationStatus_metadata, validationStatus);
  }});
  SimpleSpinnerInput.prototype.render = function () {
    return this.render_61zpoe$('input');
  };
  SimpleSpinnerInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.validationStatus);
    classSetBuilder.add_vqcfem$(this.size);
  };
  SimpleSpinnerInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', 'number');
    if ((tmp$ = this.startValue) != null) {
      attributeSetBuilder.add_puj7f4$('value', tmp$.toString());
    }if ((tmp$_0 = this.placeholder) != null) {
      attributeSetBuilder.add_puj7f4$('placeholder', this.translate_61zpoe$(tmp$_0));
    }if ((tmp$_1 = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$_1);
    }attributeSetBuilder.add_puj7f4$('min', toString_0(this.min));
    attributeSetBuilder.add_puj7f4$('max', toString_0(this.max));
    attributeSetBuilder.add_puj7f4$('step', this.step.toString());
    if ((tmp$_2 = this.autofocus) != null) {
      if (tmp$_2) {
        attributeSetBuilder.add_puj7f4$('autofocus');
      }}if ((tmp$_3 = this.readonly) != null) {
      if (tmp$_3) {
        attributeSetBuilder.add_puj7f4$('readonly');
      }}if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }};
  SimpleSpinnerInput.prototype.afterInsert_77isfd$ = function (node) {
    this.refreshState();
  };
  SimpleSpinnerInput.prototype.getValueAsString = function () {
    var tmp$;
    return (tmp$ = this.value) != null ? tmp$.toString() : null;
  };
  SimpleSpinnerInput.prototype.spinUp = function () {
    var tmp$, tmp$_0;
    (tmp$_0 = Kotlin.isType(tmp$ = this.getElement(), HTMLInputElement) ? tmp$ : null) != null ? (tmp$_0.stepUp(), Unit) : null;
    return this;
  };
  SimpleSpinnerInput.prototype.spinDown = function () {
    var tmp$, tmp$_0;
    (tmp$_0 = Kotlin.isType(tmp$ = this.getElement(), HTMLInputElement) ? tmp$ : null) != null ? (tmp$_0.stepDown(), Unit) : null;
    return this;
  };
  SimpleSpinnerInput.prototype.refreshState = function () {
    var tmp$;
    if ((tmp$ = this.value) != null) {
      var tmp$_0;
      (tmp$_0 = this.getElementD()) != null ? (tmp$_0.value = tmp$) : null;
    }if (this.value == null)
      this.value = this.min;
  };
  SimpleSpinnerInput.prototype.changeValue = function () {
    var tmp$, tmp$_0, tmp$_1;
    var v = (tmp$_0 = (tmp$ = this.getElementD()) != null ? tmp$.value : null) != null ? tmp$_0 : null;
    if (v != null && !equals(v, '')) {
      var tmp$_2;
      if ((tmp$_1 = toDoubleOrNull(v)) != null) {
        var tmp$_3, tmp$_4, tmp$_5, tmp$_6;
        tmp$_2 = this.min != null && tmp$_1 < ((tmp$_4 = (tmp$_3 = this.min) != null ? numberToDouble(tmp$_3) : null) != null ? tmp$_4 : 0.0) ? this.min : this.max != null && tmp$_1 > ((tmp$_6 = (tmp$_5 = this.max) != null ? numberToDouble(tmp$_5) : null) != null ? tmp$_6 : 0.0) ? this.max : tmp$_1;
      } else
        tmp$_2 = null;
      var newValue = tmp$_2;
      if (!equals(this.value, newValue))
        this.value = newValue;
    } else {
      this.value = null;
    }
  };
  SimpleSpinnerInput.prototype.getState = function () {
    return this.value;
  };
  function SimpleSpinnerInput$subscribe$lambda(this$SimpleSpinnerInput, closure$observer) {
    return function () {
      var $receiver = this$SimpleSpinnerInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  SimpleSpinnerInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return SimpleSpinnerInput$subscribe$lambda(this, observer);
  };
  SimpleSpinnerInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function SimpleSpinnerInput$value$lambda(this$SimpleSpinnerInput) {
    return function (it) {
      this$SimpleSpinnerInput.refreshState();
      var tmp$;
      tmp$ = this$SimpleSpinnerInput.observers.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element(it);
      }
      return Unit;
    };
  }
  function SimpleSpinnerInput$startValue$lambda(this$SimpleSpinnerInput) {
    return function (it) {
      this$SimpleSpinnerInput.value = it;
      this$SimpleSpinnerInput.refresh();
      return Unit;
    };
  }
  function SimpleSpinnerInput_init$lambda$lambda(this$) {
    return function (it) {
      this$.self.changeValue();
      return Unit;
    };
  }
  function SimpleSpinnerInput_init$lambda($receiver) {
    $receiver.input = SimpleSpinnerInput_init$lambda$lambda($receiver);
    return Unit;
  }
  SimpleSpinnerInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'SimpleSpinnerInput', interfaces: [MutableState, FormInput, GenericFormComponent, Widget]};
  function AbstractText(label, rich, floating, className) {
    AbstractText$Companion_getInstance();
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (floating === void 0)
      floating = false;
    if (className === void 0)
      className = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + (floating ? 'form-floating kv-mb-3' : 'form-group kv-mb-3'));
    this.floating = floating;
    this.idc = 'kv_form_text_' + AbstractText$Companion_getInstance().counter_8be2vx$;
    var $receiver = new FieldLabel(this.idc, label, rich, 'form-label');
    $receiver.visible = label != null;
    this.flabel_nw1e4n$_0 = $receiver;
    var $receiver_0 = new InvalidFeedback();
    $receiver_0.visible = false;
    this.invalidFeedback_cqujqb$_0 = $receiver_0;
    var tmp$_0;
    tmp$_0 = AbstractText$Companion_getInstance().counter_8be2vx$;
    AbstractText$Companion_getInstance().counter_8be2vx$ = tmp$_0 + 1 | 0;
  }
  Object.defineProperty(AbstractText.prototype, 'value', {configurable: true, get: function () {
    return this.input.value;
  }, set: function (value) {
    this.input.value = value != null ? value.length === 0 ? null : value : null;
  }});
  Object.defineProperty(AbstractText.prototype, 'startValue', {configurable: true, get: function () {
    return this.input.startValue;
  }, set: function (value) {
    this.input.startValue = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'placeholder', {configurable: true, get: function () {
    return this.input.placeholder;
  }, set: function (value) {
    this.input.placeholder = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'maxlength', {configurable: true, get: function () {
    return this.input.maxlength;
  }, set: function (value) {
    this.input.maxlength = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'autofocus', {configurable: true, get: function () {
    return this.input.autofocus;
  }, set: function (value) {
    this.input.autofocus = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'readonly', {configurable: true, get: function () {
    return this.input.readonly;
  }, set: function (value) {
    this.input.readonly = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'label', {configurable: true, get: function () {
    return this.flabel.content;
  }, set: function (value) {
    this.flabel.content = value;
    this.flabel.visible = value != null;
  }});
  Object.defineProperty(AbstractText.prototype, 'rich', {configurable: true, get: function () {
    return this.flabel.rich;
  }, set: function (value) {
    this.flabel.rich = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'maskOptions', {configurable: true, get: function () {
    return this.input.maskOptions;
  }, set: function (value) {
    this.input.maskOptions = value;
  }});
  Object.defineProperty(AbstractText.prototype, 'flabel', {configurable: true, get: function () {
    return this.flabel_nw1e4n$_0;
  }});
  Object.defineProperty(AbstractText.prototype, 'invalidFeedback', {configurable: true, get: function () {
    return this.invalidFeedback_cqujqb$_0;
  }});
  function AbstractText$Companion() {
    AbstractText$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  AbstractText$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var AbstractText$Companion_instance = null;
  function AbstractText$Companion_getInstance() {
    if (AbstractText$Companion_instance === null) {
      new AbstractText$Companion();
    }return AbstractText$Companion_instance;
  }
  AbstractText.prototype.floatingPlaceholder = function () {
    var tmp$;
    if (this.floating && this.placeholder == null && this.label != null)
      this.placeholder = (tmp$ = this.label) != null ? tmp$ : 'Enter data';
  };
  AbstractText.prototype.styleForHorizontalFormPanel_fn6884$ = function (horizontalRatio) {
    if (!this.floating) {
      this.addCssClass_61zpoe$('row');
      this.addCssClass_61zpoe$('kv-control-horiz');
      this.flabel.addCssClass_61zpoe$('col-sm-' + horizontalRatio.labels);
      this.flabel.addCssClass_61zpoe$('col-form-label');
      this.input.addSurroundingCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
      this.invalidFeedback.addCssClass_61zpoe$('offset-sm-' + horizontalRatio.labels);
      this.invalidFeedback.addCssClass_61zpoe$('col-sm-' + horizontalRatio.fields);
    }};
  AbstractText.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.validatorError != null) {
      classSetBuilder.add_61zpoe$('text-danger');
    }};
  AbstractText.prototype.setEventListener_a1up2z$ = function (block) {
    return this.input.setEventListener_a1up2z$(block);
  };
  AbstractText.prototype.removeEventListener_za3lpa$ = function (id) {
    this.input.removeEventListener_za3lpa$(id);
    return this;
  };
  AbstractText.prototype.removeEventListeners = function () {
    this.input.removeEventListeners();
    return this;
  };
  AbstractText.prototype.focus = function () {
    this.input.focus();
  };
  AbstractText.prototype.blur = function () {
    this.input.blur();
  };
  AbstractText.prototype.getState = function () {
    return this.input.getState();
  };
  AbstractText.prototype.subscribe_qlkmfe$ = function (observer) {
    return this.input.subscribe_qlkmfe$(observer);
  };
  AbstractText.prototype.setState_11rb$ = function (state) {
    this.input.setState_11rb$(state);
  };
  AbstractText.$metadata$ = {kind: Kind_CLASS, simpleName: 'AbstractText', interfaces: [MutableState, StringFormControl, SimplePanel]};
  function Widget$refreshOnUpdate$lambda_17(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_18(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function AbstractTextInput(value, className) {
    if (value === void 0)
      value = null;
    if (className === void 0)
      className = null;
    Widget.call(this, className);
    this.observers = ArrayList_init();
    this.useSnabbdomDistinctKey();
    this.setInternalEventListener_a1up2z$(AbstractTextInput_init$lambda);
    var tmp$;
    if (value != null) {
      var $receiver = value;
      tmp$ = $receiver.length === 0 ? null : $receiver;
    } else
      tmp$ = null;
    this.value_zev5ti$_0 = (new Widget$RefreshDelegateProvider(this, tmp$, AbstractTextInput$value$lambda(this))).provideDelegate_n5byny$(this, AbstractTextInput$value_metadata);
    this.startValue_hhdg76$_0 = (new Widget$RefreshDelegateProvider(this, value, AbstractTextInput$startValue$lambda(this))).provideDelegate_n5byny$(this, AbstractTextInput$startValue_metadata);
    this.placeholder_nrhkcs$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$placeholder_metadata);
    this.name_f0opge$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$name_metadata);
    this.maxlength_6pypp$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$maxlength_metadata);
    this.disabled_pu0gmn$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_17(this))).provideDelegate_n5byny$(this, AbstractTextInput$disabled_metadata);
    this.autofocus_9upgny$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$autofocus_metadata);
    this.readonly_u6gibv$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$readonly_metadata);
    this.size_exscyc$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$size_metadata);
    this.validationStatus_e06v1a$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_18(this))).provideDelegate_n5byny$(this, AbstractTextInput$validationStatus_metadata);
    this.maskOptions_i1h3ij$_0 = null;
    this.mask = null;
  }
  var AbstractTextInput$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(AbstractTextInput.prototype, 'value', {configurable: true, get: function () {
    return this.value_zev5ti$_0.getValue_fmbzy8$(this, AbstractTextInput$value_metadata);
  }, set: function (value) {
    this.value_zev5ti$_0.setValue_19qrsr$(this, AbstractTextInput$value_metadata, value);
  }});
  var AbstractTextInput$startValue_metadata = new PropertyMetadata('startValue');
  Object.defineProperty(AbstractTextInput.prototype, 'startValue', {configurable: true, get: function () {
    return this.startValue_hhdg76$_0.getValue_fmbzy8$(this, AbstractTextInput$startValue_metadata);
  }, set: function (startValue) {
    this.startValue_hhdg76$_0.setValue_19qrsr$(this, AbstractTextInput$startValue_metadata, startValue);
  }});
  var AbstractTextInput$placeholder_metadata = new PropertyMetadata('placeholder');
  Object.defineProperty(AbstractTextInput.prototype, 'placeholder', {configurable: true, get: function () {
    return this.placeholder_nrhkcs$_0.getValue_fmbzy8$(this, AbstractTextInput$placeholder_metadata);
  }, set: function (placeholder) {
    this.placeholder_nrhkcs$_0.setValue_19qrsr$(this, AbstractTextInput$placeholder_metadata, placeholder);
  }});
  var AbstractTextInput$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(AbstractTextInput.prototype, 'name', {configurable: true, get: function () {
    return this.name_f0opge$_0.getValue_fmbzy8$(this, AbstractTextInput$name_metadata);
  }, set: function (name) {
    this.name_f0opge$_0.setValue_19qrsr$(this, AbstractTextInput$name_metadata, name);
  }});
  var AbstractTextInput$maxlength_metadata = new PropertyMetadata('maxlength');
  Object.defineProperty(AbstractTextInput.prototype, 'maxlength', {configurable: true, get: function () {
    return this.maxlength_6pypp$_0.getValue_fmbzy8$(this, AbstractTextInput$maxlength_metadata);
  }, set: function (maxlength) {
    this.maxlength_6pypp$_0.setValue_19qrsr$(this, AbstractTextInput$maxlength_metadata, maxlength);
  }});
  var AbstractTextInput$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(AbstractTextInput.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_pu0gmn$_0.getValue_fmbzy8$(this, AbstractTextInput$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_pu0gmn$_0.setValue_19qrsr$(this, AbstractTextInput$disabled_metadata, disabled);
  }});
  var AbstractTextInput$autofocus_metadata = new PropertyMetadata('autofocus');
  Object.defineProperty(AbstractTextInput.prototype, 'autofocus', {configurable: true, get: function () {
    return this.autofocus_9upgny$_0.getValue_fmbzy8$(this, AbstractTextInput$autofocus_metadata);
  }, set: function (autofocus) {
    this.autofocus_9upgny$_0.setValue_19qrsr$(this, AbstractTextInput$autofocus_metadata, autofocus);
  }});
  var AbstractTextInput$readonly_metadata = new PropertyMetadata('readonly');
  Object.defineProperty(AbstractTextInput.prototype, 'readonly', {configurable: true, get: function () {
    return this.readonly_u6gibv$_0.getValue_fmbzy8$(this, AbstractTextInput$readonly_metadata);
  }, set: function (readonly) {
    this.readonly_u6gibv$_0.setValue_19qrsr$(this, AbstractTextInput$readonly_metadata, readonly);
  }});
  var AbstractTextInput$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(AbstractTextInput.prototype, 'size', {configurable: true, get: function () {
    return this.size_exscyc$_0.getValue_fmbzy8$(this, AbstractTextInput$size_metadata);
  }, set: function (size) {
    this.size_exscyc$_0.setValue_19qrsr$(this, AbstractTextInput$size_metadata, size);
  }});
  var AbstractTextInput$validationStatus_metadata = new PropertyMetadata('validationStatus');
  Object.defineProperty(AbstractTextInput.prototype, 'validationStatus', {configurable: true, get: function () {
    return this.validationStatus_e06v1a$_0.getValue_fmbzy8$(this, AbstractTextInput$validationStatus_metadata);
  }, set: function (validationStatus) {
    this.validationStatus_e06v1a$_0.setValue_19qrsr$(this, AbstractTextInput$validationStatus_metadata, validationStatus);
  }});
  Object.defineProperty(AbstractTextInput.prototype, 'maskOptions', {configurable: true, get: function () {
    return this.maskOptions_i1h3ij$_0;
  }, set: function (value) {
    if (this.maskOptions_i1h3ij$_0 != null) {
      this.uninstallMask();
    }this.maskOptions_i1h3ij$_0 = value;
    this.installMask();
    this.refreshState();
  }});
  AbstractTextInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.validationStatus);
    classSetBuilder.add_vqcfem$(this.size);
  };
  AbstractTextInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.placeholder) != null) {
      attributeSetBuilder.add_puj7f4$('placeholder', this.translate_61zpoe$(tmp$));
    }if ((tmp$_0 = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$_0);
    }if ((tmp$_1 = this.autofocus) != null) {
      if (tmp$_1) {
        attributeSetBuilder.add_puj7f4$('autofocus');
      }}if ((tmp$_2 = this.maxlength) != null) {
      attributeSetBuilder.add_puj7f4$('maxlength', '' + toString_0(tmp$_2));
    }if ((tmp$_3 = this.readonly) != null) {
      if (tmp$_3) {
        attributeSetBuilder.add_puj7f4$('readonly');
      }}if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }};
  AbstractTextInput.prototype.afterInsert_77isfd$ = function (node) {
    this.installMask();
    this.refreshState();
  };
  AbstractTextInput.prototype.afterDestroy = function () {
    this.uninstallMask();
  };
  AbstractTextInput.prototype.refreshState = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4;
    if (this.mask == null) {
      var v = (tmp$_0 = (tmp$ = this.getElementD()) != null ? tmp$.value : null) != null ? tmp$_0 : null;
      var tmp$_5 = !equals(v, this.value);
      if (tmp$_5) {
        tmp$_5 = !((v == null || v.length === 0) && this.value == null);
      }if (tmp$_5) {
        (tmp$_1 = this.getElementD()) != null ? (tmp$_1.value = this.value) : null;
      }} else {
      (tmp$_2 = this.getElementD()) != null ? (tmp$_2.value = this.value) : null;
      ensureNotNull(this.mask).refresh();
      var v_0 = (tmp$_4 = (tmp$_3 = this.mask) != null ? tmp$_3.getValue() : null) != null ? tmp$_4.length === 0 ? null : tmp$_4 : null;
      if (!equals(this.value, v_0)) {
        this.value = v_0;
      }}
  };
  AbstractTextInput.prototype.changeValue = function () {
    var tmp$, tmp$_0;
    if (this.mask == null) {
      var v = (tmp$_0 = (tmp$ = this.getElementD()) != null ? tmp$.value : null) != null ? tmp$_0 : null;
      if (v != null && !equals(v, '')) {
        this.value = v;
      } else {
        this.value = null;
      }
    }};
  function AbstractTextInput$installMask$lambda(this$AbstractTextInput) {
    return function (it) {
      var v = it != null ? it.length === 0 ? null : it : null;
      if (!equals(this$AbstractTextInput.value, v)) {
        this$AbstractTextInput.value = v;
      }return Unit;
    };
  }
  AbstractTextInput.prototype.installMask = function () {
    if (this.getElement() != null && this.maskOptions != null) {
      if (MaskManager_getInstance().factory == null)
        throw IllegalStateException_init_0('Input mask module has not been initialized');
      this.mask = ensureNotNull(MaskManager_getInstance().factory).createMask_wd8ck0$(this.getElement(), ensureNotNull(this.maskOptions));
      ensureNotNull(this.mask).onChange_rnyx3q$(AbstractTextInput$installMask$lambda(this));
    }};
  AbstractTextInput.prototype.uninstallMask = function () {
    var tmp$;
    (tmp$ = this.mask) != null ? (tmp$.destroy(), Unit) : null;
    this.mask = null;
  };
  AbstractTextInput.prototype.getState = function () {
    return this.value;
  };
  function AbstractTextInput$subscribe$lambda(this$AbstractTextInput, closure$observer) {
    return function () {
      var $receiver = this$AbstractTextInput.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  AbstractTextInput.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return AbstractTextInput$subscribe$lambda(this, observer);
  };
  AbstractTextInput.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function AbstractTextInput_init$lambda$lambda(this$) {
    return function (it) {
      this$.self.changeValue();
      return Unit;
    };
  }
  function AbstractTextInput_init$lambda($receiver) {
    $receiver.input = AbstractTextInput_init$lambda$lambda($receiver);
    return Unit;
  }
  function AbstractTextInput$value$lambda(this$AbstractTextInput) {
    return function (it) {
      if (equals(it, '')) {
        this$AbstractTextInput.value = null;
      } else {
        this$AbstractTextInput.refreshState();
        var tmp$;
        tmp$ = this$AbstractTextInput.observers.iterator();
        while (tmp$.hasNext()) {
          var element = tmp$.next();
          element(it);
        }
      }
      return Unit;
    };
  }
  function AbstractTextInput$startValue$lambda(this$AbstractTextInput) {
    return function (it) {
      this$AbstractTextInput.value = it;
      this$AbstractTextInput.refresh();
      return Unit;
    };
  }
  AbstractTextInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'AbstractTextInput', interfaces: [MutableState, FormInput, GenericFormComponent, Widget]};
  function MaskManager() {
    MaskManager_instance = this;
    this.factory = null;
  }
  MaskManager.$metadata$ = {kind: Kind_OBJECT, simpleName: 'MaskManager', interfaces: []};
  var MaskManager_instance = null;
  function MaskManager_getInstance() {
    if (MaskManager_instance === null) {
      new MaskManager();
    }return MaskManager_instance;
  }
  function Password(value, name, label, rich, floating, init) {
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (floating === void 0)
      floating = false;
    if (init === void 0)
      init = null;
    Text.call(this, InputType$PASSWORD_getInstance(), value, name, label, rich, floating);
    init != null ? init(this) : null;
    this.floatingPlaceholder();
  }
  Password.$metadata$ = {kind: Kind_CLASS, simpleName: 'Password', interfaces: [Text]};
  function Text(type, value, name, label, rich, floating, init) {
    if (type === void 0)
      type = InputType$TEXT_getInstance();
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (floating === void 0)
      floating = false;
    if (init === void 0)
      init = null;
    AbstractText.call(this, label, rich, floating);
    var $receiver = new TextInput(type, value);
    var closure$name = name;
    $receiver.id = this.idc;
    $receiver.name = closure$name;
    this.input_w3eson$_0 = $receiver;
    this.input.eventTarget = this;
    if (!floating) {
      this.addPrivate_87eobz$(this.flabel);
      this.addPrivate_87eobz$(this.input);
    } else {
      this.addPrivate_87eobz$(this.input);
      this.addPrivate_87eobz$(this.flabel);
    }
    this.addPrivate_87eobz$(this.invalidFeedback);
    init != null ? init(this) : null;
    this.floatingPlaceholder();
  }
  Object.defineProperty(Text.prototype, 'type', {configurable: true, get: function () {
    return this.input.type;
  }, set: function (value) {
    this.input.type = value;
  }});
  Object.defineProperty(Text.prototype, 'autocomplete', {configurable: true, get: function () {
    return this.input.autocomplete;
  }, set: function (value) {
    this.input.autocomplete = value;
  }});
  Object.defineProperty(Text.prototype, 'input', {configurable: true, get: function () {
    return this.input_w3eson$_0;
  }});
  Text.$metadata$ = {kind: Kind_CLASS, simpleName: 'Text', interfaces: [AbstractText]};
  function TextArea(cols, rows, value, name, label, rich, floating, init) {
    if (cols === void 0)
      cols = null;
    if (rows === void 0)
      rows = null;
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (floating === void 0)
      floating = false;
    if (init === void 0)
      init = null;
    AbstractText.call(this, label, rich, floating);
    var $receiver = new TextAreaInput(cols, rows, value);
    var closure$name = name;
    $receiver.id = this.idc;
    $receiver.name = closure$name;
    this.input_gfi7l6$_0 = $receiver;
    this.input.eventTarget = this;
    if (!floating) {
      this.addPrivate_87eobz$(this.flabel);
      this.addPrivate_87eobz$(this.input);
    } else {
      this.addPrivate_87eobz$(this.input);
      this.addPrivate_87eobz$(this.flabel);
    }
    this.addPrivate_87eobz$(this.invalidFeedback);
    init != null ? init(this) : null;
    this.floatingPlaceholder();
  }
  Object.defineProperty(TextArea.prototype, 'cols', {configurable: true, get: function () {
    return this.input.cols;
  }, set: function (value) {
    this.input.cols = value;
  }});
  Object.defineProperty(TextArea.prototype, 'rows', {configurable: true, get: function () {
    return this.input.rows;
  }, set: function (value) {
    this.input.rows = value;
  }});
  Object.defineProperty(TextArea.prototype, 'wrapHard', {configurable: true, get: function () {
    return this.input.wrapHard;
  }, set: function (value) {
    this.input.wrapHard = value;
  }});
  Object.defineProperty(TextArea.prototype, 'input', {configurable: true, get: function () {
    return this.input_gfi7l6$_0;
  }});
  TextArea.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextArea', interfaces: [AbstractText]};
  function textArea($receiver, cols, rows, value, name, label, rich, floating, init) {
    if (cols === void 0)
      cols = null;
    if (rows === void 0)
      rows = null;
    if (value === void 0)
      value = null;
    if (name === void 0)
      name = null;
    if (label === void 0)
      label = null;
    if (rich === void 0)
      rich = false;
    if (floating === void 0)
      floating = false;
    if (init === void 0)
      init = null;
    var textArea = new TextArea(cols, rows, value, name, label, rich, floating, init);
    $receiver.add_87eobz$(textArea);
    return textArea;
  }
  function Widget$refreshOnUpdate$lambda_19(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function TextAreaInput(cols, rows, value, className, init) {
    if (cols === void 0)
      cols = null;
    if (rows === void 0)
      rows = null;
    if (value === void 0)
      value = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    AbstractTextInput.call(this, value, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'form-control');
    this.cols_6abac1$_0 = (new Widget$RefreshDelegateProvider(this, cols, Widget$refreshOnUpdate$lambda_19(this))).provideDelegate_n5byny$(this, TextAreaInput$cols_metadata);
    this.rows_62259z$_0 = (new Widget$RefreshDelegateProvider(this, rows, Widget$refreshOnUpdate$lambda_19(this))).provideDelegate_n5byny$(this, TextAreaInput$rows_metadata);
    this.wrapHard_q93sj7$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_19(this))).provideDelegate_n5byny$(this, TextAreaInput$wrapHard_metadata);
    init != null ? init(this) : null;
  }
  var TextAreaInput$cols_metadata = new PropertyMetadata('cols');
  Object.defineProperty(TextAreaInput.prototype, 'cols', {configurable: true, get: function () {
    return this.cols_6abac1$_0.getValue_fmbzy8$(this, TextAreaInput$cols_metadata);
  }, set: function (cols) {
    this.cols_6abac1$_0.setValue_19qrsr$(this, TextAreaInput$cols_metadata, cols);
  }});
  var TextAreaInput$rows_metadata = new PropertyMetadata('rows');
  Object.defineProperty(TextAreaInput.prototype, 'rows', {configurable: true, get: function () {
    return this.rows_62259z$_0.getValue_fmbzy8$(this, TextAreaInput$rows_metadata);
  }, set: function (rows) {
    this.rows_62259z$_0.setValue_19qrsr$(this, TextAreaInput$rows_metadata, rows);
  }});
  var TextAreaInput$wrapHard_metadata = new PropertyMetadata('wrapHard');
  Object.defineProperty(TextAreaInput.prototype, 'wrapHard', {configurable: true, get: function () {
    return this.wrapHard_q93sj7$_0.getValue_fmbzy8$(this, TextAreaInput$wrapHard_metadata);
  }, set: function (wrapHard) {
    this.wrapHard_q93sj7$_0.setValue_19qrsr$(this, TextAreaInput$wrapHard_metadata, wrapHard);
  }});
  TextAreaInput.prototype.render = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.startValue) != null ? this.render_pjwf99$('textarea', [tmp$]) : null) != null ? tmp$_0 : this.render_61zpoe$('textarea');
  };
  TextAreaInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0;
    AbstractTextInput.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.cols) != null) {
      attributeSetBuilder.add_puj7f4$('cols', '' + toString_0(tmp$));
    }if ((tmp$_0 = this.rows) != null) {
      attributeSetBuilder.add_puj7f4$('rows', '' + toString_0(tmp$_0));
    }if (this.wrapHard) {
      attributeSetBuilder.add_puj7f4$('wrap', 'hard');
    }};
  TextAreaInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextAreaInput', interfaces: [AbstractTextInput]};
  function textAreaInput($receiver, cols, rows, value, className, init) {
    if (cols === void 0)
      cols = null;
    if (rows === void 0)
      rows = null;
    if (value === void 0)
      value = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var textAreaInput = new TextAreaInput(cols, rows, value, className, init);
    $receiver.add_87eobz$(textAreaInput);
    return textAreaInput;
  }
  function Widget$refreshOnUpdate$lambda_20(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_21(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function TextInput(type, value, className, init) {
    if (type === void 0)
      type = InputType$TEXT_getInstance();
    if (value === void 0)
      value = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    AbstractTextInput.call(this, value, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'form-control');
    this.type_qj85yj$_0 = (new Widget$RefreshDelegateProvider(this, type, Widget$refreshOnUpdate$lambda_20(this))).provideDelegate_n5byny$(this, TextInput$type_metadata);
    this.autocomplete_v5p4o7$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_21(this))).provideDelegate_n5byny$(this, TextInput$autocomplete_metadata);
    init != null ? init(this) : null;
  }
  var TextInput$type_metadata = new PropertyMetadata('type');
  Object.defineProperty(TextInput.prototype, 'type', {configurable: true, get: function () {
    return this.type_qj85yj$_0.getValue_fmbzy8$(this, TextInput$type_metadata);
  }, set: function (type) {
    this.type_qj85yj$_0.setValue_19qrsr$(this, TextInput$type_metadata, type);
  }});
  var TextInput$autocomplete_metadata = new PropertyMetadata('autocomplete');
  Object.defineProperty(TextInput.prototype, 'autocomplete', {configurable: true, get: function () {
    return this.autocomplete_v5p4o7$_0.getValue_fmbzy8$(this, TextInput$autocomplete_metadata);
  }, set: function (autocomplete) {
    this.autocomplete_v5p4o7$_0.setValue_19qrsr$(this, TextInput$autocomplete_metadata, autocomplete);
  }});
  TextInput.prototype.render = function () {
    return this.render_61zpoe$('input');
  };
  TextInput.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    AbstractTextInput.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.type === InputType$COLOR_getInstance())
      classSetBuilder.add_61zpoe$('form-control-color');
  };
  TextInput.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0;
    AbstractTextInput.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', this.type.type_8be2vx$);
    if ((tmp$ = this.startValue) != null) {
      attributeSetBuilder.add_puj7f4$('value', tmp$);
    }if ((tmp$_0 = this.autocomplete) != null) {
      attributeSetBuilder.add_puj7f4$('autocomplete', tmp$_0.type);
    }};
  TextInput.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextInput', interfaces: [AbstractTextInput]};
  function textInput($receiver, type, value, className, init) {
    if (type === void 0)
      type = InputType$TEXT_getInstance();
    if (value === void 0)
      value = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var textInput = new TextInput(type, value, className, init);
    $receiver.add_87eobz$(textInput);
    return textInput;
  }
  function B(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$B_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  B.$metadata$ = {kind: Kind_CLASS, simpleName: 'B', interfaces: [Tag]};
  function b($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var bold = new B(content, rich, align, className, init);
    $receiver.add_87eobz$(bold);
    return bold;
  }
  function Widget$refreshOnUpdate$lambda_22(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_23(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function ButtonStyle(name, ordinal, className) {
    Enum.call(this);
    this.className_oe7ad6$_0 = className;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ButtonStyle_initFields() {
    ButtonStyle_initFields = function () {
    };
    ButtonStyle$PRIMARY_instance = new ButtonStyle('PRIMARY', 0, 'btn-primary');
    ButtonStyle$SECONDARY_instance = new ButtonStyle('SECONDARY', 1, 'btn-secondary');
    ButtonStyle$SUCCESS_instance = new ButtonStyle('SUCCESS', 2, 'btn-success');
    ButtonStyle$DANGER_instance = new ButtonStyle('DANGER', 3, 'btn-danger');
    ButtonStyle$WARNING_instance = new ButtonStyle('WARNING', 4, 'btn-warning');
    ButtonStyle$INFO_instance = new ButtonStyle('INFO', 5, 'btn-info');
    ButtonStyle$LIGHT_instance = new ButtonStyle('LIGHT', 6, 'btn-light');
    ButtonStyle$DARK_instance = new ButtonStyle('DARK', 7, 'btn-dark');
    ButtonStyle$LINK_instance = new ButtonStyle('LINK', 8, 'btn-link');
    ButtonStyle$OUTLINEPRIMARY_instance = new ButtonStyle('OUTLINEPRIMARY', 9, 'btn-outline-primary');
    ButtonStyle$OUTLINESECONDARY_instance = new ButtonStyle('OUTLINESECONDARY', 10, 'btn-outline-secondary');
    ButtonStyle$OUTLINESUCCESS_instance = new ButtonStyle('OUTLINESUCCESS', 11, 'btn-outline-success');
    ButtonStyle$OUTLINEDANGER_instance = new ButtonStyle('OUTLINEDANGER', 12, 'btn-outline-danger');
    ButtonStyle$OUTLINEWARNING_instance = new ButtonStyle('OUTLINEWARNING', 13, 'btn-outline-warning');
    ButtonStyle$OUTLINEINFO_instance = new ButtonStyle('OUTLINEINFO', 14, 'btn-outline-info');
    ButtonStyle$OUTLINELIGHT_instance = new ButtonStyle('OUTLINELIGHT', 15, 'btn-outline-light');
    ButtonStyle$OUTLINEDARK_instance = new ButtonStyle('OUTLINEDARK', 16, 'btn-outline-dark');
  }
  Object.defineProperty(ButtonStyle.prototype, 'className', {get: function () {
    return this.className_oe7ad6$_0;
  }});
  var ButtonStyle$PRIMARY_instance;
  function ButtonStyle$PRIMARY_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$PRIMARY_instance;
  }
  var ButtonStyle$SECONDARY_instance;
  function ButtonStyle$SECONDARY_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$SECONDARY_instance;
  }
  var ButtonStyle$SUCCESS_instance;
  function ButtonStyle$SUCCESS_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$SUCCESS_instance;
  }
  var ButtonStyle$DANGER_instance;
  function ButtonStyle$DANGER_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$DANGER_instance;
  }
  var ButtonStyle$WARNING_instance;
  function ButtonStyle$WARNING_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$WARNING_instance;
  }
  var ButtonStyle$INFO_instance;
  function ButtonStyle$INFO_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$INFO_instance;
  }
  var ButtonStyle$LIGHT_instance;
  function ButtonStyle$LIGHT_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$LIGHT_instance;
  }
  var ButtonStyle$DARK_instance;
  function ButtonStyle$DARK_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$DARK_instance;
  }
  var ButtonStyle$LINK_instance;
  function ButtonStyle$LINK_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$LINK_instance;
  }
  var ButtonStyle$OUTLINEPRIMARY_instance;
  function ButtonStyle$OUTLINEPRIMARY_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINEPRIMARY_instance;
  }
  var ButtonStyle$OUTLINESECONDARY_instance;
  function ButtonStyle$OUTLINESECONDARY_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINESECONDARY_instance;
  }
  var ButtonStyle$OUTLINESUCCESS_instance;
  function ButtonStyle$OUTLINESUCCESS_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINESUCCESS_instance;
  }
  var ButtonStyle$OUTLINEDANGER_instance;
  function ButtonStyle$OUTLINEDANGER_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINEDANGER_instance;
  }
  var ButtonStyle$OUTLINEWARNING_instance;
  function ButtonStyle$OUTLINEWARNING_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINEWARNING_instance;
  }
  var ButtonStyle$OUTLINEINFO_instance;
  function ButtonStyle$OUTLINEINFO_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINEINFO_instance;
  }
  var ButtonStyle$OUTLINELIGHT_instance;
  function ButtonStyle$OUTLINELIGHT_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINELIGHT_instance;
  }
  var ButtonStyle$OUTLINEDARK_instance;
  function ButtonStyle$OUTLINEDARK_getInstance() {
    ButtonStyle_initFields();
    return ButtonStyle$OUTLINEDARK_instance;
  }
  ButtonStyle.$metadata$ = {kind: Kind_CLASS, simpleName: 'ButtonStyle', interfaces: [CssClass, Enum]};
  function ButtonStyle$values() {
    return [ButtonStyle$PRIMARY_getInstance(), ButtonStyle$SECONDARY_getInstance(), ButtonStyle$SUCCESS_getInstance(), ButtonStyle$DANGER_getInstance(), ButtonStyle$WARNING_getInstance(), ButtonStyle$INFO_getInstance(), ButtonStyle$LIGHT_getInstance(), ButtonStyle$DARK_getInstance(), ButtonStyle$LINK_getInstance(), ButtonStyle$OUTLINEPRIMARY_getInstance(), ButtonStyle$OUTLINESECONDARY_getInstance(), ButtonStyle$OUTLINESUCCESS_getInstance(), ButtonStyle$OUTLINEDANGER_getInstance(), ButtonStyle$OUTLINEWARNING_getInstance(), ButtonStyle$OUTLINEINFO_getInstance(), ButtonStyle$OUTLINELIGHT_getInstance(), ButtonStyle$OUTLINEDARK_getInstance()];
  }
  ButtonStyle.values = ButtonStyle$values;
  function ButtonStyle$valueOf(name) {
    switch (name) {
      case 'PRIMARY':
        return ButtonStyle$PRIMARY_getInstance();
      case 'SECONDARY':
        return ButtonStyle$SECONDARY_getInstance();
      case 'SUCCESS':
        return ButtonStyle$SUCCESS_getInstance();
      case 'DANGER':
        return ButtonStyle$DANGER_getInstance();
      case 'WARNING':
        return ButtonStyle$WARNING_getInstance();
      case 'INFO':
        return ButtonStyle$INFO_getInstance();
      case 'LIGHT':
        return ButtonStyle$LIGHT_getInstance();
      case 'DARK':
        return ButtonStyle$DARK_getInstance();
      case 'LINK':
        return ButtonStyle$LINK_getInstance();
      case 'OUTLINEPRIMARY':
        return ButtonStyle$OUTLINEPRIMARY_getInstance();
      case 'OUTLINESECONDARY':
        return ButtonStyle$OUTLINESECONDARY_getInstance();
      case 'OUTLINESUCCESS':
        return ButtonStyle$OUTLINESUCCESS_getInstance();
      case 'OUTLINEDANGER':
        return ButtonStyle$OUTLINEDANGER_getInstance();
      case 'OUTLINEWARNING':
        return ButtonStyle$OUTLINEWARNING_getInstance();
      case 'OUTLINEINFO':
        return ButtonStyle$OUTLINEINFO_getInstance();
      case 'OUTLINELIGHT':
        return ButtonStyle$OUTLINELIGHT_getInstance();
      case 'OUTLINEDARK':
        return ButtonStyle$OUTLINEDARK_getInstance();
      default:throwISE('No enum constant io.kvision.html.ButtonStyle.' + name);
    }
  }
  ButtonStyle.valueOf_61zpoe$ = ButtonStyle$valueOf;
  var ButtonSize$LARGE_instance;
  var ButtonSize$SMALL_instance;
  function ButtonType(name, ordinal, buttonType) {
    Enum.call(this);
    this.buttonType_8be2vx$ = buttonType;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ButtonType_initFields() {
    ButtonType_initFields = function () {
    };
    ButtonType$BUTTON_instance = new ButtonType('BUTTON', 0, 'button');
    ButtonType$SUBMIT_instance = new ButtonType('SUBMIT', 1, 'submit');
    ButtonType$RESET_instance = new ButtonType('RESET', 2, 'reset');
  }
  var ButtonType$BUTTON_instance;
  function ButtonType$BUTTON_getInstance() {
    ButtonType_initFields();
    return ButtonType$BUTTON_instance;
  }
  var ButtonType$SUBMIT_instance;
  function ButtonType$SUBMIT_getInstance() {
    ButtonType_initFields();
    return ButtonType$SUBMIT_instance;
  }
  var ButtonType$RESET_instance;
  function ButtonType$RESET_getInstance() {
    ButtonType_initFields();
    return ButtonType$RESET_instance;
  }
  ButtonType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ButtonType', interfaces: [Enum]};
  function ButtonType$values() {
    return [ButtonType$BUTTON_getInstance(), ButtonType$SUBMIT_getInstance(), ButtonType$RESET_getInstance()];
  }
  ButtonType.values = ButtonType$values;
  function ButtonType$valueOf(name) {
    switch (name) {
      case 'BUTTON':
        return ButtonType$BUTTON_getInstance();
      case 'SUBMIT':
        return ButtonType$SUBMIT_getInstance();
      case 'RESET':
        return ButtonType$RESET_getInstance();
      default:throwISE('No enum constant io.kvision.html.ButtonType.' + name);
    }
  }
  ButtonType.valueOf_61zpoe$ = ButtonType$valueOf;
  function Button(text, icon, style, type, disabled, separator, labelFirst, className) {
    if (icon === void 0)
      icon = null;
    if (style === void 0)
      style = ButtonStyle$PRIMARY_getInstance();
    if (type === void 0)
      type = ButtonType$BUTTON_getInstance();
    if (disabled === void 0)
      disabled = false;
    if (separator === void 0)
      separator = null;
    if (labelFirst === void 0)
      labelFirst = true;
    if (className === void 0)
      className = null;
    SimplePanel.call(this, className);
    this.text_5p3khb$_0 = (new Widget$RefreshDelegateProvider(this, text, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$text_metadata);
    this.icon_5v6rsr$_0 = (new Widget$RefreshDelegateProvider(this, icon, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$icon_metadata);
    this.style_ysmqbf$_0 = (new Widget$RefreshDelegateProvider(this, style, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$style_metadata);
    this.type_5oqz18$_0 = (new Widget$RefreshDelegateProvider(this, type, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$type_metadata);
    this.disabled_4rctgi$_0 = (new Widget$RefreshDelegateProvider(this, disabled, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$disabled_metadata);
    this.image_vdr463$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_23(this))).provideDelegate_n5byny$(this, Button$image_metadata);
    this.size_5pks03$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_23(this))).provideDelegate_n5byny$(this, Button$size_metadata);
    this.block_s24tt5$_0 = (new Widget$RefreshDelegateProvider(this, false, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$block_metadata);
    this.separator_2qnii7$_0 = (new Widget$RefreshDelegateProvider(this, separator, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$separator_metadata);
    this.labelFirst_lbreq$_0 = (new Widget$RefreshDelegateProvider(this, labelFirst, Widget$refreshOnUpdate$lambda_22(this))).provideDelegate_n5byny$(this, Button$labelFirst_metadata);
  }
  var Button$text_metadata = new PropertyMetadata('text');
  Object.defineProperty(Button.prototype, 'text', {configurable: true, get: function () {
    return this.text_5p3khb$_0.getValue_fmbzy8$(this, Button$text_metadata);
  }, set: function (text) {
    this.text_5p3khb$_0.setValue_19qrsr$(this, Button$text_metadata, text);
  }});
  var Button$icon_metadata = new PropertyMetadata('icon');
  Object.defineProperty(Button.prototype, 'icon', {configurable: true, get: function () {
    return this.icon_5v6rsr$_0.getValue_fmbzy8$(this, Button$icon_metadata);
  }, set: function (icon) {
    this.icon_5v6rsr$_0.setValue_19qrsr$(this, Button$icon_metadata, icon);
  }});
  var Button$style_metadata = new PropertyMetadata('style');
  Object.defineProperty(Button.prototype, 'style', {configurable: true, get: function () {
    return this.style_ysmqbf$_0.getValue_fmbzy8$(this, Button$style_metadata);
  }, set: function (style) {
    this.style_ysmqbf$_0.setValue_19qrsr$(this, Button$style_metadata, style);
  }});
  var Button$type_metadata = new PropertyMetadata('type');
  Object.defineProperty(Button.prototype, 'type', {configurable: true, get: function () {
    return this.type_5oqz18$_0.getValue_fmbzy8$(this, Button$type_metadata);
  }, set: function (type) {
    this.type_5oqz18$_0.setValue_19qrsr$(this, Button$type_metadata, type);
  }});
  var Button$disabled_metadata = new PropertyMetadata('disabled');
  Object.defineProperty(Button.prototype, 'disabled', {configurable: true, get: function () {
    return this.disabled_4rctgi$_0.getValue_fmbzy8$(this, Button$disabled_metadata);
  }, set: function (disabled) {
    this.disabled_4rctgi$_0.setValue_19qrsr$(this, Button$disabled_metadata, disabled);
  }});
  var Button$image_metadata = new PropertyMetadata('image');
  Object.defineProperty(Button.prototype, 'image', {configurable: true, get: function () {
    return this.image_vdr463$_0.getValue_fmbzy8$(this, Button$image_metadata);
  }, set: function (image) {
    this.image_vdr463$_0.setValue_19qrsr$(this, Button$image_metadata, image);
  }});
  var Button$size_metadata = new PropertyMetadata('size');
  Object.defineProperty(Button.prototype, 'size', {configurable: true, get: function () {
    return this.size_5pks03$_0.getValue_fmbzy8$(this, Button$size_metadata);
  }, set: function (size) {
    this.size_5pks03$_0.setValue_19qrsr$(this, Button$size_metadata, size);
  }});
  var Button$block_metadata = new PropertyMetadata('block');
  Object.defineProperty(Button.prototype, 'block', {configurable: true, get: function () {
    return this.block_s24tt5$_0.getValue_fmbzy8$(this, Button$block_metadata);
  }, set: function (block) {
    this.block_s24tt5$_0.setValue_19qrsr$(this, Button$block_metadata, block);
  }});
  var Button$separator_metadata = new PropertyMetadata('separator');
  Object.defineProperty(Button.prototype, 'separator', {configurable: true, get: function () {
    return this.separator_2qnii7$_0.getValue_fmbzy8$(this, Button$separator_metadata);
  }, set: function (separator) {
    this.separator_2qnii7$_0.setValue_19qrsr$(this, Button$separator_metadata, separator);
  }});
  var Button$labelFirst_metadata = new PropertyMetadata('labelFirst');
  Object.defineProperty(Button.prototype, 'labelFirst', {configurable: true, get: function () {
    return this.labelFirst_lbreq$_0.getValue_fmbzy8$(this, Button$labelFirst_metadata);
  }, set: function (labelFirst) {
    this.labelFirst_lbreq$_0.setValue_19qrsr$(this, Button$labelFirst_metadata, labelFirst);
  }});
  Button.prototype.render = function () {
    var tmp$;
    var t = this.createLabelWithIcon_dawjdb$(this.text, this.icon, this.image, this.separator);
    if (this.labelFirst) {
      var elements = this.childrenVNodes();
      tmp$ = this.render_pjwf99$('button', t.concat(elements));
    } else {
      tmp$ = this.render_pjwf99$('button', this.childrenVNodes().concat(t));
    }
    return tmp$;
  };
  Button.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_61zpoe$('btn');
    classSetBuilder.add_vqcfem$(this.style);
    classSetBuilder.add_vqcfem$(this.size);
    if (this.block) {
      classSetBuilder.add_61zpoe$('btn-block');
    }};
  Button.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    SimplePanel.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    attributeSetBuilder.add_puj7f4$('type', this.type.buttonType_8be2vx$);
    if (this.disabled) {
      attributeSetBuilder.add_puj7f4$('disabled');
    }};
  function Button$onClick$lambda$lambda(this$, closure$handler) {
    return function (e) {
      closure$handler(this$.self, e);
      return Unit;
    };
  }
  function Button$onClick$lambda(closure$handler) {
    return function ($receiver) {
      $receiver.click = Button$onClick$lambda$lambda($receiver, closure$handler);
      return Unit;
    };
  }
  Button.prototype.onClick_sgro9k$ = function (handler) {
    this.setEventListener_a1up2z$(Button$onClick$lambda(handler));
    return this;
  };
  Button.$metadata$ = {kind: Kind_CLASS, simpleName: 'Button', interfaces: [SimplePanel]};
  function button($receiver, text, icon, style, type, disabled, separator, labelFirst, className, init) {
    if (icon === void 0)
      icon = null;
    if (style === void 0)
      style = ButtonStyle$PRIMARY_getInstance();
    if (type === void 0)
      type = ButtonType$BUTTON_getInstance();
    if (disabled === void 0)
      disabled = false;
    if (separator === void 0)
      separator = null;
    if (labelFirst === void 0)
      labelFirst = true;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var $receiver_0 = new Button(text, icon, style, type, disabled, separator, labelFirst, className);
    init != null ? init($receiver_0) : null;
    var button = $receiver_0;
    $receiver.add_87eobz$(button);
    return button;
  }
  function Widget$refreshOnUpdate$lambda_24(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Canvas(canvasWidth, canvasHeight, className, init) {
    Canvas$Companion_getInstance();
    if (canvasWidth === void 0)
      canvasWidth = null;
    if (canvasHeight === void 0)
      canvasHeight = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Widget.call(this, className);
    this.canvasWidth_d9084e$_0 = (new Widget$RefreshDelegateProvider(this, canvasWidth, Widget$refreshOnUpdate$lambda_24(this))).provideDelegate_n5byny$(this, Canvas$canvasWidth_metadata);
    this.canvasHeight_6j7gn9$_0 = (new Widget$RefreshDelegateProvider(this, canvasHeight, Widget$refreshOnUpdate$lambda_24(this))).provideDelegate_n5byny$(this, Canvas$canvasHeight_metadata);
    this.context2D_1q65gx$_0 = this.context2D_1q65gx$_0;
    init != null ? init(this) : null;
  }
  var Canvas$canvasWidth_metadata = new PropertyMetadata('canvasWidth');
  Object.defineProperty(Canvas.prototype, 'canvasWidth', {configurable: true, get: function () {
    return this.canvasWidth_d9084e$_0.getValue_fmbzy8$(this, Canvas$canvasWidth_metadata);
  }, set: function (canvasWidth) {
    this.canvasWidth_d9084e$_0.setValue_19qrsr$(this, Canvas$canvasWidth_metadata, canvasWidth);
  }});
  var Canvas$canvasHeight_metadata = new PropertyMetadata('canvasHeight');
  Object.defineProperty(Canvas.prototype, 'canvasHeight', {configurable: true, get: function () {
    return this.canvasHeight_6j7gn9$_0.getValue_fmbzy8$(this, Canvas$canvasHeight_metadata);
  }, set: function (canvasHeight) {
    this.canvasHeight_6j7gn9$_0.setValue_19qrsr$(this, Canvas$canvasHeight_metadata, canvasHeight);
  }});
  Object.defineProperty(Canvas.prototype, 'context2D', {configurable: true, get: function () {
    if (this.context2D_1q65gx$_0 == null)
      return throwUPAE('context2D');
    return this.context2D_1q65gx$_0;
  }, set: function (context2D) {
    this.context2D_1q65gx$_0 = context2D;
  }});
  Canvas.prototype.render = function () {
    return this.render_61zpoe$('canvas');
  };
  Canvas.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.canvasWidth) != null) {
      attributeSetBuilder.add_puj7f4$('width', tmp$.toString());
    }if ((tmp$_0 = this.canvasHeight) != null) {
      attributeSetBuilder.add_puj7f4$('height', tmp$_0.toString());
    }};
  Canvas.prototype.afterInsertInternal_77isfd$ = function (node) {
    var tmp$, tmp$_0;
    Widget.prototype.afterInsertInternal_77isfd$.call(this, node);
    this.context2D = Kotlin.isType(tmp$_0 = (Kotlin.isType(tmp$ = node.elm, HTMLCanvasElement) ? tmp$ : throwCCE()).getContext('2d'), CanvasRenderingContext2D) ? tmp$_0 : throwCCE();
  };
  function Canvas$Companion() {
    Canvas$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  Canvas$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Canvas$Companion_instance = null;
  function Canvas$Companion_getInstance() {
    if (Canvas$Companion_instance === null) {
      new Canvas$Companion();
    }return Canvas$Companion_instance;
  }
  Canvas.$metadata$ = {kind: Kind_CLASS, simpleName: 'Canvas', interfaces: [Widget]};
  var CustomTag$elementName_metadata = new PropertyMetadata('elementName');
  function Div(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$DIV_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  Div.$metadata$ = {kind: Kind_CLASS, simpleName: 'Div', interfaces: [Tag]};
  function div($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var div = new Div(content, rich, align, className, init);
    $receiver.add_87eobz$(div);
    return div;
  }
  function H2(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$H2_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  H2.$metadata$ = {kind: Kind_CLASS, simpleName: 'H2', interfaces: [Tag]};
  function h2($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var h2 = new H2(content, rich, align, className, init);
    $receiver.add_87eobz$(h2);
    return h2;
  }
  function H3(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$H3_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  H3.$metadata$ = {kind: Kind_CLASS, simpleName: 'H3', interfaces: [Tag]};
  function h3($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var h3 = new H3(content, rich, align, className, init);
    $receiver.add_87eobz$(h3);
    return h3;
  }
  function Widget$refreshOnUpdate$lambda_26(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Icon(icon, init) {
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$SPAN_getInstance());
    this.icon_8rox84$_0 = (new Widget$RefreshDelegateProvider(this, icon, Widget$refreshOnUpdate$lambda_26(this))).provideDelegate_n5byny$(this, Icon$icon_metadata);
    init != null ? init(this) : null;
  }
  var Icon$icon_metadata = new PropertyMetadata('icon');
  Object.defineProperty(Icon.prototype, 'icon', {configurable: true, get: function () {
    return this.icon_8rox84$_0.getValue_fmbzy8$(this, Icon$icon_metadata);
  }, set: function (icon) {
    this.icon_8rox84$_0.setValue_19qrsr$(this, Icon$icon_metadata, icon);
  }});
  Icon.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Tag.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.addAll_jfy1ql$(split_0(this.icon, [' ']));
  };
  Icon.$metadata$ = {kind: Kind_CLASS, simpleName: 'Icon', interfaces: [Tag]};
  function icon($receiver, icon, init) {
    if (init === void 0)
      init = null;
    var i = new Icon(icon, init);
    $receiver.add_87eobz$(i);
    return i;
  }
  function Widget$refreshOnUpdate$lambda_27(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var Sandbox$ALLOWFORMS_instance;
  var Sandbox$ALLOWPOINTERLOCK_instance;
  var Sandbox$ALLOWPOPUPS_instance;
  var Sandbox$ALLOWSAMEORIGIN_instance;
  var Sandbox$ALLOWSCRIPTS_instance;
  var Sandbox$ALLOWTOPNAVIGATION_instance;
  function Iframe(src, srcdoc, name, iframeWidth, iframeHeight, sandbox, className) {
    if (src === void 0)
      src = null;
    if (srcdoc === void 0)
      srcdoc = null;
    if (name === void 0)
      name = null;
    if (iframeWidth === void 0)
      iframeWidth = null;
    if (iframeHeight === void 0)
      iframeHeight = null;
    if (sandbox === void 0)
      sandbox = null;
    if (className === void 0)
      className = null;
    Widget.call(this, className);
    this.src_xym4hs$_0 = (new Widget$RefreshDelegateProvider(this, src, Widget$refreshOnUpdate$lambda_27(this))).provideDelegate_n5byny$(this, Iframe$src_metadata);
    this.srcdoc_gonmis$_0 = (new Widget$RefreshDelegateProvider(this, srcdoc, Widget$refreshOnUpdate$lambda_27(this))).provideDelegate_n5byny$(this, Iframe$srcdoc_metadata);
    this.name_cqojkr$_0 = (new Widget$RefreshDelegateProvider(this, name, Widget$refreshOnUpdate$lambda_27(this))).provideDelegate_n5byny$(this, Iframe$name_metadata);
    this.iframeWidth_dku36m$_0 = (new Widget$RefreshDelegateProvider(this, iframeWidth, Widget$refreshOnUpdate$lambda_27(this))).provideDelegate_n5byny$(this, Iframe$iframeWidth_metadata);
    this.iframeHeight_3nia9n$_0 = (new Widget$RefreshDelegateProvider(this, iframeHeight, Widget$refreshOnUpdate$lambda_27(this))).provideDelegate_n5byny$(this, Iframe$iframeHeight_metadata);
    this.sandbox_jsf7p9$_0 = (new Widget$RefreshDelegateProvider(this, sandbox, Widget$refreshOnUpdate$lambda_27(this))).provideDelegate_n5byny$(this, Iframe$sandbox_metadata);
  }
  var Iframe$src_metadata = new PropertyMetadata('src');
  Object.defineProperty(Iframe.prototype, 'src', {configurable: true, get: function () {
    return this.src_xym4hs$_0.getValue_fmbzy8$(this, Iframe$src_metadata);
  }, set: function (src) {
    this.src_xym4hs$_0.setValue_19qrsr$(this, Iframe$src_metadata, src);
  }});
  var Iframe$srcdoc_metadata = new PropertyMetadata('srcdoc');
  Object.defineProperty(Iframe.prototype, 'srcdoc', {configurable: true, get: function () {
    return this.srcdoc_gonmis$_0.getValue_fmbzy8$(this, Iframe$srcdoc_metadata);
  }, set: function (srcdoc) {
    this.srcdoc_gonmis$_0.setValue_19qrsr$(this, Iframe$srcdoc_metadata, srcdoc);
  }});
  var Iframe$name_metadata = new PropertyMetadata('name');
  Object.defineProperty(Iframe.prototype, 'name', {configurable: true, get: function () {
    return this.name_cqojkr$_0.getValue_fmbzy8$(this, Iframe$name_metadata);
  }, set: function (name) {
    this.name_cqojkr$_0.setValue_19qrsr$(this, Iframe$name_metadata, name);
  }});
  var Iframe$iframeWidth_metadata = new PropertyMetadata('iframeWidth');
  Object.defineProperty(Iframe.prototype, 'iframeWidth', {configurable: true, get: function () {
    return this.iframeWidth_dku36m$_0.getValue_fmbzy8$(this, Iframe$iframeWidth_metadata);
  }, set: function (iframeWidth) {
    this.iframeWidth_dku36m$_0.setValue_19qrsr$(this, Iframe$iframeWidth_metadata, iframeWidth);
  }});
  var Iframe$iframeHeight_metadata = new PropertyMetadata('iframeHeight');
  Object.defineProperty(Iframe.prototype, 'iframeHeight', {configurable: true, get: function () {
    return this.iframeHeight_3nia9n$_0.getValue_fmbzy8$(this, Iframe$iframeHeight_metadata);
  }, set: function (iframeHeight) {
    this.iframeHeight_3nia9n$_0.setValue_19qrsr$(this, Iframe$iframeHeight_metadata, iframeHeight);
  }});
  var Iframe$sandbox_metadata = new PropertyMetadata('sandbox');
  Object.defineProperty(Iframe.prototype, 'sandbox', {configurable: true, get: function () {
    return this.sandbox_jsf7p9$_0.getValue_fmbzy8$(this, Iframe$sandbox_metadata);
  }, set: function (sandbox) {
    this.sandbox_jsf7p9$_0.setValue_19qrsr$(this, Iframe$sandbox_metadata, sandbox);
  }});
  Object.defineProperty(Iframe.prototype, 'location', {configurable: true, get: function () {
    return this.getLocationHref_7uausu$_0();
  }, set: function (value) {
    this.setLocationHref_oh96eb$_0(value);
  }});
  Iframe.prototype.render = function () {
    return this.render_61zpoe$('iframe');
  };
  function Iframe$buildAttributeSet$lambda$lambda(it) {
    return it.option_8be2vx$;
  }
  Iframe.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.src) != null) {
      attributeSetBuilder.add_puj7f4$('src', tmp$);
    }if ((tmp$_0 = this.srcdoc) != null) {
      attributeSetBuilder.add_puj7f4$('srcdoc', tmp$_0);
    }if ((tmp$_1 = this.name) != null) {
      attributeSetBuilder.add_puj7f4$('name', tmp$_1);
    }if ((tmp$_2 = this.iframeWidth) != null) {
      attributeSetBuilder.add_puj7f4$('width', tmp$_2.toString());
    }if ((tmp$_3 = this.iframeHeight) != null) {
      attributeSetBuilder.add_puj7f4$('height', tmp$_3.toString());
    }if ((tmp$_4 = this.sandbox) != null) {
      attributeSetBuilder.add_puj7f4$('sandbox', joinToString(tmp$_4, ' ', void 0, void 0, void 0, void 0, Iframe$buildAttributeSet$lambda$lambda));
    }};
  Iframe.prototype.getLocationHref_7uausu$_0 = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    return (tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? tmp$_0.contentWindow : null) != null ? tmp$_1.location : null) != null ? tmp$_2.href : null;
  };
  Iframe.prototype.setLocationHref_oh96eb$_0 = function (location) {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    (tmp$_2 = (tmp$_1 = (tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? tmp$_0.contentWindow : null) != null ? tmp$_1.location : null) != null ? (tmp$_2.href = location != null ? location : 'about:blank') : null;
  };
  Iframe.prototype.getIframeWindow = function () {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? tmp$_0.contentWindow : null;
  };
  Iframe.$metadata$ = {kind: Kind_CLASS, simpleName: 'Iframe', interfaces: [Widget]};
  function iframe($receiver, src, srcdoc, name, iframeWidth, iframeHeight, sandbox, className, init) {
    if (src === void 0)
      src = null;
    if (srcdoc === void 0)
      srcdoc = null;
    if (name === void 0)
      name = null;
    if (iframeWidth === void 0)
      iframeWidth = null;
    if (iframeHeight === void 0)
      iframeHeight = null;
    if (sandbox === void 0)
      sandbox = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var $receiver_0 = new Iframe(src, srcdoc, name, iframeWidth, iframeHeight, sandbox, className);
    init != null ? init($receiver_0) : null;
    var iframe = $receiver_0;
    $receiver.add_87eobz$(iframe);
    return iframe;
  }
  function Widget$refreshOnUpdate$lambda_28(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  var ImageShape$ROUNDED_instance;
  var ImageShape$CIRCLE_instance;
  var ImageShape$THUMBNAIL_instance;
  function Image(src, alt, responsive, shape, centered, className, init) {
    if (alt === void 0)
      alt = null;
    if (responsive === void 0)
      responsive = false;
    if (shape === void 0)
      shape = null;
    if (centered === void 0)
      centered = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Widget.call(this, className);
    this.src_7grjdj$_0 = (new Widget$RefreshDelegateProvider(this, src, Widget$refreshOnUpdate$lambda_28(this))).provideDelegate_n5byny$(this, Image$src_metadata);
    this.alt_7h356k$_0 = (new Widget$RefreshDelegateProvider(this, alt, Widget$refreshOnUpdate$lambda_28(this))).provideDelegate_n5byny$(this, Image$alt_metadata);
    this.responsive_6kamjx$_0 = (new Widget$RefreshDelegateProvider(this, responsive, Widget$refreshOnUpdate$lambda_28(this))).provideDelegate_n5byny$(this, Image$responsive_metadata);
    this.shape_k8q0k$_0 = (new Widget$RefreshDelegateProvider(this, shape, Widget$refreshOnUpdate$lambda_28(this))).provideDelegate_n5byny$(this, Image$shape_metadata);
    this.centered_sir15f$_0 = (new Widget$RefreshDelegateProvider(this, centered, Widget$refreshOnUpdate$lambda_28(this))).provideDelegate_n5byny$(this, Image$centered_metadata);
    init != null ? init(this) : null;
  }
  var Image$src_metadata = new PropertyMetadata('src');
  Object.defineProperty(Image.prototype, 'src', {configurable: true, get: function () {
    return this.src_7grjdj$_0.getValue_fmbzy8$(this, Image$src_metadata);
  }, set: function (src) {
    this.src_7grjdj$_0.setValue_19qrsr$(this, Image$src_metadata, src);
  }});
  var Image$alt_metadata = new PropertyMetadata('alt');
  Object.defineProperty(Image.prototype, 'alt', {configurable: true, get: function () {
    return this.alt_7h356k$_0.getValue_fmbzy8$(this, Image$alt_metadata);
  }, set: function (alt) {
    this.alt_7h356k$_0.setValue_19qrsr$(this, Image$alt_metadata, alt);
  }});
  var Image$responsive_metadata = new PropertyMetadata('responsive');
  Object.defineProperty(Image.prototype, 'responsive', {configurable: true, get: function () {
    return this.responsive_6kamjx$_0.getValue_fmbzy8$(this, Image$responsive_metadata);
  }, set: function (responsive) {
    this.responsive_6kamjx$_0.setValue_19qrsr$(this, Image$responsive_metadata, responsive);
  }});
  var Image$shape_metadata = new PropertyMetadata('shape');
  Object.defineProperty(Image.prototype, 'shape', {configurable: true, get: function () {
    return this.shape_k8q0k$_0.getValue_fmbzy8$(this, Image$shape_metadata);
  }, set: function (shape) {
    this.shape_k8q0k$_0.setValue_19qrsr$(this, Image$shape_metadata, shape);
  }});
  var Image$centered_metadata = new PropertyMetadata('centered');
  Object.defineProperty(Image.prototype, 'centered', {configurable: true, get: function () {
    return this.centered_sir15f$_0.getValue_fmbzy8$(this, Image$centered_metadata);
  }, set: function (centered) {
    this.centered_sir15f$_0.setValue_19qrsr$(this, Image$centered_metadata, centered);
  }});
  Image.prototype.render = function () {
    return this.render_61zpoe$('img');
  };
  Image.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0;
    Widget.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.src) != null) {
      attributeSetBuilder.add_puj7f4$('src', tmp$);
    }if ((tmp$_0 = this.alt) != null) {
      attributeSetBuilder.add_puj7f4$('alt', this.translate_61zpoe$(tmp$_0));
    }};
  Image.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    Widget.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.responsive) {
      classSetBuilder.add_61zpoe$('img-fluid');
    }if (this.centered) {
      classSetBuilder.add_61zpoe$('center-block');
    }classSetBuilder.add_vqcfem$(this.shape);
  };
  Image.$metadata$ = {kind: Kind_CLASS, simpleName: 'Image', interfaces: [Widget]};
  function image($receiver, src, alt, responsive, shape, centered, className, init) {
    if (alt === void 0)
      alt = null;
    if (responsive === void 0)
      responsive = false;
    if (shape === void 0)
      shape = null;
    if (centered === void 0)
      centered = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var image = new Image(src, alt, responsive, shape, centered, className, init);
    $receiver.add_87eobz$(image);
    return image;
  }
  function InputType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function InputType_initFields() {
    InputType_initFields = function () {
    };
    InputType$TEXT_instance = new InputType('TEXT', 0, 'text');
    InputType$PASSWORD_instance = new InputType('PASSWORD', 1, 'password');
    InputType$EMAIL_instance = new InputType('EMAIL', 2, 'email');
    InputType$TEL_instance = new InputType('TEL', 3, 'tel');
    InputType$COLOR_instance = new InputType('COLOR', 4, 'color');
    InputType$SEARCH_instance = new InputType('SEARCH', 5, 'search');
    InputType$URL_instance = new InputType('URL', 6, 'url');
    InputType$HIDDEN_instance = new InputType('HIDDEN', 7, 'hidden');
    InputType$BUTTON_instance = new InputType('BUTTON', 8, 'button');
    InputType$CHECKBOX_instance = new InputType('CHECKBOX', 9, 'checkbox');
    InputType$DATE_instance = new InputType('DATE', 10, 'date');
    InputType$DATETIME_LOCAL_instance = new InputType('DATETIME_LOCAL', 11, 'datetime-local');
    InputType$FILE_instance = new InputType('FILE', 12, 'file');
    InputType$IMAGE_instance = new InputType('IMAGE', 13, 'image');
    InputType$MONTH_instance = new InputType('MONTH', 14, 'month');
    InputType$NUMBER_instance = new InputType('NUMBER', 15, 'number');
    InputType$RADIO_instance = new InputType('RADIO', 16, 'radio');
    InputType$RANGE_instance = new InputType('RANGE', 17, 'range');
    InputType$RESET_instance = new InputType('RESET', 18, 'reset');
    InputType$SUBMIT_instance = new InputType('SUBMIT', 19, 'submit');
    InputType$TIME_instance = new InputType('TIME', 20, 'time');
    InputType$WEEK_instance = new InputType('WEEK', 21, 'week');
  }
  var InputType$TEXT_instance;
  function InputType$TEXT_getInstance() {
    InputType_initFields();
    return InputType$TEXT_instance;
  }
  var InputType$PASSWORD_instance;
  function InputType$PASSWORD_getInstance() {
    InputType_initFields();
    return InputType$PASSWORD_instance;
  }
  var InputType$EMAIL_instance;
  function InputType$EMAIL_getInstance() {
    InputType_initFields();
    return InputType$EMAIL_instance;
  }
  var InputType$TEL_instance;
  function InputType$TEL_getInstance() {
    InputType_initFields();
    return InputType$TEL_instance;
  }
  var InputType$COLOR_instance;
  function InputType$COLOR_getInstance() {
    InputType_initFields();
    return InputType$COLOR_instance;
  }
  var InputType$SEARCH_instance;
  function InputType$SEARCH_getInstance() {
    InputType_initFields();
    return InputType$SEARCH_instance;
  }
  var InputType$URL_instance;
  function InputType$URL_getInstance() {
    InputType_initFields();
    return InputType$URL_instance;
  }
  var InputType$HIDDEN_instance;
  function InputType$HIDDEN_getInstance() {
    InputType_initFields();
    return InputType$HIDDEN_instance;
  }
  var InputType$BUTTON_instance;
  function InputType$BUTTON_getInstance() {
    InputType_initFields();
    return InputType$BUTTON_instance;
  }
  var InputType$CHECKBOX_instance;
  function InputType$CHECKBOX_getInstance() {
    InputType_initFields();
    return InputType$CHECKBOX_instance;
  }
  var InputType$DATE_instance;
  function InputType$DATE_getInstance() {
    InputType_initFields();
    return InputType$DATE_instance;
  }
  var InputType$DATETIME_LOCAL_instance;
  function InputType$DATETIME_LOCAL_getInstance() {
    InputType_initFields();
    return InputType$DATETIME_LOCAL_instance;
  }
  var InputType$FILE_instance;
  function InputType$FILE_getInstance() {
    InputType_initFields();
    return InputType$FILE_instance;
  }
  var InputType$IMAGE_instance;
  function InputType$IMAGE_getInstance() {
    InputType_initFields();
    return InputType$IMAGE_instance;
  }
  var InputType$MONTH_instance;
  function InputType$MONTH_getInstance() {
    InputType_initFields();
    return InputType$MONTH_instance;
  }
  var InputType$NUMBER_instance;
  function InputType$NUMBER_getInstance() {
    InputType_initFields();
    return InputType$NUMBER_instance;
  }
  var InputType$RADIO_instance;
  function InputType$RADIO_getInstance() {
    InputType_initFields();
    return InputType$RADIO_instance;
  }
  var InputType$RANGE_instance;
  function InputType$RANGE_getInstance() {
    InputType_initFields();
    return InputType$RANGE_instance;
  }
  var InputType$RESET_instance;
  function InputType$RESET_getInstance() {
    InputType_initFields();
    return InputType$RESET_instance;
  }
  var InputType$SUBMIT_instance;
  function InputType$SUBMIT_getInstance() {
    InputType_initFields();
    return InputType$SUBMIT_instance;
  }
  var InputType$TIME_instance;
  function InputType$TIME_getInstance() {
    InputType_initFields();
    return InputType$TIME_instance;
  }
  var InputType$WEEK_instance;
  function InputType$WEEK_getInstance() {
    InputType_initFields();
    return InputType$WEEK_instance;
  }
  InputType.$metadata$ = {kind: Kind_CLASS, simpleName: 'InputType', interfaces: [Enum]};
  function InputType$values() {
    return [InputType$TEXT_getInstance(), InputType$PASSWORD_getInstance(), InputType$EMAIL_getInstance(), InputType$TEL_getInstance(), InputType$COLOR_getInstance(), InputType$SEARCH_getInstance(), InputType$URL_getInstance(), InputType$HIDDEN_getInstance(), InputType$BUTTON_getInstance(), InputType$CHECKBOX_getInstance(), InputType$DATE_getInstance(), InputType$DATETIME_LOCAL_getInstance(), InputType$FILE_getInstance(), InputType$IMAGE_getInstance(), InputType$MONTH_getInstance(), InputType$NUMBER_getInstance(), InputType$RADIO_getInstance(), InputType$RANGE_getInstance(), InputType$RESET_getInstance(), InputType$SUBMIT_getInstance(), InputType$TIME_getInstance(), InputType$WEEK_getInstance()];
  }
  InputType.values = InputType$values;
  function InputType$valueOf(name) {
    switch (name) {
      case 'TEXT':
        return InputType$TEXT_getInstance();
      case 'PASSWORD':
        return InputType$PASSWORD_getInstance();
      case 'EMAIL':
        return InputType$EMAIL_getInstance();
      case 'TEL':
        return InputType$TEL_getInstance();
      case 'COLOR':
        return InputType$COLOR_getInstance();
      case 'SEARCH':
        return InputType$SEARCH_getInstance();
      case 'URL':
        return InputType$URL_getInstance();
      case 'HIDDEN':
        return InputType$HIDDEN_getInstance();
      case 'BUTTON':
        return InputType$BUTTON_getInstance();
      case 'CHECKBOX':
        return InputType$CHECKBOX_getInstance();
      case 'DATE':
        return InputType$DATE_getInstance();
      case 'DATETIME_LOCAL':
        return InputType$DATETIME_LOCAL_getInstance();
      case 'FILE':
        return InputType$FILE_getInstance();
      case 'IMAGE':
        return InputType$IMAGE_getInstance();
      case 'MONTH':
        return InputType$MONTH_getInstance();
      case 'NUMBER':
        return InputType$NUMBER_getInstance();
      case 'RADIO':
        return InputType$RADIO_getInstance();
      case 'RANGE':
        return InputType$RANGE_getInstance();
      case 'RESET':
        return InputType$RESET_getInstance();
      case 'SUBMIT':
        return InputType$SUBMIT_getInstance();
      case 'TIME':
        return InputType$TIME_getInstance();
      case 'WEEK':
        return InputType$WEEK_getInstance();
      default:throwISE('No enum constant io.kvision.html.InputType.' + name);
    }
  }
  InputType.valueOf_61zpoe$ = InputType$valueOf;
  var Autocomplete$OFF_instance;
  var Autocomplete$ON_instance;
  var Autocomplete$NAME_instance;
  var Autocomplete$HONORIFIC_PREFIX_instance;
  var Autocomplete$GIVEN_NAME_instance;
  var Autocomplete$ADDITIONAL_NAME_instance;
  var Autocomplete$FAMILY_NAME_instance;
  var Autocomplete$HONORIFIC_SUFFIX_instance;
  var Autocomplete$NICKNAME_instance;
  var Autocomplete$USERNAME_instance;
  var Autocomplete$NEW_PASSWORD_instance;
  var Autocomplete$CURRENT_PASSWORD_instance;
  var Autocomplete$ONE_TIME_CODE_instance;
  var Autocomplete$ORGANIZATION_TITLE_instance;
  var Autocomplete$ORGANIZATION_instance;
  var Autocomplete$STREET_ADDRESS_instance;
  var Autocomplete$ADDRESS_LINE1_instance;
  var Autocomplete$ADDRESS_LINE2_instance;
  var Autocomplete$ADDRESS_LINE3_instance;
  var Autocomplete$ADDRESS_LEVEL4_instance;
  var Autocomplete$ADDRESS_LEVEL3_instance;
  var Autocomplete$ADDRESS_LEVEL2_instance;
  var Autocomplete$ADDRESS_LEVEL1_instance;
  var Autocomplete$COUNTRY_instance;
  var Autocomplete$COUNTRY_NAME_instance;
  var Autocomplete$POSTAL_CODE_instance;
  var Autocomplete$CC_NAME_instance;
  var Autocomplete$CC_GIVEN_NAME_instance;
  var Autocomplete$CC_ADDITIONAL_NAME_instance;
  var Autocomplete$CC_FAMILY_NAME_instance;
  var Autocomplete$CC_NUMBER_instance;
  var Autocomplete$CC_EXP_instance;
  var Autocomplete$CC_EXP_MONTH_instance;
  var Autocomplete$CC_EXP_YEAR_instance;
  var Autocomplete$CC_CSC_instance;
  var Autocomplete$CC_TYPE_instance;
  var Autocomplete$TRANSACTION_CURRENCY_instance;
  var Autocomplete$TRANSACTION_AMOUNT_instance;
  var Autocomplete$LANGUAGE_instance;
  var Autocomplete$BDAY_instance;
  var Autocomplete$BDAY_DAY_instance;
  var Autocomplete$BDAY_MONTH_instance;
  var Autocomplete$BDAY_YEAR_instance;
  var Autocomplete$SEX_instance;
  var Autocomplete$URL_instance;
  var Autocomplete$PHOTO_instance;
  var Input$type_metadata = new PropertyMetadata('type');
  var Input$accept_metadata = new PropertyMetadata('accept');
  var Input$alt_metadata = new PropertyMetadata('alt');
  var Input$autocomplete_metadata = new PropertyMetadata('autocomplete');
  var Input$autofocus_metadata = new PropertyMetadata('autofocus');
  var Input$checked_metadata = new PropertyMetadata('checked');
  var Input$disabled_metadata = new PropertyMetadata('disabled');
  var Input$form_metadata = new PropertyMetadata('form');
  var Input$formaction_metadata = new PropertyMetadata('formaction');
  var Input$formenctype_metadata = new PropertyMetadata('formenctype');
  var Input$formmethod_metadata = new PropertyMetadata('formmethod');
  var Input$formnovalidate_metadata = new PropertyMetadata('formnovalidate');
  var Input$formtarget_metadata = new PropertyMetadata('formtarget');
  var Input$max_metadata = new PropertyMetadata('max');
  var Input$maxlength_metadata = new PropertyMetadata('maxlength');
  var Input$min_metadata = new PropertyMetadata('min');
  var Input$minlength_metadata = new PropertyMetadata('minlength');
  var Input$multiple_metadata = new PropertyMetadata('multiple');
  var Input$name_metadata = new PropertyMetadata('name');
  var Input$pattern_metadata = new PropertyMetadata('pattern');
  var Input$placeholder_metadata = new PropertyMetadata('placeholder');
  var Input$readonly_metadata = new PropertyMetadata('readonly');
  var Input$required_metadata = new PropertyMetadata('required');
  var Input$size_metadata = new PropertyMetadata('size');
  var Input$src_metadata = new PropertyMetadata('src');
  var Input$step_metadata = new PropertyMetadata('step');
  var Input$value_metadata = new PropertyMetadata('value');
  var Label$forId_metadata = new PropertyMetadata('forId');
  function Li(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$LI_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  Li.$metadata$ = {kind: Kind_CLASS, simpleName: 'Li', interfaces: [Tag]};
  function li($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var li = new Li(content, rich, align, className, init);
    $receiver.add_87eobz$(li);
    return li;
  }
  function Widget$refreshOnUpdate$lambda_32(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Link(label, url, icon, image, separator, labelFirst, target, dataNavigo, className, init) {
    Link$Companion_getInstance();
    if (url === void 0)
      url = null;
    if (icon === void 0)
      icon = null;
    if (image === void 0)
      image = null;
    if (separator === void 0)
      separator = null;
    if (labelFirst === void 0)
      labelFirst = true;
    if (target === void 0)
      target = null;
    if (dataNavigo === void 0)
      dataNavigo = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.label_9ibd5y$_0 = (new Widget$RefreshDelegateProvider(this, label, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$label_metadata);
    this.url_db59q9$_0 = (new Widget$RefreshDelegateProvider(this, url, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$url_metadata);
    this.icon_de9xu5$_0 = (new Widget$RefreshDelegateProvider(this, icon, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$icon_metadata);
    this.image_aqvawd$_0 = (new Widget$RefreshDelegateProvider(this, image, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$image_metadata);
    this.separator_4r1i5z$_0 = (new Widget$RefreshDelegateProvider(this, separator, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$separator_metadata);
    this.labelFirst_9ae3wq$_0 = (new Widget$RefreshDelegateProvider(this, labelFirst, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$labelFirst_metadata);
    this.target_z1k2ob$_0 = (new Widget$RefreshDelegateProvider(this, target, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$target_metadata);
    this.dataNavigo_ipeb9q$_0 = (new Widget$RefreshDelegateProvider(this, dataNavigo, Widget$refreshOnUpdate$lambda_32(this))).provideDelegate_n5byny$(this, Link$dataNavigo_metadata);
    init != null ? init(this) : null;
  }
  var Link$label_metadata = new PropertyMetadata('label');
  Object.defineProperty(Link.prototype, 'label', {configurable: true, get: function () {
    return this.label_9ibd5y$_0.getValue_fmbzy8$(this, Link$label_metadata);
  }, set: function (label) {
    this.label_9ibd5y$_0.setValue_19qrsr$(this, Link$label_metadata, label);
  }});
  var Link$url_metadata = new PropertyMetadata('url');
  Object.defineProperty(Link.prototype, 'url', {configurable: true, get: function () {
    return this.url_db59q9$_0.getValue_fmbzy8$(this, Link$url_metadata);
  }, set: function (url) {
    this.url_db59q9$_0.setValue_19qrsr$(this, Link$url_metadata, url);
  }});
  var Link$icon_metadata = new PropertyMetadata('icon');
  Object.defineProperty(Link.prototype, 'icon', {configurable: true, get: function () {
    return this.icon_de9xu5$_0.getValue_fmbzy8$(this, Link$icon_metadata);
  }, set: function (icon) {
    this.icon_de9xu5$_0.setValue_19qrsr$(this, Link$icon_metadata, icon);
  }});
  var Link$image_metadata = new PropertyMetadata('image');
  Object.defineProperty(Link.prototype, 'image', {configurable: true, get: function () {
    return this.image_aqvawd$_0.getValue_fmbzy8$(this, Link$image_metadata);
  }, set: function (image) {
    this.image_aqvawd$_0.setValue_19qrsr$(this, Link$image_metadata, image);
  }});
  var Link$separator_metadata = new PropertyMetadata('separator');
  Object.defineProperty(Link.prototype, 'separator', {configurable: true, get: function () {
    return this.separator_4r1i5z$_0.getValue_fmbzy8$(this, Link$separator_metadata);
  }, set: function (separator) {
    this.separator_4r1i5z$_0.setValue_19qrsr$(this, Link$separator_metadata, separator);
  }});
  var Link$labelFirst_metadata = new PropertyMetadata('labelFirst');
  Object.defineProperty(Link.prototype, 'labelFirst', {configurable: true, get: function () {
    return this.labelFirst_9ae3wq$_0.getValue_fmbzy8$(this, Link$labelFirst_metadata);
  }, set: function (labelFirst) {
    this.labelFirst_9ae3wq$_0.setValue_19qrsr$(this, Link$labelFirst_metadata, labelFirst);
  }});
  var Link$target_metadata = new PropertyMetadata('target');
  Object.defineProperty(Link.prototype, 'target', {configurable: true, get: function () {
    return this.target_z1k2ob$_0.getValue_fmbzy8$(this, Link$target_metadata);
  }, set: function (target) {
    this.target_z1k2ob$_0.setValue_19qrsr$(this, Link$target_metadata, target);
  }});
  var Link$dataNavigo_metadata = new PropertyMetadata('dataNavigo');
  Object.defineProperty(Link.prototype, 'dataNavigo', {configurable: true, get: function () {
    return this.dataNavigo_ipeb9q$_0.getValue_fmbzy8$(this, Link$dataNavigo_metadata);
  }, set: function (dataNavigo) {
    this.dataNavigo_ipeb9q$_0.setValue_19qrsr$(this, Link$dataNavigo_metadata, dataNavigo);
  }});
  Link.prototype.render = function () {
    var tmp$;
    var t = this.createLabelWithIcon_dawjdb$(this.label, this.icon, this.image, this.separator);
    if (this.labelFirst) {
      var elements = this.childrenVNodes();
      tmp$ = this.render_pjwf99$('a', t.concat(elements));
    } else {
      tmp$ = this.render_pjwf99$('a', this.childrenVNodes().concat(t));
    }
    return tmp$;
  };
  Link.prototype.buildAttributeSet_34lhpl$ = function (attributeSetBuilder) {
    var tmp$, tmp$_0, tmp$_1;
    SimplePanel.prototype.buildAttributeSet_34lhpl$.call(this, attributeSetBuilder);
    if ((tmp$ = this.url) != null) {
      attributeSetBuilder.add_puj7f4$('href', tmp$);
    }if ((tmp$_0 = this.target) != null) {
      attributeSetBuilder.add_puj7f4$('target', tmp$_0);
    }var tmp$_2;
    if ((tmp$_1 = this.dataNavigo) != null) {
      attributeSetBuilder.add_puj7f4$('data-navigo', tmp$_1 ? 'data-navigo' : 'false');
      tmp$_2 = Unit;
    } else
      tmp$_2 = null;
    if (tmp$_2 == null) {
      if (Link$Companion_getInstance().useDataNavigoForLinks)
        attributeSetBuilder.add_puj7f4$('data-navigo');
    }};
  function Link$onClick$lambda$lambda(this$, closure$handler) {
    return function (e) {
      closure$handler(this$.self, e);
      return Unit;
    };
  }
  function Link$onClick$lambda(closure$handler) {
    return function ($receiver) {
      $receiver.click = Link$onClick$lambda$lambda($receiver, closure$handler);
      return Unit;
    };
  }
  Link.prototype.onClick_r4mow$ = function (handler) {
    this.setEventListener_a1up2z$(Link$onClick$lambda(handler));
    return this;
  };
  function Link$Companion() {
    Link$Companion_instance = this;
    this.useDataNavigoForLinks = false;
  }
  Link$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Link$Companion_instance = null;
  function Link$Companion_getInstance() {
    if (Link$Companion_instance === null) {
      new Link$Companion();
    }return Link$Companion_instance;
  }
  Link.$metadata$ = {kind: Kind_CLASS, simpleName: 'Link', interfaces: [SimplePanel]};
  function link($receiver, label, url, icon, image, separator, labelFirst, target, dataNavigo, className, init) {
    if (url === void 0)
      url = null;
    if (icon === void 0)
      icon = null;
    if (image === void 0)
      image = null;
    if (separator === void 0)
      separator = null;
    if (labelFirst === void 0)
      labelFirst = true;
    if (target === void 0)
      target = null;
    if (dataNavigo === void 0)
      dataNavigo = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var link = new Link(label, url, icon, image, separator, labelFirst, target, dataNavigo, className, init);
    $receiver.add_87eobz$(link);
    return link;
  }
  function Widget$refreshOnUpdate$lambda_33(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function ListType(name, ordinal, tagName) {
    Enum.call(this);
    this.tagName_8be2vx$ = tagName;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ListType_initFields() {
    ListType_initFields = function () {
    };
    ListType$UL_instance = new ListType('UL', 0, 'ul');
    ListType$OL_instance = new ListType('OL', 1, 'ol');
    ListType$UNSTYLED_instance = new ListType('UNSTYLED', 2, 'ul');
    ListType$INLINE_instance = new ListType('INLINE', 3, 'ul');
    ListType$DL_instance = new ListType('DL', 4, 'dl');
    ListType$DL_HORIZ_instance = new ListType('DL_HORIZ', 5, 'dl');
  }
  var ListType$UL_instance;
  function ListType$UL_getInstance() {
    ListType_initFields();
    return ListType$UL_instance;
  }
  var ListType$OL_instance;
  function ListType$OL_getInstance() {
    ListType_initFields();
    return ListType$OL_instance;
  }
  var ListType$UNSTYLED_instance;
  function ListType$UNSTYLED_getInstance() {
    ListType_initFields();
    return ListType$UNSTYLED_instance;
  }
  var ListType$INLINE_instance;
  function ListType$INLINE_getInstance() {
    ListType_initFields();
    return ListType$INLINE_instance;
  }
  var ListType$DL_instance;
  function ListType$DL_getInstance() {
    ListType_initFields();
    return ListType$DL_instance;
  }
  var ListType$DL_HORIZ_instance;
  function ListType$DL_HORIZ_getInstance() {
    ListType_initFields();
    return ListType$DL_HORIZ_instance;
  }
  ListType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ListType', interfaces: [Enum]};
  function ListType$values() {
    return [ListType$UL_getInstance(), ListType$OL_getInstance(), ListType$UNSTYLED_getInstance(), ListType$INLINE_getInstance(), ListType$DL_getInstance(), ListType$DL_HORIZ_getInstance()];
  }
  ListType.values = ListType$values;
  function ListType$valueOf(name) {
    switch (name) {
      case 'UL':
        return ListType$UL_getInstance();
      case 'OL':
        return ListType$OL_getInstance();
      case 'UNSTYLED':
        return ListType$UNSTYLED_getInstance();
      case 'INLINE':
        return ListType$INLINE_getInstance();
      case 'DL':
        return ListType$DL_getInstance();
      case 'DL_HORIZ':
        return ListType$DL_HORIZ_getInstance();
      default:throwISE('No enum constant io.kvision.html.ListType.' + name);
    }
  }
  ListType.valueOf_61zpoe$ = ListType$valueOf;
  function ListTag(type, elements, rich, className, init) {
    if (elements === void 0)
      elements = null;
    if (rich === void 0)
      rich = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.type_kmrc5q$_0 = (new Widget$RefreshDelegateProvider(this, type, Widget$refreshOnUpdate$lambda_33(this))).provideDelegate_n5byny$(this, ListTag$type_metadata);
    this.elements_8mpxdd$_0 = (new Widget$RefreshDelegateProvider(this, elements, Widget$refreshOnUpdate$lambda_33(this))).provideDelegate_n5byny$(this, ListTag$elements_metadata);
    this.rich_kld9m4$_0 = (new Widget$RefreshDelegateProvider(this, rich, Widget$refreshOnUpdate$lambda_33(this))).provideDelegate_n5byny$(this, ListTag$rich_metadata);
    init != null ? init(this) : null;
  }
  var ListTag$type_metadata = new PropertyMetadata('type');
  Object.defineProperty(ListTag.prototype, 'type', {configurable: true, get: function () {
    return this.type_kmrc5q$_0.getValue_fmbzy8$(this, ListTag$type_metadata);
  }, set: function (type) {
    this.type_kmrc5q$_0.setValue_19qrsr$(this, ListTag$type_metadata, type);
  }});
  var ListTag$elements_metadata = new PropertyMetadata('elements');
  Object.defineProperty(ListTag.prototype, 'elements', {configurable: true, get: function () {
    return this.elements_8mpxdd$_0.getValue_fmbzy8$(this, ListTag$elements_metadata);
  }, set: function (elements) {
    this.elements_8mpxdd$_0.setValue_19qrsr$(this, ListTag$elements_metadata, elements);
  }});
  var ListTag$rich_metadata = new PropertyMetadata('rich');
  Object.defineProperty(ListTag.prototype, 'rich', {configurable: true, get: function () {
    return this.rich_kld9m4$_0.getValue_fmbzy8$(this, ListTag$rich_metadata);
  }, set: function (rich) {
    this.rich_kld9m4$_0.setValue_19qrsr$(this, ListTag$rich_metadata, rich);
  }});
  ListTag.prototype.render = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    switch (this.type.name) {
      case 'UL':
      case 'OL':
      case 'UNSTYLED':
      case 'INLINE':
        var tmp$_3;
        if ((tmp$ = this.elements) != null) {
          var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
          var tmp$_4;
          tmp$_4 = tmp$.iterator();
          while (tmp$_4.hasNext()) {
            var item = tmp$_4.next();
            destination.add_11rb$(this.element_82i2kg$_0('li', item, this.rich, this.type === ListType$INLINE_getInstance()));
          }
          tmp$_3 = destination;
        } else
          tmp$_3 = null;
        tmp$_1 = tmp$_3;
        break;
      case 'DL':
      case 'DL_HORIZ':
        var tmp$_5;
        if ((tmp$_0 = this.elements) != null) {
          var destination_0 = ArrayList_init_0(collectionSizeOrDefault(tmp$_0, 10));
          var tmp$_6, tmp$_0_0;
          var index = 0;
          tmp$_6 = tmp$_0.iterator();
          while (tmp$_6.hasNext()) {
            var item_0 = tmp$_6.next();
            destination_0.add_11rb$(this.element_82i2kg$_0((checkIndexOverflow((tmp$_0_0 = index, index = tmp$_0_0 + 1 | 0, tmp$_0_0)) % 2 | 0) === 0 ? 'dt' : 'dd', item_0, this.rich, false));
          }
          tmp$_5 = destination_0;
        } else
          tmp$_5 = null;
        tmp$_1 = tmp$_5;
        break;
      default:tmp$_1 = Kotlin.noWhenBranchMatched();
        break;
    }
    var childrenElements = tmp$_1 != null ? copyToArray(tmp$_1) : null;
    if (childrenElements != null) {
      var tmp$_7 = this.type.tagName_8be2vx$;
      var elements = this.childrenVNodes();
      tmp$_2 = this.render_pjwf99$(tmp$_7, childrenElements.concat(elements));
    } else {
      tmp$_2 = this.render_pjwf99$(this.type.tagName_8be2vx$, this.childrenVNodes());
    }
    return tmp$_2;
  };
  function ListTag$childrenVNodes$lambda$lambda($receiver) {
    var pairs = listOf_0(to('list-inline-item', true));
    var $receiver_0 = new Object_init();
    var tmp$;
    tmp$ = pairs.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.component1(), value = element.component2();
      $receiver_0[key] = value;
    }
    $receiver.class = $receiver_0;
    return Unit;
  }
  ListTag.prototype.childrenVNodes = function () {
    var tmp$;
    var $receiver = this.getChildren();
    var destination = ArrayList_init();
    var tmp$_0;
    tmp$_0 = $receiver.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (element.visible)
        destination.add_11rb$(element);
    }
    var childrenElements = destination;
    switch (this.type.name) {
      case 'UL':
      case 'OL':
      case 'UNSTYLED':
      case 'INLINE':
        var destination_0 = ArrayList_init_0(collectionSizeOrDefault(childrenElements, 10));
        var tmp$_1;
        tmp$_1 = childrenElements.iterator();
        while (tmp$_1.hasNext()) {
          var item = tmp$_1.next();
          var tmp$_2 = destination_0.add_11rb$;
          var transform$result;
          if (Kotlin.isType(item, Tag) && (item.type === TAG$LI_getInstance() || item.type === TAG$OL_getInstance() || item.type === TAG$UL_getInstance()) || Kotlin.isType(item, ListTag)) {
            transform$result = item.renderVNode();
          } else {
            if (this.type === ListType$INLINE_getInstance()) {
              var opt = getCallableRef('apply', function ($receiver, p1) {
                p1($receiver);
                return $receiver;
              }.bind(null, {}))(ListTag$childrenVNodes$lambda$lambda);
              transform$result = h('li', opt, [item.renderVNode()]);
            } else {
              transform$result = h('li', [item.renderVNode()]);
            }
          }
          tmp$_2.call(destination_0, transform$result);
        }

        tmp$ = destination_0;
        break;
      case 'DL':
      case 'DL_HORIZ':
        var destination_1 = ArrayList_init_0(collectionSizeOrDefault(childrenElements, 10));
        var tmp$_3, tmp$_0_0;
        var index = 0;
        tmp$_3 = childrenElements.iterator();
        while (tmp$_3.hasNext()) {
          var item_0 = tmp$_3.next();
          var tmp$_4 = destination_1.add_11rb$;
          var index_0 = checkIndexOverflow((tmp$_0_0 = index, index = tmp$_0_0 + 1 | 0, tmp$_0_0));
          var transform$result_0;
          if (Kotlin.isType(item_0, Tag) && (item_0.type === TAG$LI_getInstance() || item_0.type === TAG$OL_getInstance() || item_0.type === TAG$UL_getInstance() || Kotlin.isType(item_0, ListTag))) {
            transform$result_0 = item_0.renderVNode();
          } else {
            transform$result_0 = h((index_0 % 2 | 0) === 0 ? 'dt' : 'dd', [item_0.renderVNode()]);
          }
          tmp$_4.call(destination_1, transform$result_0);
        }

        tmp$ = destination_1;
        break;
      default:tmp$ = Kotlin.noWhenBranchMatched();
        break;
    }
    var res = tmp$;
    return copyToArray(res);
  };
  function ListTag$element$lambda($receiver) {
    var pairs = listOf_0(to('list-inline-item', true));
    var $receiver_0 = new Object_init();
    var tmp$;
    tmp$ = pairs.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.component1(), value = element.component2();
      $receiver_0[key] = value;
    }
    $receiver.class = $receiver_0;
    return Unit;
  }
  function ListTag$element$lambda_0($receiver) {
    return Unit;
  }
  ListTag.prototype.element_82i2kg$_0 = function (name, value, rich, inline) {
    var tmp$, tmp$_0;
    var translatedValue = this.translate_61zpoe$(value);
    if (inline) {
      tmp$ = getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(ListTag$element$lambda);
    } else {
      tmp$ = getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(ListTag$element$lambda_0);
    }
    var opt = tmp$;
    if (rich) {
      tmp$_0 = h(name, opt, [KVManager_getInstance().virtualize_61zpoe$('<span style=' + '"' + 'display: contents;' + '"' + '>' + translatedValue + '<\/span>')]);
    } else {
      tmp$_0 = h(name, opt, translatedValue);
    }
    return tmp$_0;
  };
  ListTag.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    switch (this.type.name) {
      case 'UNSTYLED':
        classSetBuilder.add_61zpoe$('list-unstyled');
        break;
      case 'INLINE':
        classSetBuilder.add_61zpoe$('list-inline');
        break;
      case 'DL_HORIZ':
        classSetBuilder.add_61zpoe$('dl-horizontal');
        break;
      default:break;
    }
  };
  ListTag.$metadata$ = {kind: Kind_CLASS, simpleName: 'ListTag', interfaces: [SimplePanel]};
  function P(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$P_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  P.$metadata$ = {kind: Kind_CLASS, simpleName: 'P', interfaces: [Tag]};
  function p($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var p = new P(content, rich, align, className, init);
    $receiver.add_87eobz$(p);
    return p;
  }
  function Span(content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Tag.call(this, TAG$SPAN_getInstance(), content, rich, align, className);
    init != null ? init(this) : null;
  }
  Span.$metadata$ = {kind: Kind_CLASS, simpleName: 'Span', interfaces: [Tag]};
  function span($receiver, content, rich, align, className, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var span = new Span(content, rich, align, className, init);
    $receiver.add_87eobz$(span);
    return span;
  }
  function Widget$refreshOnUpdate$lambda_34(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_35(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function TAG(name, ordinal, tagName) {
    Enum.call(this);
    this.tagName_8be2vx$ = tagName;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function TAG_initFields() {
    TAG_initFields = function () {
    };
    TAG$A_instance = new TAG('A', 0, 'a');
    TAG$ABBR_instance = new TAG('ABBR', 1, 'abbr');
    TAG$ADDRESS_instance = new TAG('ADDRESS', 2, 'address');
    TAG$AREA_instance = new TAG('AREA', 3, 'area');
    TAG$ARTICLE_instance = new TAG('ARTICLE', 4, 'article');
    TAG$ASIDE_instance = new TAG('ASIDE', 5, 'aside');
    TAG$AUDIO_instance = new TAG('AUDIO', 6, 'audio');
    TAG$B_instance = new TAG('B', 7, 'b');
    TAG$BASE_instance = new TAG('BASE', 8, 'base');
    TAG$BDI_instance = new TAG('BDI', 9, 'bdi');
    TAG$BDO_instance = new TAG('BDO', 10, 'bdo');
    TAG$BLOCKQUOTE_instance = new TAG('BLOCKQUOTE', 11, 'blockquote');
    TAG$BODY_instance = new TAG('BODY', 12, 'body');
    TAG$BR_instance = new TAG('BR', 13, 'br');
    TAG$BUTTON_instance = new TAG('BUTTON', 14, 'button');
    TAG$CANVAS_instance = new TAG('CANVAS', 15, 'canvas');
    TAG$CAPTION_instance = new TAG('CAPTION', 16, 'caption');
    TAG$CITE_instance = new TAG('CITE', 17, 'cite');
    TAG$CODE_instance = new TAG('CODE', 18, 'code');
    TAG$COL_instance = new TAG('COL', 19, 'col');
    TAG$COLGROUP_instance = new TAG('COLGROUP', 20, 'colgroup');
    TAG$DATA_instance = new TAG('DATA', 21, 'data');
    TAG$DATALIST_instance = new TAG('DATALIST', 22, 'datalist');
    TAG$DD_instance = new TAG('DD', 23, 'dd');
    TAG$DEL_instance = new TAG('DEL', 24, 'del');
    TAG$DETAILS_instance = new TAG('DETAILS', 25, 'details');
    TAG$DFN_instance = new TAG('DFN', 26, 'dfn');
    TAG$DIALOG_instance = new TAG('DIALOG', 27, 'dialog');
    TAG$DIV_instance = new TAG('DIV', 28, 'div');
    TAG$DL_instance = new TAG('DL', 29, 'dl');
    TAG$DT_instance = new TAG('DT', 30, 'dt');
    TAG$EM_instance = new TAG('EM', 31, 'em');
    TAG$EMBED_instance = new TAG('EMBED', 32, 'embed');
    TAG$FIELDSET_instance = new TAG('FIELDSET', 33, 'fieldset');
    TAG$FIGCAPTION_instance = new TAG('FIGCAPTION', 34, 'figcaption');
    TAG$FIGURE_instance = new TAG('FIGURE', 35, 'figure');
    TAG$FOOTER_instance = new TAG('FOOTER', 36, 'footer');
    TAG$FORM_instance = new TAG('FORM', 37, 'form');
    TAG$H1_instance = new TAG('H1', 38, 'h1');
    TAG$H2_instance = new TAG('H2', 39, 'h2');
    TAG$H3_instance = new TAG('H3', 40, 'h3');
    TAG$H4_instance = new TAG('H4', 41, 'h4');
    TAG$H5_instance = new TAG('H5', 42, 'h5');
    TAG$H6_instance = new TAG('H6', 43, 'h6');
    TAG$HEAD_instance = new TAG('HEAD', 44, 'head');
    TAG$HEADER_instance = new TAG('HEADER', 45, 'header');
    TAG$HGROUP_instance = new TAG('HGROUP', 46, 'hgroup');
    TAG$HR_instance = new TAG('HR', 47, 'hr');
    TAG$HTML_instance = new TAG('HTML', 48, 'html');
    TAG$I_instance = new TAG('I', 49, 'i');
    TAG$IFRAME_instance = new TAG('IFRAME', 50, 'iframe');
    TAG$IMG_instance = new TAG('IMG', 51, 'img');
    TAG$INPUT_instance = new TAG('INPUT', 52, 'input');
    TAG$INS_instance = new TAG('INS', 53, 'ins');
    TAG$KBD_instance = new TAG('KBD', 54, 'kbd');
    TAG$LABEL_instance = new TAG('LABEL', 55, 'label');
    TAG$LEGEND_instance = new TAG('LEGEND', 56, 'legend');
    TAG$LI_instance = new TAG('LI', 57, 'li');
    TAG$LINK_instance = new TAG('LINK', 58, 'link');
    TAG$MAIN_instance = new TAG('MAIN', 59, 'main');
    TAG$MAP_instance = new TAG('MAP', 60, 'map');
    TAG$MARK_instance = new TAG('MARK', 61, 'mark');
    TAG$MATH_instance = new TAG('MATH', 62, 'math');
    TAG$MENU_instance = new TAG('MENU', 63, 'menu');
    TAG$MENUITEM_instance = new TAG('MENUITEM', 64, 'menuitem');
    TAG$META_instance = new TAG('META', 65, 'meta');
    TAG$METER_instance = new TAG('METER', 66, 'meter');
    TAG$NAV_instance = new TAG('NAV', 67, 'nav');
    TAG$NOSCRIPT_instance = new TAG('NOSCRIPT', 68, 'noscript');
    TAG$OBJECT_instance = new TAG('OBJECT', 69, 'object');
    TAG$OL_instance = new TAG('OL', 70, 'ol');
    TAG$OPTGROUP_instance = new TAG('OPTGROUP', 71, 'optgroup');
    TAG$OPTION_instance = new TAG('OPTION', 72, 'option');
    TAG$OUTPUT_instance = new TAG('OUTPUT', 73, 'output');
    TAG$P_instance = new TAG('P', 74, 'p');
    TAG$PARAM_instance = new TAG('PARAM', 75, 'param');
    TAG$PICTURE_instance = new TAG('PICTURE', 76, 'picture');
    TAG$PRE_instance = new TAG('PRE', 77, 'pre');
    TAG$PROGRESS_instance = new TAG('PROGRESS', 78, 'progress');
    TAG$Q_instance = new TAG('Q', 79, 'q');
    TAG$RB_instance = new TAG('RB', 80, 'rb');
    TAG$RP_instance = new TAG('RP', 81, 'rp');
    TAG$RT_instance = new TAG('RT', 82, 'rt');
    TAG$RTC_instance = new TAG('RTC', 83, 'rtc');
    TAG$RUBY_instance = new TAG('RUBY', 84, 'ruby');
    TAG$S_instance = new TAG('S', 85, 's');
    TAG$SAMP_instance = new TAG('SAMP', 86, 'samp');
    TAG$SCRIPT_instance = new TAG('SCRIPT', 87, 'script');
    TAG$SECTION_instance = new TAG('SECTION', 88, 'section');
    TAG$SELECT_instance = new TAG('SELECT', 89, 'select');
    TAG$SLOT_instance = new TAG('SLOT', 90, 'slot');
    TAG$SMALL_instance = new TAG('SMALL', 91, 'small');
    TAG$SOURCE_instance = new TAG('SOURCE', 92, 'source');
    TAG$SPAN_instance = new TAG('SPAN', 93, 'span');
    TAG$STRONG_instance = new TAG('STRONG', 94, 'strong');
    TAG$STYLE_instance = new TAG('STYLE', 95, 'style');
    TAG$SUB_instance = new TAG('SUB', 96, 'sub');
    TAG$SUMMARY_instance = new TAG('SUMMARY', 97, 'summary');
    TAG$SUP_instance = new TAG('SUP', 98, 'sup');
    TAG$SVG_instance = new TAG('SVG', 99, 'svg');
    TAG$TABLE_instance = new TAG('TABLE', 100, 'table');
    TAG$TBODY_instance = new TAG('TBODY', 101, 'tbody');
    TAG$TD_instance = new TAG('TD', 102, 'td');
    TAG$TEMPLATE_instance = new TAG('TEMPLATE', 103, 'template');
    TAG$TEXTAREA_instance = new TAG('TEXTAREA', 104, 'textarea');
    TAG$TFOOT_instance = new TAG('TFOOT', 105, 'tfoot');
    TAG$TH_instance = new TAG('TH', 106, 'th');
    TAG$THEAD_instance = new TAG('THEAD', 107, 'thead');
    TAG$TIME_instance = new TAG('TIME', 108, 'time');
    TAG$TITLE_instance = new TAG('TITLE', 109, 'title');
    TAG$TR_instance = new TAG('TR', 110, 'tr');
    TAG$TRACK_instance = new TAG('TRACK', 111, 'track');
    TAG$U_instance = new TAG('U', 112, 'u');
    TAG$UL_instance = new TAG('UL', 113, 'ul');
    TAG$VAR_instance = new TAG('VAR', 114, 'var');
    TAG$VIDEO_instance = new TAG('VIDEO', 115, 'video');
    TAG$WBR_instance = new TAG('WBR', 116, 'wbr');
  }
  var TAG$A_instance;
  function TAG$A_getInstance() {
    TAG_initFields();
    return TAG$A_instance;
  }
  var TAG$ABBR_instance;
  function TAG$ABBR_getInstance() {
    TAG_initFields();
    return TAG$ABBR_instance;
  }
  var TAG$ADDRESS_instance;
  function TAG$ADDRESS_getInstance() {
    TAG_initFields();
    return TAG$ADDRESS_instance;
  }
  var TAG$AREA_instance;
  function TAG$AREA_getInstance() {
    TAG_initFields();
    return TAG$AREA_instance;
  }
  var TAG$ARTICLE_instance;
  function TAG$ARTICLE_getInstance() {
    TAG_initFields();
    return TAG$ARTICLE_instance;
  }
  var TAG$ASIDE_instance;
  function TAG$ASIDE_getInstance() {
    TAG_initFields();
    return TAG$ASIDE_instance;
  }
  var TAG$AUDIO_instance;
  function TAG$AUDIO_getInstance() {
    TAG_initFields();
    return TAG$AUDIO_instance;
  }
  var TAG$B_instance;
  function TAG$B_getInstance() {
    TAG_initFields();
    return TAG$B_instance;
  }
  var TAG$BASE_instance;
  function TAG$BASE_getInstance() {
    TAG_initFields();
    return TAG$BASE_instance;
  }
  var TAG$BDI_instance;
  function TAG$BDI_getInstance() {
    TAG_initFields();
    return TAG$BDI_instance;
  }
  var TAG$BDO_instance;
  function TAG$BDO_getInstance() {
    TAG_initFields();
    return TAG$BDO_instance;
  }
  var TAG$BLOCKQUOTE_instance;
  function TAG$BLOCKQUOTE_getInstance() {
    TAG_initFields();
    return TAG$BLOCKQUOTE_instance;
  }
  var TAG$BODY_instance;
  function TAG$BODY_getInstance() {
    TAG_initFields();
    return TAG$BODY_instance;
  }
  var TAG$BR_instance;
  function TAG$BR_getInstance() {
    TAG_initFields();
    return TAG$BR_instance;
  }
  var TAG$BUTTON_instance;
  function TAG$BUTTON_getInstance() {
    TAG_initFields();
    return TAG$BUTTON_instance;
  }
  var TAG$CANVAS_instance;
  function TAG$CANVAS_getInstance() {
    TAG_initFields();
    return TAG$CANVAS_instance;
  }
  var TAG$CAPTION_instance;
  function TAG$CAPTION_getInstance() {
    TAG_initFields();
    return TAG$CAPTION_instance;
  }
  var TAG$CITE_instance;
  function TAG$CITE_getInstance() {
    TAG_initFields();
    return TAG$CITE_instance;
  }
  var TAG$CODE_instance;
  function TAG$CODE_getInstance() {
    TAG_initFields();
    return TAG$CODE_instance;
  }
  var TAG$COL_instance;
  function TAG$COL_getInstance() {
    TAG_initFields();
    return TAG$COL_instance;
  }
  var TAG$COLGROUP_instance;
  function TAG$COLGROUP_getInstance() {
    TAG_initFields();
    return TAG$COLGROUP_instance;
  }
  var TAG$DATA_instance;
  function TAG$DATA_getInstance() {
    TAG_initFields();
    return TAG$DATA_instance;
  }
  var TAG$DATALIST_instance;
  function TAG$DATALIST_getInstance() {
    TAG_initFields();
    return TAG$DATALIST_instance;
  }
  var TAG$DD_instance;
  function TAG$DD_getInstance() {
    TAG_initFields();
    return TAG$DD_instance;
  }
  var TAG$DEL_instance;
  function TAG$DEL_getInstance() {
    TAG_initFields();
    return TAG$DEL_instance;
  }
  var TAG$DETAILS_instance;
  function TAG$DETAILS_getInstance() {
    TAG_initFields();
    return TAG$DETAILS_instance;
  }
  var TAG$DFN_instance;
  function TAG$DFN_getInstance() {
    TAG_initFields();
    return TAG$DFN_instance;
  }
  var TAG$DIALOG_instance;
  function TAG$DIALOG_getInstance() {
    TAG_initFields();
    return TAG$DIALOG_instance;
  }
  var TAG$DIV_instance;
  function TAG$DIV_getInstance() {
    TAG_initFields();
    return TAG$DIV_instance;
  }
  var TAG$DL_instance;
  function TAG$DL_getInstance() {
    TAG_initFields();
    return TAG$DL_instance;
  }
  var TAG$DT_instance;
  function TAG$DT_getInstance() {
    TAG_initFields();
    return TAG$DT_instance;
  }
  var TAG$EM_instance;
  function TAG$EM_getInstance() {
    TAG_initFields();
    return TAG$EM_instance;
  }
  var TAG$EMBED_instance;
  function TAG$EMBED_getInstance() {
    TAG_initFields();
    return TAG$EMBED_instance;
  }
  var TAG$FIELDSET_instance;
  function TAG$FIELDSET_getInstance() {
    TAG_initFields();
    return TAG$FIELDSET_instance;
  }
  var TAG$FIGCAPTION_instance;
  function TAG$FIGCAPTION_getInstance() {
    TAG_initFields();
    return TAG$FIGCAPTION_instance;
  }
  var TAG$FIGURE_instance;
  function TAG$FIGURE_getInstance() {
    TAG_initFields();
    return TAG$FIGURE_instance;
  }
  var TAG$FOOTER_instance;
  function TAG$FOOTER_getInstance() {
    TAG_initFields();
    return TAG$FOOTER_instance;
  }
  var TAG$FORM_instance;
  function TAG$FORM_getInstance() {
    TAG_initFields();
    return TAG$FORM_instance;
  }
  var TAG$H1_instance;
  function TAG$H1_getInstance() {
    TAG_initFields();
    return TAG$H1_instance;
  }
  var TAG$H2_instance;
  function TAG$H2_getInstance() {
    TAG_initFields();
    return TAG$H2_instance;
  }
  var TAG$H3_instance;
  function TAG$H3_getInstance() {
    TAG_initFields();
    return TAG$H3_instance;
  }
  var TAG$H4_instance;
  function TAG$H4_getInstance() {
    TAG_initFields();
    return TAG$H4_instance;
  }
  var TAG$H5_instance;
  function TAG$H5_getInstance() {
    TAG_initFields();
    return TAG$H5_instance;
  }
  var TAG$H6_instance;
  function TAG$H6_getInstance() {
    TAG_initFields();
    return TAG$H6_instance;
  }
  var TAG$HEAD_instance;
  function TAG$HEAD_getInstance() {
    TAG_initFields();
    return TAG$HEAD_instance;
  }
  var TAG$HEADER_instance;
  function TAG$HEADER_getInstance() {
    TAG_initFields();
    return TAG$HEADER_instance;
  }
  var TAG$HGROUP_instance;
  function TAG$HGROUP_getInstance() {
    TAG_initFields();
    return TAG$HGROUP_instance;
  }
  var TAG$HR_instance;
  function TAG$HR_getInstance() {
    TAG_initFields();
    return TAG$HR_instance;
  }
  var TAG$HTML_instance;
  function TAG$HTML_getInstance() {
    TAG_initFields();
    return TAG$HTML_instance;
  }
  var TAG$I_instance;
  function TAG$I_getInstance() {
    TAG_initFields();
    return TAG$I_instance;
  }
  var TAG$IFRAME_instance;
  function TAG$IFRAME_getInstance() {
    TAG_initFields();
    return TAG$IFRAME_instance;
  }
  var TAG$IMG_instance;
  function TAG$IMG_getInstance() {
    TAG_initFields();
    return TAG$IMG_instance;
  }
  var TAG$INPUT_instance;
  function TAG$INPUT_getInstance() {
    TAG_initFields();
    return TAG$INPUT_instance;
  }
  var TAG$INS_instance;
  function TAG$INS_getInstance() {
    TAG_initFields();
    return TAG$INS_instance;
  }
  var TAG$KBD_instance;
  function TAG$KBD_getInstance() {
    TAG_initFields();
    return TAG$KBD_instance;
  }
  var TAG$LABEL_instance;
  function TAG$LABEL_getInstance() {
    TAG_initFields();
    return TAG$LABEL_instance;
  }
  var TAG$LEGEND_instance;
  function TAG$LEGEND_getInstance() {
    TAG_initFields();
    return TAG$LEGEND_instance;
  }
  var TAG$LI_instance;
  function TAG$LI_getInstance() {
    TAG_initFields();
    return TAG$LI_instance;
  }
  var TAG$LINK_instance;
  function TAG$LINK_getInstance() {
    TAG_initFields();
    return TAG$LINK_instance;
  }
  var TAG$MAIN_instance;
  function TAG$MAIN_getInstance() {
    TAG_initFields();
    return TAG$MAIN_instance;
  }
  var TAG$MAP_instance;
  function TAG$MAP_getInstance() {
    TAG_initFields();
    return TAG$MAP_instance;
  }
  var TAG$MARK_instance;
  function TAG$MARK_getInstance() {
    TAG_initFields();
    return TAG$MARK_instance;
  }
  var TAG$MATH_instance;
  function TAG$MATH_getInstance() {
    TAG_initFields();
    return TAG$MATH_instance;
  }
  var TAG$MENU_instance;
  function TAG$MENU_getInstance() {
    TAG_initFields();
    return TAG$MENU_instance;
  }
  var TAG$MENUITEM_instance;
  function TAG$MENUITEM_getInstance() {
    TAG_initFields();
    return TAG$MENUITEM_instance;
  }
  var TAG$META_instance;
  function TAG$META_getInstance() {
    TAG_initFields();
    return TAG$META_instance;
  }
  var TAG$METER_instance;
  function TAG$METER_getInstance() {
    TAG_initFields();
    return TAG$METER_instance;
  }
  var TAG$NAV_instance;
  function TAG$NAV_getInstance() {
    TAG_initFields();
    return TAG$NAV_instance;
  }
  var TAG$NOSCRIPT_instance;
  function TAG$NOSCRIPT_getInstance() {
    TAG_initFields();
    return TAG$NOSCRIPT_instance;
  }
  var TAG$OBJECT_instance;
  function TAG$OBJECT_getInstance() {
    TAG_initFields();
    return TAG$OBJECT_instance;
  }
  var TAG$OL_instance;
  function TAG$OL_getInstance() {
    TAG_initFields();
    return TAG$OL_instance;
  }
  var TAG$OPTGROUP_instance;
  function TAG$OPTGROUP_getInstance() {
    TAG_initFields();
    return TAG$OPTGROUP_instance;
  }
  var TAG$OPTION_instance;
  function TAG$OPTION_getInstance() {
    TAG_initFields();
    return TAG$OPTION_instance;
  }
  var TAG$OUTPUT_instance;
  function TAG$OUTPUT_getInstance() {
    TAG_initFields();
    return TAG$OUTPUT_instance;
  }
  var TAG$P_instance;
  function TAG$P_getInstance() {
    TAG_initFields();
    return TAG$P_instance;
  }
  var TAG$PARAM_instance;
  function TAG$PARAM_getInstance() {
    TAG_initFields();
    return TAG$PARAM_instance;
  }
  var TAG$PICTURE_instance;
  function TAG$PICTURE_getInstance() {
    TAG_initFields();
    return TAG$PICTURE_instance;
  }
  var TAG$PRE_instance;
  function TAG$PRE_getInstance() {
    TAG_initFields();
    return TAG$PRE_instance;
  }
  var TAG$PROGRESS_instance;
  function TAG$PROGRESS_getInstance() {
    TAG_initFields();
    return TAG$PROGRESS_instance;
  }
  var TAG$Q_instance;
  function TAG$Q_getInstance() {
    TAG_initFields();
    return TAG$Q_instance;
  }
  var TAG$RB_instance;
  function TAG$RB_getInstance() {
    TAG_initFields();
    return TAG$RB_instance;
  }
  var TAG$RP_instance;
  function TAG$RP_getInstance() {
    TAG_initFields();
    return TAG$RP_instance;
  }
  var TAG$RT_instance;
  function TAG$RT_getInstance() {
    TAG_initFields();
    return TAG$RT_instance;
  }
  var TAG$RTC_instance;
  function TAG$RTC_getInstance() {
    TAG_initFields();
    return TAG$RTC_instance;
  }
  var TAG$RUBY_instance;
  function TAG$RUBY_getInstance() {
    TAG_initFields();
    return TAG$RUBY_instance;
  }
  var TAG$S_instance;
  function TAG$S_getInstance() {
    TAG_initFields();
    return TAG$S_instance;
  }
  var TAG$SAMP_instance;
  function TAG$SAMP_getInstance() {
    TAG_initFields();
    return TAG$SAMP_instance;
  }
  var TAG$SCRIPT_instance;
  function TAG$SCRIPT_getInstance() {
    TAG_initFields();
    return TAG$SCRIPT_instance;
  }
  var TAG$SECTION_instance;
  function TAG$SECTION_getInstance() {
    TAG_initFields();
    return TAG$SECTION_instance;
  }
  var TAG$SELECT_instance;
  function TAG$SELECT_getInstance() {
    TAG_initFields();
    return TAG$SELECT_instance;
  }
  var TAG$SLOT_instance;
  function TAG$SLOT_getInstance() {
    TAG_initFields();
    return TAG$SLOT_instance;
  }
  var TAG$SMALL_instance;
  function TAG$SMALL_getInstance() {
    TAG_initFields();
    return TAG$SMALL_instance;
  }
  var TAG$SOURCE_instance;
  function TAG$SOURCE_getInstance() {
    TAG_initFields();
    return TAG$SOURCE_instance;
  }
  var TAG$SPAN_instance;
  function TAG$SPAN_getInstance() {
    TAG_initFields();
    return TAG$SPAN_instance;
  }
  var TAG$STRONG_instance;
  function TAG$STRONG_getInstance() {
    TAG_initFields();
    return TAG$STRONG_instance;
  }
  var TAG$STYLE_instance;
  function TAG$STYLE_getInstance() {
    TAG_initFields();
    return TAG$STYLE_instance;
  }
  var TAG$SUB_instance;
  function TAG$SUB_getInstance() {
    TAG_initFields();
    return TAG$SUB_instance;
  }
  var TAG$SUMMARY_instance;
  function TAG$SUMMARY_getInstance() {
    TAG_initFields();
    return TAG$SUMMARY_instance;
  }
  var TAG$SUP_instance;
  function TAG$SUP_getInstance() {
    TAG_initFields();
    return TAG$SUP_instance;
  }
  var TAG$SVG_instance;
  function TAG$SVG_getInstance() {
    TAG_initFields();
    return TAG$SVG_instance;
  }
  var TAG$TABLE_instance;
  function TAG$TABLE_getInstance() {
    TAG_initFields();
    return TAG$TABLE_instance;
  }
  var TAG$TBODY_instance;
  function TAG$TBODY_getInstance() {
    TAG_initFields();
    return TAG$TBODY_instance;
  }
  var TAG$TD_instance;
  function TAG$TD_getInstance() {
    TAG_initFields();
    return TAG$TD_instance;
  }
  var TAG$TEMPLATE_instance;
  function TAG$TEMPLATE_getInstance() {
    TAG_initFields();
    return TAG$TEMPLATE_instance;
  }
  var TAG$TEXTAREA_instance;
  function TAG$TEXTAREA_getInstance() {
    TAG_initFields();
    return TAG$TEXTAREA_instance;
  }
  var TAG$TFOOT_instance;
  function TAG$TFOOT_getInstance() {
    TAG_initFields();
    return TAG$TFOOT_instance;
  }
  var TAG$TH_instance;
  function TAG$TH_getInstance() {
    TAG_initFields();
    return TAG$TH_instance;
  }
  var TAG$THEAD_instance;
  function TAG$THEAD_getInstance() {
    TAG_initFields();
    return TAG$THEAD_instance;
  }
  var TAG$TIME_instance;
  function TAG$TIME_getInstance() {
    TAG_initFields();
    return TAG$TIME_instance;
  }
  var TAG$TITLE_instance;
  function TAG$TITLE_getInstance() {
    TAG_initFields();
    return TAG$TITLE_instance;
  }
  var TAG$TR_instance;
  function TAG$TR_getInstance() {
    TAG_initFields();
    return TAG$TR_instance;
  }
  var TAG$TRACK_instance;
  function TAG$TRACK_getInstance() {
    TAG_initFields();
    return TAG$TRACK_instance;
  }
  var TAG$U_instance;
  function TAG$U_getInstance() {
    TAG_initFields();
    return TAG$U_instance;
  }
  var TAG$UL_instance;
  function TAG$UL_getInstance() {
    TAG_initFields();
    return TAG$UL_instance;
  }
  var TAG$VAR_instance;
  function TAG$VAR_getInstance() {
    TAG_initFields();
    return TAG$VAR_instance;
  }
  var TAG$VIDEO_instance;
  function TAG$VIDEO_getInstance() {
    TAG_initFields();
    return TAG$VIDEO_instance;
  }
  var TAG$WBR_instance;
  function TAG$WBR_getInstance() {
    TAG_initFields();
    return TAG$WBR_instance;
  }
  TAG.$metadata$ = {kind: Kind_CLASS, simpleName: 'TAG', interfaces: [Enum]};
  function TAG$values() {
    return [TAG$A_getInstance(), TAG$ABBR_getInstance(), TAG$ADDRESS_getInstance(), TAG$AREA_getInstance(), TAG$ARTICLE_getInstance(), TAG$ASIDE_getInstance(), TAG$AUDIO_getInstance(), TAG$B_getInstance(), TAG$BASE_getInstance(), TAG$BDI_getInstance(), TAG$BDO_getInstance(), TAG$BLOCKQUOTE_getInstance(), TAG$BODY_getInstance(), TAG$BR_getInstance(), TAG$BUTTON_getInstance(), TAG$CANVAS_getInstance(), TAG$CAPTION_getInstance(), TAG$CITE_getInstance(), TAG$CODE_getInstance(), TAG$COL_getInstance(), TAG$COLGROUP_getInstance(), TAG$DATA_getInstance(), TAG$DATALIST_getInstance(), TAG$DD_getInstance(), TAG$DEL_getInstance(), TAG$DETAILS_getInstance(), TAG$DFN_getInstance(), TAG$DIALOG_getInstance(), TAG$DIV_getInstance(), TAG$DL_getInstance(), TAG$DT_getInstance(), TAG$EM_getInstance(), TAG$EMBED_getInstance(), TAG$FIELDSET_getInstance(), TAG$FIGCAPTION_getInstance(), TAG$FIGURE_getInstance(), TAG$FOOTER_getInstance(), TAG$FORM_getInstance(), TAG$H1_getInstance(), TAG$H2_getInstance(), TAG$H3_getInstance(), TAG$H4_getInstance(), TAG$H5_getInstance(), TAG$H6_getInstance(), TAG$HEAD_getInstance(), TAG$HEADER_getInstance(), TAG$HGROUP_getInstance(), TAG$HR_getInstance(), TAG$HTML_getInstance(), TAG$I_getInstance(), TAG$IFRAME_getInstance(), TAG$IMG_getInstance(), TAG$INPUT_getInstance(), TAG$INS_getInstance(), TAG$KBD_getInstance(), TAG$LABEL_getInstance(), TAG$LEGEND_getInstance(), TAG$LI_getInstance(), TAG$LINK_getInstance(), TAG$MAIN_getInstance(), TAG$MAP_getInstance(), TAG$MARK_getInstance(), TAG$MATH_getInstance(), TAG$MENU_getInstance(), TAG$MENUITEM_getInstance(), TAG$META_getInstance(), TAG$METER_getInstance(), TAG$NAV_getInstance(), TAG$NOSCRIPT_getInstance(), TAG$OBJECT_getInstance(), TAG$OL_getInstance(), TAG$OPTGROUP_getInstance(), TAG$OPTION_getInstance(), TAG$OUTPUT_getInstance(), TAG$P_getInstance(), TAG$PARAM_getInstance(), TAG$PICTURE_getInstance(), TAG$PRE_getInstance(), TAG$PROGRESS_getInstance(), TAG$Q_getInstance(), TAG$RB_getInstance(), TAG$RP_getInstance(), TAG$RT_getInstance(), TAG$RTC_getInstance(), TAG$RUBY_getInstance(), TAG$S_getInstance(), TAG$SAMP_getInstance(), TAG$SCRIPT_getInstance(), TAG$SECTION_getInstance(), TAG$SELECT_getInstance(), TAG$SLOT_getInstance(), TAG$SMALL_getInstance(), TAG$SOURCE_getInstance(), TAG$SPAN_getInstance(), TAG$STRONG_getInstance(), TAG$STYLE_getInstance(), TAG$SUB_getInstance(), TAG$SUMMARY_getInstance(), TAG$SUP_getInstance(), TAG$SVG_getInstance(), TAG$TABLE_getInstance(), TAG$TBODY_getInstance(), TAG$TD_getInstance(), TAG$TEMPLATE_getInstance(), TAG$TEXTAREA_getInstance(), TAG$TFOOT_getInstance(), TAG$TH_getInstance(), TAG$THEAD_getInstance(), TAG$TIME_getInstance(), TAG$TITLE_getInstance(), TAG$TR_getInstance(), TAG$TRACK_getInstance(), TAG$U_getInstance(), TAG$UL_getInstance(), TAG$VAR_getInstance(), TAG$VIDEO_getInstance(), TAG$WBR_getInstance()];
  }
  TAG.values = TAG$values;
  function TAG$valueOf(name) {
    switch (name) {
      case 'A':
        return TAG$A_getInstance();
      case 'ABBR':
        return TAG$ABBR_getInstance();
      case 'ADDRESS':
        return TAG$ADDRESS_getInstance();
      case 'AREA':
        return TAG$AREA_getInstance();
      case 'ARTICLE':
        return TAG$ARTICLE_getInstance();
      case 'ASIDE':
        return TAG$ASIDE_getInstance();
      case 'AUDIO':
        return TAG$AUDIO_getInstance();
      case 'B':
        return TAG$B_getInstance();
      case 'BASE':
        return TAG$BASE_getInstance();
      case 'BDI':
        return TAG$BDI_getInstance();
      case 'BDO':
        return TAG$BDO_getInstance();
      case 'BLOCKQUOTE':
        return TAG$BLOCKQUOTE_getInstance();
      case 'BODY':
        return TAG$BODY_getInstance();
      case 'BR':
        return TAG$BR_getInstance();
      case 'BUTTON':
        return TAG$BUTTON_getInstance();
      case 'CANVAS':
        return TAG$CANVAS_getInstance();
      case 'CAPTION':
        return TAG$CAPTION_getInstance();
      case 'CITE':
        return TAG$CITE_getInstance();
      case 'CODE':
        return TAG$CODE_getInstance();
      case 'COL':
        return TAG$COL_getInstance();
      case 'COLGROUP':
        return TAG$COLGROUP_getInstance();
      case 'DATA':
        return TAG$DATA_getInstance();
      case 'DATALIST':
        return TAG$DATALIST_getInstance();
      case 'DD':
        return TAG$DD_getInstance();
      case 'DEL':
        return TAG$DEL_getInstance();
      case 'DETAILS':
        return TAG$DETAILS_getInstance();
      case 'DFN':
        return TAG$DFN_getInstance();
      case 'DIALOG':
        return TAG$DIALOG_getInstance();
      case 'DIV':
        return TAG$DIV_getInstance();
      case 'DL':
        return TAG$DL_getInstance();
      case 'DT':
        return TAG$DT_getInstance();
      case 'EM':
        return TAG$EM_getInstance();
      case 'EMBED':
        return TAG$EMBED_getInstance();
      case 'FIELDSET':
        return TAG$FIELDSET_getInstance();
      case 'FIGCAPTION':
        return TAG$FIGCAPTION_getInstance();
      case 'FIGURE':
        return TAG$FIGURE_getInstance();
      case 'FOOTER':
        return TAG$FOOTER_getInstance();
      case 'FORM':
        return TAG$FORM_getInstance();
      case 'H1':
        return TAG$H1_getInstance();
      case 'H2':
        return TAG$H2_getInstance();
      case 'H3':
        return TAG$H3_getInstance();
      case 'H4':
        return TAG$H4_getInstance();
      case 'H5':
        return TAG$H5_getInstance();
      case 'H6':
        return TAG$H6_getInstance();
      case 'HEAD':
        return TAG$HEAD_getInstance();
      case 'HEADER':
        return TAG$HEADER_getInstance();
      case 'HGROUP':
        return TAG$HGROUP_getInstance();
      case 'HR':
        return TAG$HR_getInstance();
      case 'HTML':
        return TAG$HTML_getInstance();
      case 'I':
        return TAG$I_getInstance();
      case 'IFRAME':
        return TAG$IFRAME_getInstance();
      case 'IMG':
        return TAG$IMG_getInstance();
      case 'INPUT':
        return TAG$INPUT_getInstance();
      case 'INS':
        return TAG$INS_getInstance();
      case 'KBD':
        return TAG$KBD_getInstance();
      case 'LABEL':
        return TAG$LABEL_getInstance();
      case 'LEGEND':
        return TAG$LEGEND_getInstance();
      case 'LI':
        return TAG$LI_getInstance();
      case 'LINK':
        return TAG$LINK_getInstance();
      case 'MAIN':
        return TAG$MAIN_getInstance();
      case 'MAP':
        return TAG$MAP_getInstance();
      case 'MARK':
        return TAG$MARK_getInstance();
      case 'MATH':
        return TAG$MATH_getInstance();
      case 'MENU':
        return TAG$MENU_getInstance();
      case 'MENUITEM':
        return TAG$MENUITEM_getInstance();
      case 'META':
        return TAG$META_getInstance();
      case 'METER':
        return TAG$METER_getInstance();
      case 'NAV':
        return TAG$NAV_getInstance();
      case 'NOSCRIPT':
        return TAG$NOSCRIPT_getInstance();
      case 'OBJECT':
        return TAG$OBJECT_getInstance();
      case 'OL':
        return TAG$OL_getInstance();
      case 'OPTGROUP':
        return TAG$OPTGROUP_getInstance();
      case 'OPTION':
        return TAG$OPTION_getInstance();
      case 'OUTPUT':
        return TAG$OUTPUT_getInstance();
      case 'P':
        return TAG$P_getInstance();
      case 'PARAM':
        return TAG$PARAM_getInstance();
      case 'PICTURE':
        return TAG$PICTURE_getInstance();
      case 'PRE':
        return TAG$PRE_getInstance();
      case 'PROGRESS':
        return TAG$PROGRESS_getInstance();
      case 'Q':
        return TAG$Q_getInstance();
      case 'RB':
        return TAG$RB_getInstance();
      case 'RP':
        return TAG$RP_getInstance();
      case 'RT':
        return TAG$RT_getInstance();
      case 'RTC':
        return TAG$RTC_getInstance();
      case 'RUBY':
        return TAG$RUBY_getInstance();
      case 'S':
        return TAG$S_getInstance();
      case 'SAMP':
        return TAG$SAMP_getInstance();
      case 'SCRIPT':
        return TAG$SCRIPT_getInstance();
      case 'SECTION':
        return TAG$SECTION_getInstance();
      case 'SELECT':
        return TAG$SELECT_getInstance();
      case 'SLOT':
        return TAG$SLOT_getInstance();
      case 'SMALL':
        return TAG$SMALL_getInstance();
      case 'SOURCE':
        return TAG$SOURCE_getInstance();
      case 'SPAN':
        return TAG$SPAN_getInstance();
      case 'STRONG':
        return TAG$STRONG_getInstance();
      case 'STYLE':
        return TAG$STYLE_getInstance();
      case 'SUB':
        return TAG$SUB_getInstance();
      case 'SUMMARY':
        return TAG$SUMMARY_getInstance();
      case 'SUP':
        return TAG$SUP_getInstance();
      case 'SVG':
        return TAG$SVG_getInstance();
      case 'TABLE':
        return TAG$TABLE_getInstance();
      case 'TBODY':
        return TAG$TBODY_getInstance();
      case 'TD':
        return TAG$TD_getInstance();
      case 'TEMPLATE':
        return TAG$TEMPLATE_getInstance();
      case 'TEXTAREA':
        return TAG$TEXTAREA_getInstance();
      case 'TFOOT':
        return TAG$TFOOT_getInstance();
      case 'TH':
        return TAG$TH_getInstance();
      case 'THEAD':
        return TAG$THEAD_getInstance();
      case 'TIME':
        return TAG$TIME_getInstance();
      case 'TITLE':
        return TAG$TITLE_getInstance();
      case 'TR':
        return TAG$TR_getInstance();
      case 'TRACK':
        return TAG$TRACK_getInstance();
      case 'U':
        return TAG$U_getInstance();
      case 'UL':
        return TAG$UL_getInstance();
      case 'VAR':
        return TAG$VAR_getInstance();
      case 'VIDEO':
        return TAG$VIDEO_getInstance();
      case 'WBR':
        return TAG$WBR_getInstance();
      default:throwISE('No enum constant io.kvision.html.TAG.' + name);
    }
  }
  TAG.valueOf_61zpoe$ = TAG$valueOf;
  var Align$LEFT_instance;
  var Align$CENTER_instance;
  var Align$RIGHT_instance;
  var Align$JUSTIFY_instance;
  var Align$NOWRAP_instance;
  function Tag(type, content, rich, align, className, attributes, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (attributes === void 0)
      attributes = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.type_pp0fgs$_0 = (new Widget$RefreshDelegateProvider(this, type, Widget$refreshOnUpdate$lambda_34(this))).provideDelegate_n5byny$(this, Tag$type_metadata);
    this.content_p6xodn$_0 = (new Widget$RefreshDelegateProvider(this, content, Widget$refreshOnUpdate$lambda_34(this))).provideDelegate_n5byny$(this, Tag$content_metadata);
    this.rich_pnmcx6$_0 = (new Widget$RefreshDelegateProvider(this, rich, Widget$refreshOnUpdate$lambda_34(this))).provideDelegate_n5byny$(this, Tag$rich_metadata);
    this.align_6006dl$_0 = (new Widget$RefreshDelegateProvider(this, align, Widget$refreshOnUpdate$lambda_34(this))).provideDelegate_n5byny$(this, Tag$align_metadata);
    this.templateDataObj_lqqjuj$_0 = null;
    this.template_v5mdpw$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_35(this))).provideDelegate_n5byny$(this, Tag$template_metadata);
    this.templates_slazrp$_0 = (new Widget$RefreshDelegateProvider(this, emptyMap(), Widget$refreshOnUpdate$lambda_34(this))).provideDelegate_n5byny$(this, Tag$templates_metadata);
    if (attributes != null) {
      if (this.attributes_8be2vx$ == null) {
        this.attributes_8be2vx$ = LinkedHashMap_init();
      }var $receiver = ensureNotNull(this.attributes_8be2vx$);
      var map = attributes;
      $receiver.putAll_a2k3zr$(map);
    }init != null ? init(this) : null;
  }
  var Tag$type_metadata = new PropertyMetadata('type');
  Object.defineProperty(Tag.prototype, 'type', {configurable: true, get: function () {
    return this.type_pp0fgs$_0.getValue_fmbzy8$(this, Tag$type_metadata);
  }, set: function (type) {
    this.type_pp0fgs$_0.setValue_19qrsr$(this, Tag$type_metadata, type);
  }});
  var Tag$content_metadata = new PropertyMetadata('content');
  Object.defineProperty(Tag.prototype, 'content', {configurable: true, get: function () {
    return this.content_p6xodn$_0.getValue_fmbzy8$(this, Tag$content_metadata);
  }, set: function (content) {
    this.content_p6xodn$_0.setValue_19qrsr$(this, Tag$content_metadata, content);
  }});
  var Tag$rich_metadata = new PropertyMetadata('rich');
  Object.defineProperty(Tag.prototype, 'rich', {configurable: true, get: function () {
    return this.rich_pnmcx6$_0.getValue_fmbzy8$(this, Tag$rich_metadata);
  }, set: function (rich) {
    this.rich_pnmcx6$_0.setValue_19qrsr$(this, Tag$rich_metadata, rich);
  }});
  var Tag$align_metadata = new PropertyMetadata('align');
  Object.defineProperty(Tag.prototype, 'align', {configurable: true, get: function () {
    return this.align_6006dl$_0.getValue_fmbzy8$(this, Tag$align_metadata);
  }, set: function (align) {
    this.align_6006dl$_0.setValue_19qrsr$(this, Tag$align_metadata, align);
  }});
  Object.defineProperty(Tag.prototype, 'templateDataObj', {configurable: true, get: function () {
    return this.templateDataObj_lqqjuj$_0;
  }, set: function (templateDataObj) {
    this.templateDataObj_lqqjuj$_0 = templateDataObj;
  }});
  var Tag$template_metadata = new PropertyMetadata('template');
  Object.defineProperty(Tag.prototype, 'template', {configurable: true, get: function () {
    return this.template_v5mdpw$_0.getValue_fmbzy8$(this, Tag$template_metadata);
  }, set: function (template) {
    this.template_v5mdpw$_0.setValue_19qrsr$(this, Tag$template_metadata, template);
  }});
  var Tag$templates_metadata = new PropertyMetadata('templates');
  Object.defineProperty(Tag.prototype, 'templates', {configurable: true, get: function () {
    return this.templates_slazrp$_0.getValue_fmbzy8$(this, Tag$templates_metadata);
  }, set: function (templates) {
    this.templates_slazrp$_0.setValue_19qrsr$(this, Tag$templates_metadata, templates);
  }});
  Tag.prototype.render = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (this.templateDataObj != null && this.lastLanguage != null && !equals(this.lastLanguage, I18n_getInstance().language)) {
      if ((tmp$ = this.getRoot()) != null) {
        tmp$.singleRenderers_8be2vx$ = tmp$.singleRenderers_8be2vx$ + 1 | 0;
      }this.templateData = this.templateDataObj;
      if ((tmp$_0 = this.getRoot()) != null) {
        tmp$_0.singleRenderers_8be2vx$ = tmp$_0.singleRenderers_8be2vx$ - 1 | 0;
      }}if (this.content != null) {
      var translatedContent = (tmp$_1 = this.content) != null ? this.translate_61zpoe$(tmp$_1) : null;
      if (this.rich) {
        var tmp$_3 = this.type.tagName_8be2vx$;
        var $receiver = [KVManager_getInstance().virtualize_61zpoe$('<span style=' + '"' + 'display: contents;' + '"' + '>' + toString_0(translatedContent) + '<\/span>')];
        var elements = this.childrenVNodes();
        tmp$_2 = this.render_pjwf99$(tmp$_3, $receiver.concat(elements));
      } else {
        var tmp$_4 = this.type.tagName_8be2vx$;
        var $receiver_0 = this.childrenVNodes();
        var elements_0 = [translatedContent];
        tmp$_2 = this.render_pjwf99$(tmp$_4, $receiver_0.concat(elements_0));
      }
    } else {
      tmp$_2 = this.render_pjwf99$(this.type.tagName_8be2vx$, this.childrenVNodes());
    }
    return tmp$_2;
  };
  Tag.prototype.focus = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2;
    if (equals((tmp$_0 = (tmp$ = this.getElement()) != null ? tmp$ : null) != null ? tmp$_0.getAttribute('tabindex') : null, undefined)) {
      (tmp$_2 = (tmp$_1 = this.getElement()) != null ? tmp$_1 : null) != null ? (tmp$_2.setAttribute('tabindex', '-1'), Unit) : null;
    }SimplePanel.prototype.focus.call(this);
  };
  Tag.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    classSetBuilder.add_vqcfem$(this.align);
  };
  Tag.prototype.unaryPlus_pdl1vz$ = function ($receiver) {
    this.add_87eobz$(new TextNode($receiver, this.rich));
  };
  Tag.$metadata$ = {kind: Kind_CLASS, simpleName: 'Tag', interfaces: [Template, SimplePanel]};
  function tag($receiver, type, content, rich, align, className, attributes, init) {
    if (content === void 0)
      content = null;
    if (rich === void 0)
      rich = false;
    if (align === void 0)
      align = null;
    if (className === void 0)
      className = null;
    if (attributes === void 0)
      attributes = null;
    if (init === void 0)
      init = null;
    var tag = new Tag(type, content, rich, align, className, attributes, init);
    $receiver.add_87eobz$(tag);
    return tag;
  }
  function Template() {
  }
  Object.defineProperty(Template.prototype, 'templateData', {configurable: true, get: function () {
    return this.templateDataObj;
  }, set: function (value) {
    var tmp$, tmp$_0, tmp$_1;
    if (!this.rich)
      this.rich = true;
    this.templateDataObj = value;
    this.content = (tmp$_1 = (tmp$ = this.template) != null ? tmp$(value) : null) != null ? tmp$_1 : (tmp$_0 = this.templates.get_11rb$(I18n_getInstance().language)) != null ? tmp$_0(value) : null;
  }});
  Template.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'Template', interfaces: []};
  function Widget$refreshOnUpdate$lambda_36(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function TextNode(content, rich, init) {
    if (rich === void 0)
      rich = false;
    if (init === void 0)
      init = null;
    Widget.call(this);
    this.content_uig00$_0 = (new Widget$RefreshDelegateProvider(this, content, Widget$refreshOnUpdate$lambda_36(this))).provideDelegate_n5byny$(this, TextNode$content_metadata);
    this.rich_w1n42p$_0 = (new Widget$RefreshDelegateProvider(this, rich, Widget$refreshOnUpdate$lambda_36(this))).provideDelegate_n5byny$(this, TextNode$rich_metadata);
    init != null ? init(this) : null;
  }
  var TextNode$content_metadata = new PropertyMetadata('content');
  Object.defineProperty(TextNode.prototype, 'content', {configurable: true, get: function () {
    return this.content_uig00$_0.getValue_fmbzy8$(this, TextNode$content_metadata);
  }, set: function (content) {
    this.content_uig00$_0.setValue_19qrsr$(this, TextNode$content_metadata, content);
  }});
  var TextNode$rich_metadata = new PropertyMetadata('rich');
  Object.defineProperty(TextNode.prototype, 'rich', {configurable: true, get: function () {
    return this.rich_w1n42p$_0.getValue_fmbzy8$(this, TextNode$rich_metadata);
  }, set: function (rich) {
    this.rich_w1n42p$_0.setValue_19qrsr$(this, TextNode$rich_metadata, rich);
  }});
  TextNode.prototype.render = function () {
    var tmp$;
    var translatedContent = this.translate_61zpoe$(this.content);
    if (this.rich) {
      tmp$ = KVManager_getInstance().virtualize_61zpoe$('<span style=' + '"' + 'display: contents;' + '"' + '>' + translatedContent + '<\/span>');
    } else {
      tmp$ = translatedContent;
    }
    return tmp$;
  };
  TextNode.$metadata$ = {kind: Kind_CLASS, simpleName: 'TextNode', interfaces: [Widget]};
  var Time$datetime_metadata = new PropertyMetadata('datetime');
  function Ul(elements, rich, className, init) {
    if (elements === void 0)
      elements = null;
    if (rich === void 0)
      rich = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    ListTag.call(this, ListType$UL_getInstance(), elements, rich, className);
    init != null ? init(this) : null;
  }
  Ul.$metadata$ = {kind: Kind_CLASS, simpleName: 'Ul', interfaces: [ListTag]};
  function ul($receiver, elements, rich, className, init) {
    if (elements === void 0)
      elements = null;
    if (rich === void 0)
      rich = false;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var ul = new Ul(elements, rich, className, init);
    $receiver.add_87eobz$(ul);
    return ul;
  }
  function I18n() {
    I18n_instance = this;
    this.manager = new SimpleI18nManager();
    this.defaultLanguage_0 = split_0(window.navigator.language, ['-']).get_za3lpa$(0);
    this.language_asxknz$_0 = this.defaultLanguage_0;
  }
  Object.defineProperty(I18n.prototype, 'language', {configurable: true, get: function () {
    return this.language_asxknz$_0;
  }, set: function (value) {
    this.language_asxknz$_0 = value;
    var tmp$;
    tmp$ = Root$Companion_getInstance().roots_8be2vx$.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.restart_8be2vx$();
    }
  }});
  I18n.prototype.gettext_25kzsl$ = function (key, args) {
    return this.manager.gettext_25kzsl$(key, args.slice());
  };
  I18n.prototype.ngettext_hjhpvv$ = function (singularKey, pluralKey, value, args) {
    return this.manager.ngettext_hjhpvv$(singularKey, pluralKey, value, args.slice());
  };
  I18n.prototype.detectDecimalSeparator = function () {
    var tmp$;
    try {
      tmp$ = String.fromCharCode(last_0(dropLast((1.1).toLocaleString(this.language), 1)));
    } catch (e) {
      if (Kotlin.isType(e, Exception)) {
        tmp$ = '.';
      } else
        throw e;
    }
    return tmp$;
  };
  I18n.$metadata$ = {kind: Kind_OBJECT, simpleName: 'I18n', interfaces: [I18nManager]};
  var I18n_instance = null;
  function I18n_getInstance() {
    if (I18n_instance === null) {
      new I18n();
    }return I18n_instance;
  }
  function tr_0(key) {
    return I18n_getInstance().tr_61zpoe$(key);
  }
  function gettext(key, args) {
    return I18n_getInstance().gettext_25kzsl$(key, args.slice());
  }
  var I18N_SINGLE_DELIMITER;
  var I18N_PLURAL_DELIMITER;
  function I18nManager() {
  }
  I18nManager.prototype.tr_61zpoe$ = function (key) {
    return I18N_SINGLE_DELIMITER + key;
  };
  I18nManager.prototype.ntr_rjan26$ = function (singularKey, pluralKey, value) {
    return I18N_PLURAL_DELIMITER + singularKey + I18N_PLURAL_DELIMITER + pluralKey + I18N_PLURAL_DELIMITER + toString_0(value);
  };
  I18nManager.prototype.trans_61zpoe$ = function (text) {
    var tmp$, tmp$_0;
    if (startsWith(text, I18N_SINGLE_DELIMITER)) {
      tmp$_0 = this.gettext_25kzsl$(text.substring(13), []);
    } else if (startsWith(text, I18N_PLURAL_DELIMITER)) {
      var tab = split_0(text.substring(13), [I18N_PLURAL_DELIMITER]);
      if (tab.size === 3) {
        tmp$_0 = this.ngettext_hjhpvv$(tab.get_za3lpa$(0), tab.get_za3lpa$(1), (tmp$ = toIntOrNull(tab.get_za3lpa$(2))) != null ? tmp$ : 1, []);
      } else {
        tmp$_0 = text;
      }
    } else {
      tmp$_0 = text;
    }
    return tmp$_0;
  };
  I18nManager.prototype.trans_pdl1vj$ = function (text) {
    return text != null ? this.trans_61zpoe$(text) : null;
  };
  I18nManager.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'I18nManager', interfaces: []};
  function SimpleI18nManager() {
  }
  SimpleI18nManager.prototype.gettext_25kzsl$ = function (key, args) {
    return key;
  };
  SimpleI18nManager.prototype.ngettext_hjhpvv$ = function (singularKey, pluralKey, value, args) {
    return singularKey;
  };
  SimpleI18nManager.$metadata$ = {kind: Kind_CLASS, simpleName: 'SimpleI18nManager', interfaces: [I18nManager]};
  var Side$LEFT_instance;
  var Side$RIGHT_instance;
  var Side$CENTER_instance;
  var Side$UP_instance;
  var Side$DOWN_instance;
  function FieldsetPanel(legend, className, init) {
    if (legend === void 0)
      legend = null;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + 'kv_fieldset');
    this.legendComponent = new Tag(TAG$LEGEND_getInstance(), legend);
    init != null ? init(this) : null;
  }
  Object.defineProperty(FieldsetPanel.prototype, 'legend', {configurable: true, get: function () {
    return this.legendComponent.content;
  }, set: function (value) {
    this.legendComponent.content = value;
  }});
  FieldsetPanel.prototype.render = function () {
    var childrenVNodes = this.childrenVNodes();
    childrenVNodes.unshift(this.legendComponent.renderVNode());
    return this.render_pjwf99$('fieldset', childrenVNodes);
  };
  FieldsetPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'FieldsetPanel', interfaces: [SimplePanel]};
  function FlexPanel(direction, wrap, justify, alignItems, alignContent, spacing, useWrappers, className, init) {
    if (direction === void 0)
      direction = null;
    if (wrap === void 0)
      wrap = null;
    if (justify === void 0)
      justify = null;
    if (alignItems === void 0)
      alignItems = null;
    if (alignContent === void 0)
      alignContent = null;
    if (spacing === void 0)
      spacing = null;
    if (useWrappers === void 0)
      useWrappers = KVManager_getInstance().panelsCompatibilityMode_8be2vx$;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.useWrappers_jvplq5$_0 = useWrappers;
    this.spacing_hc0jyx$_0 = (new Widget$RefreshDelegateProvider(this, spacing, FlexPanel$spacing$lambda(this))).provideDelegate_n5byny$(this, FlexPanel$spacing_metadata);
    this.display = Display$FLEX_getInstance();
    this.flexDirection = direction;
    this.flexWrap = wrap;
    this.justifyContent = justify;
    this.alignItems = alignItems;
    this.alignContent = alignContent;
    init != null ? init(this) : null;
  }
  var FlexPanel$spacing_metadata = new PropertyMetadata('spacing');
  Object.defineProperty(FlexPanel.prototype, 'spacing', {configurable: true, get: function () {
    return this.spacing_hc0jyx$_0.getValue_fmbzy8$(this, FlexPanel$spacing_metadata);
  }, set: function (spacing) {
    this.spacing_hc0jyx$_0.setValue_19qrsr$(this, FlexPanel$spacing_metadata, spacing);
  }});
  FlexPanel.prototype.add_jpybuf$ = function (child, order, grow, shrink, basis, alignSelf, className) {
    if (order === void 0)
      order = null;
    if (grow === void 0)
      grow = null;
    if (shrink === void 0)
      shrink = null;
    if (basis === void 0)
      basis = null;
    if (alignSelf === void 0)
      alignSelf = null;
    if (className === void 0)
      className = null;
    var tmp$, tmp$_0, tmp$_1;
    if (!this.useWrappers_jvplq5$_0) {
      tmp$ = child;
    } else {
      tmp$ = new WidgetWrapper(child, className);
    }
    var wrapper = tmp$;
    if (this.spacing != null) {
      this.applySpacing_almad7$_0(wrapper);
    }if ((tmp$_1 = Kotlin.isType(tmp$_0 = wrapper, Widget) ? tmp$_0 : null) != null) {
      tmp$_1.order = order;
      tmp$_1.flexGrow = grow;
      tmp$_1.flexShrink = shrink;
      tmp$_1.flexBasis = basis;
      tmp$_1.alignSelf = alignSelf;
    }this.addInternal_87eobz$(wrapper);
    return this;
  };
  FlexPanel.prototype.add_nn970h$ = function (position, child, order, grow, shrink, basis, alignSelf, className) {
    if (order === void 0)
      order = null;
    if (grow === void 0)
      grow = null;
    if (shrink === void 0)
      shrink = null;
    if (basis === void 0)
      basis = null;
    if (alignSelf === void 0)
      alignSelf = null;
    if (className === void 0)
      className = null;
    var tmp$, tmp$_0, tmp$_1;
    if (!this.useWrappers_jvplq5$_0) {
      tmp$ = child;
    } else {
      tmp$ = new WidgetWrapper(child, className);
    }
    var wrapper = tmp$;
    if (this.spacing != null) {
      this.applySpacing_almad7$_0(wrapper);
    }if ((tmp$_1 = Kotlin.isType(tmp$_0 = wrapper, Widget) ? tmp$_0 : null) != null) {
      tmp$_1.order = order;
      tmp$_1.flexGrow = grow;
      tmp$_1.flexShrink = shrink;
      tmp$_1.flexBasis = basis;
      tmp$_1.alignSelf = alignSelf;
    }this.addInternal_pqktxj$(position, wrapper);
    return this;
  };
  function FlexPanel$options$ObjectLiteral(closure$order, closure$grow, closure$shrink, closure$basis, closure$alignSelf, closure$className, this$FlexPanel) {
    this.closure$order = closure$order;
    this.closure$grow = closure$grow;
    this.closure$shrink = closure$shrink;
    this.closure$basis = closure$basis;
    this.closure$alignSelf = closure$alignSelf;
    this.closure$className = closure$className;
    this.this$FlexPanel = this$FlexPanel;
    this.$delegate_g50dz$_0 = this$FlexPanel;
  }
  FlexPanel$options$ObjectLiteral.prototype.add_87eobz$ = function (child) {
    return this.this$FlexPanel.add_jpybuf$(child, this.closure$order, this.closure$grow, this.closure$shrink, this.closure$basis, this.closure$alignSelf, this.closure$className);
  };
  Object.defineProperty(FlexPanel$options$ObjectLiteral.prototype, 'parent', {configurable: true, get: function () {
    return this.$delegate_g50dz$_0.parent;
  }, set: function (tmp$) {
    this.$delegate_g50dz$_0.parent = tmp$;
  }});
  Object.defineProperty(FlexPanel$options$ObjectLiteral.prototype, 'visible', {configurable: true, get: function () {
    return this.$delegate_g50dz$_0.visible;
  }, set: function (tmp$) {
    this.$delegate_g50dz$_0.visible = tmp$;
  }});
  FlexPanel$options$ObjectLiteral.prototype.add_pqktxj$ = function (position, child) {
    return this.$delegate_g50dz$_0.add_pqktxj$(position, child);
  };
  FlexPanel$options$ObjectLiteral.prototype.addAfterDestroyHook_o14v8n$ = function (hook) {
    return this.$delegate_g50dz$_0.addAfterDestroyHook_o14v8n$(hook);
  };
  FlexPanel$options$ObjectLiteral.prototype.addAfterInsertHook_tcd33s$ = function (hook) {
    return this.$delegate_g50dz$_0.addAfterInsertHook_tcd33s$(hook);
  };
  FlexPanel$options$ObjectLiteral.prototype.addAll_xquxs0$ = function (children) {
    return this.$delegate_g50dz$_0.addAll_xquxs0$(children);
  };
  FlexPanel$options$ObjectLiteral.prototype.addBeforeDisposeHook_o14v8n$ = function (hook) {
    return this.$delegate_g50dz$_0.addBeforeDisposeHook_o14v8n$(hook);
  };
  FlexPanel$options$ObjectLiteral.prototype.addCssClass_61zpoe$ = function (css) {
    return this.$delegate_g50dz$_0.addCssClass_61zpoe$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.addCssStyle_807zt1$ = function (css) {
    return this.$delegate_g50dz$_0.addCssStyle_807zt1$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.addSurroundingCssClass_61zpoe$ = function (css) {
    return this.$delegate_g50dz$_0.addSurroundingCssClass_61zpoe$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.addSurroundingCssStyle_807zt1$ = function (css) {
    return this.$delegate_g50dz$_0.addSurroundingCssStyle_807zt1$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.blur = function () {
    return this.$delegate_g50dz$_0.blur();
  };
  FlexPanel$options$ObjectLiteral.prototype.clearParent = function () {
    return this.$delegate_g50dz$_0.clearParent();
  };
  FlexPanel$options$ObjectLiteral.prototype.dispose = function () {
    return this.$delegate_g50dz$_0.dispose();
  };
  FlexPanel$options$ObjectLiteral.prototype.disposeAll = function () {
    return this.$delegate_g50dz$_0.disposeAll();
  };
  FlexPanel$options$ObjectLiteral.prototype.focus = function () {
    return this.$delegate_g50dz$_0.focus();
  };
  FlexPanel$options$ObjectLiteral.prototype.getAttribute_61zpoe$ = function (name) {
    return this.$delegate_g50dz$_0.getAttribute_61zpoe$(name);
  };
  FlexPanel$options$ObjectLiteral.prototype.getChildren = function () {
    return this.$delegate_g50dz$_0.getChildren();
  };
  FlexPanel$options$ObjectLiteral.prototype.getElement = function () {
    return this.$delegate_g50dz$_0.getElement();
  };
  FlexPanel$options$ObjectLiteral.prototype.getElementD = function () {
    return this.$delegate_g50dz$_0.getElementD();
  };
  FlexPanel$options$ObjectLiteral.prototype.getRoot = function () {
    return this.$delegate_g50dz$_0.getRoot();
  };
  FlexPanel$options$ObjectLiteral.prototype.hasCssClass_61zpoe$ = function (css) {
    return this.$delegate_g50dz$_0.hasCssClass_61zpoe$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.invoke_4h7hma$ = function (children) {
    return this.$delegate_g50dz$_0.invoke_4h7hma$(children);
  };
  FlexPanel$options$ObjectLiteral.prototype.remove_87eobz$ = function (child) {
    return this.$delegate_g50dz$_0.remove_87eobz$(child);
  };
  FlexPanel$options$ObjectLiteral.prototype.removeAll = function () {
    return this.$delegate_g50dz$_0.removeAll();
  };
  FlexPanel$options$ObjectLiteral.prototype.removeAt_za3lpa$ = function (position) {
    return this.$delegate_g50dz$_0.removeAt_za3lpa$(position);
  };
  FlexPanel$options$ObjectLiteral.prototype.removeAttribute_61zpoe$ = function (name) {
    return this.$delegate_g50dz$_0.removeAttribute_61zpoe$(name);
  };
  FlexPanel$options$ObjectLiteral.prototype.removeCssClass_61zpoe$ = function (css) {
    return this.$delegate_g50dz$_0.removeCssClass_61zpoe$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.removeCssStyle_807zt1$ = function (css) {
    return this.$delegate_g50dz$_0.removeCssStyle_807zt1$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.removeSurroundingCssClass_61zpoe$ = function (css) {
    return this.$delegate_g50dz$_0.removeSurroundingCssClass_61zpoe$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.removeSurroundingCssStyle_807zt1$ = function (css) {
    return this.$delegate_g50dz$_0.removeSurroundingCssStyle_807zt1$(css);
  };
  FlexPanel$options$ObjectLiteral.prototype.renderVNode = function () {
    return this.$delegate_g50dz$_0.renderVNode();
  };
  FlexPanel$options$ObjectLiteral.prototype.setAttribute_puj7f4$ = function (name, value) {
    return this.$delegate_g50dz$_0.setAttribute_puj7f4$(name, value);
  };
  FlexPanel$options$ObjectLiteral.prototype.singleRender_klfg04$ = function (block) {
    return this.$delegate_g50dz$_0.singleRender_klfg04$(block);
  };
  FlexPanel$options$ObjectLiteral.prototype.singleRenderAsync_o14v8n$ = function (block) {
    return this.$delegate_g50dz$_0.singleRenderAsync_o14v8n$(block);
  };
  FlexPanel$options$ObjectLiteral.prototype.unaryPlus_pdl1vz$ = function ($receiver) {
    return this.$delegate_g50dz$_0.unaryPlus_pdl1vz$($receiver);
  };
  FlexPanel$options$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [Container]};
  FlexPanel.prototype.options_wzbw0s$$default = function (order, grow, shrink, basis, alignSelf, className, builder) {
    builder(new FlexPanel$options$ObjectLiteral(order, grow, shrink, basis, alignSelf, className, this));
  };
  FlexPanel.prototype.options_wzbw0s$ = function (order, grow, shrink, basis, alignSelf, className, builder, callback$default) {
    if (order === void 0)
      order = null;
    if (grow === void 0)
      grow = null;
    if (shrink === void 0)
      shrink = null;
    if (basis === void 0)
      basis = null;
    if (alignSelf === void 0)
      alignSelf = null;
    if (className === void 0)
      className = null;
    callback$default ? callback$default(order, grow, shrink, basis, alignSelf, className, builder) : this.options_wzbw0s$$default(order, grow, shrink, basis, alignSelf, className, builder);
  };
  FlexPanel.prototype.refreshSpacing_z5xnsy$_0 = function () {
    var tmp$;
    tmp$ = this.getChildren().iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      this.applySpacing_almad7$_0(element);
    }
  };
  FlexPanel.prototype.applySpacing_almad7$_0 = function (wrapper) {
    var tmp$;
    if (this.useWrappers_jvplq5$_0) {
      wrapper.marginTop = null;
      wrapper.marginRight = null;
      wrapper.marginBottom = null;
      wrapper.marginLeft = null;
    }if ((tmp$ = this.spacing) != null) {
      var tmp$_0;
      tmp$_0 = this.flexDirection;
      if (equals(tmp$_0, FlexDirection$COLUMN_getInstance()))
        wrapper.marginBottom = get_px(tmp$);
      else if (equals(tmp$_0, FlexDirection$ROWREV_getInstance()))
        if (equals(this.justifyContent, JustifyContent$FLEXEND_getInstance()))
          wrapper.marginRight = get_px(tmp$);
        else
          wrapper.marginLeft = get_px(tmp$);
      else if (equals(tmp$_0, FlexDirection$COLUMNREV_getInstance()))
        wrapper.marginTop = get_px(tmp$);
      else {
        if (equals(this.justifyContent, JustifyContent$FLEXEND_getInstance()))
          wrapper.marginLeft = get_px(tmp$);
        else
          wrapper.marginRight = get_px(tmp$);
      }
    }return wrapper;
  };
  FlexPanel.prototype.add_87eobz$ = function (child) {
    return this.add_jpybuf$(child, null);
  };
  FlexPanel.prototype.add_pqktxj$ = function (position, child) {
    return this.add_nn970h$(position, child, null);
  };
  FlexPanel.prototype.addAll_xquxs0$ = function (children) {
    var tmp$;
    tmp$ = children.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      this.add_jpybuf$(element, null);
    }
    return this;
  };
  FlexPanel.prototype.remove_87eobz$ = function (child) {
    var tmp$;
    if (this.children != null) {
      if (ensureNotNull(this.children).contains_11rb$(child)) {
        SimplePanel.prototype.remove_87eobz$.call(this, child);
      } else {
        var $receiver = ensureNotNull(this.children);
        var firstOrNull$result;
        firstOrNull$break: do {
          var tmp$_0;
          tmp$_0 = $receiver.iterator();
          while (tmp$_0.hasNext()) {
            var element = tmp$_0.next();
            var tmp$_1, tmp$_2;
            if (equals((tmp$_2 = Kotlin.isType(tmp$_1 = element, WidgetWrapper) ? tmp$_1 : null) != null ? tmp$_2.wrapped_8be2vx$ : null, child)) {
              firstOrNull$result = element;
              break firstOrNull$break;
            }}
          firstOrNull$result = null;
        }
         while (false);
        if ((tmp$ = firstOrNull$result) != null) {
          SimplePanel.prototype.remove_87eobz$.call(this, tmp$);
          tmp$.dispose();
        }}
    }return this;
  };
  FlexPanel.prototype.removeAll = function () {
    var tmp$, tmp$_0;
    if ((tmp$ = this.children) != null) {
      var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
      var tmp$_1;
      tmp$_1 = tmp$.iterator();
      while (tmp$_1.hasNext()) {
        var item = tmp$_1.next();
        var tmp$_2 = destination.add_11rb$;
        var tmp$_3, tmp$_4;
        item.clearParent();
        tmp$_2.call(destination, (tmp$_4 = Kotlin.isType(tmp$_3 = item, WidgetWrapper) ? tmp$_3 : null) != null ? (tmp$_4.dispose(), Unit) : null);
      }
    }(tmp$_0 = this.children) != null ? (tmp$_0.clear(), Unit) : null;
    this.children = null;
    this.refresh();
    return this;
  };
  FlexPanel.prototype.disposeAll = function () {
    var tmp$;
    if ((tmp$ = this.children) != null) {
      var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        var tmp$_1 = destination.add_11rb$;
        var tmp$_2, tmp$_3;
        var tmp$_4;
        if ((tmp$_3 = Kotlin.isType(tmp$_2 = item, WidgetWrapper) ? tmp$_2 : null) != null) {
          var tmp$_5;
          tmp$_4 = (tmp$_5 = tmp$_3.wrapped_8be2vx$) != null ? (tmp$_5.dispose(), Unit) : null;
        } else
          tmp$_4 = null;
        tmp$_1.call(destination, tmp$_4);
      }
    }return this.removeAll();
  };
  FlexPanel.prototype.dispose = function () {
    var tmp$;
    if ((tmp$ = this.children) != null) {
      var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        var tmp$_1 = destination.add_11rb$;
        var tmp$_2, tmp$_3;
        var tmp$_4;
        if ((tmp$_3 = Kotlin.isType(tmp$_2 = item, WidgetWrapper) ? tmp$_2 : null) != null) {
          var tmp$_5;
          tmp$_4 = (tmp$_5 = tmp$_3.wrapped_8be2vx$) != null ? (tmp$_5.dispose(), Unit) : null;
        } else
          tmp$_4 = null;
        tmp$_1.call(destination, tmp$_4);
      }
    }SimplePanel.prototype.dispose.call(this);
  };
  function FlexPanel$spacing$lambda(this$FlexPanel) {
    return function (it) {
      this$FlexPanel.refreshSpacing_z5xnsy$_0();
      this$FlexPanel.refresh();
      return Unit;
    };
  }
  FlexPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'FlexPanel', interfaces: [SimplePanel]};
  function HPanel(wrap, justify, alignItems, spacing, useWrappers, className, init) {
    if (wrap === void 0)
      wrap = null;
    if (justify === void 0)
      justify = null;
    if (alignItems === void 0)
      alignItems = null;
    if (spacing === void 0)
      spacing = null;
    if (useWrappers === void 0)
      useWrappers = KVManager_getInstance().panelsCompatibilityMode_8be2vx$;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    FlexPanel.call(this, null, wrap, justify, alignItems, null, spacing, useWrappers, className);
    init != null ? init(this) : null;
  }
  HPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'HPanel', interfaces: [FlexPanel]};
  function hPanel($receiver, wrap, justify, alignItems, spacing, useWrappers, className, init) {
    if (wrap === void 0)
      wrap = null;
    if (justify === void 0)
      justify = null;
    if (alignItems === void 0)
      alignItems = null;
    if (spacing === void 0)
      spacing = null;
    if (useWrappers === void 0)
      useWrappers = KVManager_getInstance().panelsCompatibilityMode_8be2vx$;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var hpanel = new HPanel(wrap, justify, alignItems, spacing, useWrappers, className, init);
    $receiver.add_87eobz$(hpanel);
    return hpanel;
  }
  function ContainerType(name, ordinal, type) {
    Enum.call(this);
    this.type_8be2vx$ = type;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function ContainerType_initFields() {
    ContainerType_initFields = function () {
    };
    ContainerType$NONE_instance = new ContainerType('NONE', 0, '');
    ContainerType$FIXED_instance = new ContainerType('FIXED', 1, 'container');
    ContainerType$FLUID_instance = new ContainerType('FLUID', 2, 'container-fluid');
    ContainerType$SM_instance = new ContainerType('SM', 3, 'container-sm');
    ContainerType$MD_instance = new ContainerType('MD', 4, 'container-md');
    ContainerType$LG_instance = new ContainerType('LG', 5, 'container-lg');
    ContainerType$XL_instance = new ContainerType('XL', 6, 'container-xl');
    ContainerType$XXL_instance = new ContainerType('XXL', 7, 'container-xxl');
  }
  var ContainerType$NONE_instance;
  function ContainerType$NONE_getInstance() {
    ContainerType_initFields();
    return ContainerType$NONE_instance;
  }
  var ContainerType$FIXED_instance;
  function ContainerType$FIXED_getInstance() {
    ContainerType_initFields();
    return ContainerType$FIXED_instance;
  }
  var ContainerType$FLUID_instance;
  function ContainerType$FLUID_getInstance() {
    ContainerType_initFields();
    return ContainerType$FLUID_instance;
  }
  var ContainerType$SM_instance;
  function ContainerType$SM_getInstance() {
    ContainerType_initFields();
    return ContainerType$SM_instance;
  }
  var ContainerType$MD_instance;
  function ContainerType$MD_getInstance() {
    ContainerType_initFields();
    return ContainerType$MD_instance;
  }
  var ContainerType$LG_instance;
  function ContainerType$LG_getInstance() {
    ContainerType_initFields();
    return ContainerType$LG_instance;
  }
  var ContainerType$XL_instance;
  function ContainerType$XL_getInstance() {
    ContainerType_initFields();
    return ContainerType$XL_instance;
  }
  var ContainerType$XXL_instance;
  function ContainerType$XXL_getInstance() {
    ContainerType_initFields();
    return ContainerType$XXL_instance;
  }
  ContainerType.$metadata$ = {kind: Kind_CLASS, simpleName: 'ContainerType', interfaces: [Enum]};
  function ContainerType$values() {
    return [ContainerType$NONE_getInstance(), ContainerType$FIXED_getInstance(), ContainerType$FLUID_getInstance(), ContainerType$SM_getInstance(), ContainerType$MD_getInstance(), ContainerType$LG_getInstance(), ContainerType$XL_getInstance(), ContainerType$XXL_getInstance()];
  }
  ContainerType.values = ContainerType$values;
  function ContainerType$valueOf(name) {
    switch (name) {
      case 'NONE':
        return ContainerType$NONE_getInstance();
      case 'FIXED':
        return ContainerType$FIXED_getInstance();
      case 'FLUID':
        return ContainerType$FLUID_getInstance();
      case 'SM':
        return ContainerType$SM_getInstance();
      case 'MD':
        return ContainerType$MD_getInstance();
      case 'LG':
        return ContainerType$LG_getInstance();
      case 'XL':
        return ContainerType$XL_getInstance();
      case 'XXL':
        return ContainerType$XXL_getInstance();
      default:throwISE('No enum constant io.kvision.panel.ContainerType.' + name);
    }
  }
  ContainerType.valueOf_61zpoe$ = ContainerType$valueOf;
  function Root() {
    Root$Companion_getInstance();
    this.containerType_0 = null;
    this.addRow_0 = false;
    this.contextMenus_0 = ArrayList_init();
    this.rootVnode_0 = null;
    this.singleRenderers_8be2vx$ = 0;
    this.asyncBuffer_0 = ArrayList_init();
    this.asyncTimer_0 = null;
    this.stylesCached_0 = null;
    this.isFirstRoot_0 = Root$Companion_getInstance().roots_8be2vx$.isEmpty();
    this.synchronousMode = false;
    this.disableRendering_teyle1$_0 = false;
    Root$Companion_getInstance().roots_8be2vx$.add_11rb$(this);
    if (this.isFirstRoot_0) {
      var tmp$;
      tmp$ = Root$Companion_getInstance().modals_0.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element.parent = this;
      }
    }}
  Object.defineProperty(Root.prototype, 'disableRendering', {configurable: true, get: function () {
    return this.disableRendering_teyle1$_0;
  }, set: function (value) {
    this.disableRendering_teyle1$_0 = value;
    if (!this.disableRendering)
      this.reRender_8be2vx$();
  }});
  function Root$render$lambda($receiver) {
    var pairs = listOf_0(to('row', true));
    var $receiver_0 = new Object_init();
    var tmp$;
    tmp$ = pairs.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.component1(), value = element.component2();
      $receiver_0[key] = value;
    }
    $receiver.class = $receiver_0;
    return Unit;
  }
  Root.prototype.render = function () {
    var tmp$;
    if (this.addRow_0) {
      var tmp$_0 = 'div#' + toString_0(this.id);
      var tmp$_1 = this.stylesVNodes_0();
      var elements = [h('div', getCallableRef('apply', function ($receiver, p1) {
        p1($receiver);
        return $receiver;
      }.bind(null, {}))(Root$render$lambda), this.childrenVNodes())];
      var $receiver_0 = tmp$_1.concat(elements);
      var elements_0 = this.modalsVNodes_0();
      var $receiver_1 = $receiver_0.concat(elements_0);
      var elements_1 = this.contextMenusVNodes_0();
      tmp$ = this.render_pjwf99$(tmp$_0, $receiver_1.concat(elements_1));
    } else {
      var tmp$_2 = 'div#' + toString_0(this.id);
      var $receiver_2 = this.stylesVNodes_0();
      var elements_2 = this.childrenVNodes();
      var $receiver_3 = $receiver_2.concat(elements_2);
      var elements_3 = this.modalsVNodes_0();
      var $receiver_4 = $receiver_3.concat(elements_3);
      var elements_4 = this.contextMenusVNodes_0();
      tmp$ = this.render_pjwf99$(tmp$_2, $receiver_4.concat(elements_4));
    }
    return tmp$;
  };
  function Root$addContextMenu$lambda$lambda(closure$contextMenu) {
    return function (e) {
      if (!e.dropDownCM)
        closure$contextMenu.hide();
      return Unit;
    };
  }
  function Root$addContextMenu$lambda(closure$contextMenu) {
    return function ($receiver) {
      $receiver.click = Root$addContextMenu$lambda$lambda(closure$contextMenu);
      return Unit;
    };
  }
  Root.prototype.addContextMenu_y7t574$ = function (contextMenu) {
    this.contextMenus_0.add_11rb$(contextMenu);
    contextMenu.parent = this;
    this.setInternalEventListener_a1up2z$(Root$addContextMenu$lambda(contextMenu));
    this.refresh();
  };
  function Root$stylesVNodes$lambda$lambda(it) {
    return it.generateStyle_8be2vx$();
  }
  function Root$stylesVNodes$lambda$lambda_0(it) {
    return it.generateStyle_8be2vx$();
  }
  Root.prototype.stylesVNodes_0 = function () {
    var tmp$, tmp$_0;
    if (this.isFirstRoot_0) {
      if (!Style$Companion_getInstance().styles_8be2vx$.isEmpty()) {
        if (this.stylesCached_0 != null) {
          tmp$ = ensureNotNull(this.stylesCached_0);
        } else {
          var $receiver = Style$Companion_getInstance().styles_8be2vx$;
          var destination = LinkedHashMap_init();
          var tmp$_1;
          tmp$_1 = $receiver.iterator();
          while (tmp$_1.hasNext()) {
            var element = tmp$_1.next();
            var key = element.mediaQuery;
            var tmp$_0_0;
            var value = destination.get_11rb$(key);
            if (value == null) {
              var answer = ArrayList_init();
              destination.put_xwzc9p$(key, answer);
              tmp$_0_0 = answer;
            } else {
              tmp$_0_0 = value;
            }
            var list = tmp$_0_0;
            list.add_11rb$(element);
          }
          var groupByMediaQuery = destination;
          var destination_0 = ArrayList_init_0(groupByMediaQuery.size);
          var tmp$_2;
          tmp$_2 = groupByMediaQuery.entries.iterator();
          while (tmp$_2.hasNext()) {
            var item = tmp$_2.next();
            var tmp$_3 = destination_0.add_11rb$;
            var transform$result;
            var media = item.key;
            var styles = item.value;
            if (media == null) {
              transform$result = joinToString(styles, '\n', void 0, void 0, void 0, void 0, Root$stylesVNodes$lambda$lambda);
            } else {
              transform$result = '@media (' + toString_0(media) + ') {' + '\n' + joinToString(styles, '\n', void 0, void 0, void 0, void 0, Root$stylesVNodes$lambda$lambda_0) + '\n}';
            }
            tmp$_3.call(destination_0, transform$result);
          }
          this.stylesCached_0 = joinToString(destination_0, '\n\n');
          tmp$ = ensureNotNull(this.stylesCached_0);
        }
        var stylesDesc = tmp$;
        tmp$_0 = [h('style', ['\n' + stylesDesc + '\n'])];
      } else {
        tmp$_0 = [];
      }
    } else {
      tmp$_0 = [];
    }
    return tmp$_0;
  };
  Root.prototype.modalsVNodes_0 = function () {
    var tmp$;
    if (this.isFirstRoot_0) {
      var $receiver = Root$Companion_getInstance().modals_0;
      var destination = ArrayList_init();
      var tmp$_0;
      tmp$_0 = $receiver.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        if (element.visible)
          destination.add_11rb$(element);
      }
      var destination_0 = ArrayList_init_0(collectionSizeOrDefault(destination, 10));
      var tmp$_1;
      tmp$_1 = destination.iterator();
      while (tmp$_1.hasNext()) {
        var item = tmp$_1.next();
        destination_0.add_11rb$(item.renderVNode());
      }
      tmp$ = copyToArray(destination_0);
    } else {
      tmp$ = [];
    }
    return tmp$;
  };
  Root.prototype.contextMenusVNodes_0 = function () {
    var $receiver = this.contextMenus_0;
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (element.visible)
        destination.add_11rb$(element);
    }
    var destination_0 = ArrayList_init_0(collectionSizeOrDefault(destination, 10));
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var item = tmp$_0.next();
      destination_0.add_11rb$(item.renderVNode());
    }
    return copyToArray(destination_0);
  };
  Root.prototype.buildClassSet_xutoed$ = function (classSetBuilder) {
    SimplePanel.prototype.buildClassSet_xutoed$.call(this, classSetBuilder);
    if (this.containerType_0 !== ContainerType$NONE_getInstance()) {
      classSetBuilder.add_61zpoe$(this.containerType_0.type_8be2vx$);
    }};
  Root.prototype.reRender_8be2vx$ = function () {
    if (this.singleRenderers_8be2vx$ === 0 && !this.disableRendering && this.rootVnode_0 != null) {
      this.rootVnode_0 = KVManager_getInstance().patch_6ju63b$(ensureNotNull(this.rootVnode_0), this.renderVNode());
    }return this;
  };
  Root.prototype.singleRender_klfg04$ = function (block) {
    this.singleRenderers_8be2vx$ = this.singleRenderers_8be2vx$ + 1 | 0;
    var result = block();
    this.singleRenderers_8be2vx$ = this.singleRenderers_8be2vx$ - 1 | 0;
    this.reRender_8be2vx$();
    return result;
  };
  function Root$singleRenderAsync$lambda(closure$block) {
    return function () {
      closure$block();
      return Unit;
    };
  }
  function Root$singleRenderAsync$lambda$lambda(this$Root) {
    return function () {
      var tmp$;
      tmp$ = this$Root.asyncBuffer_0.iterator();
      while (tmp$.hasNext()) {
        var element = tmp$.next();
        element();
      }
      this$Root.asyncBuffer_0.clear();
      return Unit;
    };
  }
  function Root$singleRenderAsync$lambda_0(this$Root) {
    return function () {
      this$Root.singleRender_klfg04$(Root$singleRenderAsync$lambda$lambda(this$Root));
      this$Root.asyncTimer_0 = null;
      return Unit;
    };
  }
  Root.prototype.singleRenderAsync_o14v8n$ = function (block) {
    if (this.synchronousMode) {
      this.singleRender_klfg04$(Root$singleRenderAsync$lambda(block));
    } else {
      this.asyncBuffer_0.add_11rb$(block);
      if (this.asyncTimer_0 != null) {
        window.clearTimeout(ensureNotNull(this.asyncTimer_0));
      }this.asyncTimer_0 = window.setTimeout(Root$singleRenderAsync$lambda_0(this), 0);
    }
  };
  Root.prototype.restart_8be2vx$ = function () {
    if (this.rootVnode_0 != null) {
      this.rootVnode_0 = KVManager_getInstance().patch_6ju63b$(ensureNotNull(this.rootVnode_0), h('div'));
      this.rootVnode_0 = KVManager_getInstance().patch_6ju63b$(ensureNotNull(this.rootVnode_0), this.renderVNode());
    }};
  Root.prototype.clearStylesCache_8be2vx$ = function () {
    this.stylesCached_0 = null;
  };
  Root.prototype.getRoot = function () {
    return this;
  };
  Root.prototype.dispose = function () {
    SimplePanel.prototype.dispose.call(this);
    Root$Companion_getInstance().roots_8be2vx$.remove_11rb$(this);
    if (this.isFirstRoot_0) {
      Style$Companion_getInstance().styles_8be2vx$.clear();
      Root$Companion_getInstance().modals_0.clear();
    }};
  function Root$Companion() {
    Root$Companion_instance = this;
    this.counter_8be2vx$ = 0;
    this.modals_0 = ArrayList_init();
    this.roots_8be2vx$ = ArrayList_init();
  }
  Root$Companion.prototype.disposeAllRoots = function () {
    var tmp$;
    tmp$ = this.roots_8be2vx$.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.dispose();
    }
    this.roots_8be2vx$.clear();
  };
  Root$Companion.prototype.getFirstRoot = function () {
    return !this.roots_8be2vx$.isEmpty() ? this.roots_8be2vx$.get_za3lpa$(0) : null;
  };
  Root$Companion.prototype.getLastRoot = function () {
    return !this.roots_8be2vx$.isEmpty() ? this.roots_8be2vx$.get_za3lpa$(this.roots_8be2vx$.size - 1 | 0) : null;
  };
  Root$Companion.prototype.addModal_y7t574$ = function (modal) {
    this.modals_0.add_11rb$(modal);
  };
  Root$Companion.prototype.removeModal_y7t574$ = function (modal) {
    this.modals_0.remove_11rb$(modal);
  };
  Root$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Root$Companion_instance = null;
  function Root$Companion_getInstance() {
    if (Root$Companion_instance === null) {
      new Root$Companion();
    }return Root$Companion_instance;
  }
  Root.$metadata$ = {kind: Kind_CLASS, simpleName: 'Root', interfaces: [SimplePanel]};
  function Root_init(id, containerType, addRow, init, $this) {
    if (containerType === void 0)
      containerType = ContainerType$NONE_getInstance();
    if (addRow === void 0)
      addRow = (containerType !== ContainerType$FIXED_getInstance() && containerType !== ContainerType$NONE_getInstance());
    if (init === void 0)
      init = null;
    $this = $this || Object.create(Root.prototype);
    SimplePanel.call($this);
    Root.call($this);
    $this.containerType_0 = containerType;
    $this.addRow_0 = addRow;
    if (document.getElementById(id) != null) {
      $this.rootVnode_0 = KVManager_getInstance().patch_w7nmm6$(id, $this.renderVNode());
    }$this.id = id;
    init != null ? init($this) : null;
    return $this;
  }
  function Root_init_0(element, containerType, addRow, init, $this) {
    if (containerType === void 0)
      containerType = ContainerType$NONE_getInstance();
    if (addRow === void 0)
      addRow = (containerType !== ContainerType$FIXED_getInstance() && containerType !== ContainerType$NONE_getInstance());
    if (init === void 0)
      init = null;
    $this = $this || Object.create(Root.prototype);
    SimplePanel.call($this);
    Root.call($this);
    var tmp$;
    $this.containerType_0 = containerType;
    $this.addRow_0 = addRow;
    $this.rootVnode_0 = KVManager_getInstance().patch_bcdad0$(element, $this.renderVNode());
    $this.id = 'kv_root_' + (tmp$ = Root$Companion_getInstance().counter_8be2vx$, Root$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    init != null ? init($this) : null;
    return $this;
  }
  function root($receiver, id, containerType, addRow, init) {
    if (containerType === void 0)
      containerType = ContainerType$NONE_getInstance();
    if (addRow === void 0)
      addRow = (containerType !== ContainerType$FIXED_getInstance() && containerType !== ContainerType$NONE_getInstance());
    if (init === void 0)
      init = null;
    return Root_init(id, containerType, addRow, init);
  }
  function SimplePanel(className, init) {
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    Widget.call(this, className);
    this.privateChildren = null;
    this.children = null;
    this._archivedState = null;
    init != null ? init(this) : null;
  }
  SimplePanel.prototype.render = function () {
    return this.render_pjwf99$('div', this.childrenVNodes());
  };
  function SimplePanel$childrenVNodes$lambda(c) {
    return c.visible;
  }
  function SimplePanel$childrenVNodes$lambda_0(c) {
    return c.renderVNode();
  }
  function SimplePanel$childrenVNodes$lambda_1(c) {
    return c.visible;
  }
  function SimplePanel$childrenVNodes$lambda_2(c) {
    return c.renderVNode();
  }
  function SimplePanel$childrenVNodes$lambda_3(c) {
    return c.visible;
  }
  function SimplePanel$childrenVNodes$lambda_4(c) {
    return c.renderVNode();
  }
  SimplePanel.prototype.childrenVNodes = function () {
    var tmp$;
    if (this.privateChildren == null && this.children == null) {
      tmp$ = [];
    } else if (this.privateChildren == null && this.children != null) {
      tmp$ = copyToArray(ensureNotNull(this.children)).filter(SimplePanel$childrenVNodes$lambda).map(SimplePanel$childrenVNodes$lambda_0);
    } else if (this.privateChildren != null && this.children == null) {
      tmp$ = copyToArray(ensureNotNull(this.privateChildren)).filter(SimplePanel$childrenVNodes$lambda_1).map(SimplePanel$childrenVNodes$lambda_2);
    } else {
      tmp$ = copyToArray(plus_0(ensureNotNull(this.privateChildren), ensureNotNull(this.children))).filter(SimplePanel$childrenVNodes$lambda_3).map(SimplePanel$childrenVNodes$lambda_4);
    }
    return tmp$;
  };
  SimplePanel.prototype.addPrivate_87eobz$ = function (child) {
    var tmp$;
    if (this.privateChildren == null) {
      this.privateChildren = ArrayList_init();
    }ensureNotNull(this.privateChildren).add_11rb$(child);
    (tmp$ = child.parent) != null ? tmp$.remove_87eobz$(child) : null;
    child.parent = this;
    this.refresh();
    return this;
  };
  SimplePanel.prototype.addInternal_87eobz$ = function (child) {
    var tmp$;
    if (this.children == null) {
      this.children = ArrayList_init();
    }ensureNotNull(this.children).add_11rb$(child);
    (tmp$ = child.parent) != null ? tmp$.remove_87eobz$(child) : null;
    child.parent = this;
    this.refresh();
    return this;
  };
  SimplePanel.prototype.addInternal_pqktxj$ = function (position, child) {
    var tmp$;
    if (this.children == null) {
      this.children = ArrayList_init();
    }ensureNotNull(this.children).add_wxm5ur$(position, child);
    (tmp$ = child.parent) != null ? tmp$.remove_87eobz$(child) : null;
    child.parent = this;
    this.refresh();
    return this;
  };
  SimplePanel.prototype.add_87eobz$ = function (child) {
    return this.addInternal_87eobz$(child);
  };
  SimplePanel.prototype.add_pqktxj$ = function (position, child) {
    return this.addInternal_pqktxj$(position, child);
  };
  SimplePanel.prototype.addAll_xquxs0$ = function (children) {
    if (this.children == null) {
      this.children = ArrayList_init();
    }ensureNotNull(this.children).addAll_brywnq$(children);
    var destination = ArrayList_init_0(collectionSizeOrDefault(children, 10));
    var tmp$;
    tmp$ = children.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      var tmp$_0 = destination.add_11rb$;
      var tmp$_1;
      (tmp$_1 = item.parent) != null ? tmp$_1.remove_87eobz$(item) : null;
      item.parent = this;
      tmp$_0.call(destination, Unit);
    }
    this.refresh();
    return this;
  };
  SimplePanel.prototype.remove_87eobz$ = function (child) {
    if (this.children != null && ensureNotNull(this.children).remove_11rb$(child)) {
      child.clearParent();
      this.refresh();
    }return this;
  };
  SimplePanel.prototype.removeAt_za3lpa$ = function (position) {
    var tmp$, tmp$_0;
    var child = (tmp$ = this.children) != null ? getOrNull(tmp$, position) : null;
    if (child != null) {
      (tmp$_0 = this.children) != null ? tmp$_0.removeAt_za3lpa$(position) : null;
      child.clearParent();
      this.refresh();
    }return this;
  };
  SimplePanel.prototype.removeAll = function () {
    var tmp$;
    if ((tmp$ = this.children) != null) {
      var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$, 10));
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var item = tmp$_0.next();
        destination.add_11rb$(item.clearParent());
      }
    }this.children = null;
    this.refresh();
    return this;
  };
  SimplePanel.prototype.disposeAll = function () {
    var tmp$;
    if ((tmp$ = this.children) != null) {
      var tmp$_0;
      tmp$_0 = tmp$.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        element.dispose();
      }
    }return this.removeAll();
  };
  SimplePanel.prototype.getChildren = function () {
    var tmp$;
    return (tmp$ = this.children) != null ? tmp$ : emptyList();
  };
  SimplePanel.prototype.dispose = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4;
    Widget.prototype.dispose.call(this);
    if ((tmp$ = this.children) != null) {
      var tmp$_5;
      tmp$_5 = tmp$.iterator();
      while (tmp$_5.hasNext()) {
        var element = tmp$_5.next();
        element.dispose();
      }
    }if ((tmp$_0 = this.privateChildren) != null) {
      var tmp$_6;
      tmp$_6 = tmp$_0.iterator();
      while (tmp$_6.hasNext()) {
        var element_0 = tmp$_6.next();
        element_0.dispose();
      }
    }if ((tmp$_1 = this.children) != null) {
      var destination = ArrayList_init_0(collectionSizeOrDefault(tmp$_1, 10));
      var tmp$_7;
      tmp$_7 = tmp$_1.iterator();
      while (tmp$_7.hasNext()) {
        var item = tmp$_7.next();
        destination.add_11rb$(item.clearParent());
      }
    }(tmp$_2 = this.children) != null ? (tmp$_2.clear(), Unit) : null;
    this.children = null;
    if ((tmp$_3 = this.privateChildren) != null) {
      var destination_0 = ArrayList_init_0(collectionSizeOrDefault(tmp$_3, 10));
      var tmp$_8;
      tmp$_8 = tmp$_3.iterator();
      while (tmp$_8.hasNext()) {
        var item_0 = tmp$_8.next();
        destination_0.add_11rb$(item_0.clearParent());
      }
    }(tmp$_4 = this.privateChildren) != null ? (tmp$_4.clear(), Unit) : null;
    this.privateChildren = null;
  };
  SimplePanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'SimplePanel', interfaces: [Container, Widget]};
  function simplePanel($receiver, className, init) {
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var simplePanel = new SimplePanel(className, init);
    $receiver.add_87eobz$(simplePanel);
    return simplePanel;
  }
  function Widget$refreshOnUpdate$lambda_38(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Widget$refreshOnUpdate$lambda_39(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function Direction_0(name, ordinal, dir) {
    Enum.call(this);
    this.dir_8be2vx$ = dir;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Direction_initFields_0() {
    Direction_initFields_0 = function () {
    };
    Direction$HORIZONTAL_instance = new Direction_0('HORIZONTAL', 0, 'horizontal');
    Direction$VERTICAL_instance = new Direction_0('VERTICAL', 1, 'vertical');
  }
  var Direction$HORIZONTAL_instance;
  function Direction$HORIZONTAL_getInstance() {
    Direction_initFields_0();
    return Direction$HORIZONTAL_instance;
  }
  var Direction$VERTICAL_instance;
  function Direction$VERTICAL_getInstance() {
    Direction_initFields_0();
    return Direction$VERTICAL_instance;
  }
  Direction_0.$metadata$ = {kind: Kind_CLASS, simpleName: 'Direction', interfaces: [Enum]};
  function Direction$values_0() {
    return [Direction$HORIZONTAL_getInstance(), Direction$VERTICAL_getInstance()];
  }
  Direction_0.values = Direction$values_0;
  function Direction$valueOf_0(name) {
    switch (name) {
      case 'HORIZONTAL':
        return Direction$HORIZONTAL_getInstance();
      case 'VERTICAL':
        return Direction$VERTICAL_getInstance();
      default:throwISE('No enum constant io.kvision.panel.Direction.' + name);
    }
  }
  Direction_0.valueOf_61zpoe$ = Direction$valueOf_0;
  var GutterAlign$CENTER_instance;
  var GutterAlign$START_instance;
  var GutterAlign$END_instance;
  function SplitPanel(direction, className, init) {
    if (direction === void 0)
      direction = Direction$VERTICAL_getInstance();
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var tmp$;
    SimplePanel.call(this, ((tmp$ = className != null ? className + ' ' : null) != null ? tmp$ : '') + ('splitpanel-' + direction.dir_8be2vx$));
    this.direction_hhdx9q$_0 = direction;
    this.gutterSize_emjmef$_0 = (new Widget$RefreshDelegateProvider(this, 9, Widget$refreshOnUpdate$lambda_38(this))).provideDelegate_n5byny$(this, SplitPanel$gutterSize_metadata);
    this.gutterAlign_iqrd8n$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_39(this))).provideDelegate_n5byny$(this, SplitPanel$gutterAlign_metadata);
    this.minSize_q628wu$_0 = (new Widget$RefreshDelegateProvider(this, 0, Widget$refreshOnUpdate$lambda_38(this))).provideDelegate_n5byny$(this, SplitPanel$minSize_metadata);
    this.maxSize_fhjqyc$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_39(this))).provideDelegate_n5byny$(this, SplitPanel$maxSize_metadata);
    this.expandToMin_yrrsk$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_39(this))).provideDelegate_n5byny$(this, SplitPanel$expandToMin_metadata);
    this.snapOffset_i7jkee$_0 = (new Widget$RefreshDelegateProvider(this, 0, Widget$refreshOnUpdate$lambda_38(this))).provideDelegate_n5byny$(this, SplitPanel$snapOffset_metadata);
    this.dragInterval_z0yb6y$_0 = (new Widget$RefreshDelegateProvider(this, null, Widget$refreshOnUpdate$lambda_39(this))).provideDelegate_n5byny$(this, SplitPanel$dragInterval_metadata);
    this.splitter_8be2vx$ = new Splitter(this, this.direction_hhdx9q$_0);
    this.splitJs = null;
    init != null ? init(this) : null;
  }
  var SplitPanel$gutterSize_metadata = new PropertyMetadata('gutterSize');
  Object.defineProperty(SplitPanel.prototype, 'gutterSize', {configurable: true, get: function () {
    return this.gutterSize_emjmef$_0.getValue_fmbzy8$(this, SplitPanel$gutterSize_metadata);
  }, set: function (gutterSize) {
    this.gutterSize_emjmef$_0.setValue_19qrsr$(this, SplitPanel$gutterSize_metadata, gutterSize);
  }});
  var SplitPanel$gutterAlign_metadata = new PropertyMetadata('gutterAlign');
  Object.defineProperty(SplitPanel.prototype, 'gutterAlign', {configurable: true, get: function () {
    return this.gutterAlign_iqrd8n$_0.getValue_fmbzy8$(this, SplitPanel$gutterAlign_metadata);
  }, set: function (gutterAlign) {
    this.gutterAlign_iqrd8n$_0.setValue_19qrsr$(this, SplitPanel$gutterAlign_metadata, gutterAlign);
  }});
  var SplitPanel$minSize_metadata = new PropertyMetadata('minSize');
  Object.defineProperty(SplitPanel.prototype, 'minSize', {configurable: true, get: function () {
    return this.minSize_q628wu$_0.getValue_fmbzy8$(this, SplitPanel$minSize_metadata);
  }, set: function (minSize) {
    this.minSize_q628wu$_0.setValue_19qrsr$(this, SplitPanel$minSize_metadata, minSize);
  }});
  var SplitPanel$maxSize_metadata = new PropertyMetadata('maxSize');
  Object.defineProperty(SplitPanel.prototype, 'maxSize', {configurable: true, get: function () {
    return this.maxSize_fhjqyc$_0.getValue_fmbzy8$(this, SplitPanel$maxSize_metadata);
  }, set: function (maxSize) {
    this.maxSize_fhjqyc$_0.setValue_19qrsr$(this, SplitPanel$maxSize_metadata, maxSize);
  }});
  var SplitPanel$expandToMin_metadata = new PropertyMetadata('expandToMin');
  Object.defineProperty(SplitPanel.prototype, 'expandToMin', {configurable: true, get: function () {
    return this.expandToMin_yrrsk$_0.getValue_fmbzy8$(this, SplitPanel$expandToMin_metadata);
  }, set: function (expandToMin) {
    this.expandToMin_yrrsk$_0.setValue_19qrsr$(this, SplitPanel$expandToMin_metadata, expandToMin);
  }});
  var SplitPanel$snapOffset_metadata = new PropertyMetadata('snapOffset');
  Object.defineProperty(SplitPanel.prototype, 'snapOffset', {configurable: true, get: function () {
    return this.snapOffset_i7jkee$_0.getValue_fmbzy8$(this, SplitPanel$snapOffset_metadata);
  }, set: function (snapOffset) {
    this.snapOffset_i7jkee$_0.setValue_19qrsr$(this, SplitPanel$snapOffset_metadata, snapOffset);
  }});
  var SplitPanel$dragInterval_metadata = new PropertyMetadata('dragInterval');
  Object.defineProperty(SplitPanel.prototype, 'dragInterval', {configurable: true, get: function () {
    return this.dragInterval_z0yb6y$_0.getValue_fmbzy8$(this, SplitPanel$dragInterval_metadata);
  }, set: function (dragInterval) {
    this.dragInterval_z0yb6y$_0.setValue_19qrsr$(this, SplitPanel$dragInterval_metadata, dragInterval);
  }});
  function SplitPanel$afterInsertSplitter$lambda$lambda(this$SplitPanel) {
    return function () {
      return this$SplitPanel.splitter_8be2vx$.getElement();
    };
  }
  function SplitPanel$afterInsertSplitter$lambda$lambda_0(closure$self) {
    return function (sizes) {
      var $receiver = new Object_init();
      $receiver.sizes = sizes;
      var e = $receiver;
      var tmp$ = closure$self;
      var $receiver_0 = new Object_init();
      $receiver_0.detail = e;
      return tmp$.dispatchEvent_nxedta$('dragSplitPanel', $receiver_0);
    };
  }
  function SplitPanel$afterInsertSplitter$lambda$lambda_1(closure$self) {
    return function (sizes) {
      var $receiver = new Object_init();
      $receiver.sizes = sizes;
      var e = $receiver;
      var tmp$ = closure$self;
      var $receiver_0 = new Object_init();
      $receiver_0.detail = e;
      return tmp$.dispatchEvent_nxedta$('dragStartSplitPanel', $receiver_0);
    };
  }
  function SplitPanel$afterInsertSplitter$lambda$lambda_2(closure$horizontal, closure$perc, this$SplitPanel, closure$self) {
    return function (sizes) {
      var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6;
      var $receiver = new Object_init();
      $receiver.sizes = sizes;
      var e = $receiver;
      if (closure$horizontal) {
        (tmp$_0 = Kotlin.isType(tmp$ = ensureNotNull(this$SplitPanel.children).get_za3lpa$(0), StyledComponent) ? tmp$ : null) != null ? (tmp$_0.height = to(sizes[0], closure$perc)) : null;
        (tmp$_2 = Kotlin.isType(tmp$_1 = ensureNotNull(this$SplitPanel.children).get_za3lpa$(1), StyledComponent) ? tmp$_1 : null) != null ? (tmp$_2.height = to(sizes[1], closure$perc)) : null;
      } else {
        (tmp$_4 = Kotlin.isType(tmp$_3 = ensureNotNull(this$SplitPanel.children).get_za3lpa$(0), StyledComponent) ? tmp$_3 : null) != null ? (tmp$_4.width = to(sizes[0], closure$perc)) : null;
        (tmp$_6 = Kotlin.isType(tmp$_5 = ensureNotNull(this$SplitPanel.children).get_za3lpa$(1), StyledComponent) ? tmp$_5 : null) != null ? (tmp$_6.width = to(sizes[1], closure$perc)) : null;
      }
      var tmp$_7 = closure$self;
      var $receiver_0 = new Object_init();
      $receiver_0.detail = e;
      return tmp$_7.dispatchEvent_nxedta$('dragEndSplitPanel', $receiver_0);
    };
  }
  SplitPanel.prototype.afterInsertSplitter_8be2vx$ = function () {
    var tmp$, tmp$_0, tmp$_1, tmp$_2, tmp$_3, tmp$_4, tmp$_5, tmp$_6, tmp$_7, tmp$_8, tmp$_9, tmp$_10, tmp$_11, tmp$_12, tmp$_13, tmp$_14, tmp$_15, tmp$_16, tmp$_17, tmp$_18;
    if (((tmp$ = this.children) != null ? tmp$.size : null) === 2) {
      var horizontal = this.direction_hhdx9q$_0 === Direction$HORIZONTAL_getInstance();
      var perc = UNIT$perc_getInstance();
      var self_0 = this;
      var splitJsDirection = this.direction_hhdx9q$_0 === Direction$HORIZONTAL_getInstance() ? 'vertical' : 'horizontal';
      if (horizontal) {
        var h1 = (tmp$_1 = Kotlin.isType(tmp$_0 = ensureNotNull(this.children).get_za3lpa$(0), StyledComponent) ? tmp$_0 : null) != null ? tmp$_1.height : null;
        if (h1 != null && h1.second === UNIT$perc_getInstance()) {
          tmp$_14 = [h1.first, 100 - numberToDouble(h1.first)];
        } else {
          var height = (tmp$_3 = ((tmp$_2 = this.getElementD()) != null ? tmp$_2.getBoundingClientRect() : null).height) != null ? tmp$_3 : 0;
          var firstHeight = (tmp$_6 = ((tmp$_5 = (tmp$_4 = this.getElement()) != null ? tmp$_4.firstChild : null) != null ? tmp$_5 : null).getBoundingClientRect().height) != null ? tmp$_6 : 0;
          if (height != 0 && firstHeight != 0) {
            var x = firstHeight * 100 / height;
            var firstPerc = JsMath.ceil(x);
            tmp$_14 = [firstPerc, 100 - firstPerc];
          } else {
            tmp$_14 = [0, 100];
          }
        }
      } else {
        var h1_0 = (tmp$_8 = Kotlin.isType(tmp$_7 = ensureNotNull(this.children).get_za3lpa$(0), StyledComponent) ? tmp$_7 : null) != null ? tmp$_8.width : null;
        if (h1_0 != null && h1_0.second === UNIT$perc_getInstance()) {
          tmp$_14 = [h1_0.first, 100 - numberToDouble(h1_0.first)];
        } else {
          var width = (tmp$_10 = ((tmp$_9 = this.getElementD()) != null ? tmp$_9.getBoundingClientRect() : null).width) != null ? tmp$_10 : 0;
          var firstWidth = (tmp$_13 = ((tmp$_12 = (tmp$_11 = this.getElement()) != null ? tmp$_11.firstChild : null) != null ? tmp$_12 : null).getBoundingClientRect().width) != null ? tmp$_13 : 0;
          if (width != 0 && firstWidth != 0) {
            var x_0 = firstWidth * 100 / width;
            var firstPerc_0 = JsMath.ceil(x_0);
            tmp$_14 = [firstPerc_0, 100 - firstPerc_0];
          } else {
            tmp$_14 = [0, 100];
          }
        }
      }
      var sizes = tmp$_14;
      tmp$_18 = KVManager_getInstance().splitjs_8be2vx$;
      tmp$_17 = [(tmp$_15 = this.getElement()) != null ? tmp$_15.firstChild : null, (tmp$_16 = this.getElement()) != null ? tmp$_16.lastChild : null];
      var $receiver = new Object_init();
      var tmp$_19;
      $receiver.sizes = sizes;
      $receiver.direction = splitJsDirection;
      $receiver.gutter = SplitPanel$afterInsertSplitter$lambda$lambda(this);
      $receiver.gutterSize = this.gutterSize;
      if (this.gutterAlign != null)
        $receiver.gutterAlign = (tmp$_19 = this.gutterAlign) != null ? tmp$_19.align_8be2vx$ : null;
      $receiver.minSize = this.minSize;
      if (this.maxSize != null)
        $receiver.maxSize = this.maxSize;
      if (this.expandToMin != null)
        $receiver.expandToMin = this.expandToMin;
      $receiver.snapOffset = this.snapOffset;
      if (this.dragInterval != null)
        $receiver.dragInterval = this.dragInterval;
      $receiver.onDrag = SplitPanel$afterInsertSplitter$lambda$lambda_0(self_0);
      $receiver.onDragStart = SplitPanel$afterInsertSplitter$lambda$lambda_1(self_0);
      $receiver.onDragEnd = SplitPanel$afterInsertSplitter$lambda$lambda_2(horizontal, perc, this, self_0);
      this.splitJs = tmp$_18(tmp$_17, $receiver);
    }};
  SplitPanel.prototype.getSizes = function () {
    var tmp$;
    return (tmp$ = this.splitJs) != null ? tmp$.getSizes() : null;
  };
  SplitPanel.prototype.setSizes_9mvhws$ = function (sizes) {
    var tmp$;
    (tmp$ = this.splitJs) != null ? tmp$.setSizes(sizes) : null;
  };
  SplitPanel.prototype.afterDestroy = function () {
    if (this.splitJs != null) {
      this.splitJs.destroy(false, true);
      this.splitJs = null;
    }};
  SplitPanel.prototype.childrenVNodes = function () {
    var tmp$, tmp$_0;
    if (((tmp$ = this.children) != null ? tmp$.size : null) === 2) {
      tmp$_0 = [ensureNotNull(this.children).get_za3lpa$(0).renderVNode(), this.splitter_8be2vx$.renderVNode(), ensureNotNull(this.children).get_za3lpa$(1).renderVNode()];
    } else {
      tmp$_0 = [];
    }
    return tmp$_0;
  };
  SplitPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'SplitPanel', interfaces: [SimplePanel]};
  function splitPanel($receiver, direction, className, init) {
    if (direction === void 0)
      direction = Direction$VERTICAL_getInstance();
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var splitPanel = new SplitPanel(direction, className, init);
    $receiver.add_87eobz$(splitPanel);
    return splitPanel;
  }
  function Splitter(splitPanel, direction) {
    SimplePanel.call(this, 'splitter-' + direction.dir_8be2vx$);
    this.splitPanel_0 = splitPanel;
    this.useSnabbdomDistinctKey();
  }
  Splitter.prototype.afterInsert_77isfd$ = function (node) {
    this.splitPanel_0.afterInsertSplitter_8be2vx$();
  };
  Splitter.$metadata$ = {kind: Kind_CLASS, simpleName: 'Splitter', interfaces: [SimplePanel]};
  function Widget$refreshOnUpdate$lambda_40(this$Widget) {
    return function (it) {
      this$Widget.refresh();
      return Unit;
    };
  }
  function StackPanel(activateLast, className, init) {
    StackPanel$Companion_getInstance();
    if (activateLast === void 0)
      activateLast = true;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    SimplePanel.call(this, className);
    this.activateLast_59642c$_0 = activateLast;
    this.activeIndex_t5z29f$_0 = (new Widget$RefreshDelegateProvider(this, -1, Widget$refreshOnUpdate$lambda_40(this))).provideDelegate_n5byny$(this, StackPanel$activeIndex_metadata);
    this.childrenMap_8be2vx$ = LinkedHashMap_init();
    init != null ? init(this) : null;
  }
  var StackPanel$activeIndex_metadata = new PropertyMetadata('activeIndex');
  Object.defineProperty(StackPanel.prototype, 'activeIndex', {configurable: true, get: function () {
    return this.activeIndex_t5z29f$_0.getValue_fmbzy8$(this, StackPanel$activeIndex_metadata);
  }, set: function (activeIndex) {
    this.activeIndex_t5z29f$_0.setValue_19qrsr$(this, StackPanel$activeIndex_metadata, activeIndex);
  }});
  Object.defineProperty(StackPanel.prototype, 'activeChild', {configurable: true, get: function () {
    var tmp$;
    return (tmp$ = this.children) != null ? tmp$.get_za3lpa$(this.activeIndex) : null;
  }, set: function (value) {
    var tmp$, tmp$_0;
    this.activeIndex = (tmp$_0 = (tmp$ = this.children) != null ? indexOf(tmp$, value) : null) != null ? tmp$_0 : -1;
  }});
  StackPanel.prototype.childrenVNodes = function () {
    var tmp$;
    if (this.children != null && get_indices(ensureNotNull(this.children)).contains_mef7kx$(this.activeIndex)) {
      tmp$ = [ensureNotNull(this.children).get_za3lpa$(this.activeIndex).renderVNode()];
    } else {
      tmp$ = [];
    }
    return tmp$;
  };
  function StackPanel$add$lambda$lambda(this$StackPanel, closure$currentIndex) {
    return function (f) {
      this$StackPanel.activeChild = ensureNotNull(this$StackPanel.childrenMap_8be2vx$.get_11rb$(closure$currentIndex));
      return Unit;
    };
  }
  function StackPanel$add$lambda(closure$route, this$StackPanel, closure$currentIndex) {
    return function () {
      RoutingManager_getInstance().getRouter().kvOn_a1vqyy$(closure$route, StackPanel$add$lambda$lambda(this$StackPanel, closure$currentIndex)).kvResolve();
      return Unit;
    };
  }
  StackPanel.prototype.add_7d1g9v$ = function (panel, route) {
    var tmp$;
    this.add_87eobz$(panel);
    var currentIndex = (tmp$ = StackPanel$Companion_getInstance().counter_8be2vx$, StackPanel$Companion_getInstance().counter_8be2vx$ = tmp$ + 1 | 0, tmp$);
    this.childrenMap_8be2vx$.put_xwzc9p$(currentIndex, panel);
    window.setTimeout(StackPanel$add$lambda(route, this, currentIndex), 0);
    return this;
  };
  function StackPanel$route$ObjectLiteral(closure$route, this$StackPanel) {
    this.closure$route = closure$route;
    this.this$StackPanel = this$StackPanel;
    this.$delegate_8y1drh$_0 = this$StackPanel;
  }
  StackPanel$route$ObjectLiteral.prototype.add_87eobz$ = function (child) {
    return this.this$StackPanel.add_7d1g9v$(child, this.closure$route);
  };
  Object.defineProperty(StackPanel$route$ObjectLiteral.prototype, 'parent', {configurable: true, get: function () {
    return this.$delegate_8y1drh$_0.parent;
  }, set: function (tmp$) {
    this.$delegate_8y1drh$_0.parent = tmp$;
  }});
  Object.defineProperty(StackPanel$route$ObjectLiteral.prototype, 'visible', {configurable: true, get: function () {
    return this.$delegate_8y1drh$_0.visible;
  }, set: function (tmp$) {
    this.$delegate_8y1drh$_0.visible = tmp$;
  }});
  StackPanel$route$ObjectLiteral.prototype.add_pqktxj$ = function (position, child) {
    return this.$delegate_8y1drh$_0.add_pqktxj$(position, child);
  };
  StackPanel$route$ObjectLiteral.prototype.addAfterDestroyHook_o14v8n$ = function (hook) {
    return this.$delegate_8y1drh$_0.addAfterDestroyHook_o14v8n$(hook);
  };
  StackPanel$route$ObjectLiteral.prototype.addAfterInsertHook_tcd33s$ = function (hook) {
    return this.$delegate_8y1drh$_0.addAfterInsertHook_tcd33s$(hook);
  };
  StackPanel$route$ObjectLiteral.prototype.addAll_xquxs0$ = function (children) {
    return this.$delegate_8y1drh$_0.addAll_xquxs0$(children);
  };
  StackPanel$route$ObjectLiteral.prototype.addBeforeDisposeHook_o14v8n$ = function (hook) {
    return this.$delegate_8y1drh$_0.addBeforeDisposeHook_o14v8n$(hook);
  };
  StackPanel$route$ObjectLiteral.prototype.addCssClass_61zpoe$ = function (css) {
    return this.$delegate_8y1drh$_0.addCssClass_61zpoe$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.addCssStyle_807zt1$ = function (css) {
    return this.$delegate_8y1drh$_0.addCssStyle_807zt1$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.addSurroundingCssClass_61zpoe$ = function (css) {
    return this.$delegate_8y1drh$_0.addSurroundingCssClass_61zpoe$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.addSurroundingCssStyle_807zt1$ = function (css) {
    return this.$delegate_8y1drh$_0.addSurroundingCssStyle_807zt1$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.blur = function () {
    return this.$delegate_8y1drh$_0.blur();
  };
  StackPanel$route$ObjectLiteral.prototype.clearParent = function () {
    return this.$delegate_8y1drh$_0.clearParent();
  };
  StackPanel$route$ObjectLiteral.prototype.dispose = function () {
    return this.$delegate_8y1drh$_0.dispose();
  };
  StackPanel$route$ObjectLiteral.prototype.disposeAll = function () {
    return this.$delegate_8y1drh$_0.disposeAll();
  };
  StackPanel$route$ObjectLiteral.prototype.focus = function () {
    return this.$delegate_8y1drh$_0.focus();
  };
  StackPanel$route$ObjectLiteral.prototype.getAttribute_61zpoe$ = function (name) {
    return this.$delegate_8y1drh$_0.getAttribute_61zpoe$(name);
  };
  StackPanel$route$ObjectLiteral.prototype.getChildren = function () {
    return this.$delegate_8y1drh$_0.getChildren();
  };
  StackPanel$route$ObjectLiteral.prototype.getElement = function () {
    return this.$delegate_8y1drh$_0.getElement();
  };
  StackPanel$route$ObjectLiteral.prototype.getElementD = function () {
    return this.$delegate_8y1drh$_0.getElementD();
  };
  StackPanel$route$ObjectLiteral.prototype.getRoot = function () {
    return this.$delegate_8y1drh$_0.getRoot();
  };
  StackPanel$route$ObjectLiteral.prototype.hasCssClass_61zpoe$ = function (css) {
    return this.$delegate_8y1drh$_0.hasCssClass_61zpoe$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.invoke_4h7hma$ = function (children) {
    return this.$delegate_8y1drh$_0.invoke_4h7hma$(children);
  };
  StackPanel$route$ObjectLiteral.prototype.remove_87eobz$ = function (child) {
    return this.$delegate_8y1drh$_0.remove_87eobz$(child);
  };
  StackPanel$route$ObjectLiteral.prototype.removeAll = function () {
    return this.$delegate_8y1drh$_0.removeAll();
  };
  StackPanel$route$ObjectLiteral.prototype.removeAt_za3lpa$ = function (position) {
    return this.$delegate_8y1drh$_0.removeAt_za3lpa$(position);
  };
  StackPanel$route$ObjectLiteral.prototype.removeAttribute_61zpoe$ = function (name) {
    return this.$delegate_8y1drh$_0.removeAttribute_61zpoe$(name);
  };
  StackPanel$route$ObjectLiteral.prototype.removeCssClass_61zpoe$ = function (css) {
    return this.$delegate_8y1drh$_0.removeCssClass_61zpoe$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.removeCssStyle_807zt1$ = function (css) {
    return this.$delegate_8y1drh$_0.removeCssStyle_807zt1$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.removeSurroundingCssClass_61zpoe$ = function (css) {
    return this.$delegate_8y1drh$_0.removeSurroundingCssClass_61zpoe$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.removeSurroundingCssStyle_807zt1$ = function (css) {
    return this.$delegate_8y1drh$_0.removeSurroundingCssStyle_807zt1$(css);
  };
  StackPanel$route$ObjectLiteral.prototype.renderVNode = function () {
    return this.$delegate_8y1drh$_0.renderVNode();
  };
  StackPanel$route$ObjectLiteral.prototype.setAttribute_puj7f4$ = function (name, value) {
    return this.$delegate_8y1drh$_0.setAttribute_puj7f4$(name, value);
  };
  StackPanel$route$ObjectLiteral.prototype.singleRender_klfg04$ = function (block) {
    return this.$delegate_8y1drh$_0.singleRender_klfg04$(block);
  };
  StackPanel$route$ObjectLiteral.prototype.singleRenderAsync_o14v8n$ = function (block) {
    return this.$delegate_8y1drh$_0.singleRenderAsync_o14v8n$(block);
  };
  StackPanel$route$ObjectLiteral.prototype.unaryPlus_pdl1vz$ = function ($receiver) {
    return this.$delegate_8y1drh$_0.unaryPlus_pdl1vz$($receiver);
  };
  StackPanel$route$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [Container]};
  StackPanel.prototype.route_q2ccga$ = function (route, builder) {
    builder(new StackPanel$route$ObjectLiteral(route, this));
  };
  StackPanel.prototype.add_87eobz$ = function (child) {
    SimplePanel.prototype.add_87eobz$.call(this, child);
    if (this.activateLast_59642c$_0)
      this.activeIndex = ensureNotNull(this.children).size - 1 | 0;
    else if (this.activeIndex === -1)
      this.activeIndex = 0;
    return this;
  };
  StackPanel.prototype.add_pqktxj$ = function (position, child) {
    SimplePanel.prototype.add_pqktxj$.call(this, position, child);
    if (this.activateLast_59642c$_0)
      this.activeIndex = ensureNotNull(this.children).size - 1 | 0;
    else if (this.activeIndex === -1)
      this.activeIndex = 0;
    return this;
  };
  StackPanel.prototype.addAll_xquxs0$ = function (children) {
    SimplePanel.prototype.addAll_xquxs0$.call(this, children);
    if (this.activateLast_59642c$_0)
      this.activeIndex = ensureNotNull(this.children).size - 1 | 0;
    else if (this.activeIndex === -1)
      this.activeIndex = 0;
    return this;
  };
  StackPanel.prototype.remove_87eobz$ = function (child) {
    var tmp$;
    SimplePanel.prototype.remove_87eobz$.call(this, child);
    var $receiver = this.childrenMap_8be2vx$;
    var destination = LinkedHashMap_init();
    var tmp$_0;
    tmp$_0 = $receiver.entries.iterator();
    while (tmp$_0.hasNext()) {
      var element = tmp$_0.next();
      if (equals(element.value, child)) {
        destination.put_xwzc9p$(element.key, element.value);
      }}
    if ((tmp$ = firstOrNull_0(destination.keys)) != null) {
      this.childrenMap_8be2vx$.remove_11rb$(tmp$);
    }if (this.children != null && this.activeIndex > (ensureNotNull(this.children).size - 1 | 0))
      this.activeIndex = ensureNotNull(this.children).size - 1 | 0;
    return this;
  };
  StackPanel.prototype.removeAt_za3lpa$ = function (position) {
    var tmp$;
    var child = (tmp$ = this.children) != null ? getOrNull(tmp$, position) : null;
    if (child != null)
      this.remove_87eobz$(child);
    return this;
  };
  StackPanel.prototype.removeAll = function () {
    SimplePanel.prototype.removeAll.call(this);
    this.childrenMap_8be2vx$.clear();
    if (this.children != null && this.activeIndex > (ensureNotNull(this.children).size - 1 | 0))
      this.activeIndex = ensureNotNull(this.children).size - 1 | 0;
    return this;
  };
  function StackPanel$Companion() {
    StackPanel$Companion_instance = this;
    this.counter_8be2vx$ = 0;
  }
  StackPanel$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var StackPanel$Companion_instance = null;
  function StackPanel$Companion_getInstance() {
    if (StackPanel$Companion_instance === null) {
      new StackPanel$Companion();
    }return StackPanel$Companion_instance;
  }
  StackPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'StackPanel', interfaces: [SimplePanel]};
  function stackPanel($receiver, activateLast, className, init) {
    if (activateLast === void 0)
      activateLast = true;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var stackPanel = new StackPanel(activateLast, className, init);
    $receiver.add_87eobz$(stackPanel);
    return stackPanel;
  }
  function VPanel(justify, alignItems, spacing, useWrappers, className, init) {
    if (justify === void 0)
      justify = null;
    if (alignItems === void 0)
      alignItems = null;
    if (spacing === void 0)
      spacing = null;
    if (useWrappers === void 0)
      useWrappers = KVManager_getInstance().panelsCompatibilityMode_8be2vx$;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    FlexPanel.call(this, FlexDirection$COLUMN_getInstance(), null, justify, alignItems, null, spacing, useWrappers, className);
    init != null ? init(this) : null;
  }
  VPanel.$metadata$ = {kind: Kind_CLASS, simpleName: 'VPanel', interfaces: [FlexPanel]};
  function vPanel($receiver, justify, alignItems, spacing, useWrappers, className, init) {
    if (justify === void 0)
      justify = null;
    if (alignItems === void 0)
      alignItems = null;
    if (spacing === void 0)
      spacing = null;
    if (useWrappers === void 0)
      useWrappers = KVManager_getInstance().panelsCompatibilityMode_8be2vx$;
    if (className === void 0)
      className = null;
    if (init === void 0)
      init = null;
    var vpanel = new VPanel(justify, alignItems, spacing, useWrappers, className, init);
    $receiver.add_87eobz$(vpanel);
    return vpanel;
  }
  function KVRouter() {
  }
  KVRouter.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'KVRouter', interfaces: []};
  function RouterFactory() {
  }
  RouterFactory.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'RouterFactory', interfaces: []};
  function DummyRouter() {
  }
  DummyRouter.prototype.kvNavigate_61zpoe$ = function (route) {
  };
  DummyRouter.prototype.kvOn_a1vqyy$ = function (route, handler) {
    return this;
  };
  DummyRouter.prototype.kvOff_5ij4lk$ = function (handler) {
  };
  DummyRouter.prototype.kvResolve = function () {
  };
  DummyRouter.prototype.kvDestroy = function () {
  };
  DummyRouter.$metadata$ = {kind: Kind_CLASS, simpleName: 'DummyRouter', interfaces: [KVRouter]};
  function DummyRouterFactory() {
    this.router_0 = new DummyRouter();
  }
  DummyRouterFactory.prototype.getRouter = function () {
    return this.router_0;
  };
  DummyRouterFactory.prototype.initRouter = function () {
  };
  DummyRouterFactory.prototype.shutdownRouter = function () {
  };
  DummyRouterFactory.$metadata$ = {kind: Kind_CLASS, simpleName: 'DummyRouterFactory', interfaces: [RouterFactory]};
  function RoutingManager() {
    RoutingManager_instance = this;
    this.routerFactory = new DummyRouterFactory();
  }
  RoutingManager.prototype.initRouter = function () {
    this.routerFactory.initRouter();
  };
  RoutingManager.prototype.shutdownRouter = function () {
    this.routerFactory.shutdownRouter();
  };
  RoutingManager.prototype.getRouter = function () {
    return this.routerFactory.getRouter();
  };
  RoutingManager.$metadata$ = {kind: Kind_OBJECT, simpleName: 'RoutingManager', interfaces: []};
  var RoutingManager_instance = null;
  function RoutingManager_getInstance() {
    if (RoutingManager_instance === null) {
      new RoutingManager();
    }return RoutingManager_instance;
  }
  var attributesModule;
  var classModule;
  var propsModule;
  var styleModule;
  var eventListenersModule;
  function set($receiver, key, value) {
    $receiver[key] = value;
  }
  function ObservableState() {
  }
  ObservableState.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'ObservableState', interfaces: []};
  function MutableState() {
  }
  MutableState.$metadata$ = {kind: Kind_INTERFACE, simpleName: 'MutableState', interfaces: [ObservableState]};
  Delegates$observable$ObjectLiteral.prototype = Object.create(ObservableProperty.prototype);
  Delegates$observable$ObjectLiteral.prototype.constructor = Delegates$observable$ObjectLiteral;
  function Delegates$observable$ObjectLiteral(closure$onChange, initialValue) {
    this.closure$onChange = closure$onChange;
    ObservableProperty.call(this, initialValue);
  }
  Delegates$observable$ObjectLiteral.prototype.afterChange_jxtfl0$ = function (property, oldValue, newValue) {
    this.closure$onChange(property, oldValue, newValue);
  };
  Delegates$observable$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [ObservableProperty]};
  function ObservableValue(value) {
    this.observers = ArrayList_init();
    this.value_x59t87$_0 = new Delegates$observable$ObjectLiteral(ObservableValue$value$lambda(this), value);
  }
  var ObservableValue$value_metadata = new PropertyMetadata('value');
  Object.defineProperty(ObservableValue.prototype, 'value', {configurable: true, get: function () {
    return this.value_x59t87$_0.getValue_lrcp0p$(this, ObservableValue$value_metadata);
  }, set: function (value) {
    this.value_x59t87$_0.setValue_9rddgb$(this, ObservableValue$value_metadata, value);
  }});
  ObservableValue.prototype.getState = function () {
    return this.value;
  };
  ObservableValue.prototype.setState_11rb$ = function (state) {
    this.value = state;
  };
  function ObservableValue$subscribe$lambda(this$ObservableValue, closure$observer) {
    return function () {
      var $receiver = this$ObservableValue.observers;
      var element = closure$observer;
      $receiver.remove_11rb$(element);
      return Unit;
    };
  }
  ObservableValue.prototype.subscribe_qlkmfe$ = function (observer) {
    this.observers.add_11rb$(observer);
    observer(this.value);
    return ObservableValue$subscribe$lambda(this, observer);
  };
  function ObservableValue$value$lambda(this$ObservableValue) {
    return function (f, f_0, new_0) {
      var $receiver = this$ObservableValue.observers;
      var destination = ArrayList_init_0(collectionSizeOrDefault($receiver, 10));
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        destination.add_11rb$(item);
      }
      var copy = destination;
      var tmp$_0;
      tmp$_0 = copy.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        if (this$ObservableValue.observers.contains_11rb$(element)) {
          element(new_0);
        }}
      return Unit;
    };
  }
  ObservableValue.$metadata$ = {kind: Kind_CLASS, simpleName: 'ObservableValue', interfaces: [MutableState]};
  function toDateF($receiver, format) {
    if (format === void 0)
      format = types.KV_DEFAULT_DATE_FORMAT;
    var result = KVManager_getInstance().fecha_8be2vx$.parse($receiver, format);
    return result ? result : new Date();
  }
  function toStringF($receiver, format) {
    if (format === void 0)
      format = types.KV_DEFAULT_DATE_FORMAT;
    return KVManager_getInstance().fecha_8be2vx$.format($receiver, format);
  }
  function DateSerializer() {
    DateSerializer_instance = this;
    this.descriptor_tma6qd$_0 = buildClassSerialDescriptor('kotlin.js.Date', []);
  }
  Object.defineProperty(DateSerializer.prototype, 'descriptor', {configurable: true, get: function () {
    return this.descriptor_tma6qd$_0;
  }});
  DateSerializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var tmp$;
    var str = decoder.decodeString();
    if (str.length === 10) {
      tmp$ = toDateF(str + ' 00:00:00');
    } else {
      tmp$ = toDateF(str);
    }
    return tmp$;
  };
  DateSerializer.prototype.serialize_55azsf$ = function (encoder, value) {
    encoder.encodeString_61zpoe$(toStringF(value));
  };
  DateSerializer.$metadata$ = {kind: Kind_OBJECT, simpleName: 'DateSerializer', interfaces: [KSerializer]};
  var DateSerializer_instance = null;
  function DateSerializer_getInstance() {
    if (DateSerializer_instance === null) {
      new DateSerializer();
    }return DateSerializer_instance;
  }
  function delete_0(thing, key) {
    delete thing[key];
  }
  function createInstance($receiver, args) {
    var jsClassConstructor = $receiver;
    var argsArray = copyToArray(plus_1(listOf_0(null), args));
    return new (Function.prototype.bind.apply(jsClassConstructor, argsArray))();
  }
  function LegacyTest(test) {
    if (test === void 0)
      test = true;
    this.test = test;
  }
  LegacyTest.$metadata$ = {kind: Kind_CLASS, simpleName: 'LegacyTest', interfaces: []};
  LegacyTest.prototype.component1 = function () {
    return this.test;
  };
  LegacyTest.prototype.copy_6taknv$ = function (test) {
    return new LegacyTest(test === void 0 ? this.test : test);
  };
  LegacyTest.prototype.toString = function () {
    return 'LegacyTest(test=' + Kotlin.toString(this.test) + ')';
  };
  LegacyTest.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.test) | 0;
    return result;
  };
  LegacyTest.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.test, other.test))));
  };
  function isLegacyBackend$lambda() {
    return (new LegacyTest())['test'] == true;
  }
  var isLegacyBackend;
  function get_isLegacyBackend() {
    return isLegacyBackend.value;
  }
  function getAllPropertyNamesForIR(obj) {
    var prototype = Object.getPrototypeOf(obj);
    var prototypeProps = Object.getOwnPropertyNames(prototype);
    var destination = ArrayList_init();
    var tmp$;
    for (tmp$ = 0; tmp$ !== prototypeProps.length; ++tmp$) {
      var element = prototypeProps[tmp$];
      if (!equals(element, 'constructor'))
        destination.add_11rb$(element);
    }
    var destination_0 = ArrayList_init();
    var tmp$_0;
    tmp$_0 = destination.iterator();
    while (tmp$_0.hasNext()) {
      var element_0 = tmp$_0.next();
      if (!prototype.propertyIsEnumerable(element_0))
        destination_0.add_11rb$(element_0);
    }
    return toList(destination_0);
  }
  function toPlainObj(data) {
    var tmp$;
    if (get_isLegacyBackend()) {
      tmp$ = data;
    } else {
      var properties = getAllPropertyNamesForIR(data);
      var ret = {};
      var tmp$_0;
      tmp$_0 = properties.iterator();
      while (tmp$_0.hasNext()) {
        var element = tmp$_0.next();
        ret[element] = data[element];
      }
      tmp$ = ret;
    }
    return tmp$;
  }
  function toKotlinObj(data, kClass) {
    var tmp$, tmp$_0;
    var prototype = Object.getPrototypeOf(data);
    if (get_isLegacyBackend() && prototype != null && prototype.constructor != undefined && prototype.constructor.name == kClass.simpleName) {
      tmp$_0 = data;
    } else {
      var newT = createInstance(get_js(kClass), []);
      tmp$ = iterator(Object.keys(data));
      while (tmp$.hasNext()) {
        var key = tmp$.next();
        newT[key] = data[key];
      }
      tmp$_0 = newT;
    }
    return tmp$_0;
  }
  function deepMerge$isObject(obj) {
    var tmp$ = obj != null && obj != undefined;
    if (tmp$) {
      tmp$ = typeof obj === 'object';
    }return tmp$;
  }
  function deepMerge(target, source) {
    var tmp$;
    var isObject = deepMerge$isObject;
    if (!isObject(target) || !isObject(source))
      return source;
    tmp$ = iterator(Object.keys(source));
    while (tmp$.hasNext()) {
      var key = tmp$.next();
      var targetValue = target[key];
      var sourceValue = source[key];
      if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        target[key] = targetValue.concat(sourceValue);
      } else if (isObject(targetValue) && isObject(sourceValue)) {
        target[key] = deepMerge(Object.assign({}, targetValue), sourceValue);
      } else {
        target[key] = sourceValue;
      }
    }
    return target;
  }
  var ENTER_KEY;
  var ESC_KEY;
  function Serialization() {
    Serialization_instance = this;
    this.plain = Json_0(void 0, Serialization$plain$lambda);
    this.customConfiguration = null;
  }
  Serialization.prototype.toObj_irb06o$ = defineInlineFunction('kvision-js-legacy.io.kvision.utils.Serialization.toObj_irb06o$', wrapFunction(function () {
    var getReifiedTypeParameterKType = Kotlin.getReifiedTypeParameterKType;
    var serializer = _.$$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-js-legacy'].kotlinx.serialization.serializer_saj79j$;
    var KSerializer = _.$$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-js-legacy'].kotlinx.serialization.KSerializer;
    var throwCCE = Kotlin.throwCCE;
    return function (T_0, isT, $receiver) {
      var tmp$;
      return this.toObj_41vw14$($receiver, Kotlin.isType(tmp$ = serializer(getReifiedTypeParameterKType(T_0)), KSerializer) ? tmp$ : throwCCE());
    };
  }));
  Serialization.prototype.toObj_41vw14$ = function ($receiver, serializer) {
    var tmp$;
    return JSON.parse(((tmp$ = this.customConfiguration) != null ? tmp$ : this.plain).encodeToString_tf03ej$(serializer, $receiver));
  };
  function Serialization$plain$lambda($receiver) {
    $receiver.serializersModule = serializersModuleOf(getKClass(Date), DateSerializer_getInstance());
    return Unit;
  }
  Serialization.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Serialization', interfaces: []};
  var Serialization_instance = null;
  function Serialization_getInstance() {
    if (Serialization_instance === null) {
      new Serialization();
    }return Serialization_instance;
  }
  function on(target) {
    var obj = {};
    obj['self'] = target;
    return obj;
  }
  function emptyOn() {
    return {};
  }
  function get_px($receiver) {
    return new Pair($receiver, UNIT$px_getInstance());
  }
  function get_em($receiver) {
    return new Pair($receiver, UNIT$em_getInstance());
  }
  function get_perc($receiver) {
    return new Pair($receiver, UNIT$perc_getInstance());
  }
  function get_pc($receiver) {
    return new Pair($receiver, UNIT$pc_getInstance());
  }
  function get_vh($receiver) {
    return new Pair($receiver, UNIT$vh_getInstance());
  }
  var auto;
  var normal;
  function asString($receiver) {
    var tmp$;
    switch ($receiver.second.name) {
      case 'auto':
        tmp$ = 'auto';
        break;
      case 'normal':
        tmp$ = 'normal';
        break;
      default:tmp$ = $receiver.first.toString() + $receiver.second.unit_8be2vx$;
        break;
    }
    return tmp$;
  }
  var hex;
  function toHexString($receiver) {
    var result = '';
    var num = $receiver;
    for (var i = 0; i < 6; i++) {
      result = hex[num & 15] + result;
      num = num >> 4;
    }
    return result;
  }
  function syncWithList($receiver, list) {
    var tmp$, tmp$_0;
    if (list.isEmpty()) {
      $receiver.clear();
    } else {
      tmp$ = $receiver.size - 1 | 0;
      tmp$_0 = list.size;
      for (var pos = tmp$; pos >= tmp$_0; pos--)
        $receiver.removeAt_za3lpa$(pos);
      var tmp$_1, tmp$_0_0;
      var index = 0;
      tmp$_1 = list.iterator();
      while (tmp$_1.hasNext()) {
        var item = tmp$_1.next();
        var index_0 = checkIndexOverflow((tmp$_0_0 = index, index = tmp$_0_0 + 1 | 0, tmp$_0_0));
        if (index_0 < $receiver.size) {
          if (!equals($receiver.get_za3lpa$(index_0), item))
            $receiver.set_wxm5ur$(index_0, item);
        } else {
          $receiver.add_11rb$(item);
        }
      }
    }
  }
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  package$kvision.Application = Application;
  package$kvision.startApplication_e0t03v$ = startApplication;
  package$kvision.ModuleInitializer = ModuleInitializer;
  Object.defineProperty(package$kvision, 'CoreModule', {get: CoreModule_getInstance});
  Object.defineProperty(package$kvision, 'KVManager', {get: KVManager_getInstance});
  var package$core = package$kvision.core || (package$kvision.core = {});
  package$core.AttributeSetBuilder = AttributeSetBuilder;
  package$core.AttributeSetBuilderImpl = AttributeSetBuilderImpl;
  package$core.buildAttributeSet_t5lcc8$ = buildAttributeSet;
  package$core.ClassSetBuilder = ClassSetBuilder;
  package$core.ClassSetBuilderImpl = ClassSetBuilderImpl;
  package$core.buildClassSet_ycocgk$ = buildClassSet;
  package$core.Component = Component;
  package$core.Container = Container;
  Object.defineProperty(UNIT, 'px', {get: UNIT$px_getInstance});
  Object.defineProperty(UNIT, 'pt', {get: UNIT$pt_getInstance});
  Object.defineProperty(UNIT, 'em', {get: UNIT$em_getInstance});
  Object.defineProperty(UNIT, 'cm', {get: UNIT$cm_getInstance});
  Object.defineProperty(UNIT, 'mm', {get: UNIT$mm_getInstance});
  Object.defineProperty(UNIT, 'in', {get: UNIT$in_getInstance});
  Object.defineProperty(UNIT, 'pc', {get: UNIT$pc_getInstance});
  Object.defineProperty(UNIT, 'ch', {get: UNIT$ch_getInstance});
  Object.defineProperty(UNIT, 'rem', {get: UNIT$rem_getInstance});
  Object.defineProperty(UNIT, 'vw', {get: UNIT$vw_getInstance});
  Object.defineProperty(UNIT, 'vh', {get: UNIT$vh_getInstance});
  Object.defineProperty(UNIT, 'vmin', {get: UNIT$vmin_getInstance});
  Object.defineProperty(UNIT, 'vmax', {get: UNIT$vmax_getInstance});
  Object.defineProperty(UNIT, 'perc', {get: UNIT$perc_getInstance});
  Object.defineProperty(UNIT, 'auto', {get: UNIT$auto_getInstance});
  Object.defineProperty(UNIT, 'normal', {get: UNIT$normal_getInstance});
  package$core.UNIT = UNIT;
  Object.defineProperty(Col, 'ALICEBLUE', {get: Col$ALICEBLUE_getInstance});
  Object.defineProperty(Col, 'ANTIQUEWHITE', {get: Col$ANTIQUEWHITE_getInstance});
  Object.defineProperty(Col, 'AQUA', {get: Col$AQUA_getInstance});
  Object.defineProperty(Col, 'AQUAMARINE', {get: Col$AQUAMARINE_getInstance});
  Object.defineProperty(Col, 'AZURE', {get: Col$AZURE_getInstance});
  Object.defineProperty(Col, 'BEIGE', {get: Col$BEIGE_getInstance});
  Object.defineProperty(Col, 'BISQUE', {get: Col$BISQUE_getInstance});
  Object.defineProperty(Col, 'BLACK', {get: Col$BLACK_getInstance});
  Object.defineProperty(Col, 'BLANCHEDALMOND', {get: Col$BLANCHEDALMOND_getInstance});
  Object.defineProperty(Col, 'BLUE', {get: Col$BLUE_getInstance});
  Object.defineProperty(Col, 'BLUEVIOLET', {get: Col$BLUEVIOLET_getInstance});
  Object.defineProperty(Col, 'BROWN', {get: Col$BROWN_getInstance});
  Object.defineProperty(Col, 'BURLYWOOD', {get: Col$BURLYWOOD_getInstance});
  Object.defineProperty(Col, 'CADETBLUE', {get: Col$CADETBLUE_getInstance});
  Object.defineProperty(Col, 'CHARTREUSE', {get: Col$CHARTREUSE_getInstance});
  Object.defineProperty(Col, 'CHOCOLATE', {get: Col$CHOCOLATE_getInstance});
  Object.defineProperty(Col, 'CORAL', {get: Col$CORAL_getInstance});
  Object.defineProperty(Col, 'CORNFLOWERBLUE', {get: Col$CORNFLOWERBLUE_getInstance});
  Object.defineProperty(Col, 'CORNSILK', {get: Col$CORNSILK_getInstance});
  Object.defineProperty(Col, 'CRIMSON', {get: Col$CRIMSON_getInstance});
  Object.defineProperty(Col, 'CYAN', {get: Col$CYAN_getInstance});
  Object.defineProperty(Col, 'DARKBLUE', {get: Col$DARKBLUE_getInstance});
  Object.defineProperty(Col, 'DARKCYAN', {get: Col$DARKCYAN_getInstance});
  Object.defineProperty(Col, 'DARKGOLDENROD', {get: Col$DARKGOLDENROD_getInstance});
  Object.defineProperty(Col, 'DARKGRAY', {get: Col$DARKGRAY_getInstance});
  Object.defineProperty(Col, 'DARKGREEN', {get: Col$DARKGREEN_getInstance});
  Object.defineProperty(Col, 'DARKKHAKI', {get: Col$DARKKHAKI_getInstance});
  Object.defineProperty(Col, 'DARKMAGENTA', {get: Col$DARKMAGENTA_getInstance});
  Object.defineProperty(Col, 'DARKOLIVEGREEN', {get: Col$DARKOLIVEGREEN_getInstance});
  Object.defineProperty(Col, 'DARKORANGE', {get: Col$DARKORANGE_getInstance});
  Object.defineProperty(Col, 'DARKORCHID', {get: Col$DARKORCHID_getInstance});
  Object.defineProperty(Col, 'DARKRED', {get: Col$DARKRED_getInstance});
  Object.defineProperty(Col, 'DARKSALMON', {get: Col$DARKSALMON_getInstance});
  Object.defineProperty(Col, 'DARKSEAGREEN', {get: Col$DARKSEAGREEN_getInstance});
  Object.defineProperty(Col, 'DARKSLATEBLUE', {get: Col$DARKSLATEBLUE_getInstance});
  Object.defineProperty(Col, 'DARKSLATEGRAY', {get: Col$DARKSLATEGRAY_getInstance});
  Object.defineProperty(Col, 'DARKTURQUOISE', {get: Col$DARKTURQUOISE_getInstance});
  Object.defineProperty(Col, 'DARKVIOLET', {get: Col$DARKVIOLET_getInstance});
  Object.defineProperty(Col, 'DEEPPINK', {get: Col$DEEPPINK_getInstance});
  Object.defineProperty(Col, 'DEEPSKYBLUE', {get: Col$DEEPSKYBLUE_getInstance});
  Object.defineProperty(Col, 'DIMGRAY', {get: Col$DIMGRAY_getInstance});
  Object.defineProperty(Col, 'DODGERBLUE', {get: Col$DODGERBLUE_getInstance});
  Object.defineProperty(Col, 'FIREBRICK', {get: Col$FIREBRICK_getInstance});
  Object.defineProperty(Col, 'FLORALWHITE', {get: Col$FLORALWHITE_getInstance});
  Object.defineProperty(Col, 'FORESTGREEN', {get: Col$FORESTGREEN_getInstance});
  Object.defineProperty(Col, 'FUCHSIA', {get: Col$FUCHSIA_getInstance});
  Object.defineProperty(Col, 'GAINSBORO', {get: Col$GAINSBORO_getInstance});
  Object.defineProperty(Col, 'GHOSTWHITE', {get: Col$GHOSTWHITE_getInstance});
  Object.defineProperty(Col, 'GOLD', {get: Col$GOLD_getInstance});
  Object.defineProperty(Col, 'GOLDENROD', {get: Col$GOLDENROD_getInstance});
  Object.defineProperty(Col, 'GRAY', {get: Col$GRAY_getInstance});
  Object.defineProperty(Col, 'GREEN', {get: Col$GREEN_getInstance});
  Object.defineProperty(Col, 'GREENYELLOW', {get: Col$GREENYELLOW_getInstance});
  Object.defineProperty(Col, 'HONEYDEW', {get: Col$HONEYDEW_getInstance});
  Object.defineProperty(Col, 'HOTPINK', {get: Col$HOTPINK_getInstance});
  Object.defineProperty(Col, 'INDIANRED', {get: Col$INDIANRED_getInstance});
  Object.defineProperty(Col, 'INDIGO', {get: Col$INDIGO_getInstance});
  Object.defineProperty(Col, 'IVORY', {get: Col$IVORY_getInstance});
  Object.defineProperty(Col, 'KHAKI', {get: Col$KHAKI_getInstance});
  Object.defineProperty(Col, 'LAVENDER', {get: Col$LAVENDER_getInstance});
  Object.defineProperty(Col, 'LAVENDERBLUSH', {get: Col$LAVENDERBLUSH_getInstance});
  Object.defineProperty(Col, 'LAWNGREEN', {get: Col$LAWNGREEN_getInstance});
  Object.defineProperty(Col, 'LEMONCHIFFON', {get: Col$LEMONCHIFFON_getInstance});
  Object.defineProperty(Col, 'LIGHTBLUE', {get: Col$LIGHTBLUE_getInstance});
  Object.defineProperty(Col, 'LIGHTCORAL', {get: Col$LIGHTCORAL_getInstance});
  Object.defineProperty(Col, 'LIGHTCYAN', {get: Col$LIGHTCYAN_getInstance});
  Object.defineProperty(Col, 'LIGHTGOLDENRODYELLOW', {get: Col$LIGHTGOLDENRODYELLOW_getInstance});
  Object.defineProperty(Col, 'LIGHTGRAY', {get: Col$LIGHTGRAY_getInstance});
  Object.defineProperty(Col, 'LIGHTGREEN', {get: Col$LIGHTGREEN_getInstance});
  Object.defineProperty(Col, 'LIGHTPINK', {get: Col$LIGHTPINK_getInstance});
  Object.defineProperty(Col, 'LIGHTSALMON', {get: Col$LIGHTSALMON_getInstance});
  Object.defineProperty(Col, 'LIGHTSEAGREEN', {get: Col$LIGHTSEAGREEN_getInstance});
  Object.defineProperty(Col, 'LIGHTSKYBLUE', {get: Col$LIGHTSKYBLUE_getInstance});
  Object.defineProperty(Col, 'LIGHTSLATEGRAY', {get: Col$LIGHTSLATEGRAY_getInstance});
  Object.defineProperty(Col, 'LIGHTSTEELBLUE', {get: Col$LIGHTSTEELBLUE_getInstance});
  Object.defineProperty(Col, 'LIGHTYELLOW', {get: Col$LIGHTYELLOW_getInstance});
  Object.defineProperty(Col, 'LIME', {get: Col$LIME_getInstance});
  Object.defineProperty(Col, 'LIMEGREEN', {get: Col$LIMEGREEN_getInstance});
  Object.defineProperty(Col, 'LINEN', {get: Col$LINEN_getInstance});
  Object.defineProperty(Col, 'MAGENTA', {get: Col$MAGENTA_getInstance});
  Object.defineProperty(Col, 'MAROON', {get: Col$MAROON_getInstance});
  Object.defineProperty(Col, 'MEDIUMAQUAMARINE', {get: Col$MEDIUMAQUAMARINE_getInstance});
  Object.defineProperty(Col, 'MEDIUMBLUE', {get: Col$MEDIUMBLUE_getInstance});
  Object.defineProperty(Col, 'MEDIUMORCHID', {get: Col$MEDIUMORCHID_getInstance});
  Object.defineProperty(Col, 'MEDIUMPURPLE', {get: Col$MEDIUMPURPLE_getInstance});
  Object.defineProperty(Col, 'MEDIUMSEAGREEN', {get: Col$MEDIUMSEAGREEN_getInstance});
  Object.defineProperty(Col, 'MEDIUMSLATEBLUE', {get: Col$MEDIUMSLATEBLUE_getInstance});
  Object.defineProperty(Col, 'MEDIUMSPRINGGREEN', {get: Col$MEDIUMSPRINGGREEN_getInstance});
  Object.defineProperty(Col, 'MEDIUMTURQUOISE', {get: Col$MEDIUMTURQUOISE_getInstance});
  Object.defineProperty(Col, 'MEDIUMVIOLETRED', {get: Col$MEDIUMVIOLETRED_getInstance});
  Object.defineProperty(Col, 'MIDNIGHTBLUE', {get: Col$MIDNIGHTBLUE_getInstance});
  Object.defineProperty(Col, 'MINTCREAM', {get: Col$MINTCREAM_getInstance});
  Object.defineProperty(Col, 'MISTYROSE', {get: Col$MISTYROSE_getInstance});
  Object.defineProperty(Col, 'MOCCASIN', {get: Col$MOCCASIN_getInstance});
  Object.defineProperty(Col, 'NAVAJOWHITE', {get: Col$NAVAJOWHITE_getInstance});
  Object.defineProperty(Col, 'NAVY', {get: Col$NAVY_getInstance});
  Object.defineProperty(Col, 'OLDLACE', {get: Col$OLDLACE_getInstance});
  Object.defineProperty(Col, 'OLIVE', {get: Col$OLIVE_getInstance});
  Object.defineProperty(Col, 'OLIVEDRAB', {get: Col$OLIVEDRAB_getInstance});
  Object.defineProperty(Col, 'ORANGE', {get: Col$ORANGE_getInstance});
  Object.defineProperty(Col, 'ORANGERED', {get: Col$ORANGERED_getInstance});
  Object.defineProperty(Col, 'ORCHID', {get: Col$ORCHID_getInstance});
  Object.defineProperty(Col, 'PALEGOLDENROD', {get: Col$PALEGOLDENROD_getInstance});
  Object.defineProperty(Col, 'PALEGREEN', {get: Col$PALEGREEN_getInstance});
  Object.defineProperty(Col, 'PALETURQUOISE', {get: Col$PALETURQUOISE_getInstance});
  Object.defineProperty(Col, 'PALEVIOLETRED', {get: Col$PALEVIOLETRED_getInstance});
  Object.defineProperty(Col, 'PAPAYAWHIP', {get: Col$PAPAYAWHIP_getInstance});
  Object.defineProperty(Col, 'PEACHPUFF', {get: Col$PEACHPUFF_getInstance});
  Object.defineProperty(Col, 'PERU', {get: Col$PERU_getInstance});
  Object.defineProperty(Col, 'PINK', {get: Col$PINK_getInstance});
  Object.defineProperty(Col, 'PLUM', {get: Col$PLUM_getInstance});
  Object.defineProperty(Col, 'POWDERBLUE', {get: Col$POWDERBLUE_getInstance});
  Object.defineProperty(Col, 'PURPLE', {get: Col$PURPLE_getInstance});
  Object.defineProperty(Col, 'REBECCAPURPLE', {get: Col$REBECCAPURPLE_getInstance});
  Object.defineProperty(Col, 'RED', {get: Col$RED_getInstance});
  Object.defineProperty(Col, 'ROSYBROWN', {get: Col$ROSYBROWN_getInstance});
  Object.defineProperty(Col, 'ROYALBLUE', {get: Col$ROYALBLUE_getInstance});
  Object.defineProperty(Col, 'SADDLEBROWN', {get: Col$SADDLEBROWN_getInstance});
  Object.defineProperty(Col, 'SALMON', {get: Col$SALMON_getInstance});
  Object.defineProperty(Col, 'SANDYBROWN', {get: Col$SANDYBROWN_getInstance});
  Object.defineProperty(Col, 'SEAGREEN', {get: Col$SEAGREEN_getInstance});
  Object.defineProperty(Col, 'SEASHELL', {get: Col$SEASHELL_getInstance});
  Object.defineProperty(Col, 'SIENNA', {get: Col$SIENNA_getInstance});
  Object.defineProperty(Col, 'SILVER', {get: Col$SILVER_getInstance});
  Object.defineProperty(Col, 'SKYBLUE', {get: Col$SKYBLUE_getInstance});
  Object.defineProperty(Col, 'SLATEBLUE', {get: Col$SLATEBLUE_getInstance});
  Object.defineProperty(Col, 'SLATEGRAY', {get: Col$SLATEGRAY_getInstance});
  Object.defineProperty(Col, 'SNOW', {get: Col$SNOW_getInstance});
  Object.defineProperty(Col, 'SPRINGGREEN', {get: Col$SPRINGGREEN_getInstance});
  Object.defineProperty(Col, 'STEELBLUE', {get: Col$STEELBLUE_getInstance});
  Object.defineProperty(Col, 'TAN', {get: Col$TAN_getInstance});
  Object.defineProperty(Col, 'TEAL', {get: Col$TEAL_getInstance});
  Object.defineProperty(Col, 'THISTLE', {get: Col$THISTLE_getInstance});
  Object.defineProperty(Col, 'TOMATO', {get: Col$TOMATO_getInstance});
  Object.defineProperty(Col, 'TURQUOISE', {get: Col$TURQUOISE_getInstance});
  Object.defineProperty(Col, 'VIOLET', {get: Col$VIOLET_getInstance});
  Object.defineProperty(Col, 'WHEAT', {get: Col$WHEAT_getInstance});
  Object.defineProperty(Col, 'WHITE', {get: Col$WHITE_getInstance});
  Object.defineProperty(Col, 'WHITESMOKE', {get: Col$WHITESMOKE_getInstance});
  Object.defineProperty(Col, 'YELLOW', {get: Col$YELLOW_getInstance});
  Object.defineProperty(Col, 'YELLOWGREEN', {get: Col$YELLOWGREEN_getInstance});
  package$core.Col = Col;
  Object.defineProperty(BgSize, 'COVER', {get: BgSize$COVER_getInstance});
  Object.defineProperty(BgSize, 'CONTAIN', {get: BgSize$CONTAIN_getInstance});
  package$core.BgSize = BgSize;
  Object.defineProperty(BgRepeat, 'REPEAT', {get: BgRepeat$REPEAT_getInstance});
  Object.defineProperty(BgRepeat, 'REPEATX', {get: BgRepeat$REPEATX_getInstance});
  Object.defineProperty(BgRepeat, 'REPEATY', {get: BgRepeat$REPEATY_getInstance});
  Object.defineProperty(BgRepeat, 'NOREPEAT', {get: BgRepeat$NOREPEAT_getInstance});
  package$core.BgRepeat = BgRepeat;
  Object.defineProperty(Display, 'INLINE', {get: Display$INLINE_getInstance});
  Object.defineProperty(Display, 'BLOCK', {get: Display$BLOCK_getInstance});
  Object.defineProperty(Display, 'FLEX', {get: Display$FLEX_getInstance});
  Object.defineProperty(Display, 'GRID', {get: Display$GRID_getInstance});
  Object.defineProperty(Display, 'INLINEBLOCK', {get: Display$INLINEBLOCK_getInstance});
  Object.defineProperty(Display, 'INLINEFLEX', {get: Display$INLINEFLEX_getInstance});
  Object.defineProperty(Display, 'INLINEGRID', {get: Display$INLINEGRID_getInstance});
  Object.defineProperty(Display, 'INLINETABLE', {get: Display$INLINETABLE_getInstance});
  Object.defineProperty(Display, 'LISTITEM', {get: Display$LISTITEM_getInstance});
  Object.defineProperty(Display, 'RUNIN', {get: Display$RUNIN_getInstance});
  Object.defineProperty(Display, 'TABLE', {get: Display$TABLE_getInstance});
  Object.defineProperty(Display, 'TABLECAPTION', {get: Display$TABLECAPTION_getInstance});
  Object.defineProperty(Display, 'TABLECOLUMNGROUP', {get: Display$TABLECOLUMNGROUP_getInstance});
  Object.defineProperty(Display, 'TABLEHEADERGROUP', {get: Display$TABLEHEADERGROUP_getInstance});
  Object.defineProperty(Display, 'TABLEFOOTERGROUP', {get: Display$TABLEFOOTERGROUP_getInstance});
  Object.defineProperty(Display, 'TABLEROWGROUP', {get: Display$TABLEROWGROUP_getInstance});
  Object.defineProperty(Display, 'TABLECELL', {get: Display$TABLECELL_getInstance});
  Object.defineProperty(Display, 'TABLECOLUMN', {get: Display$TABLECOLUMN_getInstance});
  Object.defineProperty(Display, 'TABLEROW', {get: Display$TABLEROW_getInstance});
  Object.defineProperty(Display, 'CONTENTS', {get: Display$CONTENTS_getInstance});
  Object.defineProperty(Display, 'NONE', {get: Display$NONE_getInstance});
  Object.defineProperty(Display, 'INITIAL', {get: Display$INITIAL_getInstance});
  Object.defineProperty(Display, 'INHERIT', {get: Display$INHERIT_getInstance});
  package$core.Display = Display;
  Object.defineProperty(Overflow, 'VISIBLE', {get: Overflow$VISIBLE_getInstance});
  Object.defineProperty(Overflow, 'HIDDEN', {get: Overflow$HIDDEN_getInstance});
  Object.defineProperty(Overflow, 'SCROLL', {get: Overflow$SCROLL_getInstance});
  Object.defineProperty(Overflow, 'AUTO', {get: Overflow$AUTO_getInstance});
  Object.defineProperty(Overflow, 'INITIAL', {get: Overflow$INITIAL_getInstance});
  Object.defineProperty(Overflow, 'INHERIT', {get: Overflow$INHERIT_getInstance});
  package$core.Overflow = Overflow;
  Object.defineProperty(Resize, 'NONE', {get: Resize$NONE_getInstance});
  Object.defineProperty(Resize, 'BOTH', {get: Resize$BOTH_getInstance});
  Object.defineProperty(Resize, 'HORIZONTAL', {get: Resize$HORIZONTAL_getInstance});
  Object.defineProperty(Resize, 'VERTICAL', {get: Resize$VERTICAL_getInstance});
  Object.defineProperty(Resize, 'INITIAL', {get: Resize$INITIAL_getInstance});
  Object.defineProperty(Resize, 'INHERIT', {get: Resize$INHERIT_getInstance});
  package$core.Resize = Resize;
  Object.defineProperty(TextAlign, 'LEFT', {get: TextAlign$LEFT_getInstance});
  Object.defineProperty(TextAlign, 'RIGHT', {get: TextAlign$RIGHT_getInstance});
  Object.defineProperty(TextAlign, 'CENTER', {get: TextAlign$CENTER_getInstance});
  Object.defineProperty(TextAlign, 'JUSTIFY', {get: TextAlign$JUSTIFY_getInstance});
  Object.defineProperty(TextAlign, 'INITIAL', {get: TextAlign$INITIAL_getInstance});
  Object.defineProperty(TextAlign, 'INHERIT', {get: TextAlign$INHERIT_getInstance});
  package$core.TextAlign = TextAlign;
  Object.defineProperty(VerticalAlign, 'BASELINE', {get: VerticalAlign$BASELINE_getInstance});
  Object.defineProperty(VerticalAlign, 'SUB', {get: VerticalAlign$SUB_getInstance});
  Object.defineProperty(VerticalAlign, 'SUPER', {get: VerticalAlign$SUPER_getInstance});
  Object.defineProperty(VerticalAlign, 'TOP', {get: VerticalAlign$TOP_getInstance});
  Object.defineProperty(VerticalAlign, 'TEXTTOP', {get: VerticalAlign$TEXTTOP_getInstance});
  Object.defineProperty(VerticalAlign, 'MIDDLE', {get: VerticalAlign$MIDDLE_getInstance});
  Object.defineProperty(VerticalAlign, 'BOTTOM', {get: VerticalAlign$BOTTOM_getInstance});
  Object.defineProperty(VerticalAlign, 'TEXTBOTTOM', {get: VerticalAlign$TEXTBOTTOM_getInstance});
  Object.defineProperty(VerticalAlign, 'INITIAL', {get: VerticalAlign$INITIAL_getInstance});
  Object.defineProperty(VerticalAlign, 'INHERIT', {get: VerticalAlign$INHERIT_getInstance});
  package$core.VerticalAlign = VerticalAlign;
  Object.defineProperty(PosFloat, 'NONE', {get: PosFloat$NONE_getInstance});
  Object.defineProperty(PosFloat, 'LEFT', {get: PosFloat$LEFT_getInstance});
  Object.defineProperty(PosFloat, 'RIGHT', {get: PosFloat$RIGHT_getInstance});
  Object.defineProperty(PosFloat, 'INITIAL', {get: PosFloat$INITIAL_getInstance});
  Object.defineProperty(PosFloat, 'INHERIT', {get: PosFloat$INHERIT_getInstance});
  package$core.PosFloat = PosFloat;
  Object.defineProperty(Clear, 'NONE', {get: Clear$NONE_getInstance});
  Object.defineProperty(Clear, 'LEFT', {get: Clear$LEFT_getInstance});
  Object.defineProperty(Clear, 'RIGHT', {get: Clear$RIGHT_getInstance});
  Object.defineProperty(Clear, 'BOTH', {get: Clear$BOTH_getInstance});
  Object.defineProperty(Clear, 'INITIAL', {get: Clear$INITIAL_getInstance});
  Object.defineProperty(Clear, 'INHERIT', {get: Clear$INHERIT_getInstance});
  package$core.Clear = Clear;
  Object.defineProperty(Cursor, 'DEFAULT', {get: Cursor$DEFAULT_getInstance});
  Object.defineProperty(Cursor, 'AUTO', {get: Cursor$AUTO_getInstance});
  Object.defineProperty(Cursor, 'NONE', {get: Cursor$NONE_getInstance});
  Object.defineProperty(Cursor, 'ALIAS', {get: Cursor$ALIAS_getInstance});
  Object.defineProperty(Cursor, 'ALLSCROLL', {get: Cursor$ALLSCROLL_getInstance});
  Object.defineProperty(Cursor, 'CELL', {get: Cursor$CELL_getInstance});
  Object.defineProperty(Cursor, 'CONTEXTMENU', {get: Cursor$CONTEXTMENU_getInstance});
  Object.defineProperty(Cursor, 'COLRESIZE', {get: Cursor$COLRESIZE_getInstance});
  Object.defineProperty(Cursor, 'COPY', {get: Cursor$COPY_getInstance});
  Object.defineProperty(Cursor, 'CROSSHAIR', {get: Cursor$CROSSHAIR_getInstance});
  Object.defineProperty(Cursor, 'ERESIZE', {get: Cursor$ERESIZE_getInstance});
  Object.defineProperty(Cursor, 'EWRESIZE', {get: Cursor$EWRESIZE_getInstance});
  Object.defineProperty(Cursor, 'GRAB', {get: Cursor$GRAB_getInstance});
  Object.defineProperty(Cursor, 'GRABBING', {get: Cursor$GRABBING_getInstance});
  Object.defineProperty(Cursor, 'HELP', {get: Cursor$HELP_getInstance});
  Object.defineProperty(Cursor, 'MOVE', {get: Cursor$MOVE_getInstance});
  Object.defineProperty(Cursor, 'NRESIZE', {get: Cursor$NRESIZE_getInstance});
  Object.defineProperty(Cursor, 'NERESIZE', {get: Cursor$NERESIZE_getInstance});
  Object.defineProperty(Cursor, 'NESWRESIZE', {get: Cursor$NESWRESIZE_getInstance});
  Object.defineProperty(Cursor, 'NSRESIZE', {get: Cursor$NSRESIZE_getInstance});
  Object.defineProperty(Cursor, 'NWRESIZE', {get: Cursor$NWRESIZE_getInstance});
  Object.defineProperty(Cursor, 'NWSERESIZE', {get: Cursor$NWSERESIZE_getInstance});
  Object.defineProperty(Cursor, 'NODROP', {get: Cursor$NODROP_getInstance});
  Object.defineProperty(Cursor, 'NOTALLOWED', {get: Cursor$NOTALLOWED_getInstance});
  Object.defineProperty(Cursor, 'POINTER', {get: Cursor$POINTER_getInstance});
  Object.defineProperty(Cursor, 'PROGRESS', {get: Cursor$PROGRESS_getInstance});
  Object.defineProperty(Cursor, 'ROWRESIZE', {get: Cursor$ROWRESIZE_getInstance});
  Object.defineProperty(Cursor, 'SRESIZE', {get: Cursor$SRESIZE_getInstance});
  Object.defineProperty(Cursor, 'SERESIZE', {get: Cursor$SERESIZE_getInstance});
  Object.defineProperty(Cursor, 'SWRESIZE', {get: Cursor$SWRESIZE_getInstance});
  Object.defineProperty(Cursor, 'TEXT', {get: Cursor$TEXT_getInstance});
  Object.defineProperty(Cursor, 'VERTICALTEXT', {get: Cursor$VERTICALTEXT_getInstance});
  Object.defineProperty(Cursor, 'WRESIZE', {get: Cursor$WRESIZE_getInstance});
  Object.defineProperty(Cursor, 'WAIT', {get: Cursor$WAIT_getInstance});
  Object.defineProperty(Cursor, 'ZOOMIN', {get: Cursor$ZOOMIN_getInstance});
  Object.defineProperty(Cursor, 'ZOOMOUT', {get: Cursor$ZOOMOUT_getInstance});
  Object.defineProperty(Cursor, 'INITIAL', {get: Cursor$INITIAL_getInstance});
  Object.defineProperty(Cursor, 'INHERIT', {get: Cursor$INHERIT_getInstance});
  package$core.Cursor = Cursor;
  Object.defineProperty(FlexDirection, 'ROW', {get: FlexDirection$ROW_getInstance});
  Object.defineProperty(FlexDirection, 'ROWREV', {get: FlexDirection$ROWREV_getInstance});
  Object.defineProperty(FlexDirection, 'COLUMN', {get: FlexDirection$COLUMN_getInstance});
  Object.defineProperty(FlexDirection, 'COLUMNREV', {get: FlexDirection$COLUMNREV_getInstance});
  package$core.FlexDirection = FlexDirection;
  Object.defineProperty(JustifyContent, 'FLEXSTART', {get: JustifyContent$FLEXSTART_getInstance});
  Object.defineProperty(JustifyContent, 'FLEXEND', {get: JustifyContent$FLEXEND_getInstance});
  Object.defineProperty(JustifyContent, 'CENTER', {get: JustifyContent$CENTER_getInstance});
  Object.defineProperty(JustifyContent, 'SPACEBETWEEN', {get: JustifyContent$SPACEBETWEEN_getInstance});
  Object.defineProperty(JustifyContent, 'SPACEAROUND', {get: JustifyContent$SPACEAROUND_getInstance});
  Object.defineProperty(JustifyContent, 'SPACEEVENLY', {get: JustifyContent$SPACEEVENLY_getInstance});
  Object.defineProperty(JustifyContent, 'START', {get: JustifyContent$START_getInstance});
  Object.defineProperty(JustifyContent, 'END', {get: JustifyContent$END_getInstance});
  Object.defineProperty(JustifyContent, 'STRETCH', {get: JustifyContent$STRETCH_getInstance});
  package$core.JustifyContent = JustifyContent;
  Object.defineProperty(Color, 'Companion', {get: Color$Companion_getInstance});
  package$core.Color = Color;
  package$core.Background = Background;
  package$core.CssClass = CssClass;
  package$core.DomAttribute = DomAttribute;
  package$core.SingleObjectCache = SingleObjectCache;
  package$core.LazyCache = LazyCache;
  Style.RefreshDelegateProvider = Style$RefreshDelegateProvider;
  Style.RefreshDelegate = Style$RefreshDelegate;
  Object.defineProperty(Style, 'Companion', {get: Style$Companion_getInstance});
  package$core.Style = Style;
  package$core.style_2it1a4$ = style_0;
  package$core.StyledComponent = StyledComponent;
  Widget.RefreshDelegateProvider = Widget$RefreshDelegateProvider;
  Widget.RefreshDelegate = Widget$RefreshDelegate;
  Object.defineProperty(Widget, 'Companion', {get: Widget$Companion_getInstance});
  package$core.Widget = Widget;
  package$core.WidgetWrapper = WidgetWrapper;
  var package$form = package$kvision.form || (package$kvision.form = {});
  package$form.FieldLabel = FieldLabel;
  package$form.FieldLabelCheck = FieldLabelCheck;
  $$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy;
  Object.defineProperty(InputSize, 'LARGE', {get: InputSize$LARGE_getInstance});
  Object.defineProperty(InputSize, 'SMALL', {get: InputSize$SMALL_getInstance});
  package$form.InputSize = InputSize;
  Object.defineProperty(ValidationStatus, 'VALID', {get: ValidationStatus$VALID_getInstance});
  Object.defineProperty(ValidationStatus, 'INVALID', {get: ValidationStatus$INVALID_getInstance});
  package$form.ValidationStatus = ValidationStatus;
  package$form.FormInput = FormInput;
  package$form.GenericFormComponent = GenericFormComponent;
  package$form.FormControl = FormControl;
  package$form.GenericFormControl = GenericFormControl;
  package$form.GenericNonNullableFormControl = GenericNonNullableFormControl;
  package$form.StringFormControl = StringFormControl;
  package$form.NumberFormControl = NumberFormControl;
  package$form.BoolFormControl = BoolFormControl;
  package$form.TriStateFormControl = TriStateFormControl;
  package$form.DateFormControl = DateFormControl;
  package$form.KFilesFormControl = KFilesFormControl;
  package$form.InvalidFeedback = InvalidFeedback;
  Object.defineProperty(CheckBox, 'Companion', {get: CheckBox$Companion_getInstance});
  var package$check = package$form.check || (package$form.check = {});
  package$check.CheckBox = CheckBox;
  package$check.CheckBoxInput = CheckBoxInput;
  Object.defineProperty(CheckInputType, 'CHECKBOX', {get: CheckInputType$CHECKBOX_getInstance});
  Object.defineProperty(CheckInputType, 'RADIO', {get: CheckInputType$RADIO_getInstance});
  package$check.CheckInputType = CheckInputType;
  package$check.CheckInput = CheckInput;
  Object.defineProperty(GenericRadioGroup, 'Companion', {get: GenericRadioGroup$Companion_getInstance});
  package$check.GenericRadioGroup = GenericRadioGroup;
  Object.defineProperty(Radio, 'Companion', {get: Radio$Companion_getInstance});
  package$check.Radio = Radio;
  package$check.RadioGroup = RadioGroup;
  package$check.radioGroup_raf63d$ = radioGroup;
  package$check.RadioInput = RadioInput;
  package$check.TriStateCheckBox = TriStateCheckBox;
  Object.defineProperty(Range, 'Companion', {get: Range$Companion_getInstance});
  var package$range = package$form.range || (package$form.range = {});
  package$range.Range = Range;
  package$range.RangeInput = RangeInput;
  var package$select = package$form.select || (package$form.select = {});
  package$select.SimpleSelect = SimpleSelect;
  Object.defineProperty(SimpleSpinner, 'Companion', {get: SimpleSpinner$Companion_getInstance});
  var package$spinner = package$form.spinner || (package$form.spinner = {});
  package$spinner.SimpleSpinner = SimpleSpinner;
  package$spinner.SimpleSpinnerInput = SimpleSpinnerInput;
  Object.defineProperty(AbstractText, 'Companion', {get: AbstractText$Companion_getInstance});
  var package$text = package$form.text || (package$form.text = {});
  package$text.AbstractText = AbstractText;
  package$text.AbstractTextInput = AbstractTextInput;
  Object.defineProperty(package$text, 'MaskManager', {get: MaskManager_getInstance});
  package$text.Password = Password;
  package$text.Text = Text;
  package$text.TextArea = TextArea;
  package$text.textArea_6t3twx$ = textArea;
  package$text.TextAreaInput = TextAreaInput;
  package$text.textAreaInput_c390jc$ = textAreaInput;
  package$text.TextInput = TextInput;
  package$text.textInput_b3dt4f$ = textInput;
  var package$html = package$kvision.html || (package$kvision.html = {});
  package$html.B = B;
  package$html.b_tdyf$ = b;
  Object.defineProperty(ButtonStyle, 'PRIMARY', {get: ButtonStyle$PRIMARY_getInstance});
  Object.defineProperty(ButtonStyle, 'SECONDARY', {get: ButtonStyle$SECONDARY_getInstance});
  Object.defineProperty(ButtonStyle, 'SUCCESS', {get: ButtonStyle$SUCCESS_getInstance});
  Object.defineProperty(ButtonStyle, 'DANGER', {get: ButtonStyle$DANGER_getInstance});
  Object.defineProperty(ButtonStyle, 'WARNING', {get: ButtonStyle$WARNING_getInstance});
  Object.defineProperty(ButtonStyle, 'INFO', {get: ButtonStyle$INFO_getInstance});
  Object.defineProperty(ButtonStyle, 'LIGHT', {get: ButtonStyle$LIGHT_getInstance});
  Object.defineProperty(ButtonStyle, 'DARK', {get: ButtonStyle$DARK_getInstance});
  Object.defineProperty(ButtonStyle, 'LINK', {get: ButtonStyle$LINK_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINEPRIMARY', {get: ButtonStyle$OUTLINEPRIMARY_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINESECONDARY', {get: ButtonStyle$OUTLINESECONDARY_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINESUCCESS', {get: ButtonStyle$OUTLINESUCCESS_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINEDANGER', {get: ButtonStyle$OUTLINEDANGER_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINEWARNING', {get: ButtonStyle$OUTLINEWARNING_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINEINFO', {get: ButtonStyle$OUTLINEINFO_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINELIGHT', {get: ButtonStyle$OUTLINELIGHT_getInstance});
  Object.defineProperty(ButtonStyle, 'OUTLINEDARK', {get: ButtonStyle$OUTLINEDARK_getInstance});
  package$html.ButtonStyle = ButtonStyle;
  Object.defineProperty(ButtonType, 'BUTTON', {get: ButtonType$BUTTON_getInstance});
  Object.defineProperty(ButtonType, 'SUBMIT', {get: ButtonType$SUBMIT_getInstance});
  Object.defineProperty(ButtonType, 'RESET', {get: ButtonType$RESET_getInstance});
  package$html.ButtonType = ButtonType;
  package$html.Button = Button;
  package$html.button_m9f0dc$ = button;
  Object.defineProperty(Canvas, 'Companion', {get: Canvas$Companion_getInstance});
  package$html.Canvas = Canvas;
  package$html.Div = Div;
  package$html.div_dgrmfs$ = div;
  package$html.H2 = H2;
  package$html.h2_v9ksh9$ = h2;
  package$html.H3 = H3;
  package$html.h3_vbkqsy$ = h3;
  package$html.Icon = Icon;
  package$html.icon_6utwb9$ = icon;
  package$html.Iframe = Iframe;
  package$html.iframe_e2wbph$ = iframe;
  package$html.Image = Image;
  package$html.image_9ai1mh$ = image;
  Object.defineProperty(InputType, 'TEXT', {get: InputType$TEXT_getInstance});
  Object.defineProperty(InputType, 'PASSWORD', {get: InputType$PASSWORD_getInstance});
  Object.defineProperty(InputType, 'EMAIL', {get: InputType$EMAIL_getInstance});
  Object.defineProperty(InputType, 'TEL', {get: InputType$TEL_getInstance});
  Object.defineProperty(InputType, 'COLOR', {get: InputType$COLOR_getInstance});
  Object.defineProperty(InputType, 'SEARCH', {get: InputType$SEARCH_getInstance});
  Object.defineProperty(InputType, 'URL', {get: InputType$URL_getInstance});
  Object.defineProperty(InputType, 'HIDDEN', {get: InputType$HIDDEN_getInstance});
  Object.defineProperty(InputType, 'BUTTON', {get: InputType$BUTTON_getInstance});
  Object.defineProperty(InputType, 'CHECKBOX', {get: InputType$CHECKBOX_getInstance});
  Object.defineProperty(InputType, 'DATE', {get: InputType$DATE_getInstance});
  Object.defineProperty(InputType, 'DATETIME_LOCAL', {get: InputType$DATETIME_LOCAL_getInstance});
  Object.defineProperty(InputType, 'FILE', {get: InputType$FILE_getInstance});
  Object.defineProperty(InputType, 'IMAGE', {get: InputType$IMAGE_getInstance});
  Object.defineProperty(InputType, 'MONTH', {get: InputType$MONTH_getInstance});
  Object.defineProperty(InputType, 'NUMBER', {get: InputType$NUMBER_getInstance});
  Object.defineProperty(InputType, 'RADIO', {get: InputType$RADIO_getInstance});
  Object.defineProperty(InputType, 'RANGE', {get: InputType$RANGE_getInstance});
  Object.defineProperty(InputType, 'RESET', {get: InputType$RESET_getInstance});
  Object.defineProperty(InputType, 'SUBMIT', {get: InputType$SUBMIT_getInstance});
  Object.defineProperty(InputType, 'TIME', {get: InputType$TIME_getInstance});
  Object.defineProperty(InputType, 'WEEK', {get: InputType$WEEK_getInstance});
  package$html.InputType = InputType;
  package$html.Li = Li;
  package$html.li_k29h34$ = li;
  Object.defineProperty(Link, 'Companion', {get: Link$Companion_getInstance});
  package$html.Link = Link;
  package$html.link_tjpj5n$ = link;
  Object.defineProperty(ListType, 'UL', {get: ListType$UL_getInstance});
  Object.defineProperty(ListType, 'OL', {get: ListType$OL_getInstance});
  Object.defineProperty(ListType, 'UNSTYLED', {get: ListType$UNSTYLED_getInstance});
  Object.defineProperty(ListType, 'INLINE', {get: ListType$INLINE_getInstance});
  Object.defineProperty(ListType, 'DL', {get: ListType$DL_getInstance});
  Object.defineProperty(ListType, 'DL_HORIZ', {get: ListType$DL_HORIZ_getInstance});
  package$html.ListType = ListType;
  package$html.ListTag = ListTag;
  package$html.P = P;
  package$html.p_nvm87t$ = p;
  package$html.Span = Span;
  package$html.span_f4ecwj$ = span;
  Object.defineProperty(TAG, 'A', {get: TAG$A_getInstance});
  Object.defineProperty(TAG, 'ABBR', {get: TAG$ABBR_getInstance});
  Object.defineProperty(TAG, 'ADDRESS', {get: TAG$ADDRESS_getInstance});
  Object.defineProperty(TAG, 'AREA', {get: TAG$AREA_getInstance});
  Object.defineProperty(TAG, 'ARTICLE', {get: TAG$ARTICLE_getInstance});
  Object.defineProperty(TAG, 'ASIDE', {get: TAG$ASIDE_getInstance});
  Object.defineProperty(TAG, 'AUDIO', {get: TAG$AUDIO_getInstance});
  Object.defineProperty(TAG, 'B', {get: TAG$B_getInstance});
  Object.defineProperty(TAG, 'BASE', {get: TAG$BASE_getInstance});
  Object.defineProperty(TAG, 'BDI', {get: TAG$BDI_getInstance});
  Object.defineProperty(TAG, 'BDO', {get: TAG$BDO_getInstance});
  Object.defineProperty(TAG, 'BLOCKQUOTE', {get: TAG$BLOCKQUOTE_getInstance});
  Object.defineProperty(TAG, 'BODY', {get: TAG$BODY_getInstance});
  Object.defineProperty(TAG, 'BR', {get: TAG$BR_getInstance});
  Object.defineProperty(TAG, 'BUTTON', {get: TAG$BUTTON_getInstance});
  Object.defineProperty(TAG, 'CANVAS', {get: TAG$CANVAS_getInstance});
  Object.defineProperty(TAG, 'CAPTION', {get: TAG$CAPTION_getInstance});
  Object.defineProperty(TAG, 'CITE', {get: TAG$CITE_getInstance});
  Object.defineProperty(TAG, 'CODE', {get: TAG$CODE_getInstance});
  Object.defineProperty(TAG, 'COL', {get: TAG$COL_getInstance});
  Object.defineProperty(TAG, 'COLGROUP', {get: TAG$COLGROUP_getInstance});
  Object.defineProperty(TAG, 'DATA', {get: TAG$DATA_getInstance});
  Object.defineProperty(TAG, 'DATALIST', {get: TAG$DATALIST_getInstance});
  Object.defineProperty(TAG, 'DD', {get: TAG$DD_getInstance});
  Object.defineProperty(TAG, 'DEL', {get: TAG$DEL_getInstance});
  Object.defineProperty(TAG, 'DETAILS', {get: TAG$DETAILS_getInstance});
  Object.defineProperty(TAG, 'DFN', {get: TAG$DFN_getInstance});
  Object.defineProperty(TAG, 'DIALOG', {get: TAG$DIALOG_getInstance});
  Object.defineProperty(TAG, 'DIV', {get: TAG$DIV_getInstance});
  Object.defineProperty(TAG, 'DL', {get: TAG$DL_getInstance});
  Object.defineProperty(TAG, 'DT', {get: TAG$DT_getInstance});
  Object.defineProperty(TAG, 'EM', {get: TAG$EM_getInstance});
  Object.defineProperty(TAG, 'EMBED', {get: TAG$EMBED_getInstance});
  Object.defineProperty(TAG, 'FIELDSET', {get: TAG$FIELDSET_getInstance});
  Object.defineProperty(TAG, 'FIGCAPTION', {get: TAG$FIGCAPTION_getInstance});
  Object.defineProperty(TAG, 'FIGURE', {get: TAG$FIGURE_getInstance});
  Object.defineProperty(TAG, 'FOOTER', {get: TAG$FOOTER_getInstance});
  Object.defineProperty(TAG, 'FORM', {get: TAG$FORM_getInstance});
  Object.defineProperty(TAG, 'H1', {get: TAG$H1_getInstance});
  Object.defineProperty(TAG, 'H2', {get: TAG$H2_getInstance});
  Object.defineProperty(TAG, 'H3', {get: TAG$H3_getInstance});
  Object.defineProperty(TAG, 'H4', {get: TAG$H4_getInstance});
  Object.defineProperty(TAG, 'H5', {get: TAG$H5_getInstance});
  Object.defineProperty(TAG, 'H6', {get: TAG$H6_getInstance});
  Object.defineProperty(TAG, 'HEAD', {get: TAG$HEAD_getInstance});
  Object.defineProperty(TAG, 'HEADER', {get: TAG$HEADER_getInstance});
  Object.defineProperty(TAG, 'HGROUP', {get: TAG$HGROUP_getInstance});
  Object.defineProperty(TAG, 'HR', {get: TAG$HR_getInstance});
  Object.defineProperty(TAG, 'HTML', {get: TAG$HTML_getInstance});
  Object.defineProperty(TAG, 'I', {get: TAG$I_getInstance});
  Object.defineProperty(TAG, 'IFRAME', {get: TAG$IFRAME_getInstance});
  Object.defineProperty(TAG, 'IMG', {get: TAG$IMG_getInstance});
  Object.defineProperty(TAG, 'INPUT', {get: TAG$INPUT_getInstance});
  Object.defineProperty(TAG, 'INS', {get: TAG$INS_getInstance});
  Object.defineProperty(TAG, 'KBD', {get: TAG$KBD_getInstance});
  Object.defineProperty(TAG, 'LABEL', {get: TAG$LABEL_getInstance});
  Object.defineProperty(TAG, 'LEGEND', {get: TAG$LEGEND_getInstance});
  Object.defineProperty(TAG, 'LI', {get: TAG$LI_getInstance});
  Object.defineProperty(TAG, 'LINK', {get: TAG$LINK_getInstance});
  Object.defineProperty(TAG, 'MAIN', {get: TAG$MAIN_getInstance});
  Object.defineProperty(TAG, 'MAP', {get: TAG$MAP_getInstance});
  Object.defineProperty(TAG, 'MARK', {get: TAG$MARK_getInstance});
  Object.defineProperty(TAG, 'MATH', {get: TAG$MATH_getInstance});
  Object.defineProperty(TAG, 'MENU', {get: TAG$MENU_getInstance});
  Object.defineProperty(TAG, 'MENUITEM', {get: TAG$MENUITEM_getInstance});
  Object.defineProperty(TAG, 'META', {get: TAG$META_getInstance});
  Object.defineProperty(TAG, 'METER', {get: TAG$METER_getInstance});
  Object.defineProperty(TAG, 'NAV', {get: TAG$NAV_getInstance});
  Object.defineProperty(TAG, 'NOSCRIPT', {get: TAG$NOSCRIPT_getInstance});
  Object.defineProperty(TAG, 'OBJECT', {get: TAG$OBJECT_getInstance});
  Object.defineProperty(TAG, 'OL', {get: TAG$OL_getInstance});
  Object.defineProperty(TAG, 'OPTGROUP', {get: TAG$OPTGROUP_getInstance});
  Object.defineProperty(TAG, 'OPTION', {get: TAG$OPTION_getInstance});
  Object.defineProperty(TAG, 'OUTPUT', {get: TAG$OUTPUT_getInstance});
  Object.defineProperty(TAG, 'P', {get: TAG$P_getInstance});
  Object.defineProperty(TAG, 'PARAM', {get: TAG$PARAM_getInstance});
  Object.defineProperty(TAG, 'PICTURE', {get: TAG$PICTURE_getInstance});
  Object.defineProperty(TAG, 'PRE', {get: TAG$PRE_getInstance});
  Object.defineProperty(TAG, 'PROGRESS', {get: TAG$PROGRESS_getInstance});
  Object.defineProperty(TAG, 'Q', {get: TAG$Q_getInstance});
  Object.defineProperty(TAG, 'RB', {get: TAG$RB_getInstance});
  Object.defineProperty(TAG, 'RP', {get: TAG$RP_getInstance});
  Object.defineProperty(TAG, 'RT', {get: TAG$RT_getInstance});
  Object.defineProperty(TAG, 'RTC', {get: TAG$RTC_getInstance});
  Object.defineProperty(TAG, 'RUBY', {get: TAG$RUBY_getInstance});
  Object.defineProperty(TAG, 'S', {get: TAG$S_getInstance});
  Object.defineProperty(TAG, 'SAMP', {get: TAG$SAMP_getInstance});
  Object.defineProperty(TAG, 'SCRIPT', {get: TAG$SCRIPT_getInstance});
  Object.defineProperty(TAG, 'SECTION', {get: TAG$SECTION_getInstance});
  Object.defineProperty(TAG, 'SELECT', {get: TAG$SELECT_getInstance});
  Object.defineProperty(TAG, 'SLOT', {get: TAG$SLOT_getInstance});
  Object.defineProperty(TAG, 'SMALL', {get: TAG$SMALL_getInstance});
  Object.defineProperty(TAG, 'SOURCE', {get: TAG$SOURCE_getInstance});
  Object.defineProperty(TAG, 'SPAN', {get: TAG$SPAN_getInstance});
  Object.defineProperty(TAG, 'STRONG', {get: TAG$STRONG_getInstance});
  Object.defineProperty(TAG, 'STYLE', {get: TAG$STYLE_getInstance});
  Object.defineProperty(TAG, 'SUB', {get: TAG$SUB_getInstance});
  Object.defineProperty(TAG, 'SUMMARY', {get: TAG$SUMMARY_getInstance});
  Object.defineProperty(TAG, 'SUP', {get: TAG$SUP_getInstance});
  Object.defineProperty(TAG, 'SVG', {get: TAG$SVG_getInstance});
  Object.defineProperty(TAG, 'TABLE', {get: TAG$TABLE_getInstance});
  Object.defineProperty(TAG, 'TBODY', {get: TAG$TBODY_getInstance});
  Object.defineProperty(TAG, 'TD', {get: TAG$TD_getInstance});
  Object.defineProperty(TAG, 'TEMPLATE', {get: TAG$TEMPLATE_getInstance});
  Object.defineProperty(TAG, 'TEXTAREA', {get: TAG$TEXTAREA_getInstance});
  Object.defineProperty(TAG, 'TFOOT', {get: TAG$TFOOT_getInstance});
  Object.defineProperty(TAG, 'TH', {get: TAG$TH_getInstance});
  Object.defineProperty(TAG, 'THEAD', {get: TAG$THEAD_getInstance});
  Object.defineProperty(TAG, 'TIME', {get: TAG$TIME_getInstance});
  Object.defineProperty(TAG, 'TITLE', {get: TAG$TITLE_getInstance});
  Object.defineProperty(TAG, 'TR', {get: TAG$TR_getInstance});
  Object.defineProperty(TAG, 'TRACK', {get: TAG$TRACK_getInstance});
  Object.defineProperty(TAG, 'U', {get: TAG$U_getInstance});
  Object.defineProperty(TAG, 'UL', {get: TAG$UL_getInstance});
  Object.defineProperty(TAG, 'VAR', {get: TAG$VAR_getInstance});
  Object.defineProperty(TAG, 'VIDEO', {get: TAG$VIDEO_getInstance});
  Object.defineProperty(TAG, 'WBR', {get: TAG$WBR_getInstance});
  package$html.TAG = TAG;
  package$html.Tag = Tag;
  package$html.tag_fw746d$ = tag;
  package$html.Template = Template;
  package$html.TextNode = TextNode;
  package$html.Ul = Ul;
  package$html.ul_ls9wyp$ = ul;
  var package$i18n = package$kvision.i18n || (package$kvision.i18n = {});
  Object.defineProperty(package$i18n, 'I18n', {get: I18n_getInstance});
  package$i18n.tr_61zpoe$ = tr_0;
  package$i18n.gettext_25kzsl$ = gettext;
  package$i18n.I18nManager = I18nManager;
  package$i18n.SimpleI18nManager = SimpleI18nManager;
  var package$panel = package$kvision.panel || (package$kvision.panel = {});
  package$panel.FieldsetPanel = FieldsetPanel;
  package$panel.FlexPanel = FlexPanel;
  package$panel.HPanel = HPanel;
  package$panel.hPanel_r23cd8$ = hPanel;
  Object.defineProperty(ContainerType, 'NONE', {get: ContainerType$NONE_getInstance});
  Object.defineProperty(ContainerType, 'FIXED', {get: ContainerType$FIXED_getInstance});
  Object.defineProperty(ContainerType, 'FLUID', {get: ContainerType$FLUID_getInstance});
  Object.defineProperty(ContainerType, 'SM', {get: ContainerType$SM_getInstance});
  Object.defineProperty(ContainerType, 'MD', {get: ContainerType$MD_getInstance});
  Object.defineProperty(ContainerType, 'LG', {get: ContainerType$LG_getInstance});
  Object.defineProperty(ContainerType, 'XL', {get: ContainerType$XL_getInstance});
  Object.defineProperty(ContainerType, 'XXL', {get: ContainerType$XXL_getInstance});
  package$panel.ContainerType = ContainerType;
  Object.defineProperty(Root, 'Companion', {get: Root$Companion_getInstance});
  package$panel.Root_init_mtt0gy$ = Root_init;
  package$panel.Root_init_39w7fw$ = Root_init_0;
  package$panel.Root = Root;
  package$panel.root_1ci80s$ = root;
  package$panel.SimplePanel = SimplePanel;
  package$panel.simplePanel_jhiteo$ = simplePanel;
  Object.defineProperty(Direction_0, 'HORIZONTAL', {get: Direction$HORIZONTAL_getInstance});
  Object.defineProperty(Direction_0, 'VERTICAL', {get: Direction$VERTICAL_getInstance});
  package$panel.Direction = Direction_0;
  package$panel.SplitPanel = SplitPanel;
  package$panel.splitPanel_mtazi4$ = splitPanel;
  package$panel.Splitter = Splitter;
  Object.defineProperty(StackPanel, 'Companion', {get: StackPanel$Companion_getInstance});
  package$panel.StackPanel = StackPanel;
  package$panel.stackPanel_hrxqij$ = stackPanel;
  package$panel.VPanel = VPanel;
  package$panel.vPanel_mfmg4y$ = vPanel;
  var package$routing = package$kvision.routing || (package$kvision.routing = {});
  package$routing.KVRouter = KVRouter;
  package$routing.RouterFactory = RouterFactory;
  package$routing.DummyRouter = DummyRouter;
  package$routing.DummyRouterFactory = DummyRouterFactory;
  Object.defineProperty(package$routing, 'RoutingManager', {get: RoutingManager_getInstance});
  var package$snabbdom = package$kvision.snabbdom || (package$kvision.snabbdom = {});
  package$snabbdom.set_dzr37t$ = set;
  var package$state = package$kvision.state || (package$kvision.state = {});
  package$state.ObservableState = ObservableState;
  package$state.MutableState = MutableState;
  package$state.ObservableValue = ObservableValue;
  var package$types = package$kvision.types || (package$kvision.types = {});
  package$types.toDateF_rjktp$ = toDateF;
  package$types.toStringF_i82nfv$ = toStringF;
  Object.defineProperty(package$types, 'DateSerializer', {get: DateSerializer_getInstance});
  var package$utils = package$kvision.utils || (package$kvision.utils = {});
  package$utils.delete_hwpqgh$ = delete_0;
  package$utils.createInstance_aevmdv$ = createInstance;
  package$utils.LegacyTest = LegacyTest;
  Object.defineProperty(package$utils, 'isLegacyBackend', {get: get_isLegacyBackend});
  package$utils.getAllPropertyNamesForIR_za3rmp$ = getAllPropertyNamesForIR;
  package$utils.toPlainObj_za3rmp$ = toPlainObj;
  package$utils.toKotlinObj_t5tk2r$ = toKotlinObj;
  package$utils.deepMerge_wn2jw4$ = deepMerge;
  Object.defineProperty(package$utils, 'Serialization', {get: Serialization_getInstance});
  package$utils.on_pbzkfn$ = on;
  package$utils.emptyOn_8be2vx$ = emptyOn;
  package$utils.get_px_s8ev3n$ = get_px;
  package$utils.get_em_rcaex3$ = get_em;
  package$utils.get_perc_rcaex3$ = get_perc;
  package$utils.get_pc_rcaex3$ = get_pc;
  package$utils.get_vh_rcaex3$ = get_vh;
  Object.defineProperty(package$utils, 'auto', {get: function () {
    return auto;
  }});
  package$utils.asString_ebgrb4$ = asString;
  package$utils.toHexString_s8ev3n$ = toHexString;
  package$utils.syncWithList_7f5kvw$ = syncWithList;
  AttributeSetBuilderImpl.prototype.add_lcqont$ = AttributeSetBuilder.prototype.add_lcqont$;
  AttributeSetBuilderImpl.prototype.addAll_y0zsll$ = AttributeSetBuilder.prototype.addAll_y0zsll$;
  AttributeSetBuilderImpl.prototype.add_puj7f4$ = AttributeSetBuilder.prototype.add_puj7f4$;
  ClassSetBuilderImpl.prototype.add_vqcfem$ = ClassSetBuilder.prototype.add_vqcfem$;
  Container.prototype.focus = Component.prototype.focus;
  Container.prototype.blur = Component.prototype.blur;
  LazyCache.prototype.clearOn_u332lz$ = SingleObjectCache.prototype.clearOn_u332lz$;
  Widget.prototype.focus = Component.prototype.focus;
  Widget.prototype.blur = Component.prototype.blur;
  SimplePanel.prototype.invoke_4h7hma$ = Container.prototype.invoke_4h7hma$;
  SimplePanel.prototype.unaryPlus_pdl1vz$ = Container.prototype.unaryPlus_pdl1vz$;
  Object.defineProperty(Tag.prototype, 'templateData', Object.getOwnPropertyDescriptor(Template.prototype, 'templateData'));
  FormInput.prototype.focus = Component.prototype.focus;
  FormInput.prototype.blur = Component.prototype.blur;
  GenericFormComponent.prototype.focus = Component.prototype.focus;
  GenericFormComponent.prototype.blur = Component.prototype.blur;
  FormControl.prototype.focus = Component.prototype.focus;
  FormControl.prototype.blur = Component.prototype.blur;
  Object.defineProperty(GenericFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(FormControl.prototype, 'disabled'));
  Object.defineProperty(GenericFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(FormControl.prototype, 'size'));
  Object.defineProperty(GenericFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(FormControl.prototype, 'name'));
  Object.defineProperty(GenericFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(FormControl.prototype, 'validationStatus'));
  Object.defineProperty(GenericFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(FormControl.prototype, 'validatorError'));
  GenericFormControl.prototype.styleForVerticalFormPanel = FormControl.prototype.styleForVerticalFormPanel;
  GenericFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = FormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  GenericFormControl.prototype.styleForInlineFormPanel = FormControl.prototype.styleForInlineFormPanel;
  GenericFormControl.prototype.focus = FormControl.prototype.focus;
  GenericFormControl.prototype.blur = FormControl.prototype.blur;
  Object.defineProperty(GenericNonNullableFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(FormControl.prototype, 'disabled'));
  Object.defineProperty(GenericNonNullableFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(FormControl.prototype, 'size'));
  Object.defineProperty(GenericNonNullableFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(FormControl.prototype, 'name'));
  Object.defineProperty(GenericNonNullableFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(FormControl.prototype, 'validationStatus'));
  Object.defineProperty(GenericNonNullableFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(FormControl.prototype, 'validatorError'));
  GenericNonNullableFormControl.prototype.styleForVerticalFormPanel = FormControl.prototype.styleForVerticalFormPanel;
  GenericNonNullableFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = FormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  GenericNonNullableFormControl.prototype.styleForInlineFormPanel = FormControl.prototype.styleForInlineFormPanel;
  GenericNonNullableFormControl.prototype.focus = FormControl.prototype.focus;
  GenericNonNullableFormControl.prototype.blur = FormControl.prototype.blur;
  StringFormControl.prototype.getValue = GenericFormControl.prototype.getValue;
  Object.defineProperty(StringFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'disabled'));
  Object.defineProperty(StringFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'size'));
  Object.defineProperty(StringFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'name'));
  Object.defineProperty(StringFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validationStatus'));
  Object.defineProperty(StringFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validatorError'));
  StringFormControl.prototype.styleForVerticalFormPanel = GenericFormControl.prototype.styleForVerticalFormPanel;
  StringFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = GenericFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  StringFormControl.prototype.styleForInlineFormPanel = GenericFormControl.prototype.styleForInlineFormPanel;
  StringFormControl.prototype.focus = GenericFormControl.prototype.focus;
  StringFormControl.prototype.blur = GenericFormControl.prototype.blur;
  NumberFormControl.prototype.getValue = GenericFormControl.prototype.getValue;
  NumberFormControl.prototype.getValueAsString = GenericFormControl.prototype.getValueAsString;
  Object.defineProperty(NumberFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'disabled'));
  Object.defineProperty(NumberFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'size'));
  Object.defineProperty(NumberFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'name'));
  Object.defineProperty(NumberFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validationStatus'));
  Object.defineProperty(NumberFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validatorError'));
  NumberFormControl.prototype.styleForVerticalFormPanel = GenericFormControl.prototype.styleForVerticalFormPanel;
  NumberFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = GenericFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  NumberFormControl.prototype.styleForInlineFormPanel = GenericFormControl.prototype.styleForInlineFormPanel;
  NumberFormControl.prototype.focus = GenericFormControl.prototype.focus;
  NumberFormControl.prototype.blur = GenericFormControl.prototype.blur;
  BoolFormControl.prototype.getValue = GenericNonNullableFormControl.prototype.getValue;
  BoolFormControl.prototype.getValueAsString = GenericNonNullableFormControl.prototype.getValueAsString;
  Object.defineProperty(BoolFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(GenericNonNullableFormControl.prototype, 'disabled'));
  Object.defineProperty(BoolFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(GenericNonNullableFormControl.prototype, 'size'));
  Object.defineProperty(BoolFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(GenericNonNullableFormControl.prototype, 'name'));
  Object.defineProperty(BoolFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(GenericNonNullableFormControl.prototype, 'validationStatus'));
  Object.defineProperty(BoolFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(GenericNonNullableFormControl.prototype, 'validatorError'));
  BoolFormControl.prototype.styleForVerticalFormPanel = GenericNonNullableFormControl.prototype.styleForVerticalFormPanel;
  BoolFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = GenericNonNullableFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  BoolFormControl.prototype.styleForInlineFormPanel = GenericNonNullableFormControl.prototype.styleForInlineFormPanel;
  BoolFormControl.prototype.focus = GenericNonNullableFormControl.prototype.focus;
  BoolFormControl.prototype.blur = GenericNonNullableFormControl.prototype.blur;
  TriStateFormControl.prototype.getValue = GenericFormControl.prototype.getValue;
  TriStateFormControl.prototype.getValueAsString = GenericFormControl.prototype.getValueAsString;
  Object.defineProperty(TriStateFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'disabled'));
  Object.defineProperty(TriStateFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'size'));
  Object.defineProperty(TriStateFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'name'));
  Object.defineProperty(TriStateFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validationStatus'));
  Object.defineProperty(TriStateFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validatorError'));
  TriStateFormControl.prototype.styleForVerticalFormPanel = GenericFormControl.prototype.styleForVerticalFormPanel;
  TriStateFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = GenericFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  TriStateFormControl.prototype.styleForInlineFormPanel = GenericFormControl.prototype.styleForInlineFormPanel;
  TriStateFormControl.prototype.focus = GenericFormControl.prototype.focus;
  TriStateFormControl.prototype.blur = GenericFormControl.prototype.blur;
  DateFormControl.prototype.getValue = GenericFormControl.prototype.getValue;
  DateFormControl.prototype.getValueAsString = GenericFormControl.prototype.getValueAsString;
  Object.defineProperty(DateFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'disabled'));
  Object.defineProperty(DateFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'size'));
  Object.defineProperty(DateFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'name'));
  Object.defineProperty(DateFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validationStatus'));
  Object.defineProperty(DateFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validatorError'));
  DateFormControl.prototype.styleForVerticalFormPanel = GenericFormControl.prototype.styleForVerticalFormPanel;
  DateFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = GenericFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  DateFormControl.prototype.styleForInlineFormPanel = GenericFormControl.prototype.styleForInlineFormPanel;
  DateFormControl.prototype.focus = GenericFormControl.prototype.focus;
  DateFormControl.prototype.blur = GenericFormControl.prototype.blur;
  KFilesFormControl.prototype.getValue = GenericFormControl.prototype.getValue;
  Object.defineProperty(KFilesFormControl.prototype, 'disabled', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'disabled'));
  Object.defineProperty(KFilesFormControl.prototype, 'size', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'size'));
  Object.defineProperty(KFilesFormControl.prototype, 'name', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'name'));
  Object.defineProperty(KFilesFormControl.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validationStatus'));
  Object.defineProperty(KFilesFormControl.prototype, 'validatorError', Object.getOwnPropertyDescriptor(GenericFormControl.prototype, 'validatorError'));
  KFilesFormControl.prototype.styleForVerticalFormPanel = GenericFormControl.prototype.styleForVerticalFormPanel;
  KFilesFormControl.prototype.styleForHorizontalFormPanel_fn6884$ = GenericFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  KFilesFormControl.prototype.styleForInlineFormPanel = GenericFormControl.prototype.styleForInlineFormPanel;
  KFilesFormControl.prototype.focus = GenericFormControl.prototype.focus;
  KFilesFormControl.prototype.blur = GenericFormControl.prototype.blur;
  CheckBox.prototype.setValue_s8jyv4$ = BoolFormControl.prototype.setValue_s8jyv4$;
  CheckBox.prototype.getValue = BoolFormControl.prototype.getValue;
  CheckBox.prototype.getValueAsString = BoolFormControl.prototype.getValueAsString;
  Object.defineProperty(CheckBox.prototype, 'disabled', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'disabled'));
  Object.defineProperty(CheckBox.prototype, 'size', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'size'));
  Object.defineProperty(CheckBox.prototype, 'name', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'name'));
  Object.defineProperty(CheckBox.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'validationStatus'));
  Object.defineProperty(CheckBox.prototype, 'validatorError', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'validatorError'));
  GenericRadioGroup.prototype.getValue = GenericFormControl.prototype.getValue;
  GenericRadioGroup.prototype.setValue_s8jyv4$ = GenericFormControl.prototype.setValue_s8jyv4$;
  GenericRadioGroup.prototype.getValueAsString = GenericFormControl.prototype.getValueAsString;
  GenericRadioGroup.prototype.styleForVerticalFormPanel = GenericFormControl.prototype.styleForVerticalFormPanel;
  GenericRadioGroup.prototype.styleForInlineFormPanel = GenericFormControl.prototype.styleForInlineFormPanel;
  Radio.prototype.setValue_s8jyv4$ = BoolFormControl.prototype.setValue_s8jyv4$;
  Radio.prototype.getValue = BoolFormControl.prototype.getValue;
  Radio.prototype.getValueAsString = BoolFormControl.prototype.getValueAsString;
  Object.defineProperty(Radio.prototype, 'disabled', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'disabled'));
  Object.defineProperty(Radio.prototype, 'size', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'size'));
  Object.defineProperty(Radio.prototype, 'name', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'name'));
  Object.defineProperty(Radio.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'validationStatus'));
  Object.defineProperty(Radio.prototype, 'validatorError', Object.getOwnPropertyDescriptor(BoolFormControl.prototype, 'validatorError'));
  TriStateCheckBox.prototype.getValue = TriStateFormControl.prototype.getValue;
  TriStateCheckBox.prototype.getValueAsString = TriStateFormControl.prototype.getValueAsString;
  Object.defineProperty(TriStateCheckBox.prototype, 'disabled', Object.getOwnPropertyDescriptor(TriStateFormControl.prototype, 'disabled'));
  Object.defineProperty(TriStateCheckBox.prototype, 'size', Object.getOwnPropertyDescriptor(TriStateFormControl.prototype, 'size'));
  Object.defineProperty(TriStateCheckBox.prototype, 'name', Object.getOwnPropertyDescriptor(TriStateFormControl.prototype, 'name'));
  Object.defineProperty(TriStateCheckBox.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(TriStateFormControl.prototype, 'validationStatus'));
  Object.defineProperty(TriStateCheckBox.prototype, 'validatorError', Object.getOwnPropertyDescriptor(TriStateFormControl.prototype, 'validatorError'));
  Range.prototype.setValue_s8jyv4$ = NumberFormControl.prototype.setValue_s8jyv4$;
  Range.prototype.getValue = NumberFormControl.prototype.getValue;
  Object.defineProperty(Range.prototype, 'disabled', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'disabled'));
  Object.defineProperty(Range.prototype, 'size', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'size'));
  Object.defineProperty(Range.prototype, 'name', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'name'));
  Object.defineProperty(Range.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'validationStatus'));
  Range.prototype.styleForVerticalFormPanel = NumberFormControl.prototype.styleForVerticalFormPanel;
  Range.prototype.styleForInlineFormPanel = NumberFormControl.prototype.styleForInlineFormPanel;
  SimpleSelect.prototype.setValue_s8jyv4$ = StringFormControl.prototype.setValue_s8jyv4$;
  SimpleSelect.prototype.getValueAsString = StringFormControl.prototype.getValueAsString;
  SimpleSelect.prototype.getValue = StringFormControl.prototype.getValue;
  Object.defineProperty(SimpleSelect.prototype, 'disabled', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'disabled'));
  Object.defineProperty(SimpleSelect.prototype, 'size', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'size'));
  Object.defineProperty(SimpleSelect.prototype, 'name', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'name'));
  Object.defineProperty(SimpleSelect.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'validationStatus'));
  Object.defineProperty(SimpleSelect.prototype, 'validatorError', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'validatorError'));
  SimpleSelect.prototype.styleForVerticalFormPanel = StringFormControl.prototype.styleForVerticalFormPanel;
  SimpleSelect.prototype.styleForHorizontalFormPanel_fn6884$ = StringFormControl.prototype.styleForHorizontalFormPanel_fn6884$;
  SimpleSelect.prototype.styleForInlineFormPanel = StringFormControl.prototype.styleForInlineFormPanel;
  SimpleSpinner.prototype.setValue_s8jyv4$ = NumberFormControl.prototype.setValue_s8jyv4$;
  SimpleSpinner.prototype.getValue = NumberFormControl.prototype.getValue;
  Object.defineProperty(SimpleSpinner.prototype, 'disabled', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'disabled'));
  Object.defineProperty(SimpleSpinner.prototype, 'size', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'size'));
  Object.defineProperty(SimpleSpinner.prototype, 'name', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'name'));
  Object.defineProperty(SimpleSpinner.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(NumberFormControl.prototype, 'validationStatus'));
  SimpleSpinner.prototype.styleForVerticalFormPanel = NumberFormControl.prototype.styleForVerticalFormPanel;
  SimpleSpinner.prototype.styleForInlineFormPanel = NumberFormControl.prototype.styleForInlineFormPanel;
  AbstractText.prototype.setValue_s8jyv4$ = StringFormControl.prototype.setValue_s8jyv4$;
  AbstractText.prototype.getValueAsString = StringFormControl.prototype.getValueAsString;
  AbstractText.prototype.getValue = StringFormControl.prototype.getValue;
  Object.defineProperty(AbstractText.prototype, 'disabled', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'disabled'));
  Object.defineProperty(AbstractText.prototype, 'size', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'size'));
  Object.defineProperty(AbstractText.prototype, 'name', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'name'));
  Object.defineProperty(AbstractText.prototype, 'validationStatus', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'validationStatus'));
  Object.defineProperty(AbstractText.prototype, 'validatorError', Object.getOwnPropertyDescriptor(StringFormControl.prototype, 'validatorError'));
  AbstractText.prototype.styleForVerticalFormPanel = StringFormControl.prototype.styleForVerticalFormPanel;
  AbstractText.prototype.styleForInlineFormPanel = StringFormControl.prototype.styleForInlineFormPanel;
  I18n.prototype.tr_61zpoe$ = I18nManager.prototype.tr_61zpoe$;
  I18n.prototype.ntr_rjan26$ = I18nManager.prototype.ntr_rjan26$;
  I18n.prototype.trans_61zpoe$ = I18nManager.prototype.trans_61zpoe$;
  I18n.prototype.trans_pdl1vj$ = I18nManager.prototype.trans_pdl1vj$;
  SimpleI18nManager.prototype.tr_61zpoe$ = I18nManager.prototype.tr_61zpoe$;
  SimpleI18nManager.prototype.ntr_rjan26$ = I18nManager.prototype.ntr_rjan26$;
  SimpleI18nManager.prototype.trans_61zpoe$ = I18nManager.prototype.trans_61zpoe$;
  SimpleI18nManager.prototype.trans_pdl1vj$ = I18nManager.prototype.trans_pdl1vj$;
  DEFAULT_STEP = 1;
  KVNULL = '#kvnull';
  SIMPLE_DEFAULT_STEP = 1;
  I18N_SINGLE_DELIMITER = '###KvI18nS###';
  I18N_PLURAL_DELIMITER = '###KvI18nP###';
  attributesModule = $module$snabbdom_0.attributesModule;
  classModule = $module$snabbdom_0.classModule;
  propsModule = $module$snabbdom_0.propsModule;
  styleModule = $module$snabbdom_0.styleModule;
  eventListenersModule = $module$snabbdom_0.eventListenersModule;
  isLegacyBackend = lazy(isLegacyBackend$lambda);
  ENTER_KEY = 13;
  ESC_KEY = 27;
  auto = new Pair(0, UNIT$auto_getInstance());
  normal = new Pair(0, UNIT$normal_getInstance());
  hex = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
  return _;
}));

//# sourceMappingURL=kvision-js-legacy.js.map
